var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// node_modules/photoswipe/dist/photoswipe.esm.js
var photoswipe_esm_exports = {};
__export(photoswipe_esm_exports, {
  default: () => PhotoSwipe
});
function createElement(className, tagName, appendToEl) {
  const el = document.createElement(tagName);
  if (className) {
    el.className = className;
  }
  if (appendToEl) {
    appendToEl.appendChild(el);
  }
  return el;
}
function equalizePoints(p1, p2) {
  p1.x = p2.x;
  p1.y = p2.y;
  if (p2.id !== void 0) {
    p1.id = p2.id;
  }
  return p1;
}
function roundPoint(p) {
  p.x = Math.round(p.x);
  p.y = Math.round(p.y);
}
function getDistanceBetween(p1, p2) {
  const x = Math.abs(p1.x - p2.x);
  const y = Math.abs(p1.y - p2.y);
  return Math.sqrt(x * x + y * y);
}
function pointsEqual(p1, p2) {
  return p1.x === p2.x && p1.y === p2.y;
}
function clamp2(val, min2, max2) {
  return Math.min(Math.max(val, min2), max2);
}
function toTransformString(x, y, scale) {
  let propValue = `translate3d(${x}px,${y || 0}px,0)`;
  if (scale !== void 0) {
    propValue += ` scale3d(${scale},${scale},1)`;
  }
  return propValue;
}
function setTransform(el, x, y, scale) {
  el.style.transform = toTransformString(x, y, scale);
}
function setTransitionStyle(el, prop, duration, ease) {
  el.style.transition = prop ? `${prop} ${duration}ms ${ease || defaultCSSEasing}` : "none";
}
function setWidthHeight(el, w, h) {
  el.style.width = typeof w === "number" ? `${w}px` : w;
  el.style.height = typeof h === "number" ? `${h}px` : h;
}
function removeTransitionStyle(el) {
  setTransitionStyle(el);
}
function decodeImage(img) {
  if ("decode" in img) {
    return img.decode().catch(() => {
    });
  }
  if (img.complete) {
    return Promise.resolve(img);
  }
  return new Promise((resolve, reject) => {
    img.onload = () => resolve(img);
    img.onerror = reject;
  });
}
function specialKeyUsed(e) {
  return "button" in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
function getElementsFromOption(option, legacySelector, parent = document) {
  let elements = [];
  if (option instanceof Element) {
    elements = [option];
  } else if (option instanceof NodeList || Array.isArray(option)) {
    elements = Array.from(option);
  } else {
    const selector = typeof option === "string" ? option : legacySelector;
    if (selector) {
      elements = Array.from(parent.querySelectorAll(selector));
    }
  }
  return elements;
}
function isSafari() {
  return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
function getViewportSize(options, pswp) {
  if (options.getViewportSizeFn) {
    const newViewportSize = options.getViewportSizeFn(options, pswp);
    if (newViewportSize) {
      return newViewportSize;
    }
  }
  return {
    x: document.documentElement.clientWidth,
    y: window.innerHeight
  };
}
function parsePaddingOption(prop, options, viewportSize, itemData, index) {
  let paddingValue = 0;
  if (options.paddingFn) {
    paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
  } else if (options.padding) {
    paddingValue = options.padding[prop];
  } else {
    const legacyPropName = "padding" + prop[0].toUpperCase() + prop.slice(1);
    if (options[legacyPropName]) {
      paddingValue = options[legacyPropName];
    }
  }
  return Number(paddingValue) || 0;
}
function getPanAreaSize(options, viewportSize, itemData, index) {
  return {
    x: viewportSize.x - parsePaddingOption("left", options, viewportSize, itemData, index) - parsePaddingOption("right", options, viewportSize, itemData, index),
    y: viewportSize.y - parsePaddingOption("top", options, viewportSize, itemData, index) - parsePaddingOption("bottom", options, viewportSize, itemData, index)
  };
}
function project(initialVelocity, decelerationRate) {
  return initialVelocity * decelerationRate / (1 - decelerationRate);
}
function getZoomPointsCenter(p, p1, p2) {
  p.x = (p1.x + p2.x) / 2;
  p.y = (p1.y + p2.y) / 2;
  return p;
}
function didTapOnMainContent(event) {
  return !!event.target.closest(".pswp__container");
}
function addElementHTML(htmlData) {
  if (typeof htmlData === "string") {
    return htmlData;
  }
  if (!htmlData || !htmlData.isCustomSVG) {
    return "";
  }
  const svgData = htmlData;
  let out = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">';
  out = out.split("%d").join(
    svgData.size || 32
  );
  if (svgData.outlineID) {
    out += '<use class="pswp__icn-shadow" xlink:href="#' + svgData.outlineID + '"/>';
  }
  out += svgData.inner;
  out += "</svg>";
  return out;
}
function initArrowButton(element, pswp, isNextButton) {
  element.classList.add("pswp__button--arrow");
  element.setAttribute("aria-controls", "pswp__items");
  pswp.on("change", () => {
    if (!pswp.options.loop) {
      if (isNextButton) {
        element.disabled = !(pswp.currIndex < pswp.getNumItems() - 1);
      } else {
        element.disabled = !(pswp.currIndex > 0);
      }
    }
  });
}
function setZoomedIn(el, isZoomedIn) {
  el.classList.toggle("pswp--zoomed-in", isZoomedIn);
}
function getBoundsByElement(el) {
  const thumbAreaRect = el.getBoundingClientRect();
  return {
    x: thumbAreaRect.left,
    y: thumbAreaRect.top,
    w: thumbAreaRect.width
  };
}
function getCroppedBoundsByElement(el, imageWidth, imageHeight) {
  const thumbAreaRect = el.getBoundingClientRect();
  const hRatio = thumbAreaRect.width / imageWidth;
  const vRatio = thumbAreaRect.height / imageHeight;
  const fillZoomLevel = hRatio > vRatio ? hRatio : vRatio;
  const offsetX = (thumbAreaRect.width - imageWidth * fillZoomLevel) / 2;
  const offsetY = (thumbAreaRect.height - imageHeight * fillZoomLevel) / 2;
  const bounds = {
    x: thumbAreaRect.left + offsetX,
    y: thumbAreaRect.top + offsetY,
    w: imageWidth * fillZoomLevel
  };
  bounds.innerRect = {
    w: thumbAreaRect.width,
    h: thumbAreaRect.height,
    x: offsetX,
    y: offsetY
  };
  return bounds;
}
function getThumbBounds(index, itemData, instance) {
  const event = instance.dispatch("thumbBounds", {
    index,
    itemData,
    instance
  });
  if (event.thumbBounds) {
    return event.thumbBounds;
  }
  const {
    element
  } = itemData;
  let thumbBounds;
  let thumbnail;
  if (element && instance.options.thumbSelector !== false) {
    const thumbSelector = instance.options.thumbSelector || "img";
    thumbnail = element.matches(thumbSelector) ? element : element.querySelector(thumbSelector);
  }
  thumbnail = instance.applyFilters("thumbEl", thumbnail, itemData, index);
  if (thumbnail) {
    if (!itemData.thumbCropped) {
      thumbBounds = getBoundsByElement(thumbnail);
    } else {
      thumbBounds = getCroppedBoundsByElement(thumbnail, itemData.width || itemData.w || 0, itemData.height || itemData.h || 0);
    }
  }
  return instance.applyFilters("thumbBounds", thumbBounds, itemData, index);
}
function lazyLoadData(itemData, instance, index) {
  const content = instance.createContentFromData(itemData, index);
  let zoomLevel;
  const {
    options
  } = instance;
  if (options) {
    zoomLevel = new ZoomLevel(options, itemData, -1);
    let viewportSize;
    if (instance.pswp) {
      viewportSize = instance.pswp.viewportSize;
    } else {
      viewportSize = getViewportSize(options, instance);
    }
    const panAreaSize = getPanAreaSize(options, viewportSize, itemData, index);
    zoomLevel.update(content.width, content.height, panAreaSize);
  }
  content.lazyLoad();
  if (zoomLevel) {
    content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
  }
  return content;
}
function lazyLoadSlide(index, instance) {
  const itemData = instance.getItemData(index);
  if (instance.dispatch("lazyLoadSlide", {
    index,
    itemData
  }).defaultPrevented) {
    return;
  }
  return lazyLoadData(itemData, instance, index);
}
var defaultCSSEasing, LOAD_STATE, supportsPassive, DOMEvents, PanBounds, MAX_IMAGE_WIDTH, ZoomLevel, Slide2, PAN_END_FRICTION, VERTICAL_DRAG_FRICTION, MIN_RATIO_TO_CLOSE, MIN_NEXT_SLIDE_SPEED, DragHandler, UPPER_ZOOM_FRICTION, LOWER_ZOOM_FRICTION, ZoomHandler, TapHandler, AXIS_SWIPE_HYSTERISIS, DOUBLE_TAP_DELAY, MIN_TAP_DISTANCE, Gestures, MAIN_SCROLL_END_FRICTION, MainScroll, KeyboardKeyCodesMap, getKeyboardEventKey, Keyboard2, DEFAULT_EASING, CSSAnimation, DEFAULT_NATURAL_FREQUENCY, DEFAULT_DAMPING_RATIO, SpringEaser, SpringAnimation, Animations, ScrollWheel, UIElement, arrowPrev, arrowNext, closeButton, zoomButton, loadingIndicator, counterIndicator, UI, PhotoSwipeEvent, Eventable, Placeholder, Content, MIN_SLIDES_TO_CACHE, ContentLoader, PhotoSwipeBase, MIN_OPACITY, Opener, defaultOptions, PhotoSwipe;
var init_photoswipe_esm = __esm({
  "node_modules/photoswipe/dist/photoswipe.esm.js"() {
    defaultCSSEasing = "cubic-bezier(.4,0,.22,1)";
    LOAD_STATE = {
      IDLE: "idle",
      LOADING: "loading",
      LOADED: "loaded",
      ERROR: "error"
    };
    supportsPassive = false;
    try {
      window.addEventListener("test", null, Object.defineProperty({}, "passive", {
        get: () => {
          supportsPassive = true;
        }
      }));
    } catch (e) {
    }
    DOMEvents = class {
      constructor() {
        this._pool = [];
      }
      add(target, type, listener, passive) {
        this._toggleListener(target, type, listener, passive);
      }
      remove(target, type, listener, passive) {
        this._toggleListener(target, type, listener, passive, true);
      }
      removeAll() {
        this._pool.forEach((poolItem) => {
          this._toggleListener(poolItem.target, poolItem.type, poolItem.listener, poolItem.passive, true, true);
        });
        this._pool = [];
      }
      _toggleListener(target, type, listener, passive, unbind, skipPool) {
        if (!target) {
          return;
        }
        const methodName = unbind ? "removeEventListener" : "addEventListener";
        const types = type.split(" ");
        types.forEach((eType) => {
          if (eType) {
            if (!skipPool) {
              if (unbind) {
                this._pool = this._pool.filter((poolItem) => {
                  return poolItem.type !== eType || poolItem.listener !== listener || poolItem.target !== target;
                });
              } else {
                this._pool.push({
                  target,
                  type: eType,
                  listener,
                  passive
                });
              }
            }
            const eventOptions = supportsPassive ? {
              passive: passive || false
            } : false;
            target[methodName](eType, listener, eventOptions);
          }
        });
      }
    };
    PanBounds = class {
      constructor(slide) {
        this.slide = slide;
        this.currZoomLevel = 1;
        this.center = {
          x: 0,
          y: 0
        };
        this.max = {
          x: 0,
          y: 0
        };
        this.min = {
          x: 0,
          y: 0
        };
      }
      update(currZoomLevel) {
        this.currZoomLevel = currZoomLevel;
        if (!this.slide.width) {
          this.reset();
        } else {
          this._updateAxis("x");
          this._updateAxis("y");
          this.slide.pswp.dispatch("calcBounds", {
            slide: this.slide
          });
        }
      }
      _updateAxis(axis) {
        const {
          pswp
        } = this.slide;
        const elSize = this.slide[axis === "x" ? "width" : "height"] * this.currZoomLevel;
        const paddingProp = axis === "x" ? "left" : "top";
        const padding = parsePaddingOption(paddingProp, pswp.options, pswp.viewportSize, this.slide.data, this.slide.index);
        const panAreaSize = this.slide.panAreaSize[axis];
        this.center[axis] = Math.round((panAreaSize - elSize) / 2) + padding;
        this.max[axis] = elSize > panAreaSize ? Math.round(panAreaSize - elSize) + padding : this.center[axis];
        this.min[axis] = elSize > panAreaSize ? padding : this.center[axis];
      }
      reset() {
        this.center.x = 0;
        this.center.y = 0;
        this.max.x = 0;
        this.max.y = 0;
        this.min.x = 0;
        this.min.y = 0;
      }
      correctPan(axis, panOffset) {
        return clamp2(panOffset, this.max[axis], this.min[axis]);
      }
    };
    MAX_IMAGE_WIDTH = 4e3;
    ZoomLevel = class {
      constructor(options, itemData, index, pswp) {
        this.pswp = pswp;
        this.options = options;
        this.itemData = itemData;
        this.index = index;
        this.panAreaSize = null;
        this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
      }
      update(maxWidth, maxHeight, panAreaSize) {
        const elementSize = {
          x: maxWidth,
          y: maxHeight
        };
        this.elementSize = elementSize;
        this.panAreaSize = panAreaSize;
        const hRatio = panAreaSize.x / elementSize.x;
        const vRatio = panAreaSize.y / elementSize.y;
        this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
        this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio);
        this.vFill = Math.min(1, vRatio);
        this.initial = this._getInitial();
        this.secondary = this._getSecondary();
        this.max = Math.max(this.initial, this.secondary, this._getMax());
        this.min = Math.min(this.fit, this.initial, this.secondary);
        if (this.pswp) {
          this.pswp.dispatch("zoomLevelsUpdate", {
            zoomLevels: this,
            slideData: this.itemData
          });
        }
      }
      _parseZoomLevelOption(optionPrefix) {
        const optionName = optionPrefix + "ZoomLevel";
        const optionValue = this.options[optionName];
        if (!optionValue) {
          return;
        }
        if (typeof optionValue === "function") {
          return optionValue(this);
        }
        if (optionValue === "fill") {
          return this.fill;
        }
        if (optionValue === "fit") {
          return this.fit;
        }
        return Number(optionValue);
      }
      _getSecondary() {
        let currZoomLevel = this._parseZoomLevelOption("secondary");
        if (currZoomLevel) {
          return currZoomLevel;
        }
        currZoomLevel = Math.min(1, this.fit * 3);
        if (this.elementSize && currZoomLevel * this.elementSize.x > MAX_IMAGE_WIDTH) {
          currZoomLevel = MAX_IMAGE_WIDTH / this.elementSize.x;
        }
        return currZoomLevel;
      }
      _getInitial() {
        return this._parseZoomLevelOption("initial") || this.fit;
      }
      _getMax() {
        return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
      }
    };
    Slide2 = class {
      constructor(data, index, pswp) {
        this.data = data;
        this.index = index;
        this.pswp = pswp;
        this.isActive = index === pswp.currIndex;
        this.currentResolution = 0;
        this.panAreaSize = {
          x: 0,
          y: 0
        };
        this.pan = {
          x: 0,
          y: 0
        };
        this.isFirstSlide = this.isActive && !pswp.opener.isOpen;
        this.zoomLevels = new ZoomLevel(pswp.options, data, index, pswp);
        this.pswp.dispatch("gettingData", {
          slide: this,
          data: this.data,
          index
        });
        this.content = this.pswp.contentLoader.getContentBySlide(this);
        this.container = createElement("pswp__zoom-wrap", "div");
        this.holderElement = null;
        this.currZoomLevel = 1;
        this.width = this.content.width;
        this.height = this.content.height;
        this.heavyAppended = false;
        this.bounds = new PanBounds(this);
        this.prevDisplayedWidth = -1;
        this.prevDisplayedHeight = -1;
        this.pswp.dispatch("slideInit", {
          slide: this
        });
      }
      setIsActive(isActive) {
        if (isActive && !this.isActive) {
          this.activate();
        } else if (!isActive && this.isActive) {
          this.deactivate();
        }
      }
      append(holderElement) {
        this.holderElement = holderElement;
        this.container.style.transformOrigin = "0 0";
        if (!this.data) {
          return;
        }
        this.calculateSize();
        this.load();
        this.updateContentSize();
        this.appendHeavy();
        this.holderElement.appendChild(this.container);
        this.zoomAndPanToInitial();
        this.pswp.dispatch("firstZoomPan", {
          slide: this
        });
        this.applyCurrentZoomPan();
        this.pswp.dispatch("afterSetContent", {
          slide: this
        });
        if (this.isActive) {
          this.activate();
        }
      }
      load() {
        this.content.load(false);
        this.pswp.dispatch("slideLoad", {
          slide: this
        });
      }
      appendHeavy() {
        const {
          pswp
        } = this;
        const appendHeavyNearby = true;
        if (this.heavyAppended || !pswp.opener.isOpen || pswp.mainScroll.isShifted() || !this.isActive && !appendHeavyNearby) {
          return;
        }
        if (this.pswp.dispatch("appendHeavy", {
          slide: this
        }).defaultPrevented) {
          return;
        }
        this.heavyAppended = true;
        this.content.append();
        this.pswp.dispatch("appendHeavyContent", {
          slide: this
        });
      }
      activate() {
        this.isActive = true;
        this.appendHeavy();
        this.content.activate();
        this.pswp.dispatch("slideActivate", {
          slide: this
        });
      }
      deactivate() {
        this.isActive = false;
        this.content.deactivate();
        if (this.currZoomLevel !== this.zoomLevels.initial) {
          this.calculateSize();
        }
        this.currentResolution = 0;
        this.zoomAndPanToInitial();
        this.applyCurrentZoomPan();
        this.updateContentSize();
        this.pswp.dispatch("slideDeactivate", {
          slide: this
        });
      }
      destroy() {
        this.content.hasSlide = false;
        this.content.remove();
        this.container.remove();
        this.pswp.dispatch("slideDestroy", {
          slide: this
        });
      }
      resize() {
        if (this.currZoomLevel === this.zoomLevels.initial || !this.isActive) {
          this.calculateSize();
          this.currentResolution = 0;
          this.zoomAndPanToInitial();
          this.applyCurrentZoomPan();
          this.updateContentSize();
        } else {
          this.calculateSize();
          this.bounds.update(this.currZoomLevel);
          this.panTo(this.pan.x, this.pan.y);
        }
      }
      updateContentSize(force) {
        const scaleMultiplier = this.currentResolution || this.zoomLevels.initial;
        if (!scaleMultiplier) {
          return;
        }
        const width = Math.round(this.width * scaleMultiplier) || this.pswp.viewportSize.x;
        const height = Math.round(this.height * scaleMultiplier) || this.pswp.viewportSize.y;
        if (!this.sizeChanged(width, height) && !force) {
          return;
        }
        this.content.setDisplayedSize(width, height);
      }
      sizeChanged(width, height) {
        if (width !== this.prevDisplayedWidth || height !== this.prevDisplayedHeight) {
          this.prevDisplayedWidth = width;
          this.prevDisplayedHeight = height;
          return true;
        }
        return false;
      }
      getPlaceholderElement() {
        var _this$content$placeho;
        return (_this$content$placeho = this.content.placeholder) === null || _this$content$placeho === void 0 ? void 0 : _this$content$placeho.element;
      }
      zoomTo(destZoomLevel, centerPoint, transitionDuration, ignoreBounds) {
        const {
          pswp
        } = this;
        if (!this.isZoomable() || pswp.mainScroll.isShifted()) {
          return;
        }
        pswp.dispatch("beforeZoomTo", {
          destZoomLevel,
          centerPoint,
          transitionDuration
        });
        pswp.animations.stopAllPan();
        const prevZoomLevel = this.currZoomLevel;
        if (!ignoreBounds) {
          destZoomLevel = clamp2(destZoomLevel, this.zoomLevels.min, this.zoomLevels.max);
        }
        this.setZoomLevel(destZoomLevel);
        this.pan.x = this.calculateZoomToPanOffset("x", centerPoint, prevZoomLevel);
        this.pan.y = this.calculateZoomToPanOffset("y", centerPoint, prevZoomLevel);
        roundPoint(this.pan);
        const finishTransition = () => {
          this._setResolution(destZoomLevel);
          this.applyCurrentZoomPan();
        };
        if (!transitionDuration) {
          finishTransition();
        } else {
          pswp.animations.startTransition({
            isPan: true,
            name: "zoomTo",
            target: this.container,
            transform: this.getCurrentTransform(),
            onComplete: finishTransition,
            duration: transitionDuration,
            easing: pswp.options.easing
          });
        }
      }
      toggleZoom(centerPoint) {
        this.zoomTo(this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial, centerPoint, this.pswp.options.zoomAnimationDuration);
      }
      setZoomLevel(currZoomLevel) {
        this.currZoomLevel = currZoomLevel;
        this.bounds.update(this.currZoomLevel);
      }
      calculateZoomToPanOffset(axis, point, prevZoomLevel) {
        const totalPanDistance = this.bounds.max[axis] - this.bounds.min[axis];
        if (totalPanDistance === 0) {
          return this.bounds.center[axis];
        }
        if (!point) {
          point = this.pswp.getViewportCenterPoint();
        }
        if (!prevZoomLevel) {
          prevZoomLevel = this.zoomLevels.initial;
        }
        const zoomFactor = this.currZoomLevel / prevZoomLevel;
        return this.bounds.correctPan(axis, (this.pan[axis] - point[axis]) * zoomFactor + point[axis]);
      }
      panTo(panX, panY) {
        this.pan.x = this.bounds.correctPan("x", panX);
        this.pan.y = this.bounds.correctPan("y", panY);
        this.applyCurrentZoomPan();
      }
      isPannable() {
        return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
      }
      isZoomable() {
        return Boolean(this.width) && this.content.isZoomable();
      }
      applyCurrentZoomPan() {
        this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel);
        if (this === this.pswp.currSlide) {
          this.pswp.dispatch("zoomPanUpdate", {
            slide: this
          });
        }
      }
      zoomAndPanToInitial() {
        this.currZoomLevel = this.zoomLevels.initial;
        this.bounds.update(this.currZoomLevel);
        equalizePoints(this.pan, this.bounds.center);
        this.pswp.dispatch("initialZoomPan", {
          slide: this
        });
      }
      _applyZoomTransform(x, y, zoom) {
        zoom /= this.currentResolution || this.zoomLevels.initial;
        setTransform(this.container, x, y, zoom);
      }
      calculateSize() {
        const {
          pswp
        } = this;
        equalizePoints(this.panAreaSize, getPanAreaSize(pswp.options, pswp.viewportSize, this.data, this.index));
        this.zoomLevels.update(this.width, this.height, this.panAreaSize);
        pswp.dispatch("calcSlideSize", {
          slide: this
        });
      }
      getCurrentTransform() {
        const scale = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
        return toTransformString(this.pan.x, this.pan.y, scale);
      }
      _setResolution(newResolution) {
        if (newResolution === this.currentResolution) {
          return;
        }
        this.currentResolution = newResolution;
        this.updateContentSize();
        this.pswp.dispatch("resolutionChanged");
      }
    };
    PAN_END_FRICTION = 0.35;
    VERTICAL_DRAG_FRICTION = 0.6;
    MIN_RATIO_TO_CLOSE = 0.4;
    MIN_NEXT_SLIDE_SPEED = 0.5;
    DragHandler = class {
      constructor(gestures) {
        this.gestures = gestures;
        this.pswp = gestures.pswp;
        this.startPan = {
          x: 0,
          y: 0
        };
      }
      start() {
        if (this.pswp.currSlide) {
          equalizePoints(this.startPan, this.pswp.currSlide.pan);
        }
        this.pswp.animations.stopAll();
      }
      change() {
        const {
          p1,
          prevP1,
          dragAxis
        } = this.gestures;
        const {
          currSlide
        } = this.pswp;
        if (dragAxis === "y" && this.pswp.options.closeOnVerticalDrag && currSlide && currSlide.currZoomLevel <= currSlide.zoomLevels.fit && !this.gestures.isMultitouch) {
          const panY = currSlide.pan.y + (p1.y - prevP1.y);
          if (!this.pswp.dispatch("verticalDrag", {
            panY
          }).defaultPrevented) {
            this._setPanWithFriction("y", panY, VERTICAL_DRAG_FRICTION);
            const bgOpacity = 1 - Math.abs(this._getVerticalDragRatio(currSlide.pan.y));
            this.pswp.applyBgOpacity(bgOpacity);
            currSlide.applyCurrentZoomPan();
          }
        } else {
          const mainScrollChanged = this._panOrMoveMainScroll("x");
          if (!mainScrollChanged) {
            this._panOrMoveMainScroll("y");
            if (currSlide) {
              roundPoint(currSlide.pan);
              currSlide.applyCurrentZoomPan();
            }
          }
        }
      }
      end() {
        const {
          velocity
        } = this.gestures;
        const {
          mainScroll,
          currSlide
        } = this.pswp;
        let indexDiff = 0;
        this.pswp.animations.stopAll();
        if (mainScroll.isShifted()) {
          const mainScrollShiftDiff = mainScroll.x - mainScroll.getCurrSlideX();
          const currentSlideVisibilityRatio = mainScrollShiftDiff / this.pswp.viewportSize.x;
          if (velocity.x < -MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio < 0 || velocity.x < 0.1 && currentSlideVisibilityRatio < -0.5) {
            indexDiff = 1;
            velocity.x = Math.min(velocity.x, 0);
          } else if (velocity.x > MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio > 0 || velocity.x > -0.1 && currentSlideVisibilityRatio > 0.5) {
            indexDiff = -1;
            velocity.x = Math.max(velocity.x, 0);
          }
          mainScroll.moveIndexBy(indexDiff, true, velocity.x);
        }
        if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.max || this.gestures.isMultitouch) {
          this.gestures.zoomLevels.correctZoomPan(true);
        } else {
          this._finishPanGestureForAxis("x");
          this._finishPanGestureForAxis("y");
        }
      }
      _finishPanGestureForAxis(axis) {
        const {
          velocity
        } = this.gestures;
        const {
          currSlide
        } = this.pswp;
        if (!currSlide) {
          return;
        }
        const {
          pan,
          bounds
        } = currSlide;
        const panPos = pan[axis];
        const restoreBgOpacity = this.pswp.bgOpacity < 1 && axis === "y";
        const decelerationRate = 0.995;
        const projectedPosition = panPos + project(velocity[axis], decelerationRate);
        if (restoreBgOpacity) {
          const vDragRatio = this._getVerticalDragRatio(panPos);
          const projectedVDragRatio = this._getVerticalDragRatio(projectedPosition);
          if (vDragRatio < 0 && projectedVDragRatio < -MIN_RATIO_TO_CLOSE || vDragRatio > 0 && projectedVDragRatio > MIN_RATIO_TO_CLOSE) {
            this.pswp.close();
            return;
          }
        }
        const correctedPanPosition = bounds.correctPan(axis, projectedPosition);
        if (panPos === correctedPanPosition) {
          return;
        }
        const dampingRatio = correctedPanPosition === projectedPosition ? 1 : 0.82;
        const initialBgOpacity = this.pswp.bgOpacity;
        const totalPanDist = correctedPanPosition - panPos;
        this.pswp.animations.startSpring({
          name: "panGesture" + axis,
          isPan: true,
          start: panPos,
          end: correctedPanPosition,
          velocity: velocity[axis],
          dampingRatio,
          onUpdate: (pos) => {
            if (restoreBgOpacity && this.pswp.bgOpacity < 1) {
              const animationProgressRatio = 1 - (correctedPanPosition - pos) / totalPanDist;
              this.pswp.applyBgOpacity(clamp2(initialBgOpacity + (1 - initialBgOpacity) * animationProgressRatio, 0, 1));
            }
            pan[axis] = Math.floor(pos);
            currSlide.applyCurrentZoomPan();
          }
        });
      }
      _panOrMoveMainScroll(axis) {
        const {
          p1,
          dragAxis,
          prevP1,
          isMultitouch
        } = this.gestures;
        const {
          currSlide,
          mainScroll
        } = this.pswp;
        const delta = p1[axis] - prevP1[axis];
        const newMainScrollX = mainScroll.x + delta;
        if (!delta || !currSlide) {
          return false;
        }
        if (axis === "x" && !currSlide.isPannable() && !isMultitouch) {
          mainScroll.moveTo(newMainScrollX, true);
          return true;
        }
        const {
          bounds
        } = currSlide;
        const newPan = currSlide.pan[axis] + delta;
        if (this.pswp.options.allowPanToNext && dragAxis === "x" && axis === "x" && !isMultitouch) {
          const currSlideMainScrollX = mainScroll.getCurrSlideX();
          const mainScrollShiftDiff = mainScroll.x - currSlideMainScrollX;
          const isLeftToRight = delta > 0;
          const isRightToLeft = !isLeftToRight;
          if (newPan > bounds.min[axis] && isLeftToRight) {
            const wasAtMinPanPosition = bounds.min[axis] <= this.startPan[axis];
            if (wasAtMinPanPosition) {
              mainScroll.moveTo(newMainScrollX, true);
              return true;
            } else {
              this._setPanWithFriction(axis, newPan);
            }
          } else if (newPan < bounds.max[axis] && isRightToLeft) {
            const wasAtMaxPanPosition = this.startPan[axis] <= bounds.max[axis];
            if (wasAtMaxPanPosition) {
              mainScroll.moveTo(newMainScrollX, true);
              return true;
            } else {
              this._setPanWithFriction(axis, newPan);
            }
          } else {
            if (mainScrollShiftDiff !== 0) {
              if (mainScrollShiftDiff > 0) {
                mainScroll.moveTo(Math.max(newMainScrollX, currSlideMainScrollX), true);
                return true;
              } else if (mainScrollShiftDiff < 0) {
                mainScroll.moveTo(Math.min(newMainScrollX, currSlideMainScrollX), true);
                return true;
              }
            } else {
              this._setPanWithFriction(axis, newPan);
            }
          }
        } else {
          if (axis === "y") {
            if (!mainScroll.isShifted() && bounds.min.y !== bounds.max.y) {
              this._setPanWithFriction(axis, newPan);
            }
          } else {
            this._setPanWithFriction(axis, newPan);
          }
        }
        return false;
      }
      _getVerticalDragRatio(panY) {
        var _this$pswp$currSlide$, _this$pswp$currSlide;
        return (panY - ((_this$pswp$currSlide$ = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.bounds.center.y) !== null && _this$pswp$currSlide$ !== void 0 ? _this$pswp$currSlide$ : 0)) / (this.pswp.viewportSize.y / 3);
      }
      _setPanWithFriction(axis, potentialPan, customFriction) {
        const {
          currSlide
        } = this.pswp;
        if (!currSlide) {
          return;
        }
        const {
          pan,
          bounds
        } = currSlide;
        const correctedPan = bounds.correctPan(axis, potentialPan);
        if (correctedPan !== potentialPan || customFriction) {
          const delta = Math.round(potentialPan - pan[axis]);
          pan[axis] += delta * (customFriction || PAN_END_FRICTION);
        } else {
          pan[axis] = potentialPan;
        }
      }
    };
    UPPER_ZOOM_FRICTION = 0.05;
    LOWER_ZOOM_FRICTION = 0.15;
    ZoomHandler = class {
      constructor(gestures) {
        this.gestures = gestures;
        this._startPan = {
          x: 0,
          y: 0
        };
        this._startZoomPoint = {
          x: 0,
          y: 0
        };
        this._zoomPoint = {
          x: 0,
          y: 0
        };
        this._wasOverFitZoomLevel = false;
        this._startZoomLevel = 1;
      }
      start() {
        const {
          currSlide
        } = this.gestures.pswp;
        if (currSlide) {
          this._startZoomLevel = currSlide.currZoomLevel;
          equalizePoints(this._startPan, currSlide.pan);
        }
        this.gestures.pswp.animations.stopAllPan();
        this._wasOverFitZoomLevel = false;
      }
      change() {
        const {
          p1,
          startP1,
          p2,
          startP2,
          pswp
        } = this.gestures;
        const {
          currSlide
        } = pswp;
        if (!currSlide) {
          return;
        }
        const minZoomLevel = currSlide.zoomLevels.min;
        const maxZoomLevel = currSlide.zoomLevels.max;
        if (!currSlide.isZoomable() || pswp.mainScroll.isShifted()) {
          return;
        }
        getZoomPointsCenter(this._startZoomPoint, startP1, startP2);
        getZoomPointsCenter(this._zoomPoint, p1, p2);
        let currZoomLevel = 1 / getDistanceBetween(startP1, startP2) * getDistanceBetween(p1, p2) * this._startZoomLevel;
        if (currZoomLevel > currSlide.zoomLevels.initial + currSlide.zoomLevels.initial / 15) {
          this._wasOverFitZoomLevel = true;
        }
        if (currZoomLevel < minZoomLevel) {
          if (pswp.options.pinchToClose && !this._wasOverFitZoomLevel && this._startZoomLevel <= currSlide.zoomLevels.initial) {
            const bgOpacity = 1 - (minZoomLevel - currZoomLevel) / (minZoomLevel / 1.2);
            if (!pswp.dispatch("pinchClose", {
              bgOpacity
            }).defaultPrevented) {
              pswp.applyBgOpacity(bgOpacity);
            }
          } else {
            currZoomLevel = minZoomLevel - (minZoomLevel - currZoomLevel) * LOWER_ZOOM_FRICTION;
          }
        } else if (currZoomLevel > maxZoomLevel) {
          currZoomLevel = maxZoomLevel + (currZoomLevel - maxZoomLevel) * UPPER_ZOOM_FRICTION;
        }
        currSlide.pan.x = this._calculatePanForZoomLevel("x", currZoomLevel);
        currSlide.pan.y = this._calculatePanForZoomLevel("y", currZoomLevel);
        currSlide.setZoomLevel(currZoomLevel);
        currSlide.applyCurrentZoomPan();
      }
      end() {
        const {
          pswp
        } = this.gestures;
        const {
          currSlide
        } = pswp;
        if ((!currSlide || currSlide.currZoomLevel < currSlide.zoomLevels.initial) && !this._wasOverFitZoomLevel && pswp.options.pinchToClose) {
          pswp.close();
        } else {
          this.correctZoomPan();
        }
      }
      _calculatePanForZoomLevel(axis, currZoomLevel) {
        const zoomFactor = currZoomLevel / this._startZoomLevel;
        return this._zoomPoint[axis] - (this._startZoomPoint[axis] - this._startPan[axis]) * zoomFactor;
      }
      correctZoomPan(ignoreGesture) {
        const {
          pswp
        } = this.gestures;
        const {
          currSlide
        } = pswp;
        if (!(currSlide !== null && currSlide !== void 0 && currSlide.isZoomable())) {
          return;
        }
        if (this._zoomPoint.x === 0) {
          ignoreGesture = true;
        }
        const prevZoomLevel = currSlide.currZoomLevel;
        let destinationZoomLevel;
        let currZoomLevelNeedsChange = true;
        if (prevZoomLevel < currSlide.zoomLevels.initial) {
          destinationZoomLevel = currSlide.zoomLevels.initial;
        } else if (prevZoomLevel > currSlide.zoomLevels.max) {
          destinationZoomLevel = currSlide.zoomLevels.max;
        } else {
          currZoomLevelNeedsChange = false;
          destinationZoomLevel = prevZoomLevel;
        }
        const initialBgOpacity = pswp.bgOpacity;
        const restoreBgOpacity = pswp.bgOpacity < 1;
        const initialPan = equalizePoints({
          x: 0,
          y: 0
        }, currSlide.pan);
        let destinationPan = equalizePoints({
          x: 0,
          y: 0
        }, initialPan);
        if (ignoreGesture) {
          this._zoomPoint.x = 0;
          this._zoomPoint.y = 0;
          this._startZoomPoint.x = 0;
          this._startZoomPoint.y = 0;
          this._startZoomLevel = prevZoomLevel;
          equalizePoints(this._startPan, initialPan);
        }
        if (currZoomLevelNeedsChange) {
          destinationPan = {
            x: this._calculatePanForZoomLevel("x", destinationZoomLevel),
            y: this._calculatePanForZoomLevel("y", destinationZoomLevel)
          };
        }
        currSlide.setZoomLevel(destinationZoomLevel);
        destinationPan = {
          x: currSlide.bounds.correctPan("x", destinationPan.x),
          y: currSlide.bounds.correctPan("y", destinationPan.y)
        };
        currSlide.setZoomLevel(prevZoomLevel);
        const panNeedsChange = !pointsEqual(destinationPan, initialPan);
        if (!panNeedsChange && !currZoomLevelNeedsChange && !restoreBgOpacity) {
          currSlide._setResolution(destinationZoomLevel);
          currSlide.applyCurrentZoomPan();
          return;
        }
        pswp.animations.stopAllPan();
        pswp.animations.startSpring({
          isPan: true,
          start: 0,
          end: 1e3,
          velocity: 0,
          dampingRatio: 1,
          naturalFrequency: 40,
          onUpdate: (now) => {
            now /= 1e3;
            if (panNeedsChange || currZoomLevelNeedsChange) {
              if (panNeedsChange) {
                currSlide.pan.x = initialPan.x + (destinationPan.x - initialPan.x) * now;
                currSlide.pan.y = initialPan.y + (destinationPan.y - initialPan.y) * now;
              }
              if (currZoomLevelNeedsChange) {
                const newZoomLevel = prevZoomLevel + (destinationZoomLevel - prevZoomLevel) * now;
                currSlide.setZoomLevel(newZoomLevel);
              }
              currSlide.applyCurrentZoomPan();
            }
            if (restoreBgOpacity && pswp.bgOpacity < 1) {
              pswp.applyBgOpacity(clamp2(initialBgOpacity + (1 - initialBgOpacity) * now, 0, 1));
            }
          },
          onComplete: () => {
            currSlide._setResolution(destinationZoomLevel);
            currSlide.applyCurrentZoomPan();
          }
        });
      }
    };
    TapHandler = class {
      constructor(gestures) {
        this.gestures = gestures;
      }
      click(point, originalEvent) {
        const targetClassList = originalEvent.target.classList;
        const isImageClick = targetClassList.contains("pswp__img");
        const isBackgroundClick = targetClassList.contains("pswp__item") || targetClassList.contains("pswp__zoom-wrap");
        if (isImageClick) {
          this._doClickOrTapAction("imageClick", point, originalEvent);
        } else if (isBackgroundClick) {
          this._doClickOrTapAction("bgClick", point, originalEvent);
        }
      }
      tap(point, originalEvent) {
        if (didTapOnMainContent(originalEvent)) {
          this._doClickOrTapAction("tap", point, originalEvent);
        }
      }
      doubleTap(point, originalEvent) {
        if (didTapOnMainContent(originalEvent)) {
          this._doClickOrTapAction("doubleTap", point, originalEvent);
        }
      }
      _doClickOrTapAction(actionName, point, originalEvent) {
        var _this$gestures$pswp$e;
        const {
          pswp
        } = this.gestures;
        const {
          currSlide
        } = pswp;
        const actionFullName = actionName + "Action";
        const optionValue = pswp.options[actionFullName];
        if (pswp.dispatch(actionFullName, {
          point,
          originalEvent
        }).defaultPrevented) {
          return;
        }
        if (typeof optionValue === "function") {
          optionValue.call(pswp, point, originalEvent);
          return;
        }
        switch (optionValue) {
          case "close":
          case "next":
            pswp[optionValue]();
            break;
          case "zoom":
            currSlide === null || currSlide === void 0 || currSlide.toggleZoom(point);
            break;
          case "zoom-or-close":
            if (currSlide !== null && currSlide !== void 0 && currSlide.isZoomable() && currSlide.zoomLevels.secondary !== currSlide.zoomLevels.initial) {
              currSlide.toggleZoom(point);
            } else if (pswp.options.clickToCloseNonZoomable) {
              pswp.close();
            }
            break;
          case "toggle-controls":
            (_this$gestures$pswp$e = this.gestures.pswp.element) === null || _this$gestures$pswp$e === void 0 || _this$gestures$pswp$e.classList.toggle("pswp--ui-visible");
            break;
        }
      }
    };
    AXIS_SWIPE_HYSTERISIS = 10;
    DOUBLE_TAP_DELAY = 300;
    MIN_TAP_DISTANCE = 25;
    Gestures = class {
      constructor(pswp) {
        this.pswp = pswp;
        this.dragAxis = null;
        this.p1 = {
          x: 0,
          y: 0
        };
        this.p2 = {
          x: 0,
          y: 0
        };
        this.prevP1 = {
          x: 0,
          y: 0
        };
        this.prevP2 = {
          x: 0,
          y: 0
        };
        this.startP1 = {
          x: 0,
          y: 0
        };
        this.startP2 = {
          x: 0,
          y: 0
        };
        this.velocity = {
          x: 0,
          y: 0
        };
        this._lastStartP1 = {
          x: 0,
          y: 0
        };
        this._intervalP1 = {
          x: 0,
          y: 0
        };
        this._numActivePoints = 0;
        this._ongoingPointers = [];
        this._touchEventEnabled = "ontouchstart" in window;
        this._pointerEventEnabled = !!window.PointerEvent;
        this.supportsTouch = this._touchEventEnabled || this._pointerEventEnabled && navigator.maxTouchPoints > 1;
        this._numActivePoints = 0;
        this._intervalTime = 0;
        this._velocityCalculated = false;
        this.isMultitouch = false;
        this.isDragging = false;
        this.isZooming = false;
        this.raf = null;
        this._tapTimer = null;
        if (!this.supportsTouch) {
          pswp.options.allowPanToNext = false;
        }
        this.drag = new DragHandler(this);
        this.zoomLevels = new ZoomHandler(this);
        this.tapHandler = new TapHandler(this);
        pswp.on("bindEvents", () => {
          pswp.events.add(
            pswp.scrollWrap,
            "click",
            this._onClick.bind(this)
          );
          if (this._pointerEventEnabled) {
            this._bindEvents("pointer", "down", "up", "cancel");
          } else if (this._touchEventEnabled) {
            this._bindEvents("touch", "start", "end", "cancel");
            if (pswp.scrollWrap) {
              pswp.scrollWrap.ontouchmove = () => {
              };
              pswp.scrollWrap.ontouchend = () => {
              };
            }
          } else {
            this._bindEvents("mouse", "down", "up");
          }
        });
      }
      _bindEvents(pref, down, up, cancel) {
        const {
          pswp
        } = this;
        const {
          events
        } = pswp;
        const cancelEvent = cancel ? pref + cancel : "";
        events.add(
          pswp.scrollWrap,
          pref + down,
          this.onPointerDown.bind(this)
        );
        events.add(
          window,
          pref + "move",
          this.onPointerMove.bind(this)
        );
        events.add(
          window,
          pref + up,
          this.onPointerUp.bind(this)
        );
        if (cancelEvent) {
          events.add(
            pswp.scrollWrap,
            cancelEvent,
            this.onPointerUp.bind(this)
          );
        }
      }
      onPointerDown(e) {
        const isMousePointer = e.type === "mousedown" || e.pointerType === "mouse";
        if (isMousePointer && e.button > 0) {
          return;
        }
        const {
          pswp
        } = this;
        if (!pswp.opener.isOpen) {
          e.preventDefault();
          return;
        }
        if (pswp.dispatch("pointerDown", {
          originalEvent: e
        }).defaultPrevented) {
          return;
        }
        if (isMousePointer) {
          pswp.mouseDetected();
          this._preventPointerEventBehaviour(e, "down");
        }
        pswp.animations.stopAll();
        this._updatePoints(e, "down");
        if (this._numActivePoints === 1) {
          this.dragAxis = null;
          equalizePoints(this.startP1, this.p1);
        }
        if (this._numActivePoints > 1) {
          this._clearTapTimer();
          this.isMultitouch = true;
        } else {
          this.isMultitouch = false;
        }
      }
      onPointerMove(e) {
        this._preventPointerEventBehaviour(e, "move");
        if (!this._numActivePoints) {
          return;
        }
        this._updatePoints(e, "move");
        if (this.pswp.dispatch("pointerMove", {
          originalEvent: e
        }).defaultPrevented) {
          return;
        }
        if (this._numActivePoints === 1 && !this.isDragging) {
          if (!this.dragAxis) {
            this._calculateDragDirection();
          }
          if (this.dragAxis && !this.isDragging) {
            if (this.isZooming) {
              this.isZooming = false;
              this.zoomLevels.end();
            }
            this.isDragging = true;
            this._clearTapTimer();
            this._updateStartPoints();
            this._intervalTime = Date.now();
            this._velocityCalculated = false;
            equalizePoints(this._intervalP1, this.p1);
            this.velocity.x = 0;
            this.velocity.y = 0;
            this.drag.start();
            this._rafStopLoop();
            this._rafRenderLoop();
          }
        } else if (this._numActivePoints > 1 && !this.isZooming) {
          this._finishDrag();
          this.isZooming = true;
          this._updateStartPoints();
          this.zoomLevels.start();
          this._rafStopLoop();
          this._rafRenderLoop();
        }
      }
      _finishDrag() {
        if (this.isDragging) {
          this.isDragging = false;
          if (!this._velocityCalculated) {
            this._updateVelocity(true);
          }
          this.drag.end();
          this.dragAxis = null;
        }
      }
      onPointerUp(e) {
        if (!this._numActivePoints) {
          return;
        }
        this._updatePoints(e, "up");
        if (this.pswp.dispatch("pointerUp", {
          originalEvent: e
        }).defaultPrevented) {
          return;
        }
        if (this._numActivePoints === 0) {
          this._rafStopLoop();
          if (this.isDragging) {
            this._finishDrag();
          } else if (!this.isZooming && !this.isMultitouch) {
            this._finishTap(e);
          }
        }
        if (this._numActivePoints < 2 && this.isZooming) {
          this.isZooming = false;
          this.zoomLevels.end();
          if (this._numActivePoints === 1) {
            this.dragAxis = null;
            this._updateStartPoints();
          }
        }
      }
      _rafRenderLoop() {
        if (this.isDragging || this.isZooming) {
          this._updateVelocity();
          if (this.isDragging) {
            if (!pointsEqual(this.p1, this.prevP1)) {
              this.drag.change();
            }
          } else {
            if (!pointsEqual(this.p1, this.prevP1) || !pointsEqual(this.p2, this.prevP2)) {
              this.zoomLevels.change();
            }
          }
          this._updatePrevPoints();
          this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this));
        }
      }
      _updateVelocity(force) {
        const time = Date.now();
        const duration = time - this._intervalTime;
        if (duration < 50 && !force) {
          return;
        }
        this.velocity.x = this._getVelocity("x", duration);
        this.velocity.y = this._getVelocity("y", duration);
        this._intervalTime = time;
        equalizePoints(this._intervalP1, this.p1);
        this._velocityCalculated = true;
      }
      _finishTap(e) {
        const {
          mainScroll
        } = this.pswp;
        if (mainScroll.isShifted()) {
          mainScroll.moveIndexBy(0, true);
          return;
        }
        if (e.type.indexOf("cancel") > 0) {
          return;
        }
        if (e.type === "mouseup" || e.pointerType === "mouse") {
          this.tapHandler.click(this.startP1, e);
          return;
        }
        const tapDelay = this.pswp.options.doubleTapAction ? DOUBLE_TAP_DELAY : 0;
        if (this._tapTimer) {
          this._clearTapTimer();
          if (getDistanceBetween(this._lastStartP1, this.startP1) < MIN_TAP_DISTANCE) {
            this.tapHandler.doubleTap(this.startP1, e);
          }
        } else {
          equalizePoints(this._lastStartP1, this.startP1);
          this._tapTimer = setTimeout(() => {
            this.tapHandler.tap(this.startP1, e);
            this._clearTapTimer();
          }, tapDelay);
        }
      }
      _clearTapTimer() {
        if (this._tapTimer) {
          clearTimeout(this._tapTimer);
          this._tapTimer = null;
        }
      }
      _getVelocity(axis, duration) {
        const displacement = this.p1[axis] - this._intervalP1[axis];
        if (Math.abs(displacement) > 1 && duration > 5) {
          return displacement / duration;
        }
        return 0;
      }
      _rafStopLoop() {
        if (this.raf) {
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }
      }
      _preventPointerEventBehaviour(e, pointerType) {
        const preventPointerEvent = this.pswp.applyFilters("preventPointerEvent", true, e, pointerType);
        if (preventPointerEvent) {
          e.preventDefault();
        }
      }
      _updatePoints(e, pointerType) {
        if (this._pointerEventEnabled) {
          const pointerEvent = e;
          const pointerIndex = this._ongoingPointers.findIndex((ongoingPointer) => {
            return ongoingPointer.id === pointerEvent.pointerId;
          });
          if (pointerType === "up" && pointerIndex > -1) {
            this._ongoingPointers.splice(pointerIndex, 1);
          } else if (pointerType === "down" && pointerIndex === -1) {
            this._ongoingPointers.push(this._convertEventPosToPoint(pointerEvent, {
              x: 0,
              y: 0
            }));
          } else if (pointerIndex > -1) {
            this._convertEventPosToPoint(pointerEvent, this._ongoingPointers[pointerIndex]);
          }
          this._numActivePoints = this._ongoingPointers.length;
          if (this._numActivePoints > 0) {
            equalizePoints(this.p1, this._ongoingPointers[0]);
          }
          if (this._numActivePoints > 1) {
            equalizePoints(this.p2, this._ongoingPointers[1]);
          }
        } else {
          const touchEvent = e;
          this._numActivePoints = 0;
          if (touchEvent.type.indexOf("touch") > -1) {
            if (touchEvent.touches && touchEvent.touches.length > 0) {
              this._convertEventPosToPoint(touchEvent.touches[0], this.p1);
              this._numActivePoints++;
              if (touchEvent.touches.length > 1) {
                this._convertEventPosToPoint(touchEvent.touches[1], this.p2);
                this._numActivePoints++;
              }
            }
          } else {
            this._convertEventPosToPoint(
              e,
              this.p1
            );
            if (pointerType === "up") {
              this._numActivePoints = 0;
            } else {
              this._numActivePoints++;
            }
          }
        }
      }
      _updatePrevPoints() {
        equalizePoints(this.prevP1, this.p1);
        equalizePoints(this.prevP2, this.p2);
      }
      _updateStartPoints() {
        equalizePoints(this.startP1, this.p1);
        equalizePoints(this.startP2, this.p2);
        this._updatePrevPoints();
      }
      _calculateDragDirection() {
        if (this.pswp.mainScroll.isShifted()) {
          this.dragAxis = "x";
        } else {
          const diff = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
          if (diff !== 0) {
            const axisToCheck = diff > 0 ? "x" : "y";
            if (Math.abs(this.p1[axisToCheck] - this.startP1[axisToCheck]) >= AXIS_SWIPE_HYSTERISIS) {
              this.dragAxis = axisToCheck;
            }
          }
        }
      }
      _convertEventPosToPoint(e, p) {
        p.x = e.pageX - this.pswp.offset.x;
        p.y = e.pageY - this.pswp.offset.y;
        if ("pointerId" in e) {
          p.id = e.pointerId;
        } else if (e.identifier !== void 0) {
          p.id = e.identifier;
        }
        return p;
      }
      _onClick(e) {
        if (this.pswp.mainScroll.isShifted()) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    };
    MAIN_SCROLL_END_FRICTION = 0.35;
    MainScroll = class {
      constructor(pswp) {
        this.pswp = pswp;
        this.x = 0;
        this.slideWidth = 0;
        this._currPositionIndex = 0;
        this._prevPositionIndex = 0;
        this._containerShiftIndex = -1;
        this.itemHolders = [];
      }
      resize(resizeSlides) {
        const {
          pswp
        } = this;
        const newSlideWidth = Math.round(pswp.viewportSize.x + pswp.viewportSize.x * pswp.options.spacing);
        const slideWidthChanged = newSlideWidth !== this.slideWidth;
        if (slideWidthChanged) {
          this.slideWidth = newSlideWidth;
          this.moveTo(this.getCurrSlideX());
        }
        this.itemHolders.forEach((itemHolder, index) => {
          if (slideWidthChanged) {
            setTransform(itemHolder.el, (index + this._containerShiftIndex) * this.slideWidth);
          }
          if (resizeSlides && itemHolder.slide) {
            itemHolder.slide.resize();
          }
        });
      }
      resetPosition() {
        this._currPositionIndex = 0;
        this._prevPositionIndex = 0;
        this.slideWidth = 0;
        this._containerShiftIndex = -1;
      }
      appendHolders() {
        this.itemHolders = [];
        for (let i = 0; i < 3; i++) {
          const el = createElement("pswp__item", "div", this.pswp.container);
          el.setAttribute("role", "group");
          el.setAttribute("aria-roledescription", "slide");
          el.setAttribute("aria-hidden", "true");
          el.style.display = i === 1 ? "block" : "none";
          this.itemHolders.push({
            el
          });
        }
      }
      canBeSwiped() {
        return this.pswp.getNumItems() > 1;
      }
      moveIndexBy(diff, animate18, velocityX) {
        const {
          pswp
        } = this;
        let newIndex = pswp.potentialIndex + diff;
        const numSlides = pswp.getNumItems();
        if (pswp.canLoop()) {
          newIndex = pswp.getLoopedIndex(newIndex);
          const distance = (diff + numSlides) % numSlides;
          if (distance <= numSlides / 2) {
            diff = distance;
          } else {
            diff = distance - numSlides;
          }
        } else {
          if (newIndex < 0) {
            newIndex = 0;
          } else if (newIndex >= numSlides) {
            newIndex = numSlides - 1;
          }
          diff = newIndex - pswp.potentialIndex;
        }
        pswp.potentialIndex = newIndex;
        this._currPositionIndex -= diff;
        pswp.animations.stopMainScroll();
        const destinationX = this.getCurrSlideX();
        if (!animate18) {
          this.moveTo(destinationX);
          this.updateCurrItem();
        } else {
          pswp.animations.startSpring({
            isMainScroll: true,
            start: this.x,
            end: destinationX,
            velocity: velocityX || 0,
            naturalFrequency: 30,
            dampingRatio: 1,
            onUpdate: (x) => {
              this.moveTo(x);
            },
            onComplete: () => {
              this.updateCurrItem();
              pswp.appendHeavy();
            }
          });
          let currDiff = pswp.potentialIndex - pswp.currIndex;
          if (pswp.canLoop()) {
            const currDistance = (currDiff + numSlides) % numSlides;
            if (currDistance <= numSlides / 2) {
              currDiff = currDistance;
            } else {
              currDiff = currDistance - numSlides;
            }
          }
          if (Math.abs(currDiff) > 1) {
            this.updateCurrItem();
          }
        }
        return Boolean(diff);
      }
      getCurrSlideX() {
        return this.slideWidth * this._currPositionIndex;
      }
      isShifted() {
        return this.x !== this.getCurrSlideX();
      }
      updateCurrItem() {
        var _this$itemHolders$;
        const {
          pswp
        } = this;
        const positionDifference = this._prevPositionIndex - this._currPositionIndex;
        if (!positionDifference) {
          return;
        }
        this._prevPositionIndex = this._currPositionIndex;
        pswp.currIndex = pswp.potentialIndex;
        let diffAbs = Math.abs(positionDifference);
        let tempHolder;
        if (diffAbs >= 3) {
          this._containerShiftIndex += positionDifference + (positionDifference > 0 ? -3 : 3);
          diffAbs = 3;
          this.itemHolders.forEach((itemHolder) => {
            var _itemHolder$slide;
            (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.destroy();
            itemHolder.slide = void 0;
          });
        }
        for (let i = 0; i < diffAbs; i++) {
          if (positionDifference > 0) {
            tempHolder = this.itemHolders.shift();
            if (tempHolder) {
              this.itemHolders[2] = tempHolder;
              this._containerShiftIndex++;
              setTransform(tempHolder.el, (this._containerShiftIndex + 2) * this.slideWidth);
              pswp.setContent(tempHolder, pswp.currIndex - diffAbs + i + 2);
            }
          } else {
            tempHolder = this.itemHolders.pop();
            if (tempHolder) {
              this.itemHolders.unshift(tempHolder);
              this._containerShiftIndex--;
              setTransform(tempHolder.el, this._containerShiftIndex * this.slideWidth);
              pswp.setContent(tempHolder, pswp.currIndex + diffAbs - i - 2);
            }
          }
        }
        if (Math.abs(this._containerShiftIndex) > 50 && !this.isShifted()) {
          this.resetPosition();
          this.resize();
        }
        pswp.animations.stopAllPan();
        this.itemHolders.forEach((itemHolder, i) => {
          if (itemHolder.slide) {
            itemHolder.slide.setIsActive(i === 1);
          }
        });
        pswp.currSlide = (_this$itemHolders$ = this.itemHolders[1]) === null || _this$itemHolders$ === void 0 ? void 0 : _this$itemHolders$.slide;
        pswp.contentLoader.updateLazy(positionDifference);
        if (pswp.currSlide) {
          pswp.currSlide.applyCurrentZoomPan();
        }
        pswp.dispatch("change");
      }
      moveTo(x, dragging) {
        if (!this.pswp.canLoop() && dragging) {
          let newSlideIndexOffset = (this.slideWidth * this._currPositionIndex - x) / this.slideWidth;
          newSlideIndexOffset += this.pswp.currIndex;
          const delta = Math.round(x - this.x);
          if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= this.pswp.getNumItems() - 1 && delta < 0) {
            x = this.x + delta * MAIN_SCROLL_END_FRICTION;
          }
        }
        this.x = x;
        if (this.pswp.container) {
          setTransform(this.pswp.container, x);
        }
        this.pswp.dispatch("moveMainScroll", {
          x,
          dragging: dragging !== null && dragging !== void 0 ? dragging : false
        });
      }
    };
    KeyboardKeyCodesMap = {
      Escape: 27,
      z: 90,
      ArrowLeft: 37,
      ArrowUp: 38,
      ArrowRight: 39,
      ArrowDown: 40,
      Tab: 9
    };
    getKeyboardEventKey = (key, isKeySupported) => {
      return isKeySupported ? key : KeyboardKeyCodesMap[key];
    };
    Keyboard2 = class {
      constructor(pswp) {
        this.pswp = pswp;
        this._wasFocused = false;
        pswp.on("bindEvents", () => {
          if (pswp.options.trapFocus) {
            if (!pswp.options.initialPointerPos) {
              this._focusRoot();
            }
            pswp.events.add(
              document,
              "focusin",
              this._onFocusIn.bind(this)
            );
          }
          pswp.events.add(
            document,
            "keydown",
            this._onKeyDown.bind(this)
          );
        });
        const lastActiveElement = document.activeElement;
        pswp.on("destroy", () => {
          if (pswp.options.returnFocus && lastActiveElement && this._wasFocused) {
            lastActiveElement.focus();
          }
        });
      }
      _focusRoot() {
        if (!this._wasFocused && this.pswp.element) {
          this.pswp.element.focus();
          this._wasFocused = true;
        }
      }
      _onKeyDown(e) {
        const {
          pswp
        } = this;
        if (pswp.dispatch("keydown", {
          originalEvent: e
        }).defaultPrevented) {
          return;
        }
        if (specialKeyUsed(e)) {
          return;
        }
        let keydownAction;
        let axis;
        let isForward = false;
        const isKeySupported = "key" in e;
        switch (isKeySupported ? e.key : e.keyCode) {
          case getKeyboardEventKey("Escape", isKeySupported):
            if (pswp.options.escKey) {
              keydownAction = "close";
            }
            break;
          case getKeyboardEventKey("z", isKeySupported):
            keydownAction = "toggleZoom";
            break;
          case getKeyboardEventKey("ArrowLeft", isKeySupported):
            axis = "x";
            break;
          case getKeyboardEventKey("ArrowUp", isKeySupported):
            axis = "y";
            break;
          case getKeyboardEventKey("ArrowRight", isKeySupported):
            axis = "x";
            isForward = true;
            break;
          case getKeyboardEventKey("ArrowDown", isKeySupported):
            isForward = true;
            axis = "y";
            break;
          case getKeyboardEventKey("Tab", isKeySupported):
            this._focusRoot();
            break;
        }
        if (axis) {
          e.preventDefault();
          const {
            currSlide
          } = pswp;
          if (pswp.options.arrowKeys && axis === "x" && pswp.getNumItems() > 1) {
            keydownAction = isForward ? "next" : "prev";
          } else if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.fit) {
            currSlide.pan[axis] += isForward ? -80 : 80;
            currSlide.panTo(currSlide.pan.x, currSlide.pan.y);
          }
        }
        if (keydownAction) {
          e.preventDefault();
          pswp[keydownAction]();
        }
      }
      _onFocusIn(e) {
        const {
          template: template2
        } = this.pswp;
        if (template2 && document !== e.target && template2 !== e.target && !template2.contains(
          e.target
        )) {
          template2.focus();
        }
      }
    };
    DEFAULT_EASING = "cubic-bezier(.4,0,.22,1)";
    CSSAnimation = class {
      constructor(props) {
        var _props$prop;
        this.props = props;
        const {
          target,
          onComplete,
          transform,
          onFinish = () => {
          },
          duration = 333,
          easing = DEFAULT_EASING
        } = props;
        this.onFinish = onFinish;
        const prop = transform ? "transform" : "opacity";
        const propValue = (_props$prop = props[prop]) !== null && _props$prop !== void 0 ? _props$prop : "";
        this._target = target;
        this._onComplete = onComplete;
        this._finished = false;
        this._onTransitionEnd = this._onTransitionEnd.bind(this);
        this._helperTimeout = setTimeout(() => {
          setTransitionStyle(target, prop, duration, easing);
          this._helperTimeout = setTimeout(() => {
            target.addEventListener("transitionend", this._onTransitionEnd, false);
            target.addEventListener("transitioncancel", this._onTransitionEnd, false);
            this._helperTimeout = setTimeout(() => {
              this._finalizeAnimation();
            }, duration + 500);
            target.style[prop] = propValue;
          }, 30);
        }, 0);
      }
      _onTransitionEnd(e) {
        if (e.target === this._target) {
          this._finalizeAnimation();
        }
      }
      _finalizeAnimation() {
        if (!this._finished) {
          this._finished = true;
          this.onFinish();
          if (this._onComplete) {
            this._onComplete();
          }
        }
      }
      destroy() {
        if (this._helperTimeout) {
          clearTimeout(this._helperTimeout);
        }
        removeTransitionStyle(this._target);
        this._target.removeEventListener("transitionend", this._onTransitionEnd, false);
        this._target.removeEventListener("transitioncancel", this._onTransitionEnd, false);
        if (!this._finished) {
          this._finalizeAnimation();
        }
      }
    };
    DEFAULT_NATURAL_FREQUENCY = 12;
    DEFAULT_DAMPING_RATIO = 0.75;
    SpringEaser = class {
      constructor(initialVelocity, dampingRatio, naturalFrequency) {
        this.velocity = initialVelocity * 1e3;
        this._dampingRatio = dampingRatio || DEFAULT_DAMPING_RATIO;
        this._naturalFrequency = naturalFrequency || DEFAULT_NATURAL_FREQUENCY;
        this._dampedFrequency = this._naturalFrequency;
        if (this._dampingRatio < 1) {
          this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio);
        }
      }
      easeFrame(deltaPosition, deltaTime) {
        let displacement = 0;
        let coeff;
        deltaTime /= 1e3;
        const naturalDumpingPow = Math.E ** (-this._dampingRatio * this._naturalFrequency * deltaTime);
        if (this._dampingRatio === 1) {
          coeff = this.velocity + this._naturalFrequency * deltaPosition;
          displacement = (deltaPosition + coeff * deltaTime) * naturalDumpingPow;
          this.velocity = displacement * -this._naturalFrequency + coeff * naturalDumpingPow;
        } else if (this._dampingRatio < 1) {
          coeff = 1 / this._dampedFrequency * (this._dampingRatio * this._naturalFrequency * deltaPosition + this.velocity);
          const dumpedFCos = Math.cos(this._dampedFrequency * deltaTime);
          const dumpedFSin = Math.sin(this._dampedFrequency * deltaTime);
          displacement = naturalDumpingPow * (deltaPosition * dumpedFCos + coeff * dumpedFSin);
          this.velocity = displacement * -this._naturalFrequency * this._dampingRatio + naturalDumpingPow * (-this._dampedFrequency * deltaPosition * dumpedFSin + this._dampedFrequency * coeff * dumpedFCos);
        }
        return displacement;
      }
    };
    SpringAnimation = class {
      constructor(props) {
        this.props = props;
        this._raf = 0;
        const {
          start,
          end,
          velocity,
          onUpdate,
          onComplete,
          onFinish = () => {
          },
          dampingRatio,
          naturalFrequency
        } = props;
        this.onFinish = onFinish;
        const easer = new SpringEaser(velocity, dampingRatio, naturalFrequency);
        let prevTime = Date.now();
        let deltaPosition = start - end;
        const animationLoop = () => {
          if (this._raf) {
            deltaPosition = easer.easeFrame(deltaPosition, Date.now() - prevTime);
            if (Math.abs(deltaPosition) < 1 && Math.abs(easer.velocity) < 50) {
              onUpdate(end);
              if (onComplete) {
                onComplete();
              }
              this.onFinish();
            } else {
              prevTime = Date.now();
              onUpdate(deltaPosition + end);
              this._raf = requestAnimationFrame(animationLoop);
            }
          }
        };
        this._raf = requestAnimationFrame(animationLoop);
      }
      destroy() {
        if (this._raf >= 0) {
          cancelAnimationFrame(this._raf);
        }
        this._raf = 0;
      }
    };
    Animations = class {
      constructor() {
        this.activeAnimations = [];
      }
      startSpring(props) {
        this._start(props, true);
      }
      startTransition(props) {
        this._start(props);
      }
      _start(props, isSpring) {
        const animation = isSpring ? new SpringAnimation(
          props
        ) : new CSSAnimation(
          props
        );
        this.activeAnimations.push(animation);
        animation.onFinish = () => this.stop(animation);
        return animation;
      }
      stop(animation) {
        animation.destroy();
        const index = this.activeAnimations.indexOf(animation);
        if (index > -1) {
          this.activeAnimations.splice(index, 1);
        }
      }
      stopAll() {
        this.activeAnimations.forEach((animation) => {
          animation.destroy();
        });
        this.activeAnimations = [];
      }
      stopAllPan() {
        this.activeAnimations = this.activeAnimations.filter((animation) => {
          if (animation.props.isPan) {
            animation.destroy();
            return false;
          }
          return true;
        });
      }
      stopMainScroll() {
        this.activeAnimations = this.activeAnimations.filter((animation) => {
          if (animation.props.isMainScroll) {
            animation.destroy();
            return false;
          }
          return true;
        });
      }
      isPanRunning() {
        return this.activeAnimations.some((animation) => {
          return animation.props.isPan;
        });
      }
    };
    ScrollWheel = class {
      constructor(pswp) {
        this.pswp = pswp;
        pswp.events.add(
          pswp.element,
          "wheel",
          this._onWheel.bind(this)
        );
      }
      _onWheel(e) {
        e.preventDefault();
        const {
          currSlide
        } = this.pswp;
        let {
          deltaX,
          deltaY
        } = e;
        if (!currSlide) {
          return;
        }
        if (this.pswp.dispatch("wheel", {
          originalEvent: e
        }).defaultPrevented) {
          return;
        }
        if (e.ctrlKey || this.pswp.options.wheelToZoom) {
          if (currSlide.isZoomable()) {
            let zoomFactor = -deltaY;
            if (e.deltaMode === 1) {
              zoomFactor *= 0.05;
            } else {
              zoomFactor *= e.deltaMode ? 1 : 2e-3;
            }
            zoomFactor = 2 ** zoomFactor;
            const destZoomLevel = currSlide.currZoomLevel * zoomFactor;
            currSlide.zoomTo(destZoomLevel, {
              x: e.clientX,
              y: e.clientY
            });
          }
        } else {
          if (currSlide.isPannable()) {
            if (e.deltaMode === 1) {
              deltaX *= 18;
              deltaY *= 18;
            }
            currSlide.panTo(currSlide.pan.x - deltaX, currSlide.pan.y - deltaY);
          }
        }
      }
    };
    UIElement = class {
      constructor(pswp, data) {
        var _container;
        const name = data.name || data.className;
        let elementHTML = data.html;
        if (pswp.options[name] === false) {
          return;
        }
        if (typeof pswp.options[name + "SVG"] === "string") {
          elementHTML = pswp.options[name + "SVG"];
        }
        pswp.dispatch("uiElementCreate", {
          data
        });
        let className = "";
        if (data.isButton) {
          className += "pswp__button ";
          className += data.className || `pswp__button--${data.name}`;
        } else {
          className += data.className || `pswp__${data.name}`;
        }
        let tagName = data.isButton ? data.tagName || "button" : data.tagName || "div";
        tagName = tagName.toLowerCase();
        const element = createElement(className, tagName);
        if (data.isButton) {
          if (tagName === "button") {
            element.type = "button";
          }
          let {
            title
          } = data;
          const {
            ariaLabel
          } = data;
          if (typeof pswp.options[name + "Title"] === "string") {
            title = pswp.options[name + "Title"];
          }
          if (title) {
            element.title = title;
          }
          const ariaText = ariaLabel || title;
          if (ariaText) {
            element.setAttribute("aria-label", ariaText);
          }
        }
        element.innerHTML = addElementHTML(elementHTML);
        if (data.onInit) {
          data.onInit(element, pswp);
        }
        if (data.onClick) {
          element.onclick = (e) => {
            if (typeof data.onClick === "string") {
              pswp[data.onClick]();
            } else if (typeof data.onClick === "function") {
              data.onClick(e, element, pswp);
            }
          };
        }
        const appendTo = data.appendTo || "bar";
        let container = pswp.element;
        if (appendTo === "bar") {
          if (!pswp.topBar) {
            pswp.topBar = createElement("pswp__top-bar pswp__hide-on-close", "div", pswp.scrollWrap);
          }
          container = pswp.topBar;
        } else {
          element.classList.add("pswp__hide-on-close");
          if (appendTo === "wrapper") {
            container = pswp.scrollWrap;
          }
        }
        (_container = container) === null || _container === void 0 || _container.appendChild(pswp.applyFilters("uiElement", element, data));
      }
    };
    arrowPrev = {
      name: "arrowPrev",
      className: "pswp__button--arrow--prev",
      title: "Previous",
      order: 10,
      isButton: true,
      appendTo: "wrapper",
      html: {
        isCustomSVG: true,
        size: 60,
        inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
        outlineID: "pswp__icn-arrow"
      },
      onClick: "prev",
      onInit: initArrowButton
    };
    arrowNext = {
      name: "arrowNext",
      className: "pswp__button--arrow--next",
      title: "Next",
      order: 11,
      isButton: true,
      appendTo: "wrapper",
      html: {
        isCustomSVG: true,
        size: 60,
        inner: '<use xlink:href="#pswp__icn-arrow"/>',
        outlineID: "pswp__icn-arrow"
      },
      onClick: "next",
      onInit: (el, pswp) => {
        initArrowButton(el, pswp, true);
      }
    };
    closeButton = {
      name: "close",
      title: "Close",
      order: 20,
      isButton: true,
      html: {
        isCustomSVG: true,
        inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
        outlineID: "pswp__icn-close"
      },
      onClick: "close"
    };
    zoomButton = {
      name: "zoom",
      title: "Zoom",
      order: 10,
      isButton: true,
      html: {
        isCustomSVG: true,
        inner: '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/><path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/><path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
        outlineID: "pswp__icn-zoom"
      },
      onClick: "toggleZoom"
    };
    loadingIndicator = {
      name: "preloader",
      appendTo: "bar",
      order: 7,
      html: {
        isCustomSVG: true,
        inner: '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
        outlineID: "pswp__icn-loading"
      },
      onInit: (indicatorElement, pswp) => {
        let isVisible;
        let delayTimeout = null;
        const toggleIndicatorClass = (className, add) => {
          indicatorElement.classList.toggle("pswp__preloader--" + className, add);
        };
        const setIndicatorVisibility = (visible) => {
          if (isVisible !== visible) {
            isVisible = visible;
            toggleIndicatorClass("active", visible);
          }
        };
        const updatePreloaderVisibility = () => {
          var _pswp$currSlide;
          if (!((_pswp$currSlide = pswp.currSlide) !== null && _pswp$currSlide !== void 0 && _pswp$currSlide.content.isLoading())) {
            setIndicatorVisibility(false);
            if (delayTimeout) {
              clearTimeout(delayTimeout);
              delayTimeout = null;
            }
            return;
          }
          if (!delayTimeout) {
            delayTimeout = setTimeout(() => {
              var _pswp$currSlide2;
              setIndicatorVisibility(Boolean((_pswp$currSlide2 = pswp.currSlide) === null || _pswp$currSlide2 === void 0 ? void 0 : _pswp$currSlide2.content.isLoading()));
              delayTimeout = null;
            }, pswp.options.preloaderDelay);
          }
        };
        pswp.on("change", updatePreloaderVisibility);
        pswp.on("loadComplete", (e) => {
          if (pswp.currSlide === e.slide) {
            updatePreloaderVisibility();
          }
        });
        if (pswp.ui) {
          pswp.ui.updatePreloaderVisibility = updatePreloaderVisibility;
        }
      }
    };
    counterIndicator = {
      name: "counter",
      order: 5,
      onInit: (counterElement, pswp) => {
        pswp.on("change", () => {
          counterElement.innerText = pswp.currIndex + 1 + pswp.options.indexIndicatorSep + pswp.getNumItems();
        });
      }
    };
    UI = class {
      constructor(pswp) {
        this.pswp = pswp;
        this.isRegistered = false;
        this.uiElementsData = [];
        this.items = [];
        this.updatePreloaderVisibility = () => {
        };
        this._lastUpdatedZoomLevel = void 0;
      }
      init() {
        const {
          pswp
        } = this;
        this.isRegistered = false;
        this.uiElementsData = [closeButton, arrowPrev, arrowNext, zoomButton, loadingIndicator, counterIndicator];
        pswp.dispatch("uiRegister");
        this.uiElementsData.sort((a, b) => {
          return (a.order || 0) - (b.order || 0);
        });
        this.items = [];
        this.isRegistered = true;
        this.uiElementsData.forEach((uiElementData) => {
          this.registerElement(uiElementData);
        });
        pswp.on("change", () => {
          var _pswp$element;
          (_pswp$element = pswp.element) === null || _pswp$element === void 0 || _pswp$element.classList.toggle("pswp--one-slide", pswp.getNumItems() === 1);
        });
        pswp.on("zoomPanUpdate", () => this._onZoomPanUpdate());
      }
      registerElement(elementData) {
        if (this.isRegistered) {
          this.items.push(new UIElement(this.pswp, elementData));
        } else {
          this.uiElementsData.push(elementData);
        }
      }
      _onZoomPanUpdate() {
        const {
          template: template2,
          currSlide,
          options
        } = this.pswp;
        if (this.pswp.opener.isClosing || !template2 || !currSlide) {
          return;
        }
        let {
          currZoomLevel
        } = currSlide;
        if (!this.pswp.opener.isOpen) {
          currZoomLevel = currSlide.zoomLevels.initial;
        }
        if (currZoomLevel === this._lastUpdatedZoomLevel) {
          return;
        }
        this._lastUpdatedZoomLevel = currZoomLevel;
        const currZoomLevelDiff = currSlide.zoomLevels.initial - currSlide.zoomLevels.secondary;
        if (Math.abs(currZoomLevelDiff) < 0.01 || !currSlide.isZoomable()) {
          setZoomedIn(template2, false);
          template2.classList.remove("pswp--zoom-allowed");
          return;
        }
        template2.classList.add("pswp--zoom-allowed");
        const potentialZoomLevel = currZoomLevel === currSlide.zoomLevels.initial ? currSlide.zoomLevels.secondary : currSlide.zoomLevels.initial;
        setZoomedIn(template2, potentialZoomLevel <= currZoomLevel);
        if (options.imageClickAction === "zoom" || options.imageClickAction === "zoom-or-close") {
          template2.classList.add("pswp--click-to-zoom");
        }
      }
    };
    PhotoSwipeEvent = class {
      constructor(type, details) {
        this.type = type;
        this.defaultPrevented = false;
        if (details) {
          Object.assign(this, details);
        }
      }
      preventDefault() {
        this.defaultPrevented = true;
      }
    };
    Eventable = class {
      constructor() {
        this._listeners = {};
        this._filters = {};
        this.pswp = void 0;
        this.options = void 0;
      }
      addFilter(name, fn, priority = 100) {
        var _this$_filters$name, _this$_filters$name2, _this$pswp;
        if (!this._filters[name]) {
          this._filters[name] = [];
        }
        (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
          fn,
          priority
        });
        (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort((f1, f2) => f1.priority - f2.priority);
        (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
      }
      removeFilter(name, fn) {
        if (this._filters[name]) {
          this._filters[name] = this._filters[name].filter((filter) => filter.fn !== fn);
        }
        if (this.pswp) {
          this.pswp.removeFilter(name, fn);
        }
      }
      applyFilters(name, ...args) {
        var _this$_filters$name3;
        (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach((filter) => {
          args[0] = filter.fn.apply(this, args);
        });
        return args[0];
      }
      on(name, fn) {
        var _this$_listeners$name, _this$pswp2;
        if (!this._listeners[name]) {
          this._listeners[name] = [];
        }
        (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn);
        (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
      }
      off(name, fn) {
        var _this$pswp3;
        if (this._listeners[name]) {
          this._listeners[name] = this._listeners[name].filter((listener) => fn !== listener);
        }
        (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
      }
      dispatch(name, details) {
        var _this$_listeners$name2;
        if (this.pswp) {
          return this.pswp.dispatch(name, details);
        }
        const event = new PhotoSwipeEvent(name, details);
        (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach((listener) => {
          listener.call(this, event);
        });
        return event;
      }
    };
    Placeholder = class {
      constructor(imageSrc, container) {
        this.element = createElement("pswp__img pswp__img--placeholder", imageSrc ? "img" : "div", container);
        if (imageSrc) {
          const imgEl = this.element;
          imgEl.decoding = "async";
          imgEl.alt = "";
          imgEl.src = imageSrc;
          imgEl.setAttribute("role", "presentation");
        }
        this.element.setAttribute("aria-hidden", "true");
      }
      setDisplayedSize(width, height) {
        if (!this.element) {
          return;
        }
        if (this.element.tagName === "IMG") {
          setWidthHeight(this.element, 250, "auto");
          this.element.style.transformOrigin = "0 0";
          this.element.style.transform = toTransformString(0, 0, width / 250);
        } else {
          setWidthHeight(this.element, width, height);
        }
      }
      destroy() {
        var _this$element;
        if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) {
          this.element.remove();
        }
        this.element = null;
      }
    };
    Content = class {
      constructor(itemData, instance, index) {
        this.instance = instance;
        this.data = itemData;
        this.index = index;
        this.element = void 0;
        this.placeholder = void 0;
        this.slide = void 0;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        this.state = LOAD_STATE.IDLE;
        if (this.data.type) {
          this.type = this.data.type;
        } else if (this.data.src) {
          this.type = "image";
        } else {
          this.type = "html";
        }
        this.instance.dispatch("contentInit", {
          content: this
        });
      }
      removePlaceholder() {
        if (this.placeholder && !this.keepPlaceholder()) {
          setTimeout(() => {
            if (this.placeholder) {
              this.placeholder.destroy();
              this.placeholder = void 0;
            }
          }, 1e3);
        }
      }
      load(isLazy, reload) {
        if (this.slide && this.usePlaceholder()) {
          if (!this.placeholder) {
            const placeholderSrc = this.instance.applyFilters(
              "placeholderSrc",
              this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false,
              this
            );
            this.placeholder = new Placeholder(placeholderSrc, this.slide.container);
          } else {
            const placeholderEl = this.placeholder.element;
            if (placeholderEl && !placeholderEl.parentElement) {
              this.slide.container.prepend(placeholderEl);
            }
          }
        }
        if (this.element && !reload) {
          return;
        }
        if (this.instance.dispatch("contentLoad", {
          content: this,
          isLazy
        }).defaultPrevented) {
          return;
        }
        if (this.isImageContent()) {
          this.element = createElement("pswp__img", "img");
          if (this.displayedImageWidth) {
            this.loadImage(isLazy);
          }
        } else {
          this.element = createElement("pswp__content", "div");
          this.element.innerHTML = this.data.html || "";
        }
        if (reload && this.slide) {
          this.slide.updateContentSize(true);
        }
      }
      loadImage(isLazy) {
        var _this$data$src, _this$data$alt;
        if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
          content: this,
          isLazy
        }).defaultPrevented) {
          return;
        }
        const imageElement = this.element;
        this.updateSrcsetSizes();
        if (this.data.srcset) {
          imageElement.srcset = this.data.srcset;
        }
        imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : "";
        imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : "";
        this.state = LOAD_STATE.LOADING;
        if (imageElement.complete) {
          this.onLoaded();
        } else {
          imageElement.onload = () => {
            this.onLoaded();
          };
          imageElement.onerror = () => {
            this.onError();
          };
        }
      }
      setSlide(slide) {
        this.slide = slide;
        this.hasSlide = true;
        this.instance = slide.pswp;
      }
      onLoaded() {
        this.state = LOAD_STATE.LOADED;
        if (this.slide && this.element) {
          this.instance.dispatch("loadComplete", {
            slide: this.slide,
            content: this
          });
          if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
            this.append();
            this.slide.updateContentSize(true);
          }
          if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
            this.removePlaceholder();
          }
        }
      }
      onError() {
        this.state = LOAD_STATE.ERROR;
        if (this.slide) {
          this.displayError();
          this.instance.dispatch("loadComplete", {
            slide: this.slide,
            isError: true,
            content: this
          });
          this.instance.dispatch("loadError", {
            slide: this.slide,
            content: this
          });
        }
      }
      isLoading() {
        return this.instance.applyFilters("isContentLoading", this.state === LOAD_STATE.LOADING, this);
      }
      isError() {
        return this.state === LOAD_STATE.ERROR;
      }
      isImageContent() {
        return this.type === "image";
      }
      setDisplayedSize(width, height) {
        if (!this.element) {
          return;
        }
        if (this.placeholder) {
          this.placeholder.setDisplayedSize(width, height);
        }
        if (this.instance.dispatch("contentResize", {
          content: this,
          width,
          height
        }).defaultPrevented) {
          return;
        }
        setWidthHeight(this.element, width, height);
        if (this.isImageContent() && !this.isError()) {
          const isInitialSizeUpdate = !this.displayedImageWidth && width;
          this.displayedImageWidth = width;
          this.displayedImageHeight = height;
          if (isInitialSizeUpdate) {
            this.loadImage(false);
          } else {
            this.updateSrcsetSizes();
          }
          if (this.slide) {
            this.instance.dispatch("imageSizeChange", {
              slide: this.slide,
              width,
              height,
              content: this
            });
          }
        }
      }
      isZoomable() {
        return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== LOAD_STATE.ERROR, this);
      }
      updateSrcsetSizes() {
        if (!this.isImageContent() || !this.element || !this.data.srcset) {
          return;
        }
        const image = this.element;
        const sizesWidth = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
        if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
          image.sizes = sizesWidth + "px";
          image.dataset.largestUsedSize = String(sizesWidth);
        }
      }
      usePlaceholder() {
        return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
      }
      lazyLoad() {
        if (this.instance.dispatch("contentLazyLoad", {
          content: this
        }).defaultPrevented) {
          return;
        }
        this.load(true);
      }
      keepPlaceholder() {
        return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
      }
      destroy() {
        this.hasSlide = false;
        this.slide = void 0;
        if (this.instance.dispatch("contentDestroy", {
          content: this
        }).defaultPrevented) {
          return;
        }
        this.remove();
        if (this.placeholder) {
          this.placeholder.destroy();
          this.placeholder = void 0;
        }
        if (this.isImageContent() && this.element) {
          this.element.onload = null;
          this.element.onerror = null;
          this.element = void 0;
        }
      }
      displayError() {
        if (this.slide) {
          var _this$instance$option, _this$instance$option2;
          let errorMsgEl = createElement("pswp__error-msg", "div");
          errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : "";
          errorMsgEl = this.instance.applyFilters("contentErrorElement", errorMsgEl, this);
          this.element = createElement("pswp__content pswp__error-msg-container", "div");
          this.element.appendChild(errorMsgEl);
          this.slide.container.innerText = "";
          this.slide.container.appendChild(this.element);
          this.slide.updateContentSize(true);
          this.removePlaceholder();
        }
      }
      append() {
        if (this.isAttached || !this.element) {
          return;
        }
        this.isAttached = true;
        if (this.state === LOAD_STATE.ERROR) {
          this.displayError();
          return;
        }
        if (this.instance.dispatch("contentAppend", {
          content: this
        }).defaultPrevented) {
          return;
        }
        const supportsDecode = "decode" in this.element;
        if (this.isImageContent()) {
          if (supportsDecode && this.slide && (!this.slide.isActive || isSafari())) {
            this.isDecoding = true;
            this.element.decode().catch(() => {
            }).finally(() => {
              this.isDecoding = false;
              this.appendImage();
            });
          } else {
            this.appendImage();
          }
        } else if (this.slide && !this.element.parentNode) {
          this.slide.container.appendChild(this.element);
        }
      }
      activate() {
        if (this.instance.dispatch("contentActivate", {
          content: this
        }).defaultPrevented || !this.slide) {
          return;
        }
        if (this.isImageContent() && this.isDecoding && !isSafari()) {
          this.appendImage();
        } else if (this.isError()) {
          this.load(false, true);
        }
        if (this.slide.holderElement) {
          this.slide.holderElement.setAttribute("aria-hidden", "false");
        }
      }
      deactivate() {
        this.instance.dispatch("contentDeactivate", {
          content: this
        });
        if (this.slide && this.slide.holderElement) {
          this.slide.holderElement.setAttribute("aria-hidden", "true");
        }
      }
      remove() {
        this.isAttached = false;
        if (this.instance.dispatch("contentRemove", {
          content: this
        }).defaultPrevented) {
          return;
        }
        if (this.element && this.element.parentNode) {
          this.element.remove();
        }
        if (this.placeholder && this.placeholder.element) {
          this.placeholder.element.remove();
        }
      }
      appendImage() {
        if (!this.isAttached) {
          return;
        }
        if (this.instance.dispatch("contentAppendImage", {
          content: this
        }).defaultPrevented) {
          return;
        }
        if (this.slide && this.element && !this.element.parentNode) {
          this.slide.container.appendChild(this.element);
        }
        if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
          this.removePlaceholder();
        }
      }
    };
    MIN_SLIDES_TO_CACHE = 5;
    ContentLoader = class {
      constructor(pswp) {
        this.pswp = pswp;
        this.limit = Math.max(pswp.options.preload[0] + pswp.options.preload[1] + 1, MIN_SLIDES_TO_CACHE);
        this._cachedItems = [];
      }
      updateLazy(diff) {
        const {
          pswp
        } = this;
        if (pswp.dispatch("lazyLoad").defaultPrevented) {
          return;
        }
        const {
          preload
        } = pswp.options;
        const isForward = diff === void 0 ? true : diff >= 0;
        let i;
        for (i = 0; i <= preload[1]; i++) {
          this.loadSlideByIndex(pswp.currIndex + (isForward ? i : -i));
        }
        for (i = 1; i <= preload[0]; i++) {
          this.loadSlideByIndex(pswp.currIndex + (isForward ? -i : i));
        }
      }
      loadSlideByIndex(initialIndex) {
        const index = this.pswp.getLoopedIndex(initialIndex);
        let content = this.getContentByIndex(index);
        if (!content) {
          content = lazyLoadSlide(index, this.pswp);
          if (content) {
            this.addToCache(content);
          }
        }
      }
      getContentBySlide(slide) {
        let content = this.getContentByIndex(slide.index);
        if (!content) {
          content = this.pswp.createContentFromData(slide.data, slide.index);
          this.addToCache(content);
        }
        content.setSlide(slide);
        return content;
      }
      addToCache(content) {
        this.removeByIndex(content.index);
        this._cachedItems.push(content);
        if (this._cachedItems.length > this.limit) {
          const indexToRemove = this._cachedItems.findIndex((item) => {
            return !item.isAttached && !item.hasSlide;
          });
          if (indexToRemove !== -1) {
            const removedItem = this._cachedItems.splice(indexToRemove, 1)[0];
            removedItem.destroy();
          }
        }
      }
      removeByIndex(index) {
        const indexToRemove = this._cachedItems.findIndex((item) => item.index === index);
        if (indexToRemove !== -1) {
          this._cachedItems.splice(indexToRemove, 1);
        }
      }
      getContentByIndex(index) {
        return this._cachedItems.find((content) => content.index === index);
      }
      destroy() {
        this._cachedItems.forEach((content) => content.destroy());
        this._cachedItems = [];
      }
    };
    PhotoSwipeBase = class extends Eventable {
      getNumItems() {
        var _this$options;
        let numItems = 0;
        const dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
        if (dataSource && "length" in dataSource) {
          numItems = dataSource.length;
        } else if (dataSource && "gallery" in dataSource) {
          if (!dataSource.items) {
            dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
          }
          if (dataSource.items) {
            numItems = dataSource.items.length;
          }
        }
        const event = this.dispatch("numItems", {
          dataSource,
          numItems
        });
        return this.applyFilters("numItems", event.numItems, dataSource);
      }
      createContentFromData(slideData, index) {
        return new Content(slideData, this, index);
      }
      getItemData(index) {
        var _this$options2;
        const dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
        let dataSourceItem = {};
        if (Array.isArray(dataSource)) {
          dataSourceItem = dataSource[index];
        } else if (dataSource && "gallery" in dataSource) {
          if (!dataSource.items) {
            dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
          }
          dataSourceItem = dataSource.items[index];
        }
        let itemData = dataSourceItem;
        if (itemData instanceof Element) {
          itemData = this._domElementToItemData(itemData);
        }
        const event = this.dispatch("itemData", {
          itemData: itemData || {},
          index
        });
        return this.applyFilters("itemData", event.itemData, index);
      }
      _getGalleryDOMElements(galleryElement) {
        var _this$options3, _this$options4;
        if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) {
          return getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
        }
        return [galleryElement];
      }
      _domElementToItemData(element) {
        const itemData = {
          element
        };
        const linkEl = element.tagName === "A" ? element : element.querySelector("a");
        if (linkEl) {
          itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
          if (linkEl.dataset.pswpSrcset) {
            itemData.srcset = linkEl.dataset.pswpSrcset;
          }
          itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
          itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0;
          itemData.w = itemData.width;
          itemData.h = itemData.height;
          if (linkEl.dataset.pswpType) {
            itemData.type = linkEl.dataset.pswpType;
          }
          const thumbnailEl = element.querySelector("img");
          if (thumbnailEl) {
            var _thumbnailEl$getAttri;
            itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
            itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute("alt")) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : "";
          }
          if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) {
            itemData.thumbCropped = true;
          }
        }
        return this.applyFilters("domItemData", itemData, element, linkEl);
      }
      lazyLoadData(itemData, index) {
        return lazyLoadData(itemData, this, index);
      }
    };
    MIN_OPACITY = 3e-3;
    Opener = class {
      constructor(pswp) {
        this.pswp = pswp;
        this.isClosed = true;
        this.isOpen = false;
        this.isClosing = false;
        this.isOpening = false;
        this._duration = void 0;
        this._useAnimation = false;
        this._croppedZoom = false;
        this._animateRootOpacity = false;
        this._animateBgOpacity = false;
        this._placeholder = void 0;
        this._opacityElement = void 0;
        this._cropContainer1 = void 0;
        this._cropContainer2 = void 0;
        this._thumbBounds = void 0;
        this._prepareOpen = this._prepareOpen.bind(this);
        pswp.on("firstZoomPan", this._prepareOpen);
      }
      open() {
        this._prepareOpen();
        this._start();
      }
      close() {
        if (this.isClosed || this.isClosing || this.isOpening) {
          return;
        }
        const slide = this.pswp.currSlide;
        this.isOpen = false;
        this.isOpening = false;
        this.isClosing = true;
        this._duration = this.pswp.options.hideAnimationDuration;
        if (slide && slide.currZoomLevel * slide.width >= this.pswp.options.maxWidthToAnimate) {
          this._duration = 0;
        }
        this._applyStartProps();
        setTimeout(() => {
          this._start();
        }, this._croppedZoom ? 30 : 0);
      }
      _prepareOpen() {
        this.pswp.off("firstZoomPan", this._prepareOpen);
        if (!this.isOpening) {
          const slide = this.pswp.currSlide;
          this.isOpening = true;
          this.isClosing = false;
          this._duration = this.pswp.options.showAnimationDuration;
          if (slide && slide.zoomLevels.initial * slide.width >= this.pswp.options.maxWidthToAnimate) {
            this._duration = 0;
          }
          this._applyStartProps();
        }
      }
      _applyStartProps() {
        const {
          pswp
        } = this;
        const slide = this.pswp.currSlide;
        const {
          options
        } = pswp;
        if (options.showHideAnimationType === "fade") {
          options.showHideOpacity = true;
          this._thumbBounds = void 0;
        } else if (options.showHideAnimationType === "none") {
          options.showHideOpacity = false;
          this._duration = 0;
          this._thumbBounds = void 0;
        } else if (this.isOpening && pswp._initialThumbBounds) {
          this._thumbBounds = pswp._initialThumbBounds;
        } else {
          this._thumbBounds = this.pswp.getThumbBounds();
        }
        this._placeholder = slide === null || slide === void 0 ? void 0 : slide.getPlaceholderElement();
        pswp.animations.stopAll();
        this._useAnimation = Boolean(this._duration && this._duration > 50);
        this._animateZoom = Boolean(this._thumbBounds) && (slide === null || slide === void 0 ? void 0 : slide.content.usePlaceholder()) && (!this.isClosing || !pswp.mainScroll.isShifted());
        if (!this._animateZoom) {
          this._animateRootOpacity = true;
          if (this.isOpening && slide) {
            slide.zoomAndPanToInitial();
            slide.applyCurrentZoomPan();
          }
        } else {
          var _options$showHideOpac;
          this._animateRootOpacity = (_options$showHideOpac = options.showHideOpacity) !== null && _options$showHideOpac !== void 0 ? _options$showHideOpac : false;
        }
        this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > MIN_OPACITY;
        this._opacityElement = this._animateRootOpacity ? pswp.element : pswp.bg;
        if (!this._useAnimation) {
          this._duration = 0;
          this._animateZoom = false;
          this._animateBgOpacity = false;
          this._animateRootOpacity = true;
          if (this.isOpening) {
            if (pswp.element) {
              pswp.element.style.opacity = String(MIN_OPACITY);
            }
            pswp.applyBgOpacity(1);
          }
          return;
        }
        if (this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect) {
          var _this$pswp$currSlide;
          this._croppedZoom = true;
          this._cropContainer1 = this.pswp.container;
          this._cropContainer2 = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.holderElement;
          if (pswp.container) {
            pswp.container.style.overflow = "hidden";
            pswp.container.style.width = pswp.viewportSize.x + "px";
          }
        } else {
          this._croppedZoom = false;
        }
        if (this.isOpening) {
          if (this._animateRootOpacity) {
            if (pswp.element) {
              pswp.element.style.opacity = String(MIN_OPACITY);
            }
            pswp.applyBgOpacity(1);
          } else {
            if (this._animateBgOpacity && pswp.bg) {
              pswp.bg.style.opacity = String(MIN_OPACITY);
            }
            if (pswp.element) {
              pswp.element.style.opacity = "1";
            }
          }
          if (this._animateZoom) {
            this._setClosedStateZoomPan();
            if (this._placeholder) {
              this._placeholder.style.willChange = "transform";
              this._placeholder.style.opacity = String(MIN_OPACITY);
            }
          }
        } else if (this.isClosing) {
          if (pswp.mainScroll.itemHolders[0]) {
            pswp.mainScroll.itemHolders[0].el.style.display = "none";
          }
          if (pswp.mainScroll.itemHolders[2]) {
            pswp.mainScroll.itemHolders[2].el.style.display = "none";
          }
          if (this._croppedZoom) {
            if (pswp.mainScroll.x !== 0) {
              pswp.mainScroll.resetPosition();
              pswp.mainScroll.resize();
            }
          }
        }
      }
      _start() {
        if (this.isOpening && this._useAnimation && this._placeholder && this._placeholder.tagName === "IMG") {
          new Promise((resolve) => {
            let decoded = false;
            let isDelaying = true;
            decodeImage(
              this._placeholder
            ).finally(() => {
              decoded = true;
              if (!isDelaying) {
                resolve(true);
              }
            });
            setTimeout(() => {
              isDelaying = false;
              if (decoded) {
                resolve(true);
              }
            }, 50);
            setTimeout(resolve, 250);
          }).finally(() => this._initiate());
        } else {
          this._initiate();
        }
      }
      _initiate() {
        var _this$pswp$element, _this$pswp$element2;
        (_this$pswp$element = this.pswp.element) === null || _this$pswp$element === void 0 || _this$pswp$element.style.setProperty("--pswp-transition-duration", this._duration + "ms");
        this.pswp.dispatch(this.isOpening ? "openingAnimationStart" : "closingAnimationStart");
        this.pswp.dispatch(
          "initialZoom" + (this.isOpening ? "In" : "Out")
        );
        (_this$pswp$element2 = this.pswp.element) === null || _this$pswp$element2 === void 0 || _this$pswp$element2.classList.toggle("pswp--ui-visible", this.isOpening);
        if (this.isOpening) {
          if (this._placeholder) {
            this._placeholder.style.opacity = "1";
          }
          this._animateToOpenState();
        } else if (this.isClosing) {
          this._animateToClosedState();
        }
        if (!this._useAnimation) {
          this._onAnimationComplete();
        }
      }
      _onAnimationComplete() {
        const {
          pswp
        } = this;
        this.isOpen = this.isOpening;
        this.isClosed = this.isClosing;
        this.isOpening = false;
        this.isClosing = false;
        pswp.dispatch(this.isOpen ? "openingAnimationEnd" : "closingAnimationEnd");
        pswp.dispatch(
          "initialZoom" + (this.isOpen ? "InEnd" : "OutEnd")
        );
        if (this.isClosed) {
          pswp.destroy();
        } else if (this.isOpen) {
          var _pswp$currSlide;
          if (this._animateZoom && pswp.container) {
            pswp.container.style.overflow = "visible";
            pswp.container.style.width = "100%";
          }
          (_pswp$currSlide = pswp.currSlide) === null || _pswp$currSlide === void 0 || _pswp$currSlide.applyCurrentZoomPan();
        }
      }
      _animateToOpenState() {
        const {
          pswp
        } = this;
        if (this._animateZoom) {
          if (this._croppedZoom && this._cropContainer1 && this._cropContainer2) {
            this._animateTo(this._cropContainer1, "transform", "translate3d(0,0,0)");
            this._animateTo(this._cropContainer2, "transform", "none");
          }
          if (pswp.currSlide) {
            pswp.currSlide.zoomAndPanToInitial();
            this._animateTo(pswp.currSlide.container, "transform", pswp.currSlide.getCurrentTransform());
          }
        }
        if (this._animateBgOpacity && pswp.bg) {
          this._animateTo(pswp.bg, "opacity", String(pswp.options.bgOpacity));
        }
        if (this._animateRootOpacity && pswp.element) {
          this._animateTo(pswp.element, "opacity", "1");
        }
      }
      _animateToClosedState() {
        const {
          pswp
        } = this;
        if (this._animateZoom) {
          this._setClosedStateZoomPan(true);
        }
        if (this._animateBgOpacity && pswp.bgOpacity > 0.01 && pswp.bg) {
          this._animateTo(pswp.bg, "opacity", "0");
        }
        if (this._animateRootOpacity && pswp.element) {
          this._animateTo(pswp.element, "opacity", "0");
        }
      }
      _setClosedStateZoomPan(animate18) {
        if (!this._thumbBounds)
          return;
        const {
          pswp
        } = this;
        const {
          innerRect
        } = this._thumbBounds;
        const {
          currSlide,
          viewportSize
        } = pswp;
        if (this._croppedZoom && innerRect && this._cropContainer1 && this._cropContainer2) {
          const containerOnePanX = -viewportSize.x + (this._thumbBounds.x - innerRect.x) + innerRect.w;
          const containerOnePanY = -viewportSize.y + (this._thumbBounds.y - innerRect.y) + innerRect.h;
          const containerTwoPanX = viewportSize.x - innerRect.w;
          const containerTwoPanY = viewportSize.y - innerRect.h;
          if (animate18) {
            this._animateTo(this._cropContainer1, "transform", toTransformString(containerOnePanX, containerOnePanY));
            this._animateTo(this._cropContainer2, "transform", toTransformString(containerTwoPanX, containerTwoPanY));
          } else {
            setTransform(this._cropContainer1, containerOnePanX, containerOnePanY);
            setTransform(this._cropContainer2, containerTwoPanX, containerTwoPanY);
          }
        }
        if (currSlide) {
          equalizePoints(currSlide.pan, innerRect || this._thumbBounds);
          currSlide.currZoomLevel = this._thumbBounds.w / currSlide.width;
          if (animate18) {
            this._animateTo(currSlide.container, "transform", currSlide.getCurrentTransform());
          } else {
            currSlide.applyCurrentZoomPan();
          }
        }
      }
      _animateTo(target, prop, propValue) {
        if (!this._duration) {
          target.style[prop] = propValue;
          return;
        }
        const {
          animations
        } = this.pswp;
        const animProps = {
          duration: this._duration,
          easing: this.pswp.options.easing,
          onComplete: () => {
            if (!animations.activeAnimations.length) {
              this._onAnimationComplete();
            }
          },
          target
        };
        animProps[prop] = propValue;
        animations.startTransition(animProps);
      }
    };
    defaultOptions = {
      allowPanToNext: true,
      spacing: 0.1,
      loop: true,
      pinchToClose: true,
      closeOnVerticalDrag: true,
      hideAnimationDuration: 333,
      showAnimationDuration: 333,
      zoomAnimationDuration: 333,
      escKey: true,
      arrowKeys: true,
      trapFocus: true,
      returnFocus: true,
      maxWidthToAnimate: 4e3,
      clickToCloseNonZoomable: true,
      imageClickAction: "zoom-or-close",
      bgClickAction: "close",
      tapAction: "toggle-controls",
      doubleTapAction: "zoom",
      indexIndicatorSep: " / ",
      preloaderDelay: 2e3,
      bgOpacity: 0.8,
      index: 0,
      errorMsg: "The image cannot be loaded",
      preload: [1, 2],
      easing: "cubic-bezier(.4,0,.22,1)"
    };
    PhotoSwipe = class extends PhotoSwipeBase {
      constructor(options) {
        super();
        this.options = this._prepareOptions(options || {});
        this.offset = {
          x: 0,
          y: 0
        };
        this._prevViewportSize = {
          x: 0,
          y: 0
        };
        this.viewportSize = {
          x: 0,
          y: 0
        };
        this.bgOpacity = 1;
        this.currIndex = 0;
        this.potentialIndex = 0;
        this.isOpen = false;
        this.isDestroying = false;
        this.hasMouse = false;
        this._initialItemData = {};
        this._initialThumbBounds = void 0;
        this.topBar = void 0;
        this.element = void 0;
        this.template = void 0;
        this.container = void 0;
        this.scrollWrap = void 0;
        this.currSlide = void 0;
        this.events = new DOMEvents();
        this.animations = new Animations();
        this.mainScroll = new MainScroll(this);
        this.gestures = new Gestures(this);
        this.opener = new Opener(this);
        this.keyboard = new Keyboard2(this);
        this.contentLoader = new ContentLoader(this);
      }
      init() {
        if (this.isOpen || this.isDestroying) {
          return false;
        }
        this.isOpen = true;
        this.dispatch("init");
        this.dispatch("beforeOpen");
        this._createMainStructure();
        let rootClasses = "pswp--open";
        if (this.gestures.supportsTouch) {
          rootClasses += " pswp--touch";
        }
        if (this.options.mainClass) {
          rootClasses += " " + this.options.mainClass;
        }
        if (this.element) {
          this.element.className += " " + rootClasses;
        }
        this.currIndex = this.options.index || 0;
        this.potentialIndex = this.currIndex;
        this.dispatch("firstUpdate");
        this.scrollWheel = new ScrollWheel(this);
        if (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems()) {
          this.currIndex = 0;
        }
        if (!this.gestures.supportsTouch) {
          this.mouseDetected();
        }
        this.updateSize();
        this.offset.y = window.pageYOffset;
        this._initialItemData = this.getItemData(this.currIndex);
        this.dispatch("gettingData", {
          index: this.currIndex,
          data: this._initialItemData,
          slide: void 0
        });
        this._initialThumbBounds = this.getThumbBounds();
        this.dispatch("initialLayout");
        this.on("openingAnimationEnd", () => {
          const {
            itemHolders
          } = this.mainScroll;
          if (itemHolders[0]) {
            itemHolders[0].el.style.display = "block";
            this.setContent(itemHolders[0], this.currIndex - 1);
          }
          if (itemHolders[2]) {
            itemHolders[2].el.style.display = "block";
            this.setContent(itemHolders[2], this.currIndex + 1);
          }
          this.appendHeavy();
          this.contentLoader.updateLazy();
          this.events.add(window, "resize", this._handlePageResize.bind(this));
          this.events.add(window, "scroll", this._updatePageScrollOffset.bind(this));
          this.dispatch("bindEvents");
        });
        if (this.mainScroll.itemHolders[1]) {
          this.setContent(this.mainScroll.itemHolders[1], this.currIndex);
        }
        this.dispatch("change");
        this.opener.open();
        this.dispatch("afterInit");
        return true;
      }
      getLoopedIndex(index) {
        const numSlides = this.getNumItems();
        if (this.options.loop) {
          if (index > numSlides - 1) {
            index -= numSlides;
          }
          if (index < 0) {
            index += numSlides;
          }
        }
        return clamp2(index, 0, numSlides - 1);
      }
      appendHeavy() {
        this.mainScroll.itemHolders.forEach((itemHolder) => {
          var _itemHolder$slide;
          (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.appendHeavy();
        });
      }
      goTo(index) {
        this.mainScroll.moveIndexBy(this.getLoopedIndex(index) - this.potentialIndex);
      }
      next() {
        this.goTo(this.potentialIndex + 1);
      }
      prev() {
        this.goTo(this.potentialIndex - 1);
      }
      zoomTo(...args) {
        var _this$currSlide;
        (_this$currSlide = this.currSlide) === null || _this$currSlide === void 0 || _this$currSlide.zoomTo(...args);
      }
      toggleZoom() {
        var _this$currSlide2;
        (_this$currSlide2 = this.currSlide) === null || _this$currSlide2 === void 0 || _this$currSlide2.toggleZoom();
      }
      close() {
        if (!this.opener.isOpen || this.isDestroying) {
          return;
        }
        this.isDestroying = true;
        this.dispatch("close");
        this.events.removeAll();
        this.opener.close();
      }
      destroy() {
        var _this$element;
        if (!this.isDestroying) {
          this.options.showHideAnimationType = "none";
          this.close();
          return;
        }
        this.dispatch("destroy");
        this._listeners = {};
        if (this.scrollWrap) {
          this.scrollWrap.ontouchmove = null;
          this.scrollWrap.ontouchend = null;
        }
        (_this$element = this.element) === null || _this$element === void 0 || _this$element.remove();
        this.mainScroll.itemHolders.forEach((itemHolder) => {
          var _itemHolder$slide2;
          (_itemHolder$slide2 = itemHolder.slide) === null || _itemHolder$slide2 === void 0 || _itemHolder$slide2.destroy();
        });
        this.contentLoader.destroy();
        this.events.removeAll();
      }
      refreshSlideContent(slideIndex) {
        this.contentLoader.removeByIndex(slideIndex);
        this.mainScroll.itemHolders.forEach((itemHolder, i) => {
          var _this$currSlide$index, _this$currSlide3;
          let potentialHolderIndex = ((_this$currSlide$index = (_this$currSlide3 = this.currSlide) === null || _this$currSlide3 === void 0 ? void 0 : _this$currSlide3.index) !== null && _this$currSlide$index !== void 0 ? _this$currSlide$index : 0) - 1 + i;
          if (this.canLoop()) {
            potentialHolderIndex = this.getLoopedIndex(potentialHolderIndex);
          }
          if (potentialHolderIndex === slideIndex) {
            this.setContent(itemHolder, slideIndex, true);
            if (i === 1) {
              var _itemHolder$slide3;
              this.currSlide = itemHolder.slide;
              (_itemHolder$slide3 = itemHolder.slide) === null || _itemHolder$slide3 === void 0 || _itemHolder$slide3.setIsActive(true);
            }
          }
        });
        this.dispatch("change");
      }
      setContent(holder, index, force) {
        if (this.canLoop()) {
          index = this.getLoopedIndex(index);
        }
        if (holder.slide) {
          if (holder.slide.index === index && !force) {
            return;
          }
          holder.slide.destroy();
          holder.slide = void 0;
        }
        if (!this.canLoop() && (index < 0 || index >= this.getNumItems())) {
          return;
        }
        const itemData = this.getItemData(index);
        holder.slide = new Slide2(itemData, index, this);
        if (index === this.currIndex) {
          this.currSlide = holder.slide;
        }
        holder.slide.append(holder.el);
      }
      getViewportCenterPoint() {
        return {
          x: this.viewportSize.x / 2,
          y: this.viewportSize.y / 2
        };
      }
      updateSize(force) {
        if (this.isDestroying) {
          return;
        }
        const newViewportSize = getViewportSize(this.options, this);
        if (!force && pointsEqual(newViewportSize, this._prevViewportSize)) {
          return;
        }
        equalizePoints(this._prevViewportSize, newViewportSize);
        this.dispatch("beforeResize");
        equalizePoints(this.viewportSize, this._prevViewportSize);
        this._updatePageScrollOffset();
        this.dispatch("viewportSize");
        this.mainScroll.resize(this.opener.isOpen);
        if (!this.hasMouse && window.matchMedia("(any-hover: hover)").matches) {
          this.mouseDetected();
        }
        this.dispatch("resize");
      }
      applyBgOpacity(opacity) {
        this.bgOpacity = Math.max(opacity, 0);
        if (this.bg) {
          this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity);
        }
      }
      mouseDetected() {
        if (!this.hasMouse) {
          var _this$element2;
          this.hasMouse = true;
          (_this$element2 = this.element) === null || _this$element2 === void 0 || _this$element2.classList.add("pswp--has_mouse");
        }
      }
      _handlePageResize() {
        this.updateSize();
        if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
          setTimeout(() => {
            this.updateSize();
          }, 500);
        }
      }
      _updatePageScrollOffset() {
        this.setScrollOffset(0, window.pageYOffset);
      }
      setScrollOffset(x, y) {
        this.offset.x = x;
        this.offset.y = y;
        this.dispatch("updateScrollOffset");
      }
      _createMainStructure() {
        this.element = createElement("pswp", "div");
        this.element.setAttribute("tabindex", "-1");
        this.element.setAttribute("role", "dialog");
        this.template = this.element;
        this.bg = createElement("pswp__bg", "div", this.element);
        this.scrollWrap = createElement("pswp__scroll-wrap", "section", this.element);
        this.container = createElement("pswp__container", "div", this.scrollWrap);
        this.scrollWrap.setAttribute("aria-roledescription", "carousel");
        this.container.setAttribute("aria-live", "off");
        this.container.setAttribute("id", "pswp__items");
        this.mainScroll.appendHolders();
        this.ui = new UI(this);
        this.ui.init();
        (this.options.appendToEl || document.body).appendChild(this.element);
      }
      getThumbBounds() {
        return getThumbBounds(this.currIndex, this.currSlide ? this.currSlide.data : this._initialItemData, this);
      }
      canLoop() {
        return this.options.loop && this.getNumItems() > 2;
      }
      _prepareOptions(options) {
        if (window.matchMedia("(prefers-reduced-motion), (update: slow)").matches) {
          options.showHideAnimationType = "none";
          options.zoomAnimationDuration = 0;
        }
        return {
          ...defaultOptions,
          ...options
        };
      }
    };
  }
});

// node_modules/algoliasearch/dist/algoliasearch.umd.js
var require_algoliasearch_umd = __commonJS({
  "node_modules/algoliasearch/dist/algoliasearch.umd.js"(exports, module) {
    !function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = t || self).algoliasearch = e();
    }(exports, function() {
      "use strict";
      function t(t2, e2, r2) {
        return e2 in t2 ? Object.defineProperty(t2, e2, { value: r2, enumerable: true, configurable: true, writable: true }) : t2[e2] = r2, t2;
      }
      function e(t2, e2) {
        var r2 = Object.keys(t2);
        if (Object.getOwnPropertySymbols) {
          var n2 = Object.getOwnPropertySymbols(t2);
          e2 && (n2 = n2.filter(function(e3) {
            return Object.getOwnPropertyDescriptor(t2, e3).enumerable;
          })), r2.push.apply(r2, n2);
        }
        return r2;
      }
      function r(r2) {
        for (var n2 = 1; n2 < arguments.length; n2++) {
          var a2 = null != arguments[n2] ? arguments[n2] : {};
          n2 % 2 ? e(Object(a2), true).forEach(function(e2) {
            t(r2, e2, a2[e2]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r2, Object.getOwnPropertyDescriptors(a2)) : e(Object(a2)).forEach(function(t2) {
            Object.defineProperty(r2, t2, Object.getOwnPropertyDescriptor(a2, t2));
          });
        }
        return r2;
      }
      function n(t2, e2) {
        if (null == t2)
          return {};
        var r2, n2, a2 = function(t3, e3) {
          if (null == t3)
            return {};
          var r3, n3, a3 = {}, o3 = Object.keys(t3);
          for (n3 = 0; n3 < o3.length; n3++)
            r3 = o3[n3], e3.indexOf(r3) >= 0 || (a3[r3] = t3[r3]);
          return a3;
        }(t2, e2);
        if (Object.getOwnPropertySymbols) {
          var o2 = Object.getOwnPropertySymbols(t2);
          for (n2 = 0; n2 < o2.length; n2++)
            r2 = o2[n2], e2.indexOf(r2) >= 0 || Object.prototype.propertyIsEnumerable.call(t2, r2) && (a2[r2] = t2[r2]);
        }
        return a2;
      }
      function a(t2, e2) {
        return function(t3) {
          if (Array.isArray(t3))
            return t3;
        }(t2) || function(t3, e3) {
          if (!(Symbol.iterator in Object(t3) || "[object Arguments]" === Object.prototype.toString.call(t3)))
            return;
          var r2 = [], n2 = true, a2 = false, o2 = void 0;
          try {
            for (var i2, u2 = t3[Symbol.iterator](); !(n2 = (i2 = u2.next()).done) && (r2.push(i2.value), !e3 || r2.length !== e3); n2 = true)
              ;
          } catch (t4) {
            a2 = true, o2 = t4;
          } finally {
            try {
              n2 || null == u2.return || u2.return();
            } finally {
              if (a2)
                throw o2;
            }
          }
          return r2;
        }(t2, e2) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      function o(t2) {
        return function(t3) {
          if (Array.isArray(t3)) {
            for (var e2 = 0, r2 = new Array(t3.length); e2 < t3.length; e2++)
              r2[e2] = t3[e2];
            return r2;
          }
        }(t2) || function(t3) {
          if (Symbol.iterator in Object(t3) || "[object Arguments]" === Object.prototype.toString.call(t3))
            return Array.from(t3);
        }(t2) || function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }
      function i(t2) {
        var e2, r2 = "algoliasearch-client-js-".concat(t2.key), n2 = function() {
          return void 0 === e2 && (e2 = t2.localStorage || window.localStorage), e2;
        }, o2 = function() {
          return JSON.parse(n2().getItem(r2) || "{}");
        }, i2 = function(t3) {
          n2().setItem(r2, JSON.stringify(t3));
        }, u2 = function() {
          var e3 = t2.timeToLive ? 1e3 * t2.timeToLive : null, r3 = o2(), n3 = Object.fromEntries(Object.entries(r3).filter(function(t3) {
            return void 0 !== a(t3, 2)[1].timestamp;
          }));
          if (i2(n3), e3) {
            var u3 = Object.fromEntries(Object.entries(n3).filter(function(t3) {
              var r4 = a(t3, 2)[1], n4 = new Date().getTime();
              return !(r4.timestamp + e3 < n4);
            }));
            i2(u3);
          }
        };
        return { get: function(t3, e3) {
          var r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } };
          return Promise.resolve().then(function() {
            u2();
            var e4 = JSON.stringify(t3);
            return o2()[e4];
          }).then(function(t4) {
            return Promise.all([t4 ? t4.value : e3(), void 0 !== t4]);
          }).then(function(t4) {
            var e4 = a(t4, 2), n3 = e4[0], o3 = e4[1];
            return Promise.all([n3, o3 || r3.miss(n3)]);
          }).then(function(t4) {
            return a(t4, 1)[0];
          });
        }, set: function(t3, e3) {
          return Promise.resolve().then(function() {
            var a2 = o2();
            return a2[JSON.stringify(t3)] = { timestamp: new Date().getTime(), value: e3 }, n2().setItem(r2, JSON.stringify(a2)), e3;
          });
        }, delete: function(t3) {
          return Promise.resolve().then(function() {
            var e3 = o2();
            delete e3[JSON.stringify(t3)], n2().setItem(r2, JSON.stringify(e3));
          });
        }, clear: function() {
          return Promise.resolve().then(function() {
            n2().removeItem(r2);
          });
        } };
      }
      function u(t2) {
        var e2 = o(t2.caches), r2 = e2.shift();
        return void 0 === r2 ? { get: function(t3, e3) {
          var r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } }, n2 = e3();
          return n2.then(function(t4) {
            return Promise.all([t4, r3.miss(t4)]);
          }).then(function(t4) {
            return a(t4, 1)[0];
          });
        }, set: function(t3, e3) {
          return Promise.resolve(e3);
        }, delete: function(t3) {
          return Promise.resolve();
        }, clear: function() {
          return Promise.resolve();
        } } : { get: function(t3, n2) {
          var a2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } };
          return r2.get(t3, n2, a2).catch(function() {
            return u({ caches: e2 }).get(t3, n2, a2);
          });
        }, set: function(t3, n2) {
          return r2.set(t3, n2).catch(function() {
            return u({ caches: e2 }).set(t3, n2);
          });
        }, delete: function(t3) {
          return r2.delete(t3).catch(function() {
            return u({ caches: e2 }).delete(t3);
          });
        }, clear: function() {
          return r2.clear().catch(function() {
            return u({ caches: e2 }).clear();
          });
        } };
      }
      function s() {
        var t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : { serializable: true }, e2 = {};
        return { get: function(r2, n2) {
          var a2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } }, o2 = JSON.stringify(r2);
          if (o2 in e2)
            return Promise.resolve(t2.serializable ? JSON.parse(e2[o2]) : e2[o2]);
          var i2 = n2(), u2 = a2 && a2.miss || function() {
            return Promise.resolve();
          };
          return i2.then(function(t3) {
            return u2(t3);
          }).then(function() {
            return i2;
          });
        }, set: function(r2, n2) {
          return e2[JSON.stringify(r2)] = t2.serializable ? JSON.stringify(n2) : n2, Promise.resolve(n2);
        }, delete: function(t3) {
          return delete e2[JSON.stringify(t3)], Promise.resolve();
        }, clear: function() {
          return e2 = {}, Promise.resolve();
        } };
      }
      function c(t2, e2, r2) {
        var n2 = { "x-algolia-api-key": r2, "x-algolia-application-id": e2 };
        return { headers: function() {
          return t2 === m.WithinHeaders ? n2 : {};
        }, queryParameters: function() {
          return t2 === m.WithinQueryParameters ? n2 : {};
        } };
      }
      function f(t2) {
        var e2 = 0;
        return t2(function r2() {
          return e2++, new Promise(function(n2) {
            setTimeout(function() {
              n2(t2(r2));
            }, Math.min(100 * e2, 1e3));
          });
        });
      }
      function d(t2) {
        var e2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function(t3, e3) {
          return Promise.resolve();
        };
        return Object.assign(t2, { wait: function(r2) {
          return d(t2.then(function(t3) {
            return Promise.all([e2(t3, r2), t3]);
          }).then(function(t3) {
            return t3[1];
          }));
        } });
      }
      function l(t2) {
        for (var e2 = t2.length - 1; e2 > 0; e2--) {
          var r2 = Math.floor(Math.random() * (e2 + 1)), n2 = t2[e2];
          t2[e2] = t2[r2], t2[r2] = n2;
        }
        return t2;
      }
      function h(t2, e2) {
        return e2 ? (Object.keys(e2).forEach(function(r2) {
          t2[r2] = e2[r2](t2);
        }), t2) : t2;
      }
      function p(t2) {
        for (var e2 = arguments.length, r2 = new Array(e2 > 1 ? e2 - 1 : 0), n2 = 1; n2 < e2; n2++)
          r2[n2 - 1] = arguments[n2];
        var a2 = 0;
        return t2.replace(/%s/g, function() {
          return encodeURIComponent(r2[a2++]);
        });
      }
      var m = { WithinQueryParameters: 0, WithinHeaders: 1 };
      function y(t2, e2) {
        var r2 = t2 || {}, n2 = r2.data || {};
        return Object.keys(r2).forEach(function(t3) {
          -1 === ["timeout", "headers", "queryParameters", "data", "cacheable"].indexOf(t3) && (n2[t3] = r2[t3]);
        }), { data: Object.entries(n2).length > 0 ? n2 : void 0, timeout: r2.timeout || e2, headers: r2.headers || {}, queryParameters: r2.queryParameters || {}, cacheable: r2.cacheable };
      }
      var g = { Read: 1, Write: 2, Any: 3 }, v = 1, b = 2, P = 3;
      function O(t2) {
        var e2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : v;
        return r(r({}, t2), {}, { status: e2, lastUpdate: Date.now() });
      }
      function w(t2) {
        return "string" == typeof t2 ? { protocol: "https", url: t2, accept: g.Any } : { protocol: t2.protocol || "https", url: t2.url, accept: t2.accept || g.Any };
      }
      var I = "DELETE", x = "GET", j = "POST", D = "PUT";
      function q(t2, e2) {
        return Promise.all(e2.map(function(e3) {
          return t2.get(e3, function() {
            return Promise.resolve(O(e3));
          });
        })).then(function(t3) {
          var r2 = t3.filter(function(t4) {
            return function(t5) {
              return t5.status === v || Date.now() - t5.lastUpdate > 12e4;
            }(t4);
          }), n2 = t3.filter(function(t4) {
            return function(t5) {
              return t5.status === P && Date.now() - t5.lastUpdate <= 12e4;
            }(t4);
          }), a2 = [].concat(o(r2), o(n2));
          return { getTimeout: function(t4, e3) {
            return (0 === n2.length && 0 === t4 ? 1 : n2.length + 3 + t4) * e3;
          }, statelessHosts: a2.length > 0 ? a2.map(function(t4) {
            return w(t4);
          }) : e2 };
        });
      }
      function S(t2, e2, n2, a2) {
        var i2 = [], u2 = function(t3, e3) {
          if (t3.method === x || void 0 === t3.data && void 0 === e3.data)
            return;
          var n3 = Array.isArray(t3.data) ? t3.data : r(r({}, t3.data), e3.data);
          return JSON.stringify(n3);
        }(n2, a2), s2 = function(t3, e3) {
          var n3 = r(r({}, t3.headers), e3.headers), a3 = {};
          return Object.keys(n3).forEach(function(t4) {
            var e4 = n3[t4];
            a3[t4.toLowerCase()] = e4;
          }), a3;
        }(t2, a2), c2 = n2.method, f2 = n2.method !== x ? {} : r(r({}, n2.data), a2.data), d2 = r(r(r({ "x-algolia-agent": t2.userAgent.value }, t2.queryParameters), f2), a2.queryParameters), l2 = 0, h2 = function e3(r2, o2) {
          var f3 = r2.pop();
          if (void 0 === f3)
            throw { name: "RetryError", message: "Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support .", transporterStackTrace: E(i2) };
          var h3 = { data: u2, headers: s2, method: c2, url: N(f3, n2.path, d2), connectTimeout: o2(l2, t2.timeouts.connect), responseTimeout: o2(l2, a2.timeout) }, p2 = function(t3) {
            var e4 = { request: h3, response: t3, host: f3, triesLeft: r2.length };
            return i2.push(e4), e4;
          }, m2 = { onSuccess: function(t3) {
            return function(t4) {
              try {
                return JSON.parse(t4.content);
              } catch (e4) {
                throw function(t5, e5) {
                  return { name: "DeserializationError", message: t5, response: e5 };
                }(e4.message, t4);
              }
            }(t3);
          }, onRetry: function(n3) {
            var a3 = p2(n3);
            return n3.isTimedOut && l2++, Promise.all([t2.logger.info("Retryable failure", A(a3)), t2.hostsCache.set(f3, O(f3, n3.isTimedOut ? P : b))]).then(function() {
              return e3(r2, o2);
            });
          }, onFail: function(t3) {
            throw p2(t3), function(t4, e4) {
              var r3 = t4.content, n3 = t4.status, a3 = r3;
              try {
                a3 = JSON.parse(r3).message;
              } catch (t5) {
              }
              return function(t5, e5, r4) {
                return { name: "ApiError", message: t5, status: e5, transporterStackTrace: r4 };
              }(a3, n3, e4);
            }(t3, E(i2));
          } };
          return t2.requester.send(h3).then(function(t3) {
            return function(t4, e4) {
              return function(t5) {
                var e5 = t5.status;
                return t5.isTimedOut || function(t6) {
                  var e6 = t6.isTimedOut, r3 = t6.status;
                  return !e6 && 0 == ~~r3;
                }(t5) || 2 != ~~(e5 / 100) && 4 != ~~(e5 / 100);
              }(t4) ? e4.onRetry(t4) : 2 == ~~(t4.status / 100) ? e4.onSuccess(t4) : e4.onFail(t4);
            }(t3, m2);
          });
        };
        return q(t2.hostsCache, e2).then(function(t3) {
          return h2(o(t3.statelessHosts).reverse(), t3.getTimeout);
        });
      }
      function k(t2) {
        var e2 = t2.hostsCache, r2 = t2.logger, n2 = t2.requester, o2 = t2.requestsCache, i2 = t2.responsesCache, u2 = t2.timeouts, s2 = t2.userAgent, c2 = t2.hosts, f2 = t2.queryParameters, d2 = { hostsCache: e2, logger: r2, requester: n2, requestsCache: o2, responsesCache: i2, timeouts: u2, userAgent: s2, headers: t2.headers, queryParameters: f2, hosts: c2.map(function(t3) {
          return w(t3);
        }), read: function(t3, e3) {
          var r3 = y(e3, d2.timeouts.read), n3 = function() {
            return S(d2, d2.hosts.filter(function(t4) {
              return 0 != (t4.accept & g.Read);
            }), t3, r3);
          };
          if (true !== (void 0 !== r3.cacheable ? r3.cacheable : t3.cacheable))
            return n3();
          var o3 = { request: t3, mappedRequestOptions: r3, transporter: { queryParameters: d2.queryParameters, headers: d2.headers } };
          return d2.responsesCache.get(o3, function() {
            return d2.requestsCache.get(o3, function() {
              return d2.requestsCache.set(o3, n3()).then(function(t4) {
                return Promise.all([d2.requestsCache.delete(o3), t4]);
              }, function(t4) {
                return Promise.all([d2.requestsCache.delete(o3), Promise.reject(t4)]);
              }).then(function(t4) {
                var e4 = a(t4, 2);
                e4[0];
                return e4[1];
              });
            });
          }, { miss: function(t4) {
            return d2.responsesCache.set(o3, t4);
          } });
        }, write: function(t3, e3) {
          return S(d2, d2.hosts.filter(function(t4) {
            return 0 != (t4.accept & g.Write);
          }), t3, y(e3, d2.timeouts.write));
        } };
        return d2;
      }
      function T(t2) {
        var e2 = { value: "Algolia for JavaScript (".concat(t2, ")"), add: function(t3) {
          var r2 = "; ".concat(t3.segment).concat(void 0 !== t3.version ? " (".concat(t3.version, ")") : "");
          return -1 === e2.value.indexOf(r2) && (e2.value = "".concat(e2.value).concat(r2)), e2;
        } };
        return e2;
      }
      function N(t2, e2, r2) {
        var n2 = R(r2), a2 = "".concat(t2.protocol, "://").concat(t2.url, "/").concat("/" === e2.charAt(0) ? e2.substr(1) : e2);
        return n2.length && (a2 += "?".concat(n2)), a2;
      }
      function R(t2) {
        return Object.keys(t2).map(function(e2) {
          return p("%s=%s", e2, (r2 = t2[e2], "[object Object]" === Object.prototype.toString.call(r2) || "[object Array]" === Object.prototype.toString.call(r2) ? JSON.stringify(t2[e2]) : t2[e2]));
          var r2;
        }).join("&");
      }
      function E(t2) {
        return t2.map(function(t3) {
          return A(t3);
        });
      }
      function A(t2) {
        var e2 = t2.request.headers["x-algolia-api-key"] ? { "x-algolia-api-key": "*****" } : {};
        return r(r({}, t2), {}, { request: r(r({}, t2.request), {}, { headers: r(r({}, t2.request.headers), e2) }) });
      }
      var C = function(t2) {
        return function(e2, r2) {
          return t2.transporter.write({ method: j, path: "2/abtests", data: e2 }, r2);
        };
      }, U = function(t2) {
        return function(e2, r2) {
          return t2.transporter.write({ method: I, path: p("2/abtests/%s", e2) }, r2);
        };
      }, z = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("2/abtests/%s", e2) }, r2);
        };
      }, J = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "2/abtests" }, e2);
        };
      }, F = function(t2) {
        return function(e2, r2) {
          return t2.transporter.write({ method: j, path: p("2/abtests/%s/stop", e2) }, r2);
        };
      }, H = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/strategies/personalization" }, e2);
        };
      }, M = function(t2) {
        return function(e2, r2) {
          return t2.transporter.write({ method: j, path: "1/strategies/personalization", data: e2 }, r2);
        };
      };
      function B(t2) {
        return function e2(r2) {
          return t2.request(r2).then(function(n2) {
            if (void 0 !== t2.batch && t2.batch(n2.hits), !t2.shouldStop(n2))
              return n2.cursor ? e2({ cursor: n2.cursor }) : e2({ page: (r2.page || 0) + 1 });
          });
        }({});
      }
      var K = function(t2) {
        return function(e2, a2) {
          var o2 = a2 || {}, i2 = o2.queryParameters, u2 = n(o2, ["queryParameters"]), s2 = r({ acl: e2 }, void 0 !== i2 ? { queryParameters: i2 } : {});
          return d(t2.transporter.write({ method: j, path: "1/keys", data: s2 }, u2), function(e3, r2) {
            return f(function(n2) {
              return tt(t2)(e3.key, r2).catch(function(t3) {
                if (404 !== t3.status)
                  throw t3;
                return n2();
              });
            });
          });
        };
      }, W = function(t2) {
        return function(e2, r2, n2) {
          var a2 = y(n2);
          return a2.queryParameters["X-Algolia-User-ID"] = e2, t2.transporter.write({ method: j, path: "1/clusters/mapping", data: { cluster: r2 } }, a2);
        };
      }, L = function(t2) {
        return function(e2, r2, n2) {
          return t2.transporter.write({ method: j, path: "1/clusters/mapping/batch", data: { users: e2, cluster: r2 } }, n2);
        };
      }, Q = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: j, path: p("/1/dictionaries/%s/batch", e2), data: { clearExistingDictionaryEntries: true, requests: { action: "addEntry", body: [] } } }, r2), function(e3, r3) {
            return jt(t2)(e3.taskID, r3);
          });
        };
      }, G = function(t2) {
        return function(e2, r2, n2) {
          return d(t2.transporter.write({ method: j, path: p("1/indexes/%s/operation", e2), data: { operation: "copy", destination: r2 } }, n2), function(r3, n3) {
            return ut(t2)(e2, { methods: { waitTask: de } }).waitTask(r3.taskID, n3);
          });
        };
      }, V = function(t2) {
        return function(e2, n2, a2) {
          return G(t2)(e2, n2, r(r({}, a2), {}, { scope: [he.Rules] }));
        };
      }, _ = function(t2) {
        return function(e2, n2, a2) {
          return G(t2)(e2, n2, r(r({}, a2), {}, { scope: [he.Settings] }));
        };
      }, X = function(t2) {
        return function(e2, n2, a2) {
          return G(t2)(e2, n2, r(r({}, a2), {}, { scope: [he.Synonyms] }));
        };
      }, Y = function(t2) {
        return function(e2, r2) {
          return e2.method === x ? t2.transporter.read(e2, r2) : t2.transporter.write(e2, r2);
        };
      }, Z = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: I, path: p("1/keys/%s", e2) }, r2), function(r3, n2) {
            return f(function(r4) {
              return tt(t2)(e2, n2).then(r4).catch(function(t3) {
                if (404 !== t3.status)
                  throw t3;
              });
            });
          });
        };
      }, $ = function(t2) {
        return function(e2, r2, n2) {
          var a2 = r2.map(function(t3) {
            return { action: "deleteEntry", body: { objectID: t3 } };
          });
          return d(t2.transporter.write({ method: j, path: p("/1/dictionaries/%s/batch", e2), data: { clearExistingDictionaryEntries: false, requests: a2 } }, n2), function(e3, r3) {
            return jt(t2)(e3.taskID, r3);
          });
        };
      }, tt = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/keys/%s", e2) }, r2);
        };
      }, et = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/task/%s", e2.toString()) }, r2);
        };
      }, rt = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "/1/dictionaries/*/settings" }, e2);
        };
      }, nt = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/logs" }, e2);
        };
      }, at = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/clusters/mapping/top" }, e2);
        };
      }, ot = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/clusters/mapping/%s", e2) }, r2);
        };
      }, it = function(t2) {
        return function(e2) {
          var r2 = e2 || {}, a2 = r2.retrieveMappings, o2 = n(r2, ["retrieveMappings"]);
          return true === a2 && (o2.getClusters = true), t2.transporter.read({ method: x, path: "1/clusters/mapping/pending" }, o2);
        };
      }, ut = function(t2) {
        return function(e2) {
          var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n2 = { transporter: t2.transporter, appId: t2.appId, indexName: e2 };
          return h(n2, r2.methods);
        };
      }, st = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/keys" }, e2);
        };
      }, ct = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/clusters" }, e2);
        };
      }, ft = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/indexes" }, e2);
        };
      }, dt = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/clusters/mapping" }, e2);
        };
      }, lt = function(t2) {
        return function(e2, r2, n2) {
          return d(t2.transporter.write({ method: j, path: p("1/indexes/%s/operation", e2), data: { operation: "move", destination: r2 } }, n2), function(r3, n3) {
            return ut(t2)(e2, { methods: { waitTask: de } }).waitTask(r3.taskID, n3);
          });
        };
      }, ht = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: j, path: "1/indexes/*/batch", data: { requests: e2 } }, r2), function(e3, r3) {
            return Promise.all(Object.keys(e3.taskID).map(function(n2) {
              return ut(t2)(n2, { methods: { waitTask: de } }).waitTask(e3.taskID[n2], r3);
            }));
          });
        };
      }, pt = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: j, path: "1/indexes/*/objects", data: { requests: e2 } }, r2);
        };
      }, mt = function(t2) {
        return function(e2, n2) {
          var a2 = e2.map(function(t3) {
            return r(r({}, t3), {}, { params: R(t3.params || {}) });
          });
          return t2.transporter.read({ method: j, path: "1/indexes/*/queries", data: { requests: a2 }, cacheable: true }, n2);
        };
      }, yt = function(t2) {
        return function(e2, a2) {
          return Promise.all(e2.map(function(e3) {
            var o2 = e3.params, i2 = o2.facetName, u2 = o2.facetQuery, s2 = n(o2, ["facetName", "facetQuery"]);
            return ut(t2)(e3.indexName, { methods: { searchForFacetValues: ue } }).searchForFacetValues(i2, u2, r(r({}, a2), s2));
          }));
        };
      }, gt = function(t2) {
        return function(e2, r2) {
          var n2 = y(r2);
          return n2.queryParameters["X-Algolia-User-ID"] = e2, t2.transporter.write({ method: I, path: "1/clusters/mapping" }, n2);
        };
      }, vt = function(t2) {
        return function(e2, r2, n2) {
          var a2 = r2.map(function(t3) {
            return { action: "addEntry", body: t3 };
          });
          return d(t2.transporter.write({ method: j, path: p("/1/dictionaries/%s/batch", e2), data: { clearExistingDictionaryEntries: true, requests: a2 } }, n2), function(e3, r3) {
            return jt(t2)(e3.taskID, r3);
          });
        };
      }, bt = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: j, path: p("1/keys/%s/restore", e2) }, r2), function(r3, n2) {
            return f(function(r4) {
              return tt(t2)(e2, n2).catch(function(t3) {
                if (404 !== t3.status)
                  throw t3;
                return r4();
              });
            });
          });
        };
      }, Pt = function(t2) {
        return function(e2, r2, n2) {
          var a2 = r2.map(function(t3) {
            return { action: "addEntry", body: t3 };
          });
          return d(t2.transporter.write({ method: j, path: p("/1/dictionaries/%s/batch", e2), data: { clearExistingDictionaryEntries: false, requests: a2 } }, n2), function(e3, r3) {
            return jt(t2)(e3.taskID, r3);
          });
        };
      }, Ot = function(t2) {
        return function(e2, r2, n2) {
          return t2.transporter.read({ method: j, path: p("/1/dictionaries/%s/search", e2), data: { query: r2 }, cacheable: true }, n2);
        };
      }, wt = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: j, path: "1/clusters/mapping/search", data: { query: e2 } }, r2);
        };
      }, It = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: D, path: "/1/dictionaries/*/settings", data: e2 }, r2), function(e3, r3) {
            return jt(t2)(e3.taskID, r3);
          });
        };
      }, xt = function(t2) {
        return function(e2, r2) {
          var a2 = Object.assign({}, r2), o2 = r2 || {}, i2 = o2.queryParameters, u2 = n(o2, ["queryParameters"]), s2 = i2 ? { queryParameters: i2 } : {}, c2 = ["acl", "indexes", "referers", "restrictSources", "queryParameters", "description", "maxQueriesPerIPPerHour", "maxHitsPerQuery"];
          return d(t2.transporter.write({ method: D, path: p("1/keys/%s", e2), data: s2 }, u2), function(r3, n2) {
            return f(function(r4) {
              return tt(t2)(e2, n2).then(function(t3) {
                return function(t4) {
                  return Object.keys(a2).filter(function(t5) {
                    return -1 !== c2.indexOf(t5);
                  }).every(function(e3) {
                    if (Array.isArray(t4[e3]) && Array.isArray(a2[e3])) {
                      var r5 = t4[e3];
                      return r5.length === a2[e3].length && r5.every(function(t5, r6) {
                        return t5 === a2[e3][r6];
                      });
                    }
                    return t4[e3] === a2[e3];
                  });
                }(t3) ? Promise.resolve() : r4();
              });
            });
          });
        };
      }, jt = function(t2) {
        return function(e2, r2) {
          return f(function(n2) {
            return et(t2)(e2, r2).then(function(t3) {
              return "published" !== t3.status ? n2() : void 0;
            });
          });
        };
      }, Dt = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: j, path: p("1/indexes/%s/batch", t2.indexName), data: { requests: e2 } }, r2), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, qt = function(t2) {
        return function(e2) {
          return B(r(r({ shouldStop: function(t3) {
            return void 0 === t3.cursor;
          } }, e2), {}, { request: function(r2) {
            return t2.transporter.read({ method: j, path: p("1/indexes/%s/browse", t2.indexName), data: r2 }, e2);
          } }));
        };
      }, St = function(t2) {
        return function(e2) {
          var n2 = r({ hitsPerPage: 1e3 }, e2);
          return B(r(r({ shouldStop: function(t3) {
            return t3.hits.length < n2.hitsPerPage;
          } }, n2), {}, { request: function(e3) {
            return se(t2)("", r(r({}, n2), e3)).then(function(t3) {
              return r(r({}, t3), {}, { hits: t3.hits.map(function(t4) {
                return delete t4._highlightResult, t4;
              }) });
            });
          } }));
        };
      }, kt = function(t2) {
        return function(e2) {
          var n2 = r({ hitsPerPage: 1e3 }, e2);
          return B(r(r({ shouldStop: function(t3) {
            return t3.hits.length < n2.hitsPerPage;
          } }, n2), {}, { request: function(e3) {
            return ce(t2)("", r(r({}, n2), e3)).then(function(t3) {
              return r(r({}, t3), {}, { hits: t3.hits.map(function(t4) {
                return delete t4._highlightResult, t4;
              }) });
            });
          } }));
        };
      }, Tt = function(t2) {
        return function(e2, r2, a2) {
          var o2 = a2 || {}, i2 = o2.batchSize, u2 = n(o2, ["batchSize"]), s2 = { taskIDs: [], objectIDs: [] };
          return d(function n2() {
            var a3, o3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, c2 = [];
            for (a3 = o3; a3 < e2.length && (c2.push(e2[a3]), c2.length !== (i2 || 1e3)); a3++)
              ;
            return 0 === c2.length ? Promise.resolve(s2) : Dt(t2)(c2.map(function(t3) {
              return { action: r2, body: t3 };
            }), u2).then(function(t3) {
              return s2.objectIDs = s2.objectIDs.concat(t3.objectIDs), s2.taskIDs.push(t3.taskID), a3++, n2(a3);
            });
          }(), function(e3, r3) {
            return Promise.all(e3.taskIDs.map(function(e4) {
              return de(t2)(e4, r3);
            }));
          });
        };
      }, Nt = function(t2) {
        return function(e2) {
          return d(t2.transporter.write({ method: j, path: p("1/indexes/%s/clear", t2.indexName) }, e2), function(e3, r2) {
            return de(t2)(e3.taskID, r2);
          });
        };
      }, Rt = function(t2) {
        return function(e2) {
          var r2 = e2 || {}, a2 = r2.forwardToReplicas, o2 = y(n(r2, ["forwardToReplicas"]));
          return a2 && (o2.queryParameters.forwardToReplicas = 1), d(t2.transporter.write({ method: j, path: p("1/indexes/%s/rules/clear", t2.indexName) }, o2), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, Et = function(t2) {
        return function(e2) {
          var r2 = e2 || {}, a2 = r2.forwardToReplicas, o2 = y(n(r2, ["forwardToReplicas"]));
          return a2 && (o2.queryParameters.forwardToReplicas = 1), d(t2.transporter.write({ method: j, path: p("1/indexes/%s/synonyms/clear", t2.indexName) }, o2), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, At = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: j, path: p("1/indexes/%s/deleteByQuery", t2.indexName), data: e2 }, r2), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, Ct = function(t2) {
        return function(e2) {
          return d(t2.transporter.write({ method: I, path: p("1/indexes/%s", t2.indexName) }, e2), function(e3, r2) {
            return de(t2)(e3.taskID, r2);
          });
        };
      }, Ut = function(t2) {
        return function(e2, r2) {
          return d(zt(t2)([e2], r2).then(function(t3) {
            return { taskID: t3.taskIDs[0] };
          }), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, zt = function(t2) {
        return function(e2, r2) {
          var n2 = e2.map(function(t3) {
            return { objectID: t3 };
          });
          return Tt(t2)(n2, le.DeleteObject, r2);
        };
      }, Jt = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.forwardToReplicas, i2 = y(n(a2, ["forwardToReplicas"]));
          return o2 && (i2.queryParameters.forwardToReplicas = 1), d(t2.transporter.write({ method: I, path: p("1/indexes/%s/rules/%s", t2.indexName, e2) }, i2), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, Ft = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.forwardToReplicas, i2 = y(n(a2, ["forwardToReplicas"]));
          return o2 && (i2.queryParameters.forwardToReplicas = 1), d(t2.transporter.write({ method: I, path: p("1/indexes/%s/synonyms/%s", t2.indexName, e2) }, i2), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, Ht = function(t2) {
        return function(e2) {
          return Gt(t2)(e2).then(function() {
            return true;
          }).catch(function(t3) {
            if (404 !== t3.status)
              throw t3;
            return false;
          });
        };
      }, Mt = function(t2) {
        return function(e2, r2, n2) {
          return t2.transporter.read({ method: j, path: p("1/answers/%s/prediction", t2.indexName), data: { query: e2, queryLanguages: r2 }, cacheable: true }, n2);
        };
      }, Bt = function(t2) {
        return function(e2, o2) {
          var i2 = o2 || {}, u2 = i2.query, s2 = i2.paginate, c2 = n(i2, ["query", "paginate"]), f2 = 0;
          return function n2() {
            return ie(t2)(u2 || "", r(r({}, c2), {}, { page: f2 })).then(function(t3) {
              for (var r2 = 0, o3 = Object.entries(t3.hits); r2 < o3.length; r2++) {
                var i3 = a(o3[r2], 2), u3 = i3[0], c3 = i3[1];
                if (e2(c3))
                  return { object: c3, position: parseInt(u3, 10), page: f2 };
              }
              if (f2++, false === s2 || f2 >= t3.nbPages)
                throw { name: "ObjectNotFoundError", message: "Object not found." };
              return n2();
            });
          }();
        };
      }, Kt = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/indexes/%s/%s", t2.indexName, e2) }, r2);
        };
      }, Wt = function() {
        return function(t2, e2) {
          for (var r2 = 0, n2 = Object.entries(t2.hits); r2 < n2.length; r2++) {
            var o2 = a(n2[r2], 2), i2 = o2[0];
            if (o2[1].objectID === e2)
              return parseInt(i2, 10);
          }
          return -1;
        };
      }, Lt = function(t2) {
        return function(e2, a2) {
          var o2 = a2 || {}, i2 = o2.attributesToRetrieve, u2 = n(o2, ["attributesToRetrieve"]), s2 = e2.map(function(e3) {
            return r({ indexName: t2.indexName, objectID: e3 }, i2 ? { attributesToRetrieve: i2 } : {});
          });
          return t2.transporter.read({ method: j, path: "1/indexes/*/objects", data: { requests: s2 } }, u2);
        };
      }, Qt = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/indexes/%s/rules/%s", t2.indexName, e2) }, r2);
        };
      }, Gt = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: p("1/indexes/%s/settings", t2.indexName), data: { getVersion: 2 } }, e2);
        };
      }, Vt = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/indexes/%s/synonyms/%s", t2.indexName, e2) }, r2);
        };
      }, _t = function(t2) {
        return function(e2, r2) {
          return d(Xt(t2)([e2], r2).then(function(t3) {
            return { objectID: t3.objectIDs[0], taskID: t3.taskIDs[0] };
          }), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, Xt = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.createIfNotExists, i2 = n(a2, ["createIfNotExists"]), u2 = o2 ? le.PartialUpdateObject : le.PartialUpdateObjectNoCreate;
          return Tt(t2)(e2, u2, i2);
        };
      }, Yt = function(t2) {
        return function(e2, i2) {
          var u2 = i2 || {}, s2 = u2.safe, c2 = u2.autoGenerateObjectIDIfNotExist, f2 = u2.batchSize, l2 = n(u2, ["safe", "autoGenerateObjectIDIfNotExist", "batchSize"]), h2 = function(e3, r2, n2, a2) {
            return d(t2.transporter.write({ method: j, path: p("1/indexes/%s/operation", e3), data: { operation: n2, destination: r2 } }, a2), function(e4, r3) {
              return de(t2)(e4.taskID, r3);
            });
          }, m2 = Math.random().toString(36).substring(7), y2 = "".concat(t2.indexName, "_tmp_").concat(m2), g2 = ee({ appId: t2.appId, transporter: t2.transporter, indexName: y2 }), v2 = [], b2 = h2(t2.indexName, y2, "copy", r(r({}, l2), {}, { scope: ["settings", "synonyms", "rules"] }));
          return v2.push(b2), d((s2 ? b2.wait(l2) : b2).then(function() {
            var t3 = g2(e2, r(r({}, l2), {}, { autoGenerateObjectIDIfNotExist: c2, batchSize: f2 }));
            return v2.push(t3), s2 ? t3.wait(l2) : t3;
          }).then(function() {
            var e3 = h2(y2, t2.indexName, "move", l2);
            return v2.push(e3), s2 ? e3.wait(l2) : e3;
          }).then(function() {
            return Promise.all(v2);
          }).then(function(t3) {
            var e3 = a(t3, 3), r2 = e3[0], n2 = e3[1], i3 = e3[2];
            return { objectIDs: n2.objectIDs, taskIDs: [r2.taskID].concat(o(n2.taskIDs), [i3.taskID]) };
          }), function(t3, e3) {
            return Promise.all(v2.map(function(t4) {
              return t4.wait(e3);
            }));
          });
        };
      }, Zt = function(t2) {
        return function(e2, n2) {
          return ne(t2)(e2, r(r({}, n2), {}, { clearExistingRules: true }));
        };
      }, $t = function(t2) {
        return function(e2, n2) {
          return oe(t2)(e2, r(r({}, n2), {}, { clearExistingSynonyms: true }));
        };
      }, te = function(t2) {
        return function(e2, r2) {
          return d(ee(t2)([e2], r2).then(function(t3) {
            return { objectID: t3.objectIDs[0], taskID: t3.taskIDs[0] };
          }), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, ee = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.autoGenerateObjectIDIfNotExist, i2 = n(a2, ["autoGenerateObjectIDIfNotExist"]), u2 = o2 ? le.AddObject : le.UpdateObject;
          if (u2 === le.UpdateObject) {
            var s2 = true, c2 = false, f2 = void 0;
            try {
              for (var l2, h2 = e2[Symbol.iterator](); !(s2 = (l2 = h2.next()).done); s2 = true) {
                if (void 0 === l2.value.objectID)
                  return d(Promise.reject({ name: "MissingObjectIDError", message: "All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option." }));
              }
            } catch (t3) {
              c2 = true, f2 = t3;
            } finally {
              try {
                s2 || null == h2.return || h2.return();
              } finally {
                if (c2)
                  throw f2;
              }
            }
          }
          return Tt(t2)(e2, u2, i2);
        };
      }, re = function(t2) {
        return function(e2, r2) {
          return ne(t2)([e2], r2);
        };
      }, ne = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.forwardToReplicas, i2 = a2.clearExistingRules, u2 = y(n(a2, ["forwardToReplicas", "clearExistingRules"]));
          return o2 && (u2.queryParameters.forwardToReplicas = 1), i2 && (u2.queryParameters.clearExistingRules = 1), d(t2.transporter.write({ method: j, path: p("1/indexes/%s/rules/batch", t2.indexName), data: e2 }, u2), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, ae = function(t2) {
        return function(e2, r2) {
          return oe(t2)([e2], r2);
        };
      }, oe = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.forwardToReplicas, i2 = a2.clearExistingSynonyms, u2 = a2.replaceExistingSynonyms, s2 = y(n(a2, ["forwardToReplicas", "clearExistingSynonyms", "replaceExistingSynonyms"]));
          return o2 && (s2.queryParameters.forwardToReplicas = 1), (u2 || i2) && (s2.queryParameters.replaceExistingSynonyms = 1), d(t2.transporter.write({ method: j, path: p("1/indexes/%s/synonyms/batch", t2.indexName), data: e2 }, s2), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, ie = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: j, path: p("1/indexes/%s/query", t2.indexName), data: { query: e2 }, cacheable: true }, r2);
        };
      }, ue = function(t2) {
        return function(e2, r2, n2) {
          return t2.transporter.read({ method: j, path: p("1/indexes/%s/facets/%s/query", t2.indexName, e2), data: { facetQuery: r2 }, cacheable: true }, n2);
        };
      }, se = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: j, path: p("1/indexes/%s/rules/search", t2.indexName), data: { query: e2 } }, r2);
        };
      }, ce = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: j, path: p("1/indexes/%s/synonyms/search", t2.indexName), data: { query: e2 } }, r2);
        };
      }, fe = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.forwardToReplicas, i2 = y(n(a2, ["forwardToReplicas"]));
          return o2 && (i2.queryParameters.forwardToReplicas = 1), d(t2.transporter.write({ method: D, path: p("1/indexes/%s/settings", t2.indexName), data: e2 }, i2), function(e3, r3) {
            return de(t2)(e3.taskID, r3);
          });
        };
      }, de = function(t2) {
        return function(e2, r2) {
          return f(function(n2) {
            return function(t3) {
              return function(e3, r3) {
                return t3.transporter.read({ method: x, path: p("1/indexes/%s/task/%s", t3.indexName, e3.toString()) }, r3);
              };
            }(t2)(e2, r2).then(function(t3) {
              return "published" !== t3.status ? n2() : void 0;
            });
          });
        };
      }, le = { AddObject: "addObject", UpdateObject: "updateObject", PartialUpdateObject: "partialUpdateObject", PartialUpdateObjectNoCreate: "partialUpdateObjectNoCreate", DeleteObject: "deleteObject", DeleteIndex: "delete", ClearIndex: "clear" }, he = { Settings: "settings", Synonyms: "synonyms", Rules: "rules" }, pe = 1, me = 2, ye = 3;
      var ge = function(t2) {
        return function(e2, n2) {
          var a2 = e2.map(function(t3) {
            return r(r({}, t3), {}, { threshold: t3.threshold || 0 });
          });
          return t2.transporter.read({ method: j, path: "1/indexes/*/recommendations", data: { requests: a2 }, cacheable: true }, n2);
        };
      }, ve = function(t2) {
        return function(e2, n2) {
          return ge(t2)(e2.map(function(t3) {
            return r(r({}, t3), {}, { fallbackParameters: {}, model: "bought-together" });
          }), n2);
        };
      }, be = function(t2) {
        return function(e2, n2) {
          return ge(t2)(e2.map(function(t3) {
            return r(r({}, t3), {}, { model: "related-products" });
          }), n2);
        };
      }, Pe = function(t2) {
        return function(e2, n2) {
          var a2 = e2.map(function(t3) {
            return r(r({}, t3), {}, { model: "trending-facets", threshold: t3.threshold || 0 });
          });
          return t2.transporter.read({ method: j, path: "1/indexes/*/recommendations", data: { requests: a2 }, cacheable: true }, n2);
        };
      }, Oe = function(t2) {
        return function(e2, n2) {
          var a2 = e2.map(function(t3) {
            return r(r({}, t3), {}, { model: "trending-items", threshold: t3.threshold || 0 });
          });
          return t2.transporter.read({ method: j, path: "1/indexes/*/recommendations", data: { requests: a2 }, cacheable: true }, n2);
        };
      }, we = function(t2) {
        return function(e2, n2) {
          return ge(t2)(e2.map(function(t3) {
            return r(r({}, t3), {}, { model: "looking-similar" });
          }), n2);
        };
      }, Ie = function(t2) {
        return function(e2, n2) {
          var a2 = e2.map(function(t3) {
            return r(r({}, t3), {}, { model: "recommended-for-you", threshold: t3.threshold || 0 });
          });
          return t2.transporter.read({ method: j, path: "1/indexes/*/recommendations", data: { requests: a2 }, cacheable: true }, n2);
        };
      };
      function xe(t2, e2, n2) {
        var a2, o2 = { appId: t2, apiKey: e2, timeouts: { connect: 1, read: 2, write: 30 }, requester: { send: function(t3) {
          return new Promise(function(e3) {
            var r2 = new XMLHttpRequest();
            r2.open(t3.method, t3.url, true), Object.keys(t3.headers).forEach(function(e4) {
              return r2.setRequestHeader(e4, t3.headers[e4]);
            });
            var n3, a3 = function(t4, n4) {
              return setTimeout(function() {
                r2.abort(), e3({ status: 0, content: n4, isTimedOut: true });
              }, 1e3 * t4);
            }, o3 = a3(t3.connectTimeout, "Connection timeout");
            r2.onreadystatechange = function() {
              r2.readyState > r2.OPENED && void 0 === n3 && (clearTimeout(o3), n3 = a3(t3.responseTimeout, "Socket timeout"));
            }, r2.onerror = function() {
              0 === r2.status && (clearTimeout(o3), clearTimeout(n3), e3({ content: r2.responseText || "Network request failed", status: r2.status, isTimedOut: false }));
            }, r2.onload = function() {
              clearTimeout(o3), clearTimeout(n3), e3({ content: r2.responseText, status: r2.status, isTimedOut: false });
            }, r2.send(t3.data);
          });
        } }, logger: (a2 = ye, { debug: function(t3, e3) {
          return pe >= a2 && console.debug(t3, e3), Promise.resolve();
        }, info: function(t3, e3) {
          return me >= a2 && console.info(t3, e3), Promise.resolve();
        }, error: function(t3, e3) {
          return console.error(t3, e3), Promise.resolve();
        } }), responsesCache: s(), requestsCache: s({ serializable: false }), hostsCache: u({ caches: [i({ key: "".concat("4.24.0", "-").concat(t2) }), s()] }), userAgent: T("4.24.0").add({ segment: "Browser" }) }, f2 = r(r({}, o2), n2), d2 = function() {
          return function(t3) {
            return function(t4) {
              var e3 = t4.region || "us", n3 = c(m.WithinHeaders, t4.appId, t4.apiKey), a3 = k(r(r({ hosts: [{ url: "personalization.".concat(e3, ".algolia.com") }] }, t4), {}, { headers: r(r(r({}, n3.headers()), { "content-type": "application/json" }), t4.headers), queryParameters: r(r({}, n3.queryParameters()), t4.queryParameters) }));
              return h({ appId: t4.appId, transporter: a3 }, t4.methods);
            }(r(r(r({}, o2), t3), {}, { methods: { getPersonalizationStrategy: H, setPersonalizationStrategy: M } }));
          };
        };
        return function(t3) {
          var e3 = t3.appId, n3 = c(void 0 !== t3.authMode ? t3.authMode : m.WithinHeaders, e3, t3.apiKey), a3 = k(r(r({ hosts: [{ url: "".concat(e3, "-dsn.algolia.net"), accept: g.Read }, { url: "".concat(e3, ".algolia.net"), accept: g.Write }].concat(l([{ url: "".concat(e3, "-1.algolianet.com") }, { url: "".concat(e3, "-2.algolianet.com") }, { url: "".concat(e3, "-3.algolianet.com") }])) }, t3), {}, { headers: r(r(r({}, n3.headers()), { "content-type": "application/x-www-form-urlencoded" }), t3.headers), queryParameters: r(r({}, n3.queryParameters()), t3.queryParameters) }));
          return h({ transporter: a3, appId: e3, addAlgoliaAgent: function(t4, e4) {
            a3.userAgent.add({ segment: t4, version: e4 });
          }, clearCache: function() {
            return Promise.all([a3.requestsCache.clear(), a3.responsesCache.clear()]).then(function() {
            });
          } }, t3.methods);
        }(r(r({}, f2), {}, { methods: { search: mt, searchForFacetValues: yt, multipleBatch: ht, multipleGetObjects: pt, multipleQueries: mt, copyIndex: G, copySettings: _, copySynonyms: X, copyRules: V, moveIndex: lt, listIndices: ft, getLogs: nt, listClusters: ct, multipleSearchForFacetValues: yt, getApiKey: tt, addApiKey: K, listApiKeys: st, updateApiKey: xt, deleteApiKey: Z, restoreApiKey: bt, assignUserID: W, assignUserIDs: L, getUserID: ot, searchUserIDs: wt, listUserIDs: dt, getTopUserIDs: at, removeUserID: gt, hasPendingMappings: it, clearDictionaryEntries: Q, deleteDictionaryEntries: $, getDictionarySettings: rt, getAppTask: et, replaceDictionaryEntries: vt, saveDictionaryEntries: Pt, searchDictionaryEntries: Ot, setDictionarySettings: It, waitAppTask: jt, customRequest: Y, initIndex: function(t3) {
          return function(e3) {
            return ut(t3)(e3, { methods: { batch: Dt, delete: Ct, findAnswers: Mt, getObject: Kt, getObjects: Lt, saveObject: te, saveObjects: ee, search: ie, searchForFacetValues: ue, waitTask: de, setSettings: fe, getSettings: Gt, partialUpdateObject: _t, partialUpdateObjects: Xt, deleteObject: Ut, deleteObjects: zt, deleteBy: At, clearObjects: Nt, browseObjects: qt, getObjectPosition: Wt, findObject: Bt, exists: Ht, saveSynonym: ae, saveSynonyms: oe, getSynonym: Vt, searchSynonyms: ce, browseSynonyms: kt, deleteSynonym: Ft, clearSynonyms: Et, replaceAllObjects: Yt, replaceAllSynonyms: $t, searchRules: se, getRule: Qt, deleteRule: Jt, saveRule: re, saveRules: ne, replaceAllRules: Zt, browseRules: St, clearRules: Rt } });
          };
        }, initAnalytics: function() {
          return function(t3) {
            return function(t4) {
              var e3 = t4.region || "us", n3 = c(m.WithinHeaders, t4.appId, t4.apiKey), a3 = k(r(r({ hosts: [{ url: "analytics.".concat(e3, ".algolia.com") }] }, t4), {}, { headers: r(r(r({}, n3.headers()), { "content-type": "application/json" }), t4.headers), queryParameters: r(r({}, n3.queryParameters()), t4.queryParameters) }));
              return h({ appId: t4.appId, transporter: a3 }, t4.methods);
            }(r(r(r({}, o2), t3), {}, { methods: { addABTest: C, getABTest: z, getABTests: J, stopABTest: F, deleteABTest: U } }));
          };
        }, initPersonalization: d2, initRecommendation: function() {
          return function(t3) {
            return f2.logger.info("The `initRecommendation` method is deprecated. Use `initPersonalization` instead."), d2()(t3);
          };
        }, getRecommendations: ge, getFrequentlyBoughtTogether: ve, getLookingSimilar: we, getRecommendedForYou: Ie, getRelatedProducts: be, getTrendingFacets: Pe, getTrendingItems: Oe } }));
      }
      return xe.version = "4.24.0", xe;
    });
  }
});

// dev/src/js/common/utilities/country-selector.js
var _onCountryChangedListener, _onCountryChanged, onCountryChanged_fn;
var CountrySelector = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onCountryChanged);
    __privateAdd(this, _onCountryChangedListener, __privateMethod(this, _onCountryChanged, onCountryChanged_fn).bind(this));
  }
  connectedCallback() {
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement?.addEventListener("change", __privateGet(this, _onCountryChangedListener));
    if (this.getAttribute("country") !== "") {
      this.countryElement.selectedIndex = Math.max(0, Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.getAttribute("country")));
    }
    this.countryElement?.dispatchEvent(new Event("change"));
  }
  disconnectedCallback() {
    this.countryElement?.removeEventListener("change", __privateGet(this, _onCountryChangedListener));
  }
};
_onCountryChangedListener = new WeakMap();
_onCountryChanged = new WeakSet();
onCountryChanged_fn = function() {
  const option = this.countryElement?.options[this.countryElement.selectedIndex], provinces = JSON.parse(option.getAttribute("data-provinces"));
  this.provinceElement.parentElement.hidden = provinces.length === 0;
  if (provinces.length === 0) {
    return;
  }
  this.provinceElement.innerHTML = "";
  provinces.forEach((data) => {
    const selected = data[1] === this.getAttribute("province") || data[0] === this.getAttribute("province");
    this.provinceElement.options.add(new Option(data[1], data[0], selected, selected));
  });
};
if (!window.customElements.get("country-selector")) {
  window.customElements.define("country-selector", CountrySelector);
}

// dev/src/js/common/utilities/format-money.js
function formatMoney(cents, format2 = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format2 || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, "", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

// dev/src/js/common/utilities/cached-fetch.js
var cachedMap = /* @__PURE__ */ new Map();
function cachedFetch(url, options) {
  const cacheKey = url;
  if (cachedMap.has(cacheKey)) {
    return Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])));
  }
  return fetch(url, options).then((response) => {
    if (response.status === 200) {
      const contentType = response.headers.get("Content-Type");
      if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
        response.clone().text().then((content) => {
          cachedMap.set(cacheKey, content);
        });
      }
    }
    return response;
  });
}

// dev/src/js/common/utilities/extract-section-id.js
function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

// dev/src/js/common/utilities/dom.js
function throttle(callback) {
  let requestId = null, lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}
function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
function waitForEvent(element, eventName) {
  return new Promise((resolve) => {
    const done = (event) => {
      if (event.target === element) {
        element.removeEventListener(eventName, done);
        resolve(event);
      }
    };
    element.addEventListener(eventName, done);
  });
}
function waitForWindowObject(predicate, timeout) {
  return new Promise((resolve, reject) => {
    const check = () => {
      if (!predicate())
        return;
      clearInterval(interval);
      resolve();
    };
    const interval = setInterval(check, 200);
    check();
    if (!timeout)
      return;
    setTimeout(() => {
      clearInterval(interval);
      reject();
    }, timeout);
  });
}

// dev/src/js/common/utilities/media.js
function videoLoaded(videoOrArray) {
  if (!videoOrArray) {
    return Promise.resolve();
  }
  videoOrArray = videoOrArray instanceof Element ? [videoOrArray] : Array.from(videoOrArray);
  return Promise.all(videoOrArray.map((video) => {
    return new Promise((resolve) => {
      if (video.tagName === "VIDEO" && video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA || !video.offsetParent) {
        resolve();
      } else {
        video.oncanplay = () => resolve();
      }
    });
  }));
}
function imageLoaded(imageOrArray) {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(imageOrArray.map((image) => {
    return new Promise((resolve) => {
      if (image.tagName === "IMG" && image.complete || !image.offsetParent) {
        resolve();
      } else {
        image.onload = () => resolve();
      }
    });
  }));
}
function generateSrcset(imageObjectOrString, widths = []) {
  let imageUrl, maxWidth;
  if (typeof imageObjectOrString === "string") {
    imageUrl = new URL(imageObjectOrString.startsWith("//") ? `https:${imageObjectOrString}` : imageObjectOrString);
    maxWidth = parseInt(imageUrl.searchParams.get("width"));
  } else {
    imageUrl = new URL(imageObjectOrString["src"]);
    maxWidth = imageObjectOrString["width"];
  }
  return widths.filter((width) => width <= maxWidth).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}
function createMediaImg(media, widths = [], attributes = {}) {
  const image = new Image(media["preview_image"]["width"], media["preview_image"]["height"]), featuredMediaUrl = new URL(media["preview_image"]["src"]);
  for (const attributeKey in attributes) {
    image.setAttribute(attributeKey, attributes[attributeKey]);
  }
  image.alt = media["alt"];
  image.src = featuredMediaUrl.href;
  image.srcset = generateSrcset(media["preview_image"], widths);
  return image;
}

// dev/src/js/common/utilities/media-query.js
function matchesMediaQuery(breakpointName) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    return false;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).matches;
}
function mediaQueryListener(breakpointName, func) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).addEventListener("change", func);
}
function mediaQueryRemoveListener(breakpointName, func) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).removeEventListener("change", func);
}

// dev/src/js/common/utilities/paginate.js
var Pagination = class {
  static getPagination(current, last, delta = 2) {
    if (last === 1)
      return [1];
    const left = current - delta, right = current + delta + 1, range = [];
    for (let i = 1; i <= last; i++) {
      if (i === 1 || i === last || i >= left && i < right) {
        if (i === left && i > 2) {
          range.push("...");
        }
        if (i === current) {
          range.push("current:" + i);
        } else {
          range.push(i);
        }
        if (i === right - 1 && i < last - 1) {
          range.push("...");
        }
      }
    }
    return range;
  }
};

// dev/src/js/common/utilities/player.js
var _callback, _duration, _remainingTime, _startTime, _timer, _state, _onVisibilityChangeListener, _mustResumeOnVisibility, _onVisibilityChange, onVisibilityChange_fn;
var Player = class extends EventTarget {
  constructor(durationInSec, stopOnVisibility = true) {
    super();
    __privateAdd(this, _onVisibilityChange);
    __privateAdd(this, _callback, void 0);
    __privateAdd(this, _duration, void 0);
    __privateAdd(this, _remainingTime, void 0);
    __privateAdd(this, _startTime, void 0);
    __privateAdd(this, _timer, void 0);
    __privateAdd(this, _state, "paused");
    __privateAdd(this, _onVisibilityChangeListener, __privateMethod(this, _onVisibilityChange, onVisibilityChange_fn).bind(this));
    __privateAdd(this, _mustResumeOnVisibility, true);
    __privateSet(this, _callback, () => this.dispatchEvent(new CustomEvent("player:end")));
    __privateSet(this, _duration, __privateSet(this, _remainingTime, durationInSec * 1e3));
    if (stopOnVisibility) {
      document.addEventListener("visibilitychange", __privateGet(this, _onVisibilityChangeListener));
    }
  }
  pause() {
    if (__privateGet(this, _state) !== "started") {
      return;
    }
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _state, "paused");
    __privateSet(this, _remainingTime, __privateGet(this, _remainingTime) - (new Date().getTime() - __privateGet(this, _startTime)));
    this.dispatchEvent(new CustomEvent("player:pause"));
  }
  resume(restartTimer = false) {
    if (__privateGet(this, _state) !== "stopped") {
      if (restartTimer) {
        this.start();
      } else {
        clearTimeout(__privateGet(this, _timer));
        __privateSet(this, _startTime, new Date().getTime());
        __privateSet(this, _state, "started");
        __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime)));
        this.dispatchEvent(new CustomEvent("player:resume"));
      }
    }
  }
  start() {
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _startTime, new Date().getTime());
    __privateSet(this, _state, "started");
    __privateSet(this, _remainingTime, __privateGet(this, _duration));
    __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime)));
    this.dispatchEvent(new CustomEvent("player:start"));
  }
  stop() {
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _state, "stopped");
    this.dispatchEvent(new CustomEvent("player:stop"));
  }
};
_callback = new WeakMap();
_duration = new WeakMap();
_remainingTime = new WeakMap();
_startTime = new WeakMap();
_timer = new WeakMap();
_state = new WeakMap();
_onVisibilityChangeListener = new WeakMap();
_mustResumeOnVisibility = new WeakMap();
_onVisibilityChange = new WeakSet();
onVisibilityChange_fn = function() {
  if (document.visibilityState === "hidden") {
    __privateSet(this, _mustResumeOnVisibility, __privateGet(this, _state) === "started");
    this.pause();
    this.dispatchEvent(new CustomEvent("player:visibility-pause"));
  } else if (document.visibilityState === "visible" && __privateGet(this, _mustResumeOnVisibility)) {
    this.resume();
    this.dispatchEvent(new CustomEvent("player:visibility-resume"));
  }
};

// dev/src/js/common/utilities/qr-code.js
var QrCode = class extends HTMLElement {
  connectedCallback() {
    new window.QRCode(this, {
      text: this.getAttribute("identifier"),
      width: this.hasAttribute("width") ? parseInt(this.getAttribute("width")) : 200,
      height: this.hasAttribute("height") ? parseInt(this.getAttribute("height")) : 200
    });
  }
};
if (!window.customElements.get("qr-code")) {
  window.customElements.define("qr-code", QrCode);
}

// dev/src/js/common/actions/back-to-top.js
var _onScrollListener, _offset, _backToTop, backToTop_fn, _onScroll, onScroll_fn;
var BackToTop = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _backToTop);
    __privateAdd(this, _onScroll);
    __privateAdd(this, _onScrollListener, throttle(__privateMethod(this, _onScroll, onScroll_fn).bind(this)));
    __privateAdd(this, _offset, void 0);
    const offsetElement = document.querySelector(this.getAttribute("offset"));
    __privateSet(this, _offset, offsetElement?.offsetTop + offsetElement?.offsetHeight);
    this.addEventListener("click", __privateMethod(this, _backToTop, backToTop_fn));
    window.addEventListener("scroll", __privateGet(this, _onScrollListener));
    __privateMethod(this, _onScroll, onScroll_fn).call(this);
  }
};
_onScrollListener = new WeakMap();
_offset = new WeakMap();
_backToTop = new WeakSet();
backToTop_fn = function() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};
_onScroll = new WeakSet();
onScroll_fn = function() {
  this.classList.toggle("active", window.scrollY > __privateGet(this, _offset));
};
if (!window.customElements.get("back-to-top")) {
  window.customElements.define("back-to-top", BackToTop);
}

// dev/src/js/common/actions/confirm-button.js
var ConfirmButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      if (!window.confirm(this.getAttribute("data-message") ?? "Once confirmed, this action cannot be undone.")) {
        event.preventDefault();
      }
    });
  }
};
if (!window.customElements.get("confirm-button")) {
  window.customElements.define("confirm-button", ConfirmButton, { extends: "button" });
}

// dev/src/js/common/animation/marquee-text.js
import { inView, animate } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _direction, direction_get, _scroller, scroller_get, _initialize, initialize_fn;
var MarqueeText = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _direction);
    __privateAdd(this, _scroller);
    __privateAdd(this, _initialize);
    inView(this, __privateMethod(this, _initialize, initialize_fn).bind(this), { margin: "400px" });
  }
};
_direction = new WeakSet();
direction_get = function() {
  return this.getAttribute("direction") === "right" ? 1 : -1;
};
_scroller = new WeakSet();
scroller_get = function() {
  return this.shadowRoot.querySelector('[part="scroller"]');
};
_initialize = new WeakSet();
initialize_fn = function() {
  this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment(`
      <slot part="scroller"></slot>
    `));
  const fragment = document.createDocumentFragment();
  for (let i = 1; i <= 5; ++i) {
    const node = this.firstElementChild.cloneNode(true);
    node.setAttribute("aria-hidden", "true");
    node.style.cssText = `position: absolute; inset-inline-start: ${100 * i * -__privateGet(this, _direction, direction_get)}%;`;
    fragment.appendChild(node);
  }
  this.append(fragment);
  animate(__privateGet(this, _scroller, scroller_get), { transform: ["translateX(0)", `translateX(calc(1 * ${__privateGet(this, _direction, direction_get) * 100}%))`] }, {
    duration: 1 / parseFloat(this.getAttribute("speed")) * (__privateGet(this, _scroller, scroller_get).clientWidth / 300),
    easing: "linear",
    repeat: Infinity
  });
};
if (!window.customElements.get("marquee-text")) {
  window.customElements.define("marquee-text", MarqueeText);
}

// dev/src/js/common/behavior/gesture-area.js
var _domElement, _thresholdDistance, _thresholdTime, _signal, _firstClientX, _tracking, _start, _touchStart, touchStart_fn, _preventTouch, preventTouch_fn, _gestureStart, gestureStart_fn, _gestureMove, gestureMove_fn, _gestureEnd, gestureEnd_fn;
var GestureArea = class {
  constructor(domElement, { thresholdDistance = 80, thresholdTime = 500, signal = null } = {}) {
    __privateAdd(this, _touchStart);
    __privateAdd(this, _preventTouch);
    __privateAdd(this, _gestureStart);
    __privateAdd(this, _gestureMove);
    __privateAdd(this, _gestureEnd);
    __privateAdd(this, _domElement, void 0);
    __privateAdd(this, _thresholdDistance, void 0);
    __privateAdd(this, _thresholdTime, void 0);
    __privateAdd(this, _signal, void 0);
    __privateAdd(this, _firstClientX, void 0);
    __privateAdd(this, _tracking, false);
    __privateAdd(this, _start, {});
    __privateSet(this, _domElement, domElement);
    __privateSet(this, _thresholdDistance, thresholdDistance);
    __privateSet(this, _thresholdTime, thresholdTime);
    __privateSet(this, _signal, signal ?? new AbortController().signal);
    __privateGet(this, _domElement).addEventListener("touchstart", __privateMethod(this, _touchStart, touchStart_fn).bind(this), { passive: true, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("touchmove", __privateMethod(this, _preventTouch, preventTouch_fn).bind(this), { passive: false, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerdown", __privateMethod(this, _gestureStart, gestureStart_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointermove", __privateMethod(this, _gestureMove, gestureMove_fn).bind(this), { passive: false, signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerup", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointerleave", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
    __privateGet(this, _domElement).addEventListener("pointercancel", __privateMethod(this, _gestureEnd, gestureEnd_fn).bind(this), { signal: __privateGet(this, _signal) });
  }
};
_domElement = new WeakMap();
_thresholdDistance = new WeakMap();
_thresholdTime = new WeakMap();
_signal = new WeakMap();
_firstClientX = new WeakMap();
_tracking = new WeakMap();
_start = new WeakMap();
_touchStart = new WeakSet();
touchStart_fn = function(event) {
  __privateSet(this, _firstClientX, event.touches[0].clientX);
};
_preventTouch = new WeakSet();
preventTouch_fn = function(event) {
  if (Math.abs(event.touches[0].clientX - __privateGet(this, _firstClientX)) > 10) {
    event.preventDefault();
  }
};
_gestureStart = new WeakSet();
gestureStart_fn = function(event) {
  __privateSet(this, _tracking, true);
  __privateSet(this, _start, {
    time: new Date().getTime(),
    x: event.clientX,
    y: event.clientY
  });
};
_gestureMove = new WeakSet();
gestureMove_fn = function(event) {
  if (__privateGet(this, _tracking)) {
    event.preventDefault();
  }
};
_gestureEnd = new WeakSet();
gestureEnd_fn = function(event) {
  if (!__privateGet(this, _tracking)) {
    return;
  }
  __privateSet(this, _tracking, false);
  const now = new Date().getTime(), deltaTime = now - __privateGet(this, _start).time, deltaX = event.clientX - __privateGet(this, _start).x, deltaY = event.clientY - __privateGet(this, _start).y;
  if (deltaTime > __privateGet(this, _thresholdTime)) {
    return;
  }
  let matchedEvent;
  if (deltaX === 0 && deltaY === 0) {
    matchedEvent = "tap";
  } else if (deltaX > __privateGet(this, _thresholdDistance) && Math.abs(deltaY) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swiperight";
  } else if (-deltaX > __privateGet(this, _thresholdDistance) && Math.abs(deltaY) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipeleft";
  } else if (deltaY > __privateGet(this, _thresholdDistance) && Math.abs(deltaX) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipedown";
  } else if (-deltaY > __privateGet(this, _thresholdDistance) && Math.abs(deltaX) < __privateGet(this, _thresholdDistance)) {
    matchedEvent = "swipeup";
  }
  if (matchedEvent) {
    __privateGet(this, _domElement).dispatchEvent(new CustomEvent(matchedEvent, { bubbles: true, composed: true, detail: { originalEvent: event } }));
  }
};

// dev/src/js/common/behavior/height-observer.js
var _updateCustomProperties, updateCustomProperties_fn;
var HeightObserver = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _updateCustomProperties);
    if (window.ResizeObserver) {
      new ResizeObserver(throttle(__privateMethod(this, _updateCustomProperties, updateCustomProperties_fn).bind(this))).observe(this);
    }
  }
  connectedCallback() {
    if (!window.ResizeObserver) {
      document.documentElement.style.setProperty(`--${this.getAttribute("variable")}-height`, `${this.clientHeight.toFixed(2)}px`);
    }
  }
};
_updateCustomProperties = new WeakSet();
updateCustomProperties_fn = function(entries) {
  entries.forEach((entry) => {
    if (entry.target === this) {
      const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
      document.documentElement.style.setProperty(`--${this.getAttribute("variable")}-height`, `${Math.round(height)}px`);
    }
  });
};
if (!window.customElements.get("height-observer")) {
  window.customElements.define("height-observer", HeightObserver);
}

// dev/src/js/common/behavior/loading-bar.js
import { animate as animate2 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _onLoadingStart, onLoadingStart_fn, _onLoadingEnd, onLoadingEnd_fn;
var LoadingBar = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onLoadingStart);
    __privateAdd(this, _onLoadingEnd);
    document.addEventListener("theme:loading:start", __privateMethod(this, _onLoadingStart, onLoadingStart_fn).bind(this));
    document.addEventListener("theme:loading:end", __privateMethod(this, _onLoadingEnd, onLoadingEnd_fn).bind(this));
  }
};
_onLoadingStart = new WeakSet();
onLoadingStart_fn = function() {
  animate2(this, { opacity: [0, 1], transform: ["scaleX(0)", "scaleX(0.4)"] }, { duration: 0.25 });
};
_onLoadingEnd = new WeakSet();
onLoadingEnd_fn = async function() {
  await animate2(this, { transform: [null, "scaleX(1)"] }, { duration: 0.25 }).finished;
  animate2(this, { opacity: 0 }, { duration: 0.25 });
};
if (!window.customElements.get("loading-bar")) {
  window.customElements.define("loading-bar", LoadingBar);
}

// dev/src/js/common/behavior/safe-sticky.js
import { inView as inView2 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _resizeObserver, _checkPositionListener, _initialTop, _lastKnownY, _currentTop, _position, _headerElement, _collectionStickyElement, _recalculateStyles, recalculateStyles_fn, _checkPosition, checkPosition_fn;
var SafeSticky = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _recalculateStyles);
    __privateAdd(this, _checkPosition);
    __privateAdd(this, _resizeObserver, new ResizeObserver(__privateMethod(this, _recalculateStyles, recalculateStyles_fn).bind(this)));
    __privateAdd(this, _checkPositionListener, throttle(__privateMethod(this, _checkPosition, checkPosition_fn).bind(this)));
    __privateAdd(this, _initialTop, 0);
    __privateAdd(this, _lastKnownY, 0);
    __privateAdd(this, _currentTop, 0);
    __privateAdd(this, _position, "relative");
    __privateAdd(this, _headerElement, void 0);
    __privateAdd(this, _collectionStickyElement, void 0);
  }
  connectedCallback() {
    __privateSet(this, _headerElement, document.querySelector("header.header"));
    inView2(this, () => {
      window.addEventListener("scroll", __privateGet(this, _checkPositionListener));
      __privateGet(this, _resizeObserver).observe(this);
      return () => {
        window.removeEventListener("scroll", __privateGet(this, _checkPositionListener));
        __privateGet(this, _resizeObserver).unobserve(this);
      };
    }, { margin: "500px" });
    if (document.querySelector(".shopify-section.shopify-section--header-collection")) {
      this.targetElement = document.querySelector(".shopify-section.shopify-section--header-collection");
      this.stickyElement = document.querySelector(".collection__sticky-filter-banner");
      this.options = {
        root: null,
        rootMargin: matchesMediaQuery("sm") ? "-137px" : "-129px",
        threshold: 0
      };
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.stickyElement.classList.remove("filter-banner--sticky");
          } else {
            this.stickyElement.classList.add("filter-banner--sticky");
          }
        });
      }, this.options);
      this.observer.observe(this.targetElement);
    }
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", __privateGet(this, _checkPositionListener));
    __privateGet(this, _resizeObserver).unobserve(this);
  }
};
_resizeObserver = new WeakMap();
_checkPositionListener = new WeakMap();
_initialTop = new WeakMap();
_lastKnownY = new WeakMap();
_currentTop = new WeakMap();
_position = new WeakMap();
_headerElement = new WeakMap();
_collectionStickyElement = new WeakMap();
_recalculateStyles = new WeakSet();
recalculateStyles_fn = function() {
  this.style.removeProperty("top");
  const computedStyles = getComputedStyle(this);
  __privateSet(this, _initialTop, parseInt(computedStyles.top));
  __privateSet(this, _position, computedStyles.position);
  __privateMethod(this, _checkPosition, checkPosition_fn).call(this);
};
_checkPosition = new WeakSet();
checkPosition_fn = function() {
  if (__privateGet(this, _position) !== "sticky") {
    return this.style.removeProperty("top");
  }
  let bounds = this.getBoundingClientRect(), maxTop = bounds.top + window.scrollY - this.offsetTop + __privateGet(this, _initialTop), minTop = this.clientHeight - window.innerHeight + 20;
  if (window.scrollY < __privateGet(this, _lastKnownY)) {
    __privateSet(this, _currentTop, __privateGet(this, _currentTop) - (window.scrollY - __privateGet(this, _lastKnownY)));
  } else {
    __privateSet(this, _currentTop, __privateGet(this, _currentTop) + (__privateGet(this, _lastKnownY) - window.scrollY));
  }
  __privateSet(this, _currentTop, Math.min(Math.max(__privateGet(this, _currentTop), -minTop), maxTop, __privateGet(this, _initialTop)));
  __privateSet(this, _lastKnownY, window.scrollY);
  this.style.top = `${Math.round(__privateGet(this, _currentTop))}px`;
  if (__privateGet(this, _currentTop) === __privateGet(this, _initialTop)) {
    __privateGet(this, _headerElement).classList.add("has-sticky");
  } else {
    __privateGet(this, _headerElement).classList.remove("has-sticky");
  }
};
if (!window.customElements.get("safe-sticky")) {
  window.customElements.define("safe-sticky", SafeSticky);
}

// dev/src/js/common/behavior/scroll-shadow.js
var template = `
  <style>
    :host {
      display: inline-block;
      contain: layout;
      position: relative;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    s {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      pointer-events: none;
      background-image:
        var(--scroll-shadow-top, linear-gradient(to bottom, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-bottom, linear-gradient(to top, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-left, linear-gradient(to right, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-right, linear-gradient(to left, rgb(var(--background)), rgb(var(--background) / 0)));
      background-position: top, bottom, left, right;
      background-repeat: no-repeat;
      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
    }
  </style>
  <slot></slot>
  <s></s>
`;
var Updater = class {
  constructor(targetElement) {
    this.scheduleUpdate = throttle(() => this.update(targetElement, getComputedStyle(targetElement)));
    this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this));
  }
  start(element) {
    if (this.element) {
      this.stop();
    }
    if (element) {
      element.addEventListener("scroll", this.scheduleUpdate);
      this.resizeObserver.observe(element);
      this.element = element;
    }
  }
  stop() {
    if (!this.element) {
      return;
    }
    this.element.removeEventListener("scroll", this.scheduleUpdate);
    this.resizeObserver.unobserve(this.element);
    this.element = null;
  }
  update(targetElement, style2) {
    if (!this.element) {
      return;
    }
    const maxSize = style2.getPropertyValue("--scroll-shadow-size") ? parseInt(style2.getPropertyValue("--scroll-shadow-size")) : 0;
    const scroll = {
      top: Math.max(this.element.scrollTop, 0),
      bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
      left: Math.max(this.element.scrollLeft, 0),
      right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0)
    };
    for (const position of ["top", "bottom", "left", "right"]) {
      targetElement.style.setProperty(
        `--${position}`,
        `${scroll[position] > maxSize ? maxSize : scroll[position]}px`
      );
    }
  }
};
var ScrollShadow = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).innerHTML = template;
    this.updater = new Updater(this.shadowRoot.lastElementChild);
  }
  connectedCallback() {
    this.shadowRoot.querySelector("slot").addEventListener("slotchange", this.start);
    this.start();
  }
  disconnectedCallback() {
    this.updater.stop();
  }
  start() {
    if (this.firstElementChild) {
      this.updater.start(this.firstElementChild);
    }
  }
};
if ("ResizeObserver" in window && !window.customElements.get("scroll-shadow")) {
  window.customElements.define("scroll-shadow", ScrollShadow);
}

// dev/src/js/common/carousel/carousel-container.js
var CarouselContainer = class extends HTMLElement {
  connectedCallback() {
    this.calcProductCarouselHeight();
    window.addEventListener("resize", this.calcProductCarouselHeight.bind(this));
  }
  get imageToObserve() {
    return this.querySelectorAll(this.getAttribute("image-selector"))[0];
  }
  calcProductCarouselHeight() {
    if (this.imageToObserve) {
      Array.from(this.querySelectorAll(".carousel-controls-centered")).forEach((item) => {
        item.style.height = this.imageToObserve.offsetHeight + "px";
      });
    }
  }
};
if (!window.customElements.get("carousel-container")) {
  window.customElements.define("carousel-container", CarouselContainer);
}

// dev/src/js/common/carousel/carousel-navigation.js
var CarouselNavigation = class extends HTMLElement {
  #abortController;
  #allItems = [];
  connectedCallback() {
    if (!this.carousel) {
      throw "Carousel navigation component requires an aria-controls attribute that refers to the controlled carousel.";
    }
    this.#abortController = new AbortController();
    this.#allItems = Array.from(this.querySelectorAll("button"));
    this.#allItems.forEach((button) => button.addEventListener("click", () => this.onButtonClicked(this.items.indexOf(button)), { signal: this.#abortController.signal }));
    this.carousel.addEventListener("carousel:change", (event) => this.onNavigationChange(event.detail.index), { signal: this.#abortController.signal });
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.select(this.items.indexOf(event.target)));
    }
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get items() {
    return this.#allItems.filter((item) => !item.hasAttribute("hidden"));
  }
  get carousel() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
  get selectedIndex() {
    return this.#allItems.findIndex((button) => button.getAttribute("aria-current") === "true");
  }
  onButtonClicked(newIndex) {
    this.carousel.select(newIndex);
    this.onNavigationChange(newIndex);
  }
  onNavigationChange(newIndex) {
    this.items.forEach((button, index) => button.setAttribute("aria-current", newIndex === index ? "true" : "false"));
    if (this.hasAttribute("align-selected") && (this.scrollWidth !== this.clientWidth || this.scrollHeight !== this.clientHeight)) {
      this.scrollTo({
        left: this.items[newIndex].offsetLeft - this.clientWidth / 2 + this.items[newIndex].clientWidth / 2,
        top: this.items[newIndex].offsetTop - this.clientHeight / 2 + this.items[newIndex].clientHeight / 2,
        behavior: matchesMediaQuery("motion-safe") ? "smooth" : "auto"
      });
    }
  }
};
var CarouselPrevButton = class extends HTMLButtonElement {
  #abortController;
  connectedCallback() {
    if (!this.carousel) {
      throw "Carousel prev button component requires an aria-controls attribute that refers to the controlled carousel.";
    }
    this.#abortController = new AbortController();
    this.addEventListener("click", () => this.carousel.previous(), { signal: this.#abortController.signal });
    this.carousel.addEventListener("scroll:edge-nearing", (event) => this.disabled = event.detail.position === "start", { signal: this.#abortController.signal });
    this.carousel.addEventListener("scroll:edge-leaving", (event) => this.disabled = event.detail.position === "start" ? false : this.disabled, { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get carousel() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
};
var CarouselNextButton = class extends HTMLButtonElement {
  #abortController;
  connectedCallback() {
    if (!this.carousel) {
      throw "Carousel next button component requires an aria-controls attribute that refers to the controlled carousel.";
    }
    this.#abortController = new AbortController();
    this.addEventListener("click", () => this.carousel.next(), { signal: this.#abortController.signal });
    this.carousel.addEventListener("scroll:edge-nearing", (event) => this.disabled = event.detail.position === "end", { signal: this.#abortController.signal });
    this.carousel.addEventListener("scroll:edge-leaving", (event) => this.disabled = event.detail.position === "end" ? false : this.disabled, { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get carousel() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
};
if (!window.customElements.get("carousel-prev-button")) {
  window.customElements.define("carousel-prev-button", CarouselPrevButton, { extends: "button" });
}
if (!window.customElements.get("carousel-next-button")) {
  window.customElements.define("carousel-next-button", CarouselNextButton, { extends: "button" });
}
if (!window.customElements.get("carousel-navigation")) {
  window.customElements.define("carousel-navigation", CarouselNavigation);
}

// node_modules/@splidejs/splide/dist/js/splide.esm.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var CREATED = 1;
var MOUNTED = 2;
var IDLE = 3;
var MOVING = 4;
var SCROLLING = 5;
var DRAGGING = 6;
var DESTROYED = 7;
var STATES = {
  CREATED,
  MOUNTED,
  IDLE,
  MOVING,
  SCROLLING,
  DRAGGING,
  DESTROYED
};
function empty(array) {
  array.length = 0;
}
function slice(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply(func) {
  return func.bind.apply(func, [null].concat(slice(arguments, 1)));
}
var nextTick = setTimeout;
var noop = function noop2() {
};
function raf(func) {
  return requestAnimationFrame(func);
}
function typeOf(type, subject) {
  return typeof subject === type;
}
function isObject(subject) {
  return !isNull(subject) && typeOf("object", subject);
}
var isArray = Array.isArray;
var isFunction = apply(typeOf, "function");
var isString = apply(typeOf, "string");
var isUndefined = apply(typeOf, "undefined");
function isNull(subject) {
  return subject === null;
}
function isHTMLElement(subject) {
  try {
    return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
  } catch (e) {
    return false;
  }
}
function toArray(value) {
  return isArray(value) ? value : [value];
}
function forEach(values, iteratee) {
  toArray(values).forEach(iteratee);
}
function includes(array, value) {
  return array.indexOf(value) > -1;
}
function push(array, items) {
  array.push.apply(array, toArray(items));
  return array;
}
function toggleClass(elm, classes, add) {
  if (elm) {
    forEach(classes, function(name) {
      if (name) {
        elm.classList[add ? "add" : "remove"](name);
      }
    });
  }
}
function addClass(elm, classes) {
  toggleClass(elm, isString(classes) ? classes.split(" ") : classes, true);
}
function append(parent, children2) {
  forEach(children2, parent.appendChild.bind(parent));
}
function before(nodes, ref) {
  forEach(nodes, function(node) {
    var parent = (ref || node).parentNode;
    if (parent) {
      parent.insertBefore(node, ref);
    }
  });
}
function matches(elm, selector) {
  return isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function children(parent, selector) {
  var children2 = parent ? slice(parent.children) : [];
  return selector ? children2.filter(function(child2) {
    return matches(child2, selector);
  }) : children2;
}
function child(parent, selector) {
  return selector ? children(parent, selector)[0] : parent.firstElementChild;
}
var ownKeys = Object.keys;
function forOwn(object, iteratee, right) {
  if (object) {
    (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(function(key) {
      key !== "__proto__" && iteratee(object[key], key);
    });
  }
  return object;
}
function assign(object) {
  slice(arguments, 1).forEach(function(source) {
    forOwn(source, function(value, key) {
      object[key] = source[key];
    });
  });
  return object;
}
function merge(object) {
  slice(arguments, 1).forEach(function(source) {
    forOwn(source, function(value, key) {
      if (isArray(value)) {
        object[key] = value.slice();
      } else if (isObject(value)) {
        object[key] = merge({}, isObject(object[key]) ? object[key] : {}, value);
      } else {
        object[key] = value;
      }
    });
  });
  return object;
}
function omit(object, keys) {
  forEach(keys || ownKeys(object), function(key) {
    delete object[key];
  });
}
function removeAttribute(elms, attrs) {
  forEach(elms, function(elm) {
    forEach(attrs, function(attr) {
      elm && elm.removeAttribute(attr);
    });
  });
}
function setAttribute(elms, attrs, value) {
  if (isObject(attrs)) {
    forOwn(attrs, function(value2, name) {
      setAttribute(elms, name, value2);
    });
  } else {
    forEach(elms, function(elm) {
      isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
  }
}
function create(tag, attrs, parent) {
  var elm = document.createElement(tag);
  if (attrs) {
    isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
  }
  parent && append(parent, elm);
  return elm;
}
function style(elm, prop, value) {
  if (isUndefined(value)) {
    return getComputedStyle(elm)[prop];
  }
  if (!isNull(value)) {
    elm.style[prop] = "" + value;
  }
}
function display(elm, display2) {
  style(elm, "display", display2);
}
function focus(elm) {
  elm["setActive"] && elm["setActive"]() || elm.focus({
    preventScroll: true
  });
}
function getAttribute(elm, attr) {
  return elm.getAttribute(attr);
}
function hasClass(elm, className) {
  return elm && elm.classList.contains(className);
}
function rect(target) {
  return target.getBoundingClientRect();
}
function remove(nodes) {
  forEach(nodes, function(node) {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}
function parseHtml(html) {
  return child(new DOMParser().parseFromString(html, "text/html").body);
}
function prevent(e, stopPropagation) {
  e.preventDefault();
  if (stopPropagation) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}
function query(parent, selector) {
  return parent && parent.querySelector(selector);
}
function queryAll(parent, selector) {
  return selector ? slice(parent.querySelectorAll(selector)) : [];
}
function removeClass(elm, classes) {
  toggleClass(elm, classes, false);
}
function timeOf(e) {
  return e.timeStamp;
}
function unit(value) {
  return isString(value) ? value : value ? value + "px" : "";
}
var PROJECT_CODE = "splide";
var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;
function assert(condition, message) {
  if (!condition) {
    throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
  }
}
var min = Math.min;
var max = Math.max;
var floor = Math.floor;
var ceil = Math.ceil;
var abs = Math.abs;
function approximatelyEqual(x, y, epsilon) {
  return abs(x - y) < epsilon;
}
function between(number, x, y, exclusive) {
  var minimum = min(x, y);
  var maximum = max(x, y);
  return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function clamp(number, x, y) {
  var minimum = min(x, y);
  var maximum = max(x, y);
  return min(max(minimum, number), maximum);
}
function sign(x) {
  return +(x > 0) - +(x < 0);
}
function format(string, replacements) {
  forEach(replacements, function(replacement) {
    string = string.replace("%s", "" + replacement);
  });
  return string;
}
function pad(number) {
  return number < 10 ? "0" + number : "" + number;
}
var ids = {};
function uniqueId(prefix) {
  return "" + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
}
function EventBinder() {
  var listeners = [];
  function bind(targets, events, callback, options) {
    forEachEvent(targets, events, function(target, event, namespace) {
      var isEventTarget = "addEventListener" in target;
      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
      isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
      listeners.push([target, event, namespace, callback, remover]);
    });
  }
  function unbind(targets, events, callback) {
    forEachEvent(targets, events, function(target, event, namespace) {
      listeners = listeners.filter(function(listener) {
        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
          listener[4]();
          return false;
        }
        return true;
      });
    });
  }
  function dispatch(target, type, detail) {
    var e;
    var bubbles = true;
    if (typeof CustomEvent === "function") {
      e = new CustomEvent(type, {
        bubbles,
        detail
      });
    } else {
      e = document.createEvent("CustomEvent");
      e.initCustomEvent(type, bubbles, false, detail);
    }
    target.dispatchEvent(e);
    return e;
  }
  function forEachEvent(targets, events, iteratee) {
    forEach(targets, function(target) {
      target && forEach(events, function(events2) {
        events2.split(" ").forEach(function(eventNS) {
          var fragment = eventNS.split(".");
          iteratee(target, fragment[0], fragment[1]);
        });
      });
    });
  }
  function destroy() {
    listeners.forEach(function(data) {
      data[4]();
    });
    empty(listeners);
  }
  return {
    bind,
    unbind,
    dispatch,
    destroy
  };
}
var EVENT_MOUNTED = "mounted";
var EVENT_READY = "ready";
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_CLICK = "click";
var EVENT_ACTIVE = "active";
var EVENT_INACTIVE = "inactive";
var EVENT_VISIBLE = "visible";
var EVENT_HIDDEN = "hidden";
var EVENT_REFRESH = "refresh";
var EVENT_UPDATED = "updated";
var EVENT_RESIZE = "resize";
var EVENT_RESIZED = "resized";
var EVENT_DRAG = "drag";
var EVENT_DRAGGING = "dragging";
var EVENT_DRAGGED = "dragged";
var EVENT_SCROLL = "scroll";
var EVENT_SCROLLED = "scrolled";
var EVENT_OVERFLOW = "overflow";
var EVENT_DESTROY = "destroy";
var EVENT_ARROWS_MOUNTED = "arrows:mounted";
var EVENT_ARROWS_UPDATED = "arrows:updated";
var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
var EVENT_PAGINATION_UPDATED = "pagination:updated";
var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
var EVENT_AUTOPLAY_PLAY = "autoplay:play";
var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
var EVENT_SLIDE_KEYDOWN = "sk";
var EVENT_SHIFTED = "sh";
var EVENT_END_INDEX_CHANGED = "ei";
function EventInterface(Splide2) {
  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
  var binder = EventBinder();
  function on(events, callback) {
    binder.bind(bus, toArray(events).join(" "), function(e) {
      callback.apply(callback, isArray(e.detail) ? e.detail : []);
    });
  }
  function emit(event) {
    binder.dispatch(bus, event, slice(arguments, 1));
  }
  if (Splide2) {
    Splide2.event.on(EVENT_DESTROY, binder.destroy);
  }
  return assign(binder, {
    bus,
    on,
    off: apply(binder.unbind, bus),
    emit
  });
}
function RequestInterval(interval, onInterval, onUpdate, limit) {
  var now = Date.now;
  var startTime;
  var rate = 0;
  var id;
  var paused = true;
  var count = 0;
  function update() {
    if (!paused) {
      rate = interval ? min((now() - startTime) / interval, 1) : 1;
      onUpdate && onUpdate(rate);
      if (rate >= 1) {
        onInterval();
        startTime = now();
        if (limit && ++count >= limit) {
          return pause();
        }
      }
      id = raf(update);
    }
  }
  function start(resume) {
    resume || cancel();
    startTime = now() - (resume ? rate * interval : 0);
    paused = false;
    id = raf(update);
  }
  function pause() {
    paused = true;
  }
  function rewind() {
    startTime = now();
    rate = 0;
    if (onUpdate) {
      onUpdate(rate);
    }
  }
  function cancel() {
    id && cancelAnimationFrame(id);
    rate = 0;
    id = 0;
    paused = true;
  }
  function set(time) {
    interval = time;
  }
  function isPaused() {
    return paused;
  }
  return {
    start,
    rewind,
    pause,
    cancel,
    set,
    isPaused
  };
}
function State(initialState) {
  var state = initialState;
  function set(value) {
    state = value;
  }
  function is(states) {
    return includes(toArray(states), state);
  }
  return {
    set,
    is
  };
}
function Throttle(func, duration) {
  var interval = RequestInterval(duration || 0, func, null, 1);
  return function() {
    interval.isPaused() && interval.start();
  };
}
function Media(Splide2, Components2, options) {
  var state = Splide2.state;
  var breakpoints = options.breakpoints || {};
  var reducedMotion = options.reducedMotion || {};
  var binder = EventBinder();
  var queries = [];
  function setup() {
    var isMin = options.mediaQuery === "min";
    ownKeys(breakpoints).sort(function(n, m) {
      return isMin ? +n - +m : +m - +n;
    }).forEach(function(key) {
      register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
    });
    register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
    update();
  }
  function destroy(completely) {
    if (completely) {
      binder.destroy();
    }
  }
  function register(options2, query2) {
    var queryList = matchMedia(query2);
    binder.bind(queryList, "change", update);
    queries.push([options2, queryList]);
  }
  function update() {
    var destroyed = state.is(DESTROYED);
    var direction = options.direction;
    var merged = queries.reduce(function(merged2, entry) {
      return merge(merged2, entry[1].matches ? entry[0] : {});
    }, {});
    omit(options);
    set(merged);
    if (options.destroy) {
      Splide2.destroy(options.destroy === "completely");
    } else if (destroyed) {
      destroy(true);
      Splide2.mount();
    } else {
      direction !== options.direction && Splide2.refresh();
    }
  }
  function reduce(enable) {
    if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
      enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
    }
  }
  function set(opts, base, notify) {
    merge(options, opts);
    base && merge(Object.getPrototypeOf(options), opts);
    if (notify || !state.is(CREATED)) {
      Splide2.emit(EVENT_UPDATED, options);
    }
  }
  return {
    setup,
    destroy,
    reduce,
    set
  };
}
var ARROW = "Arrow";
var ARROW_LEFT = ARROW + "Left";
var ARROW_RIGHT = ARROW + "Right";
var ARROW_UP = ARROW + "Up";
var ARROW_DOWN = ARROW + "Down";
var RTL = "rtl";
var TTB = "ttb";
var ORIENTATION_MAP = {
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: [ARROW_UP, ARROW_RIGHT],
  ArrowRight: [ARROW_DOWN, ARROW_LEFT]
};
function Direction(Splide2, Components2, options) {
  function resolve(prop, axisOnly, direction) {
    direction = direction || options.direction;
    var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
    return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
      var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
      return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
    });
  }
  function orient(value) {
    return value * (options.direction === RTL ? 1 : -1);
  }
  return {
    resolve,
    orient
  };
}
var ROLE = "role";
var TAB_INDEX = "tabindex";
var DISABLED = "disabled";
var ARIA_PREFIX = "aria-";
var ARIA_CONTROLS = ARIA_PREFIX + "controls";
var ARIA_CURRENT = ARIA_PREFIX + "current";
var ARIA_SELECTED = ARIA_PREFIX + "selected";
var ARIA_LABEL = ARIA_PREFIX + "label";
var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
var ARIA_LIVE = ARIA_PREFIX + "live";
var ARIA_BUSY = ARIA_PREFIX + "busy";
var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
var ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION];
var CLASS_PREFIX = PROJECT_CODE + "__";
var STATUS_CLASS_PREFIX = "is-";
var CLASS_ROOT = PROJECT_CODE;
var CLASS_TRACK = CLASS_PREFIX + "track";
var CLASS_LIST = CLASS_PREFIX + "list";
var CLASS_SLIDE = CLASS_PREFIX + "slide";
var CLASS_CLONE = CLASS_SLIDE + "--clone";
var CLASS_CONTAINER = CLASS_SLIDE + "__container";
var CLASS_ARROWS = CLASS_PREFIX + "arrows";
var CLASS_ARROW = CLASS_PREFIX + "arrow";
var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
var CLASS_PAGINATION = CLASS_PREFIX + "pagination";
var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
var CLASS_PROGRESS = CLASS_PREFIX + "progress";
var CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar";
var CLASS_TOGGLE = CLASS_PREFIX + "toggle";
var CLASS_TOGGLE_PLAY = CLASS_TOGGLE + "__play";
var CLASS_TOGGLE_PAUSE = CLASS_TOGGLE + "__pause";
var CLASS_SPINNER = CLASS_PREFIX + "spinner";
var CLASS_SR = CLASS_PREFIX + "sr";
var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized";
var CLASS_ACTIVE = STATUS_CLASS_PREFIX + "active";
var CLASS_PREV = STATUS_CLASS_PREFIX + "prev";
var CLASS_NEXT = STATUS_CLASS_PREFIX + "next";
var CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible";
var CLASS_LOADING = STATUS_CLASS_PREFIX + "loading";
var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in";
var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow";
var STATUS_CLASSES = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN, CLASS_OVERFLOW];
var CLASSES = {
  slide: CLASS_SLIDE,
  clone: CLASS_CLONE,
  arrows: CLASS_ARROWS,
  arrow: CLASS_ARROW,
  prev: CLASS_ARROW_PREV,
  next: CLASS_ARROW_NEXT,
  pagination: CLASS_PAGINATION,
  page: CLASS_PAGINATION_PAGE,
  spinner: CLASS_SPINNER
};
function closest(from, selector) {
  if (isFunction(from.closest)) {
    return from.closest(selector);
  }
  var elm = from;
  while (elm && elm.nodeType === 1) {
    if (matches(elm, selector)) {
      break;
    }
    elm = elm.parentElement;
  }
  return elm;
}
var FRICTION = 5;
var LOG_INTERVAL = 200;
var POINTER_DOWN_EVENTS = "touchstart mousedown";
var POINTER_MOVE_EVENTS = "touchmove mousemove";
var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function Elements(Splide2, Components2, options) {
  var _EventInterface = EventInterface(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
  var root = Splide2.root;
  var i18n = options.i18n;
  var elements = {};
  var slides = [];
  var rootClasses = [];
  var trackClasses = [];
  var track;
  var list;
  var isUsingKey;
  function setup() {
    collect();
    init();
    update();
  }
  function mount() {
    on(EVENT_REFRESH, destroy);
    on(EVENT_REFRESH, setup);
    on(EVENT_UPDATED, update);
    bind(document, POINTER_DOWN_EVENTS + " keydown", function(e) {
      isUsingKey = e.type === "keydown";
    }, {
      capture: true
    });
    bind(root, "focusin", function() {
      toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
    });
  }
  function destroy(completely) {
    var attrs = ALL_ATTRIBUTES.concat("style");
    empty(slides);
    removeClass(root, rootClasses);
    removeClass(track, trackClasses);
    removeAttribute([track, list], attrs);
    removeAttribute(root, completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]);
  }
  function update() {
    removeClass(root, rootClasses);
    removeClass(track, trackClasses);
    rootClasses = getClasses(CLASS_ROOT);
    trackClasses = getClasses(CLASS_TRACK);
    addClass(root, rootClasses);
    addClass(track, trackClasses);
    setAttribute(root, ARIA_LABEL, options.label);
    setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
  }
  function collect() {
    track = find("." + CLASS_TRACK);
    list = child(track, "." + CLASS_LIST);
    assert(track && list, "A track/list element is missing.");
    push(slides, children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")"));
    forOwn({
      arrows: CLASS_ARROWS,
      pagination: CLASS_PAGINATION,
      prev: CLASS_ARROW_PREV,
      next: CLASS_ARROW_NEXT,
      bar: CLASS_PROGRESS_BAR,
      toggle: CLASS_TOGGLE
    }, function(className, key) {
      elements[key] = find("." + className);
    });
    assign(elements, {
      root,
      track,
      list,
      slides
    });
  }
  function init() {
    var id = root.id || uniqueId(PROJECT_CODE);
    var role = options.role;
    root.id = id;
    track.id = track.id || id + "-track";
    list.id = list.id || id + "-list";
    if (!getAttribute(root, ROLE) && root.tagName !== "SECTION" && role) {
      setAttribute(root, ROLE, role);
    }
    setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
    setAttribute(list, ROLE, "presentation");
  }
  function find(selector) {
    var elm = query(root, selector);
    return elm && closest(elm, "." + CLASS_ROOT) === root ? elm : void 0;
  }
  function getClasses(base) {
    return [base + "--" + options.type, base + "--" + options.direction, options.drag && base + "--draggable", options.isNavigation && base + "--nav", base === CLASS_ROOT && CLASS_ACTIVE];
  }
  return assign(elements, {
    setup,
    mount,
    destroy
  });
}
var SLIDE = "slide";
var LOOP = "loop";
var FADE = "fade";
function Slide$1(Splide2, index, slideIndex, slide) {
  var event = EventInterface(Splide2);
  var on = event.on, emit = event.emit, bind = event.bind;
  var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
  var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
  var resolve = Components.Direction.resolve;
  var styles = getAttribute(slide, "style");
  var label = getAttribute(slide, ARIA_LABEL);
  var isClone = slideIndex > -1;
  var container = child(slide, "." + CLASS_CONTAINER);
  var destroyed;
  function mount() {
    if (!isClone) {
      slide.id = root.id + "-slide" + pad(index + 1);
      setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
      setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
      setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
    }
    listen();
  }
  function listen() {
    bind(slide, "click", apply(emit, EVENT_CLICK, self2));
    bind(slide, "keydown", apply(emit, EVENT_SLIDE_KEYDOWN, self2));
    on([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
    on(EVENT_NAVIGATION_MOUNTED, initNavigation);
    if (updateOnMove) {
      on(EVENT_MOVE, onMove);
    }
  }
  function destroy() {
    destroyed = true;
    event.destroy();
    removeClass(slide, STATUS_CLASSES);
    removeAttribute(slide, ALL_ATTRIBUTES);
    setAttribute(slide, "style", styles);
    setAttribute(slide, ARIA_LABEL, label || "");
  }
  function initNavigation() {
    var controls = Splide2.splides.map(function(target) {
      var Slide22 = target.splide.Components.Slides.getAt(index);
      return Slide22 ? Slide22.slide.id : "";
    }).join(" ");
    setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
    setAttribute(slide, ARIA_CONTROLS, controls);
    setAttribute(slide, ROLE, slideFocus ? "button" : "");
    slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
  }
  function onMove() {
    if (!destroyed) {
      update();
    }
  }
  function update() {
    if (!destroyed) {
      var curr = Splide2.index;
      updateActivity();
      updateVisibility();
      toggleClass(slide, CLASS_PREV, index === curr - 1);
      toggleClass(slide, CLASS_NEXT, index === curr + 1);
    }
  }
  function updateActivity() {
    var active = isActive();
    if (active !== hasClass(slide, CLASS_ACTIVE)) {
      toggleClass(slide, CLASS_ACTIVE, active);
      setAttribute(slide, ARIA_CURRENT, isNavigation && active || "");
      emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self2);
    }
  }
  function updateVisibility() {
    var visible = isVisible();
    var hidden = !visible && (!isActive() || isClone);
    if (!Splide2.state.is([MOVING, SCROLLING])) {
      setAttribute(slide, ARIA_HIDDEN, hidden || "");
    }
    setAttribute(queryAll(slide, options.focusableNodes || ""), TAB_INDEX, hidden ? -1 : "");
    if (slideFocus) {
      setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
    }
    if (visible !== hasClass(slide, CLASS_VISIBLE)) {
      toggleClass(slide, CLASS_VISIBLE, visible);
      emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self2);
    }
    if (!visible && document.activeElement === slide) {
      var Slide22 = Components.Slides.getAt(Splide2.index);
      Slide22 && focus(Slide22.slide);
    }
  }
  function style$1(prop, value, useContainer) {
    style(useContainer && container || slide, prop, value);
  }
  function isActive() {
    var curr = Splide2.index;
    return curr === index || options.cloneStatus && curr === slideIndex;
  }
  function isVisible() {
    if (Splide2.is(FADE)) {
      return isActive();
    }
    var trackRect = rect(Components.Elements.track);
    var slideRect = rect(slide);
    var left = resolve("left", true);
    var right = resolve("right", true);
    return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
  }
  function isWithin(from, distance) {
    var diff = abs(from - index);
    if (!isClone && (options.rewind || Splide2.is(LOOP))) {
      diff = min(diff, Splide2.length - diff);
    }
    return diff <= distance;
  }
  var self2 = {
    index,
    slideIndex,
    slide,
    container,
    isClone,
    mount,
    destroy,
    update,
    style: style$1,
    isWithin
  };
  return self2;
}
function Slides(Splide2, Components2, options) {
  var _EventInterface2 = EventInterface(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
  var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
  var Slides2 = [];
  function mount() {
    init();
    on(EVENT_REFRESH, destroy);
    on(EVENT_REFRESH, init);
  }
  function init() {
    slides.forEach(function(slide, index) {
      register(slide, index, -1);
    });
  }
  function destroy() {
    forEach$1(function(Slide22) {
      Slide22.destroy();
    });
    empty(Slides2);
  }
  function update() {
    forEach$1(function(Slide22) {
      Slide22.update();
    });
  }
  function register(slide, index, slideIndex) {
    var object = Slide$1(Splide2, index, slideIndex, slide);
    object.mount();
    Slides2.push(object);
    Slides2.sort(function(Slide1, Slide22) {
      return Slide1.index - Slide22.index;
    });
  }
  function get(excludeClones) {
    return excludeClones ? filter(function(Slide22) {
      return !Slide22.isClone;
    }) : Slides2;
  }
  function getIn(page) {
    var Controller2 = Components2.Controller;
    var index = Controller2.toIndex(page);
    var max2 = Controller2.hasFocus() ? 1 : options.perPage;
    return filter(function(Slide22) {
      return between(Slide22.index, index, index + max2 - 1);
    });
  }
  function getAt(index) {
    return filter(index)[0];
  }
  function add(items, index) {
    forEach(items, function(slide) {
      if (isString(slide)) {
        slide = parseHtml(slide);
      }
      if (isHTMLElement(slide)) {
        var ref = slides[index];
        ref ? before(slide, ref) : append(list, slide);
        addClass(slide, options.classes.slide);
        observeImages(slide, apply(emit, EVENT_RESIZE));
      }
    });
    emit(EVENT_REFRESH);
  }
  function remove$1(matcher) {
    remove(filter(matcher).map(function(Slide22) {
      return Slide22.slide;
    }));
    emit(EVENT_REFRESH);
  }
  function forEach$1(iteratee, excludeClones) {
    get(excludeClones).forEach(iteratee);
  }
  function filter(matcher) {
    return Slides2.filter(isFunction(matcher) ? matcher : function(Slide22) {
      return isString(matcher) ? matches(Slide22.slide, matcher) : includes(toArray(matcher), Slide22.index);
    });
  }
  function style2(prop, value, useContainer) {
    forEach$1(function(Slide22) {
      Slide22.style(prop, value, useContainer);
    });
  }
  function observeImages(elm, callback) {
    var images = queryAll(elm, "img");
    var length = images.length;
    if (length) {
      images.forEach(function(img) {
        bind(img, "load error", function() {
          if (!--length) {
            callback();
          }
        });
      });
    } else {
      callback();
    }
  }
  function getLength(excludeClones) {
    return excludeClones ? slides.length : Slides2.length;
  }
  function isEnough() {
    return Slides2.length > options.perPage;
  }
  return {
    mount,
    destroy,
    update,
    register,
    get,
    getIn,
    getAt,
    add,
    remove: remove$1,
    forEach: forEach$1,
    filter,
    style: style2,
    getLength,
    isEnough
  };
}
function Layout(Splide2, Components2, options) {
  var _EventInterface3 = EventInterface(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
  var Slides2 = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
  var getAt = Slides2.getAt, styleSlides = Slides2.style;
  var vertical;
  var rootRect;
  var overflow;
  function mount() {
    init();
    bind(window, "resize load", Throttle(apply(emit, EVENT_RESIZE)));
    on([EVENT_UPDATED, EVENT_REFRESH], init);
    on(EVENT_RESIZE, resize);
  }
  function init() {
    vertical = options.direction === TTB;
    style(root, "maxWidth", unit(options.width));
    style(track, resolve("paddingLeft"), cssPadding(false));
    style(track, resolve("paddingRight"), cssPadding(true));
    resize(true);
  }
  function resize(force) {
    var newRect = rect(root);
    if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
      style(track, "height", cssTrackHeight());
      styleSlides(resolve("marginRight"), unit(options.gap));
      styleSlides("width", cssSlideWidth());
      styleSlides("height", cssSlideHeight(), true);
      rootRect = newRect;
      emit(EVENT_RESIZED);
      if (overflow !== (overflow = isOverflow())) {
        toggleClass(root, CLASS_OVERFLOW, overflow);
        emit(EVENT_OVERFLOW, overflow);
      }
    }
  }
  function cssPadding(right) {
    var padding = options.padding;
    var prop = resolve(right ? "right" : "left");
    return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
  }
  function cssTrackHeight() {
    var height = "";
    if (vertical) {
      height = cssHeight();
      assert(height, "height or heightRatio is missing.");
      height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
    }
    return height;
  }
  function cssHeight() {
    return unit(options.height || rect(list).width * options.heightRatio);
  }
  function cssSlideWidth() {
    return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
  }
  function cssSlideHeight() {
    return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
  }
  function cssSlideSize() {
    var gap = unit(options.gap);
    return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
  }
  function listSize() {
    return rect(list)[resolve("width")];
  }
  function slideSize(index, withoutGap) {
    var Slide3 = getAt(index || 0);
    return Slide3 ? rect(Slide3.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
  }
  function totalSize(index, withoutGap) {
    var Slide3 = getAt(index);
    if (Slide3) {
      var right = rect(Slide3.slide)[resolve("right")];
      var left = rect(list)[resolve("left")];
      return abs(right - left) + (withoutGap ? 0 : getGap());
    }
    return 0;
  }
  function sliderSize(withoutGap) {
    return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
  }
  function getGap() {
    var Slide3 = getAt(0);
    return Slide3 && parseFloat(style(Slide3.slide, resolve("marginRight"))) || 0;
  }
  function getPadding(right) {
    return parseFloat(style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
  }
  function isOverflow() {
    return Splide2.is(FADE) || sliderSize(true) > listSize();
  }
  return {
    mount,
    resize,
    listSize,
    slideSize,
    sliderSize,
    totalSize,
    getPadding,
    isOverflow
  };
}
var MULTIPLIER = 2;
function Clones(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on;
  var Elements2 = Components2.Elements, Slides2 = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var clones = [];
  var cloneCount;
  function mount() {
    on(EVENT_REFRESH, remount);
    on([EVENT_UPDATED, EVENT_RESIZE], observe);
    if (cloneCount = computeCloneCount()) {
      generate(cloneCount);
      Components2.Layout.resize(true);
    }
  }
  function remount() {
    destroy();
    mount();
  }
  function destroy() {
    remove(clones);
    empty(clones);
    event.destroy();
  }
  function observe() {
    var count = computeCloneCount();
    if (cloneCount !== count) {
      if (cloneCount < count || !count) {
        event.emit(EVENT_REFRESH);
      }
    }
  }
  function generate(count) {
    var slides = Slides2.get().slice();
    var length = slides.length;
    if (length) {
      while (slides.length < count) {
        push(slides, slides);
      }
      push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide3, index) {
        var isHead = index < count;
        var clone = cloneDeep(Slide3.slide, index);
        isHead ? before(clone, slides[0].slide) : append(Elements2.list, clone);
        push(clones, clone);
        Slides2.register(clone, index - count + (isHead ? 0 : length), Slide3.index);
      });
    }
  }
  function cloneDeep(elm, index) {
    var clone = elm.cloneNode(true);
    addClass(clone, options.classes.clone);
    clone.id = Splide2.root.id + "-clone" + pad(index + 1);
    return clone;
  }
  function computeCloneCount() {
    var clones2 = options.clones;
    if (!Splide2.is(LOOP)) {
      clones2 = 0;
    } else if (isUndefined(clones2)) {
      var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
      var fixedCount = fixedSize && ceil(rect(Elements2.track)[resolve("width")] / fixedSize);
      clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * MULTIPLIER;
    }
    return clones2;
  }
  return {
    mount,
    destroy
  };
}
function Move(Splide2, Components2, options) {
  var _EventInterface4 = EventInterface(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
  var set = Splide2.state.set;
  var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
  var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
  var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
  var Transition;
  function mount() {
    Transition = Components2.Transition;
    on([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
  }
  function reposition() {
    if (!Components2.Controller.isBusy()) {
      Components2.Scroll.cancel();
      jump(Splide2.index);
      Components2.Slides.update();
    }
  }
  function move(dest, index, prev, callback) {
    if (dest !== index && canShift(dest > prev)) {
      cancel();
      translate(shift(getPosition(), dest > prev), true);
    }
    set(MOVING);
    emit(EVENT_MOVE, index, prev, dest);
    Transition.start(index, function() {
      set(IDLE);
      emit(EVENT_MOVED, index, prev, dest);
      callback && callback();
    });
  }
  function jump(index) {
    translate(toPosition(index, true));
  }
  function translate(position, preventLoop) {
    if (!Splide2.is(FADE)) {
      var destination = preventLoop ? position : loop(position);
      style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
      position !== destination && emit(EVENT_SHIFTED);
    }
  }
  function loop(position) {
    if (Splide2.is(LOOP)) {
      var index = toIndex(position);
      var exceededMax = index > Components2.Controller.getEnd();
      var exceededMin = index < 0;
      if (exceededMin || exceededMax) {
        position = shift(position, exceededMax);
      }
    }
    return position;
  }
  function shift(position, backwards) {
    var excess = position - getLimit(backwards);
    var size = sliderSize();
    position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
    return position;
  }
  function cancel() {
    translate(getPosition(), true);
    Transition.cancel();
  }
  function toIndex(position) {
    var Slides2 = Components2.Slides.get();
    var index = 0;
    var minDistance = Infinity;
    for (var i = 0; i < Slides2.length; i++) {
      var slideIndex = Slides2[i].index;
      var distance = abs(toPosition(slideIndex, true) - position);
      if (distance <= minDistance) {
        minDistance = distance;
        index = slideIndex;
      } else {
        break;
      }
    }
    return index;
  }
  function toPosition(index, trimming) {
    var position = orient(totalSize(index - 1) - offset(index));
    return trimming ? trim(position) : position;
  }
  function getPosition() {
    var left = resolve("left");
    return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
  }
  function trim(position) {
    if (options.trimSpace && Splide2.is(SLIDE)) {
      position = clamp(position, 0, orient(sliderSize(true) - listSize()));
    }
    return position;
  }
  function offset(index) {
    var focus2 = options.focus;
    return focus2 === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus2 * slideSize(index) || 0;
  }
  function getLimit(max2) {
    return toPosition(max2 ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
  }
  function canShift(backwards) {
    var shifted = orient(shift(getPosition(), backwards));
    return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - rect(track)[resolve("width")];
  }
  function exceededLimit(max2, position) {
    position = isUndefined(position) ? getPosition() : position;
    var exceededMin = max2 !== true && orient(position) < orient(getLimit(false));
    var exceededMax = max2 !== false && orient(position) > orient(getLimit(true));
    return exceededMin || exceededMax;
  }
  return {
    mount,
    move,
    jump,
    translate,
    shift,
    cancel,
    toIndex,
    toPosition,
    getPosition,
    getLimit,
    exceededLimit,
    reposition
  };
}
function Controller(Splide2, Components2, options) {
  var _EventInterface5 = EventInterface(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
  var Move2 = Components2.Move;
  var getPosition = Move2.getPosition, getLimit = Move2.getLimit, toPosition = Move2.toPosition;
  var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
  var omitEnd = options.omitEnd;
  var isLoop = Splide2.is(LOOP);
  var isSlide = Splide2.is(SLIDE);
  var getNext = apply(getAdjacent, false);
  var getPrev = apply(getAdjacent, true);
  var currIndex = options.start || 0;
  var endIndex;
  var prevIndex = currIndex;
  var slideCount;
  var perMove;
  var perPage;
  function mount() {
    init();
    on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], init);
    on(EVENT_RESIZED, onResized);
  }
  function init() {
    slideCount = getLength(true);
    perMove = options.perMove;
    perPage = options.perPage;
    endIndex = getEnd();
    var index = clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
    if (index !== currIndex) {
      currIndex = index;
      Move2.reposition();
    }
  }
  function onResized() {
    if (endIndex !== getEnd()) {
      emit(EVENT_END_INDEX_CHANGED);
    }
  }
  function go(control, allowSameIndex, callback) {
    if (!isBusy()) {
      var dest = parse(control);
      var index = loop(dest);
      if (index > -1 && (allowSameIndex || index !== currIndex)) {
        setIndex(index);
        Move2.move(dest, index, prevIndex, callback);
      }
    }
  }
  function scroll(destination, duration, snap, callback) {
    Components2.Scroll.scroll(destination, duration, snap, function() {
      var index = loop(Move2.toIndex(getPosition()));
      setIndex(omitEnd ? min(index, endIndex) : index);
      callback && callback();
    });
  }
  function parse(control) {
    var index = currIndex;
    if (isString(control)) {
      var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
      if (indicator === "+" || indicator === "-") {
        index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
      } else if (indicator === ">") {
        index = number ? toIndex(+number) : getNext(true);
      } else if (indicator === "<") {
        index = getPrev(true);
      }
    } else {
      index = isLoop ? control : clamp(control, 0, endIndex);
    }
    return index;
  }
  function getAdjacent(prev, destination) {
    var number = perMove || (hasFocus() ? 1 : perPage);
    var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
    if (dest === -1 && isSlide) {
      if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
        return prev ? 0 : endIndex;
      }
    }
    return destination ? dest : loop(dest);
  }
  function computeDestIndex(dest, from, snapPage) {
    if (isEnough() || hasFocus()) {
      var index = computeMovableDestIndex(dest);
      if (index !== dest) {
        from = dest;
        dest = index;
        snapPage = false;
      }
      if (dest < 0 || dest > endIndex) {
        if (!perMove && (between(0, dest, from, true) || between(endIndex, from, dest, true))) {
          dest = toIndex(toPage(dest));
        } else {
          if (isLoop) {
            dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
          } else if (options.rewind) {
            dest = dest < 0 ? endIndex : 0;
          } else {
            dest = -1;
          }
        }
      } else {
        if (snapPage && dest !== from) {
          dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        }
      }
    } else {
      dest = -1;
    }
    return dest;
  }
  function computeMovableDestIndex(dest) {
    if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
      var position = getPosition();
      while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) {
        dest < currIndex ? --dest : ++dest;
      }
    }
    return dest;
  }
  function loop(index) {
    return isLoop ? (index + slideCount) % slideCount || 0 : index;
  }
  function getEnd() {
    var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
    while (omitEnd && end-- > 0) {
      if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
        end++;
        break;
      }
    }
    return clamp(end, 0, slideCount - 1);
  }
  function toIndex(page) {
    return clamp(hasFocus() ? page : perPage * page, 0, endIndex);
  }
  function toPage(index) {
    return hasFocus() ? min(index, endIndex) : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
  }
  function toDest(destination) {
    var closest2 = Move2.toIndex(destination);
    return isSlide ? clamp(closest2, 0, endIndex) : closest2;
  }
  function setIndex(index) {
    if (index !== currIndex) {
      prevIndex = currIndex;
      currIndex = index;
    }
  }
  function getIndex(prev) {
    return prev ? prevIndex : currIndex;
  }
  function hasFocus() {
    return !isUndefined(options.focus) || options.isNavigation;
  }
  function isBusy() {
    return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
  }
  return {
    mount,
    go,
    scroll,
    getNext,
    getPrev,
    getAdjacent,
    getEnd,
    setIndex,
    getIndex,
    toIndex,
    toPage,
    toDest,
    hasFocus,
    isBusy
  };
}
var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var SIZE = 40;
function Arrows(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on, bind = event.bind, emit = event.emit;
  var classes = options.classes, i18n = options.i18n;
  var Elements2 = Components2.Elements, Controller2 = Components2.Controller;
  var placeholder = Elements2.arrows, track = Elements2.track;
  var wrapper = placeholder;
  var prev = Elements2.prev;
  var next = Elements2.next;
  var created;
  var wrapperClasses;
  var arrows = {};
  function mount() {
    init();
    on(EVENT_UPDATED, remount);
  }
  function remount() {
    destroy();
    mount();
  }
  function init() {
    var enabled = options.arrows;
    if (enabled && !(prev && next)) {
      createArrows();
    }
    if (prev && next) {
      assign(arrows, {
        prev,
        next
      });
      display(wrapper, enabled ? "" : "none");
      addClass(wrapper, wrapperClasses = CLASS_ARROWS + "--" + options.direction);
      if (enabled) {
        listen();
        update();
        setAttribute([prev, next], ARIA_CONTROLS, track.id);
        emit(EVENT_ARROWS_MOUNTED, prev, next);
      }
    }
  }
  function destroy() {
    event.destroy();
    removeClass(wrapper, wrapperClasses);
    if (created) {
      remove(placeholder ? [prev, next] : wrapper);
      prev = next = null;
    } else {
      removeAttribute([prev, next], ALL_ATTRIBUTES);
    }
  }
  function listen() {
    on([EVENT_MOUNTED, EVENT_MOVED, EVENT_REFRESH, EVENT_SCROLLED, EVENT_END_INDEX_CHANGED], update);
    bind(next, "click", apply(go, ">"));
    bind(prev, "click", apply(go, "<"));
  }
  function go(control) {
    Controller2.go(control, true);
  }
  function createArrows() {
    wrapper = placeholder || create("div", classes.arrows);
    prev = createArrow(true);
    next = createArrow(false);
    created = true;
    append(wrapper, [prev, next]);
    !placeholder && before(wrapper, track);
  }
  function createArrow(prev2) {
    var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + XML_NAME_SPACE + '" viewBox="0 0 ' + SIZE + " " + SIZE + '" width="' + SIZE + '" height="' + SIZE + '" focusable="false"><path d="' + (options.arrowPath || PATH) + '" />';
    return parseHtml(arrow);
  }
  function update() {
    if (prev && next) {
      var index = Splide2.index;
      var prevIndex = Controller2.getPrev();
      var nextIndex = Controller2.getNext();
      var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
      var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
      prev.disabled = prevIndex < 0;
      next.disabled = nextIndex < 0;
      setAttribute(prev, ARIA_LABEL, prevLabel);
      setAttribute(next, ARIA_LABEL, nextLabel);
      emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
    }
  }
  return {
    arrows,
    mount,
    destroy,
    update
  };
}
var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";
function Autoplay(Splide2, Components2, options) {
  var _EventInterface6 = EventInterface(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
  var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
  var isPaused = interval.isPaused;
  var Elements2 = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
  var autoplay = options.autoplay;
  var hovered;
  var focused;
  var stopped = autoplay === "pause";
  function mount() {
    if (autoplay) {
      listen();
      toggle && setAttribute(toggle, ARIA_CONTROLS, Elements2.track.id);
      stopped || play();
      update();
    }
  }
  function listen() {
    if (options.pauseOnHover) {
      bind(root, "mouseenter mouseleave", function(e) {
        hovered = e.type === "mouseenter";
        autoToggle();
      });
    }
    if (options.pauseOnFocus) {
      bind(root, "focusin focusout", function(e) {
        focused = e.type === "focusin";
        autoToggle();
      });
    }
    if (toggle) {
      bind(toggle, "click", function() {
        stopped ? play() : pause(true);
      });
    }
    on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
    on(EVENT_MOVE, onMove);
  }
  function play() {
    if (isPaused() && Components2.Slides.isEnough()) {
      interval.start(!options.resetProgress);
      focused = hovered = stopped = false;
      update();
      emit(EVENT_AUTOPLAY_PLAY);
    }
  }
  function pause(stop) {
    if (stop === void 0) {
      stop = true;
    }
    stopped = !!stop;
    update();
    if (!isPaused()) {
      interval.pause();
      emit(EVENT_AUTOPLAY_PAUSE);
    }
  }
  function autoToggle() {
    if (!stopped) {
      hovered || focused ? pause(false) : play();
    }
  }
  function update() {
    if (toggle) {
      toggleClass(toggle, CLASS_ACTIVE, !stopped);
      setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
    }
  }
  function onAnimationFrame(rate) {
    var bar = Elements2.bar;
    bar && style(bar, "width", rate * 100 + "%");
    emit(EVENT_AUTOPLAY_PLAYING, rate);
  }
  function onMove(index) {
    var Slide3 = Components2.Slides.getAt(index);
    interval.set(Slide3 && +getAttribute(Slide3.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
  }
  return {
    mount,
    destroy: interval.cancel,
    play,
    pause,
    isPaused
  };
}
function Cover(Splide2, Components2, options) {
  var _EventInterface7 = EventInterface(Splide2), on = _EventInterface7.on;
  function mount() {
    if (options.cover) {
      on(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
      on([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply(cover, true));
    }
  }
  function cover(cover2) {
    Components2.Slides.forEach(function(Slide3) {
      var img = child(Slide3.container || Slide3.slide, "img");
      if (img && img.src) {
        toggle(cover2, img, Slide3);
      }
    });
  }
  function toggle(cover2, img, Slide3) {
    Slide3.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
    display(img, cover2 ? "none" : "");
  }
  return {
    mount,
    destroy: apply(cover, false)
  };
}
var BOUNCE_DIFF_THRESHOLD = 10;
var BOUNCE_DURATION = 600;
var FRICTION_FACTOR = 0.6;
var BASE_VELOCITY = 1.5;
var MIN_DURATION = 800;
function Scroll(Splide2, Components2, options) {
  var _EventInterface8 = EventInterface(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
  var set = Splide2.state.set;
  var Move2 = Components2.Move;
  var getPosition = Move2.getPosition, getLimit = Move2.getLimit, exceededLimit = Move2.exceededLimit, translate = Move2.translate;
  var isSlide = Splide2.is(SLIDE);
  var interval;
  var callback;
  var friction = 1;
  function mount() {
    on(EVENT_MOVE, clear);
    on([EVENT_UPDATED, EVENT_REFRESH], cancel);
  }
  function scroll(destination, duration, snap, onScrolled, noConstrain) {
    var from = getPosition();
    clear();
    if (snap && (!isSlide || !exceededLimit())) {
      var size = Components2.Layout.sliderSize();
      var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
      destination = Move2.toPosition(Components2.Controller.toDest(destination % size)) + offset;
    }
    var noDistance = approximatelyEqual(from, destination, 1);
    friction = 1;
    duration = noDistance ? 0 : duration || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
    callback = onScrolled;
    interval = RequestInterval(duration, onEnd, apply(update, from, destination, noConstrain), 1);
    set(SCROLLING);
    emit(EVENT_SCROLL);
    interval.start();
  }
  function onEnd() {
    set(IDLE);
    callback && callback();
    emit(EVENT_SCROLLED);
  }
  function update(from, to, noConstrain, rate) {
    var position = getPosition();
    var target = from + (to - from) * easing(rate);
    var diff = (target - position) * friction;
    translate(position + diff);
    if (isSlide && !noConstrain && exceededLimit()) {
      friction *= FRICTION_FACTOR;
      if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
        scroll(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
      }
    }
  }
  function clear() {
    if (interval) {
      interval.cancel();
    }
  }
  function cancel() {
    if (interval && !interval.isPaused()) {
      clear();
      onEnd();
    }
  }
  function easing(t) {
    var easingFunc = options.easingFunc;
    return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
  }
  return {
    mount,
    destroy: clear,
    scroll,
    cancel
  };
}
var SCROLL_LISTENER_OPTIONS = {
  passive: false,
  capture: true
};
function Drag(Splide2, Components2, options) {
  var _EventInterface9 = EventInterface(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
  var state = Splide2.state;
  var Move2 = Components2.Move, Scroll2 = Components2.Scroll, Controller2 = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
  var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
  var getPosition = Move2.getPosition, exceededLimit = Move2.exceededLimit;
  var basePosition;
  var baseEvent;
  var prevBaseEvent;
  var isFree;
  var dragging;
  var exceeded = false;
  var clickPrevented;
  var disabled;
  var target;
  function mount() {
    bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
    bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
    bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
    bind(track, "click", onClick, {
      capture: true
    });
    bind(track, "dragstart", prevent);
    on([EVENT_MOUNTED, EVENT_UPDATED], init);
  }
  function init() {
    var drag = options.drag;
    disable(!drag);
    isFree = drag === "free";
  }
  function onPointerDown(e) {
    clickPrevented = false;
    if (!disabled) {
      var isTouch = isTouchEvent(e);
      if (isDraggable(e.target) && (isTouch || !e.button)) {
        if (!Controller2.isBusy()) {
          target = isTouch ? track : window;
          dragging = state.is([MOVING, SCROLLING]);
          prevBaseEvent = null;
          bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
          bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
          Move2.cancel();
          Scroll2.cancel();
          save(e);
        } else {
          prevent(e, true);
        }
      }
    }
  }
  function onPointerMove(e) {
    if (!state.is(DRAGGING)) {
      state.set(DRAGGING);
      emit(EVENT_DRAG);
    }
    if (e.cancelable) {
      if (dragging) {
        Move2.translate(basePosition + constrain(diffCoord(e)));
        var expired = diffTime(e) > LOG_INTERVAL;
        var hasExceeded = exceeded !== (exceeded = exceededLimit());
        if (expired || hasExceeded) {
          save(e);
        }
        clickPrevented = true;
        emit(EVENT_DRAGGING);
        prevent(e);
      } else if (isSliderDirection(e)) {
        dragging = shouldStart(e);
        prevent(e);
      }
    }
  }
  function onPointerUp(e) {
    if (state.is(DRAGGING)) {
      state.set(IDLE);
      emit(EVENT_DRAGGED);
    }
    if (dragging) {
      move(e);
      prevent(e);
    }
    unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
    unbind(target, POINTER_UP_EVENTS, onPointerUp);
    dragging = false;
  }
  function onClick(e) {
    if (!disabled && clickPrevented) {
      prevent(e, true);
    }
  }
  function save(e) {
    prevBaseEvent = baseEvent;
    baseEvent = e;
    basePosition = getPosition();
  }
  function move(e) {
    var velocity = computeVelocity(e);
    var destination = computeDestination(velocity);
    var rewind = options.rewind && options.rewindByDrag;
    reduce(false);
    if (isFree) {
      Controller2.scroll(destination, 0, options.snap);
    } else if (Splide2.is(FADE)) {
      Controller2.go(orient(sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
    } else if (Splide2.is(SLIDE) && exceeded && rewind) {
      Controller2.go(exceededLimit(true) ? ">" : "<");
    } else {
      Controller2.go(Controller2.toDest(destination), true);
    }
    reduce(true);
  }
  function shouldStart(e) {
    var thresholds = options.dragMinThreshold;
    var isObj = isObject(thresholds);
    var mouse = isObj && thresholds.mouse || 0;
    var touch = (isObj ? thresholds.touch : +thresholds) || 10;
    return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
  }
  function isSliderDirection(e) {
    return abs(diffCoord(e)) > abs(diffCoord(e, true));
  }
  function computeVelocity(e) {
    if (Splide2.is(LOOP) || !exceeded) {
      var time = diffTime(e);
      if (time && time < LOG_INTERVAL) {
        return diffCoord(e) / time;
      }
    }
    return 0;
  }
  function computeDestination(velocity) {
    return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
  }
  function diffCoord(e, orthogonal) {
    return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
  }
  function diffTime(e) {
    return timeOf(e) - timeOf(getBaseEvent(e));
  }
  function getBaseEvent(e) {
    return baseEvent === e && prevBaseEvent || baseEvent;
  }
  function coordOf(e, orthogonal) {
    return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
  }
  function constrain(diff) {
    return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
  }
  function isDraggable(target2) {
    var noDrag = options.noDrag;
    return !matches(target2, "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW) && (!noDrag || !matches(target2, noDrag));
  }
  function isTouchEvent(e) {
    return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
  }
  function isDragging() {
    return dragging;
  }
  function disable(value) {
    disabled = value;
  }
  return {
    mount,
    disable,
    isDragging
  };
}
var NORMALIZATION_MAP = {
  Spacebar: " ",
  Right: ARROW_RIGHT,
  Left: ARROW_LEFT,
  Up: ARROW_UP,
  Down: ARROW_DOWN
};
function normalizeKey(key) {
  key = isString(key) ? key : key.key;
  return NORMALIZATION_MAP[key] || key;
}
var KEYBOARD_EVENT = "keydown";
function Keyboard(Splide2, Components2, options) {
  var _EventInterface10 = EventInterface(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
  var root = Splide2.root;
  var resolve = Components2.Direction.resolve;
  var target;
  var disabled;
  function mount() {
    init();
    on(EVENT_UPDATED, destroy);
    on(EVENT_UPDATED, init);
    on(EVENT_MOVE, onMove);
  }
  function init() {
    var keyboard = options.keyboard;
    if (keyboard) {
      target = keyboard === "global" ? window : root;
      bind(target, KEYBOARD_EVENT, onKeydown);
    }
  }
  function destroy() {
    unbind(target, KEYBOARD_EVENT);
  }
  function disable(value) {
    disabled = value;
  }
  function onMove() {
    var _disabled = disabled;
    disabled = true;
    nextTick(function() {
      disabled = _disabled;
    });
  }
  function onKeydown(e) {
    if (!disabled) {
      var key = normalizeKey(e);
      if (key === resolve(ARROW_LEFT)) {
        Splide2.go("<");
      } else if (key === resolve(ARROW_RIGHT)) {
        Splide2.go(">");
      }
    }
  }
  return {
    mount,
    destroy,
    disable
  };
}
var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
var IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";
function LazyLoad(Splide2, Components2, options) {
  var _EventInterface11 = EventInterface(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
  var isSequential = options.lazyLoad === "sequential";
  var events = [EVENT_MOVED, EVENT_SCROLLED];
  var entries = [];
  function mount() {
    if (options.lazyLoad) {
      init();
      on(EVENT_REFRESH, init);
    }
  }
  function init() {
    empty(entries);
    register();
    if (isSequential) {
      loadNext();
    } else {
      off(events);
      on(events, check);
      check();
    }
  }
  function register() {
    Components2.Slides.forEach(function(Slide3) {
      queryAll(Slide3.slide, IMAGE_SELECTOR).forEach(function(img) {
        var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
        var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);
        if (src !== img.src || srcset !== img.srcset) {
          var className = options.classes.spinner;
          var parent = img.parentElement;
          var spinner = child(parent, "." + className) || create("span", className, parent);
          entries.push([img, Slide3, spinner]);
          img.src || display(img, "none");
        }
      });
    });
  }
  function check() {
    entries = entries.filter(function(data) {
      var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
      return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
    });
    entries.length || off(events);
  }
  function load(data) {
    var img = data[0];
    addClass(data[1].slide, CLASS_LOADING);
    bind(img, "load error", apply(onLoad, data));
    setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
    setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_ATTRIBUTE));
    removeAttribute(img, SRC_DATA_ATTRIBUTE);
    removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
  }
  function onLoad(data, e) {
    var img = data[0], Slide3 = data[1];
    removeClass(Slide3.slide, CLASS_LOADING);
    if (e.type !== "error") {
      remove(data[2]);
      display(img, "");
      emit(EVENT_LAZYLOAD_LOADED, img, Slide3);
      emit(EVENT_RESIZE);
    }
    isSequential && loadNext();
  }
  function loadNext() {
    entries.length && load(entries.shift());
  }
  return {
    mount,
    destroy: apply(empty, entries),
    check
  };
}
function Pagination2(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on, emit = event.emit, bind = event.bind;
  var Slides2 = Components2.Slides, Elements2 = Components2.Elements, Controller2 = Components2.Controller;
  var hasFocus = Controller2.hasFocus, getIndex = Controller2.getIndex, go = Controller2.go;
  var resolve = Components2.Direction.resolve;
  var placeholder = Elements2.pagination;
  var items = [];
  var list;
  var paginationClasses;
  function mount() {
    destroy();
    on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], mount);
    var enabled = options.pagination;
    placeholder && display(placeholder, enabled ? "" : "none");
    if (enabled) {
      on([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
      createPagination();
      update();
      emit(EVENT_PAGINATION_MOUNTED, {
        list,
        items
      }, getAt(Splide2.index));
    }
  }
  function destroy() {
    if (list) {
      remove(placeholder ? slice(list.children) : list);
      removeClass(list, paginationClasses);
      empty(items);
      list = null;
    }
    event.destroy();
  }
  function createPagination() {
    var length = Splide2.length;
    var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
    var max2 = hasFocus() ? Controller2.getEnd() + 1 : ceil(length / perPage);
    list = placeholder || create("ul", classes.pagination, Elements2.track.parentElement);
    addClass(list, paginationClasses = CLASS_PAGINATION + "--" + getDirection());
    setAttribute(list, ROLE, "tablist");
    setAttribute(list, ARIA_LABEL, i18n.select);
    setAttribute(list, ARIA_ORIENTATION, getDirection() === TTB ? "vertical" : "");
    for (var i = 0; i < max2; i++) {
      var li = create("li", null, list);
      var button = create("button", {
        class: classes.page,
        type: "button"
      }, li);
      var controls = Slides2.getIn(i).map(function(Slide3) {
        return Slide3.slide.id;
      });
      var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
      bind(button, "click", apply(onClick, i));
      if (options.paginationKeyboard) {
        bind(button, "keydown", apply(onKeydown, i));
      }
      setAttribute(li, ROLE, "presentation");
      setAttribute(button, ROLE, "tab");
      setAttribute(button, ARIA_CONTROLS, controls.join(" "));
      setAttribute(button, ARIA_LABEL, format(text, i + 1));
      setAttribute(button, TAB_INDEX, -1);
      items.push({
        li,
        button,
        page: i
      });
    }
  }
  function onClick(page) {
    go(">" + page, true);
  }
  function onKeydown(page, e) {
    var length = items.length;
    var key = normalizeKey(e);
    var dir = getDirection();
    var nextPage = -1;
    if (key === resolve(ARROW_RIGHT, false, dir)) {
      nextPage = ++page % length;
    } else if (key === resolve(ARROW_LEFT, false, dir)) {
      nextPage = (--page + length) % length;
    } else if (key === "Home") {
      nextPage = 0;
    } else if (key === "End") {
      nextPage = length - 1;
    }
    var item = items[nextPage];
    if (item) {
      focus(item.button);
      go(">" + nextPage);
      prevent(e, true);
    }
  }
  function getDirection() {
    return options.paginationDirection || options.direction;
  }
  function getAt(index) {
    return items[Controller2.toPage(index)];
  }
  function update() {
    var prev = getAt(getIndex(true));
    var curr = getAt(getIndex());
    if (prev) {
      var button = prev.button;
      removeClass(button, CLASS_ACTIVE);
      removeAttribute(button, ARIA_SELECTED);
      setAttribute(button, TAB_INDEX, -1);
    }
    if (curr) {
      var _button = curr.button;
      addClass(_button, CLASS_ACTIVE);
      setAttribute(_button, ARIA_SELECTED, true);
      setAttribute(_button, TAB_INDEX, "");
    }
    emit(EVENT_PAGINATION_UPDATED, {
      list,
      items
    }, prev, curr);
  }
  return {
    items,
    mount,
    destroy,
    getAt,
    update
  };
}
var TRIGGER_KEYS = [" ", "Enter"];
function Sync(Splide2, Components2, options) {
  var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
  var events = [];
  function mount() {
    Splide2.splides.forEach(function(target) {
      if (!target.isParent) {
        sync(Splide2, target.splide);
        sync(target.splide, Splide2);
      }
    });
    if (isNavigation) {
      navigate();
    }
  }
  function destroy() {
    events.forEach(function(event) {
      event.destroy();
    });
    empty(events);
  }
  function remount() {
    destroy();
    mount();
  }
  function sync(splide, target) {
    var event = EventInterface(splide);
    event.on(EVENT_MOVE, function(index, prev, dest) {
      target.go(target.is(LOOP) ? dest : index);
    });
    events.push(event);
  }
  function navigate() {
    var event = EventInterface(Splide2);
    var on = event.on;
    on(EVENT_CLICK, onClick);
    on(EVENT_SLIDE_KEYDOWN, onKeydown);
    on([EVENT_MOUNTED, EVENT_UPDATED], update);
    events.push(event);
    event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
  }
  function update() {
    setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === TTB ? "vertical" : "");
  }
  function onClick(Slide3) {
    Splide2.go(Slide3.index);
  }
  function onKeydown(Slide3, e) {
    if (includes(TRIGGER_KEYS, normalizeKey(e))) {
      onClick(Slide3);
      prevent(e);
    }
  }
  return {
    setup: apply(Components2.Media.set, {
      slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus
    }, true),
    mount,
    destroy,
    remount
  };
}
function Wheel(Splide2, Components2, options) {
  var _EventInterface12 = EventInterface(Splide2), bind = _EventInterface12.bind;
  var lastTime = 0;
  function mount() {
    if (options.wheel) {
      bind(Components2.Elements.track, "wheel", onWheel, SCROLL_LISTENER_OPTIONS);
    }
  }
  function onWheel(e) {
    if (e.cancelable) {
      var deltaY = e.deltaY;
      var backwards = deltaY < 0;
      var timeStamp = timeOf(e);
      var _min = options.wheelMinThreshold || 0;
      var sleep = options.wheelSleep || 0;
      if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
        Splide2.go(backwards ? "<" : ">");
        lastTime = timeStamp;
      }
      shouldPrevent(backwards) && prevent(e);
    }
  }
  function shouldPrevent(backwards) {
    return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
  }
  return {
    mount
  };
}
var SR_REMOVAL_DELAY = 90;
function Live(Splide2, Components2, options) {
  var _EventInterface13 = EventInterface(Splide2), on = _EventInterface13.on;
  var track = Components2.Elements.track;
  var enabled = options.live && !options.isNavigation;
  var sr = create("span", CLASS_SR);
  var interval = RequestInterval(SR_REMOVAL_DELAY, apply(toggle, false));
  function mount() {
    if (enabled) {
      disable(!Components2.Autoplay.isPaused());
      setAttribute(track, ARIA_ATOMIC, true);
      sr.textContent = "\u2026";
      on(EVENT_AUTOPLAY_PLAY, apply(disable, true));
      on(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
      on([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
    }
  }
  function toggle(active) {
    setAttribute(track, ARIA_BUSY, active);
    if (active) {
      append(track, sr);
      interval.start();
    } else {
      remove(sr);
      interval.cancel();
    }
  }
  function destroy() {
    removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
    remove(sr);
  }
  function disable(disabled) {
    if (enabled) {
      setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
    }
  }
  return {
    mount,
    disable,
    destroy
  };
}
var ComponentConstructors = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Media,
  Direction,
  Elements,
  Slides,
  Layout,
  Clones,
  Move,
  Controller,
  Arrows,
  Autoplay,
  Cover,
  Scroll,
  Drag,
  Keyboard,
  LazyLoad,
  Pagination: Pagination2,
  Sync,
  Wheel,
  Live
});
var I18N = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  slideLabel: "%s of %s"
};
var DEFAULTS = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: true,
  arrows: true,
  pagination: true,
  paginationKeyboard: true,
  interval: 5e3,
  pauseOnHover: true,
  pauseOnFocus: true,
  resetProgress: true,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: true,
  direction: "ltr",
  trimSpace: true,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: true,
  classes: CLASSES,
  i18n: I18N,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause"
  }
};
function Fade(Splide2, Components2, options) {
  var Slides2 = Components2.Slides;
  function mount() {
    EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
  }
  function init() {
    Slides2.forEach(function(Slide3) {
      Slide3.style("transform", "translateX(-" + 100 * Slide3.index + "%)");
    });
  }
  function start(index, done) {
    Slides2.style("transition", "opacity " + options.speed + "ms " + options.easing);
    nextTick(done);
  }
  return {
    mount,
    start,
    cancel: noop
  };
}
function Slide(Splide2, Components2, options) {
  var Move2 = Components2.Move, Controller2 = Components2.Controller, Scroll2 = Components2.Scroll;
  var list = Components2.Elements.list;
  var transition = apply(style, list, "transition");
  var endCallback;
  function mount() {
    EventInterface(Splide2).bind(list, "transitionend", function(e) {
      if (e.target === list && endCallback) {
        cancel();
        endCallback();
      }
    });
  }
  function start(index, done) {
    var destination = Move2.toPosition(index, true);
    var position = Move2.getPosition();
    var speed = getSpeed(index);
    if (abs(destination - position) >= 1 && speed >= 1) {
      if (options.useScroll) {
        Scroll2.scroll(destination, speed, false, done);
      } else {
        transition("transform " + speed + "ms " + options.easing);
        Move2.translate(destination, true);
        endCallback = done;
      }
    } else {
      Move2.jump(index);
      done();
    }
  }
  function cancel() {
    transition("");
    Scroll2.cancel();
  }
  function getSpeed(index) {
    var rewindSpeed = options.rewindSpeed;
    if (Splide2.is(SLIDE) && rewindSpeed) {
      var prev = Controller2.getIndex(true);
      var end = Controller2.getEnd();
      if (prev === 0 && index >= end || prev >= end && index === 0) {
        return rewindSpeed;
      }
    }
    return options.speed;
  }
  return {
    mount,
    start,
    cancel
  };
}
var _Splide = /* @__PURE__ */ function() {
  function _Splide2(target, options) {
    this.event = EventInterface();
    this.Components = {};
    this.state = State(CREATED);
    this.splides = [];
    this._o = {};
    this._E = {};
    var root = isString(target) ? query(document, target) : target;
    assert(root, root + " is invalid.");
    this.root = root;
    options = merge({
      label: getAttribute(root, ARIA_LABEL) || "",
      labelledby: getAttribute(root, ARIA_LABELLEDBY) || ""
    }, DEFAULTS, _Splide2.defaults, options || {});
    try {
      merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
    } catch (e) {
      assert(false, "Invalid JSON");
    }
    this._o = Object.create(merge({}, options));
  }
  var _proto = _Splide2.prototype;
  _proto.mount = function mount(Extensions, Transition) {
    var _this = this;
    var state = this.state, Components2 = this.Components;
    assert(state.is([CREATED, DESTROYED]), "Already mounted!");
    state.set(CREATED);
    this._C = Components2;
    this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
    this._E = Extensions || this._E;
    var Constructors = assign({}, ComponentConstructors, this._E, {
      Transition: this._T
    });
    forOwn(Constructors, function(Component, key) {
      var component = Component(_this, Components2, _this._o);
      Components2[key] = component;
      component.setup && component.setup();
    });
    forOwn(Components2, function(component) {
      component.mount && component.mount();
    });
    this.emit(EVENT_MOUNTED);
    addClass(this.root, CLASS_INITIALIZED);
    state.set(IDLE);
    this.emit(EVENT_READY);
    return this;
  };
  _proto.sync = function sync(splide) {
    this.splides.push({
      splide
    });
    splide.splides.push({
      splide: this,
      isParent: true
    });
    if (this.state.is(IDLE)) {
      this._C.Sync.remount();
      splide.Components.Sync.remount();
    }
    return this;
  };
  _proto.go = function go(control) {
    this._C.Controller.go(control);
    return this;
  };
  _proto.on = function on(events, callback) {
    this.event.on(events, callback);
    return this;
  };
  _proto.off = function off(events) {
    this.event.off(events);
    return this;
  };
  _proto.emit = function emit(event) {
    var _this$event;
    (_this$event = this.event).emit.apply(_this$event, [event].concat(slice(arguments, 1)));
    return this;
  };
  _proto.add = function add(slides, index) {
    this._C.Slides.add(slides, index);
    return this;
  };
  _proto.remove = function remove2(matcher) {
    this._C.Slides.remove(matcher);
    return this;
  };
  _proto.is = function is(type) {
    return this._o.type === type;
  };
  _proto.refresh = function refresh() {
    this.emit(EVENT_REFRESH);
    return this;
  };
  _proto.destroy = function destroy(completely) {
    if (completely === void 0) {
      completely = true;
    }
    var event = this.event, state = this.state;
    if (state.is(CREATED)) {
      EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
    } else {
      forOwn(this._C, function(component) {
        component.destroy && component.destroy(completely);
      }, true);
      event.emit(EVENT_DESTROY);
      event.destroy();
      completely && empty(this.splides);
      state.set(DESTROYED);
    }
    return this;
  };
  _createClass(_Splide2, [{
    key: "options",
    get: function get() {
      return this._o;
    },
    set: function set(options) {
      this._C.Media.set(options, true, true);
    }
  }, {
    key: "length",
    get: function get() {
      return this._C.Slides.getLength(true);
    }
  }, {
    key: "index",
    get: function get() {
      return this._C.Controller.getIndex();
    }
  }]);
  return _Splide2;
}();
var Splide = _Splide;
Splide.defaults = {};
Splide.STATES = STATES;

// dev/src/js/common/carousel/custom-scroll-carousel.js
var CustomScrollCarousel = class extends HTMLElement {
  constructor() {
    super();
    this.setupSlider();
  }
  get externalArrows() {
    return this.getAttribute("external-arrows");
  }
  get type() {
    return this.getAttribute("type");
  }
  get drag() {
    return this.getAttribute("drag");
  }
  get hasArrow() {
    return this.getAttribute("arrow");
  }
  get hasPagination() {
    return this.getAttribute("pagination");
  }
  get autoWidth() {
    return this.getAttribute("auto-width");
  }
  get perPage() {
    return this.getAttribute("per-page");
  }
  get gap() {
    return this.getAttribute("gap");
  }
  get snap() {
    return this.getAttribute("snap");
  }
  get paddingLeft() {
    return parseInt(this.getAttribute("padding-left"));
  }
  get paddingRight() {
    return parseInt(this.getAttribute("padding-right"));
  }
  get focus() {
    return this.getAttribute("focus");
  }
  get fixedWidth() {
    return this.getAttribute("fixed-width");
  }
  get rewind() {
    return this.getAttribute("rewind");
  }
  get omitEnd() {
    return this.getAttribute("omit-end");
  }
  get perMove() {
    return this.getAttribute("per-move");
  }
  setupSlider() {
    let sliderOptions = {
      type: this.type || "slide",
      drag: this.drag !== "false",
      arrows: this.hasArrow || false,
      pagination: this.hasPagination || false,
      autoWidth: this.autoWidth || false,
      perPage: this.perPage || 1,
      gap: this.gap || null,
      snap: this.snap || false,
      padding: { left: this.paddingLeft || null, right: this.paddingRight || null },
      focus: 0,
      omitEnd: this.omitEnd || false,
      fixedWidth: this.fixedWidth || null,
      rewind: this.rewind || false,
      perMove: this.perMove || 1,
      breakpoints: {
        1279: {
          arrows: false,
          drag: true
        }
      }
    };
    const splide = this.querySelector(".splide");
    if (splide) {
      this.splide = new Splide(splide, sliderOptions);
      this.splide.mount();
      if (this.externalArrows) {
        const prevButton = document.getElementById("prevSlide");
        const nextButton = document.getElementById("nextSlide");
        const updateArrowState = () => {
          prevButton.disabled = this.splide.index === 0;
          nextButton.disabled = this.splide.index === this.splide.Components.Controller.getEnd();
        };
        this.splide.on("mounted", () => {
          setTimeout(updateArrowState, 100);
        });
        this.splide.on("move", updateArrowState);
        prevButton.addEventListener("click", () => this.splide.go("<"));
        nextButton.addEventListener("click", () => this.splide.go(">"));
      }
    }
  }
};
if (!customElements.get("custom-scroll-carousel")) {
  customElements.define("custom-scroll-carousel", CustomScrollCarousel);
}

// dev/src/js/common/carousel/effect-carousel.js
import { animate as animate3, timeline, inView as inView3 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _listenersAbortController, _gestureArea, _player, _targetIndex, _preventInitialTransition, _setupListeners, setupListeners_fn, _onKeyboardNavigation, onKeyboardNavigation_fn, _preloadImages, preloadImages_fn;
var EffectCarousel = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _setupListeners);
    __privateAdd(this, _onKeyboardNavigation);
    __privateAdd(this, _preloadImages);
    __privateAdd(this, _listenersAbortController, void 0);
    __privateAdd(this, _gestureArea, void 0);
    __privateAdd(this, _player, void 0);
    __privateAdd(this, _targetIndex, 0);
    __privateAdd(this, _preventInitialTransition, false);
    __privateMethod(this, _setupListeners, setupListeners_fn).call(this);
    inView3(this, () => this.onBecameVisible());
    this.addEventListener("carousel:settle", (event) => event.detail.cell.classList.add("is-selected"));
  }
  connectedCallback() {
    __privateSet(this, _targetIndex, Math.max(0, this.cells.findIndex((item) => item.classList.contains("is-selected"))));
    __privateMethod(this, _preloadImages, preloadImages_fn).call(this);
  }
  get allowSwipe() {
    return this.hasAttribute("allow-swipe");
  }
  get cellSelector() {
    return this.hasAttribute("cell-selector") ? this.getAttribute("cell-selector") : null;
  }
  get allCells() {
    return this.cellSelector ? Array.from(this.querySelectorAll(this.cellSelector)) : Array.from(this.children);
  }
  get cells() {
    return this.allCells.filter((cell) => !cell.hasAttribute("hidden"));
  }
  get selectedCell() {
    return this.cells[this.selectedIndex];
  }
  get selectedIndex() {
    return __privateGet(this, _targetIndex);
  }
  get player() {
    return __privateGet(this, _player);
  }
  previous({ instant = false } = {}) {
    return this.select((this.selectedIndex - 1 + this.cells.length) % this.cells.length, { instant, direction: "previous" });
  }
  next({ instant = false } = {}) {
    return this.select((this.selectedIndex + 1 + this.cells.length) % this.cells.length, { instant, direction: "next" });
  }
  async select(index, { instant = false, direction = null } = {}) {
    if (!(index in this.cells)) {
      return Promise.resolve();
    }
    this.dispatchEvent(new CustomEvent("carousel:select", { detail: { index, cell: this.cells[index] } }));
    if (index === this.selectedIndex) {
      return Promise.resolve();
    }
    __privateGet(this, _player)?.pause();
    const [fromSlide, toSlide] = [this.selectedCell, this.cells[index]];
    direction ??= index > this.selectedIndex ? "next" : "previous";
    __privateSet(this, _targetIndex, index);
    this.dispatchEvent(new CustomEvent("carousel:change", { detail: { index, cell: this.cells[index] } }));
    const animationControls = this.createOnChangeAnimationControls(fromSlide, toSlide, { direction });
    if ("leaveControls" in animationControls && "enterControls" in animationControls) {
      const leaveAnimationControls = animationControls.leaveControls();
      if (instant) {
        leaveAnimationControls.finish();
      }
      await leaveAnimationControls.finished;
      __privateGet(this, _player)?.resume(true);
      fromSlide.classList.remove("is-selected");
      toSlide.classList.add("is-selected");
      const enterAnimationControls = animationControls.enterControls();
      if (instant) {
        enterAnimationControls.finish();
      }
      await enterAnimationControls.finished;
    } else {
      if (instant) {
        animationControls.finish();
      }
      __privateGet(this, _player)?.resume(true);
      toSlide.classList.add("is-selected");
      await animationControls.finished;
      fromSlide.classList.remove("is-selected");
    }
    this.dispatchEvent(new CustomEvent("carousel:settle", { detail: { index, cell: this.cells[index] } }));
  }
  filter(indexes = []) {
    this.allCells.forEach((cell, index) => {
      cell.toggleAttribute("hidden", indexes.includes(index));
    });
    this.dispatchEvent(new CustomEvent("carousel:filter", { detail: { filteredIndexes: indexes } }));
  }
  async onBecameVisible() {
    const animationControls = await this.createOnBecameVisibleAnimationControls(this.selectedCell);
    [this.selectedCell, ...this.selectedCell.querySelectorAll("[reveal-on-scroll]")].forEach((element) => {
      element.removeAttribute("reveal-on-scroll");
    });
    if (__privateGet(this, _preventInitialTransition) && typeof animationControls.finish === "function") {
      animationControls.finish();
    }
    return animationControls.finished.then(() => {
      __privateGet(this, _player)?.resume(true);
      this.dispatchEvent(new CustomEvent("carousel:settle", { detail: { index: this.selectedIndex, cell: this.selectedCell } }));
    });
  }
  createOnBecameVisibleAnimationControls(toSlide) {
    return animate3(toSlide, {}, { duration: 0 });
  }
  createOnChangeAnimationControls(fromSlide, toSlide, { direction } = {}) {
    return timeline([
      [fromSlide, { opacity: [1, 0] }, { duration: 0.3 }],
      [toSlide, { opacity: [0, 1] }, { duration: 0.3, at: "<" }]
    ]);
  }
  cleanUpAnimations() {
    this.allCells.forEach((cell) => {
      cell.style.removeProperty("opacity");
      cell.style.removeProperty("visibility");
    });
  }
};
_listenersAbortController = new WeakMap();
_gestureArea = new WeakMap();
_player = new WeakMap();
_targetIndex = new WeakMap();
_preventInitialTransition = new WeakMap();
_setupListeners = new WeakSet();
setupListeners_fn = function() {
  if (this.hasAttribute("disabled-on")) {
    mediaQueryListener(this.getAttribute("disabled-on"), (event) => {
      if (event.matches) {
        __privateGet(this, _listenersAbortController)?.abort();
        this.cleanUpAnimations();
      } else {
        __privateMethod(this, _setupListeners, setupListeners_fn).call(this);
      }
    });
    if (matchesMediaQuery(this.getAttribute("disabled-on"))) {
      return;
    }
  }
  __privateSet(this, _listenersAbortController, new AbortController());
  const listenerOptions = { signal: __privateGet(this, _listenersAbortController).signal };
  if (Shopify.designMode) {
    this.closest(".shopify-section").addEventListener("shopify:section:select", (event) => __privateSet(this, _preventInitialTransition, event.detail.load), listenerOptions);
  }
  if (this.allCells.length > 1) {
    this.addEventListener("carousel:change", __privateMethod(this, _preloadImages, preloadImages_fn));
    if (this.allowSwipe) {
      __privateSet(this, _gestureArea, new GestureArea(this, { signal: __privateGet(this, _listenersAbortController).signal }));
      this.addEventListener("swipeleft", this.next, listenerOptions);
      this.addEventListener("swiperight", this.previous, listenerOptions);
    }
    if (!this.hasAttribute("disable-keyboard-navigation")) {
      this.tabIndex = 0;
      this.addEventListener("keydown", __privateMethod(this, _onKeyboardNavigation, onKeyboardNavigation_fn), listenerOptions);
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.select(this.cells.indexOf(event.target), { instant: event.detail.load }), listenerOptions);
    }
    if (this.hasAttribute("autoplay")) {
      __privateGet(this, _player) ?? __privateSet(this, _player, new Player(this.getAttribute("autoplay") ?? 5));
      __privateGet(this, _player).addEventListener("player:end", this.next.bind(this), listenerOptions);
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", () => __privateGet(this, _player).stop(), listenerOptions);
        this.addEventListener("shopify:block:deselect", () => __privateGet(this, _player).start(), listenerOptions);
      }
    }
  }
};
_onKeyboardNavigation = new WeakSet();
onKeyboardNavigation_fn = function(event) {
  if (event.target !== this) {
    return;
  }
  if (event.code === "ArrowLeft") {
    this.previous();
  } else if (event.code === "ArrowRight") {
    this.next();
  }
};
_preloadImages = new WeakSet();
preloadImages_fn = function() {
  const previousSlide = this.cells[(this.selectedIndex - 1 + this.cells.length) % this.cells.length], nextSlide = this.cells[(this.selectedIndex + 1 + this.cells.length) % this.cells.length];
  [previousSlide, this.selectedCell, nextSlide].forEach((item) => {
    if (item) {
      Array.from(item.querySelectorAll('img[loading="lazy"]'))?.forEach((img) => img.setAttribute("loading", "eager"));
      Array.from(item.querySelectorAll('video[preload="none"]'))?.forEach((video) => video.setAttribute("preload", "metadata"));
    }
  });
};
if (!window.customElements.get("effect-carousel")) {
  window.customElements.define("effect-carousel", EffectCarousel);
}

// dev/src/js/common/carousel/ksp-carousel.js
var KspCarousel = class extends EffectCarousel {
  constructor() {
    super();
    this.addEventListener("mouseenter", this.handleMouseEnter.bind(this));
    this.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
  }
  handleMouseEnter() {
    this.player.pause();
  }
  handleMouseLeave() {
    this.player.resume(true);
  }
};
if (!customElements.get("ksp-carousel")) {
  customElements.define("ksp-carousel", KspCarousel);
}

// dev/src/js/common/carousel/scroll-carousel.js
var _hasPendingProgrammaticScroll, _onMouseDownListener, _onMouseMoveListener, _onMouseClickListener, _onMouseUpListener, _targetIndex2, _forceChangeEvent, _dragPosition, _isDragging, _dispatchableScrollEvents, _scrollTimeout, _setupListeners2, setupListeners_fn2, _updateTargetIndex, updateTargetIndex_fn, _onScroll2, onScroll_fn2, _onScrollEnd, onScrollEnd_fn, _calculateLeftScroll, calculateLeftScroll_fn, _calculateClosestIndexToAlignment, calculateClosestIndexToAlignment_fn, _onMouseDown, onMouseDown_fn, _onMouseMove, onMouseMove_fn, _onMouseClick, onMouseClick_fn, _onMouseUp, onMouseUp_fn, _onResize, onResize_fn, _onMutate, onMutate_fn, _preloadImages2, preloadImages_fn2;
var ScrollCarousel = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _setupListeners2);
    __privateAdd(this, _updateTargetIndex);
    __privateAdd(this, _onScroll2);
    __privateAdd(this, _onScrollEnd);
    __privateAdd(this, _calculateLeftScroll);
    __privateAdd(this, _calculateClosestIndexToAlignment);
    __privateAdd(this, _onMouseDown);
    __privateAdd(this, _onMouseMove);
    __privateAdd(this, _onMouseClick);
    __privateAdd(this, _onMouseUp);
    __privateAdd(this, _onResize);
    __privateAdd(this, _onMutate);
    __privateAdd(this, _preloadImages2);
    __privateAdd(this, _hasPendingProgrammaticScroll, false);
    __privateAdd(this, _onMouseDownListener, __privateMethod(this, _onMouseDown, onMouseDown_fn).bind(this));
    __privateAdd(this, _onMouseMoveListener, __privateMethod(this, _onMouseMove, onMouseMove_fn).bind(this));
    __privateAdd(this, _onMouseClickListener, __privateMethod(this, _onMouseClick, onMouseClick_fn).bind(this));
    __privateAdd(this, _onMouseUpListener, __privateMethod(this, _onMouseUp, onMouseUp_fn).bind(this));
    __privateAdd(this, _targetIndex2, 0);
    __privateAdd(this, _forceChangeEvent, false);
    __privateAdd(this, _dragPosition, {});
    __privateAdd(this, _isDragging, false);
    __privateAdd(this, _dispatchableScrollEvents, { nearingStart: true, nearingEnd: true, leavingStart: true, leavingEnd: true });
    __privateAdd(this, _scrollTimeout, void 0);
    __privateMethod(this, _setupListeners2, setupListeners_fn2).call(this);
    new ResizeObserver(__privateMethod(this, _onResize, onResize_fn).bind(this)).observe(this);
    new MutationObserver(__privateMethod(this, _onMutate, onMutate_fn).bind(this)).observe(this, { subtree: true, attributes: true, attributeFilter: ["hidden"] });
  }
  connectedCallback() {
    __privateSet(this, _targetIndex2, Math.max(0, this.cells.findIndex((item) => item.classList.contains("is-initial"))));
    if (__privateGet(this, _targetIndex2) > 0) {
      this.select(__privateGet(this, _targetIndex2), { instant: true });
    }
    __privateMethod(this, _preloadImages2, preloadImages_fn2).call(this);
  }
  disconnectedCallback() {
    this.removeEventListener("mousemove", __privateGet(this, _onMouseMoveListener));
    document.removeEventListener("mouseup", __privateGet(this, _onMouseUpListener));
  }
  get cellSelector() {
    return this.hasAttribute("cell-selector") ? this.getAttribute("cell-selector") : null;
  }
  get allCells() {
    return this.cellSelector ? Array.from(this.querySelectorAll(this.cellSelector)) : Array.from(this.children);
  }
  get cells() {
    return this.allCells.filter((cell) => !cell.hasAttribute("hidden"));
  }
  get selectedCell() {
    return this.cells[this.selectedIndex];
  }
  get selectedIndex() {
    return __privateGet(this, _targetIndex2);
  }
  get cellAlign() {
    const scrollSnapAlign = this.cells.length > 0 ? getComputedStyle(this.cells[0]).scrollSnapAlign : "";
    return scrollSnapAlign === "none" ? "center" : scrollSnapAlign;
  }
  get groupCells() {
    if (this.hasAttribute("group-cells")) {
      const number = parseInt(this.getAttribute("group-cells"));
      return isNaN(number) ? Math.floor(this.clientWidth / this.cells[0].clientWidth) : number;
    } else {
      return 1;
    }
  }
  get isScrollable() {
    return this.scrollWidth !== this.clientWidth || this.scrollHeight !== this.clientHeight;
  }
  previous({ instant = false } = {}) {
    this.select(Math.max(__privateGet(this, _targetIndex2) - this.groupCells, 0), { instant });
  }
  next({ instant = false } = {}) {
    this.select(Math.min(__privateGet(this, _targetIndex2) + this.groupCells, this.cells.length - 1), { instant });
  }
  select(index, { instant = false } = {}) {
    if (!(index in this.cells)) {
      return;
    }
    this.dispatchEvent(new CustomEvent("carousel:select", { detail: { index, cell: this.cells[index] } }));
    if ("checkVisibility" in this && this.checkVisibility() || this.offsetWidth > 0 && this.offsetHeight > 0) {
      const targetScrollLeft = __privateMethod(this, _calculateLeftScroll, calculateLeftScroll_fn).call(this, this.cells[index]);
      if (this.scrollLeft !== targetScrollLeft) {
        __privateMethod(this, _updateTargetIndex, updateTargetIndex_fn).call(this, index);
        __privateSet(this, _hasPendingProgrammaticScroll, true);
        this.scrollTo({ left: targetScrollLeft, behavior: instant ? "auto" : "smooth" });
      } else {
        __privateMethod(this, _updateTargetIndex, updateTargetIndex_fn).call(this, __privateMethod(this, _calculateClosestIndexToAlignment, calculateClosestIndexToAlignment_fn).call(this));
      }
    } else {
      __privateSet(this, _targetIndex2, index);
      __privateSet(this, _forceChangeEvent, true);
    }
  }
  filter(indexes = []) {
    this.allCells.forEach((cell, index) => {
      cell.toggleAttribute("hidden", indexes.includes(index));
    });
    this.dispatchEvent(new CustomEvent("carousel:filter", { detail: { filteredIndexes: indexes } }));
  }
};
_hasPendingProgrammaticScroll = new WeakMap();
_onMouseDownListener = new WeakMap();
_onMouseMoveListener = new WeakMap();
_onMouseClickListener = new WeakMap();
_onMouseUpListener = new WeakMap();
_targetIndex2 = new WeakMap();
_forceChangeEvent = new WeakMap();
_dragPosition = new WeakMap();
_isDragging = new WeakMap();
_dispatchableScrollEvents = new WeakMap();
_scrollTimeout = new WeakMap();
_setupListeners2 = new WeakSet();
setupListeners_fn2 = function() {
  if (this.allCells.length > 1) {
    this.addEventListener("carousel:change", __privateMethod(this, _preloadImages2, preloadImages_fn2));
    this.addEventListener("scroll", throttle(__privateMethod(this, _onScroll2, onScroll_fn2).bind(this)));
    this.addEventListener("scrollend", __privateMethod(this, _onScrollEnd, onScrollEnd_fn));
    if (this.hasAttribute("allow-drag")) {
      const mediaQuery = window.matchMedia("screen and (pointer: fine)");
      mediaQuery.addEventListener("change", (event) => {
        if (event.matches) {
          this.addEventListener("mousedown", __privateGet(this, _onMouseDownListener));
        } else {
          this.removeEventListener("mousedown", __privateGet(this, _onMouseDownListener));
        }
      });
      if (mediaQuery.matches) {
        this.addEventListener("mousedown", __privateGet(this, _onMouseDownListener));
      }
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.select(this.cells.indexOf(event.target), { instant: event.detail.load }));
    }
  }
};
_updateTargetIndex = new WeakSet();
updateTargetIndex_fn = function(newValue) {
  if (newValue === __privateGet(this, _targetIndex2) && !__privateGet(this, _forceChangeEvent)) {
    return;
  }
  __privateSet(this, _targetIndex2, newValue);
  __privateSet(this, _forceChangeEvent, false);
  this.dispatchEvent(new CustomEvent("carousel:change", { detail: { index: newValue, cell: this.cells[newValue] } }));
};
_onScroll2 = new WeakSet();
onScroll_fn2 = function() {
  const scrollEdgeThreshold = 100, normalizedScrollLeft = Math.round(Math.abs(this.scrollLeft));
  if (normalizedScrollLeft < scrollEdgeThreshold && __privateGet(this, _dispatchableScrollEvents)["nearingStart"]) {
    this.dispatchEvent(new CustomEvent("scroll:edge-nearing", { detail: { position: "start" } }));
    __privateGet(this, _dispatchableScrollEvents)["nearingStart"] = false;
    __privateGet(this, _dispatchableScrollEvents)["leavingStart"] = true;
  }
  if (normalizedScrollLeft >= scrollEdgeThreshold && __privateGet(this, _dispatchableScrollEvents)["leavingStart"]) {
    this.dispatchEvent(new CustomEvent("scroll:edge-leaving", { detail: { position: "start" } }));
    __privateGet(this, _dispatchableScrollEvents)["leavingStart"] = false;
    __privateGet(this, _dispatchableScrollEvents)["nearingStart"] = true;
  }
  if (this.scrollWidth - this.clientWidth < normalizedScrollLeft + scrollEdgeThreshold && __privateGet(this, _dispatchableScrollEvents)["nearingEnd"]) {
    this.dispatchEvent(new CustomEvent("scroll:edge-nearing", { detail: { position: "end" } }));
    __privateGet(this, _dispatchableScrollEvents)["nearingEnd"] = false;
    __privateGet(this, _dispatchableScrollEvents)["leavingEnd"] = true;
  }
  if (this.scrollWidth - this.clientWidth >= normalizedScrollLeft + scrollEdgeThreshold && __privateGet(this, _dispatchableScrollEvents)["leavingEnd"]) {
    this.dispatchEvent(new CustomEvent("scroll:edge-leaving", { detail: { position: "end" } }));
    __privateGet(this, _dispatchableScrollEvents)["leavingEnd"] = false;
    __privateGet(this, _dispatchableScrollEvents)["nearingEnd"] = true;
  }
  if (!("onscrollend" in window)) {
    clearTimeout(__privateGet(this, _scrollTimeout));
    __privateSet(this, _scrollTimeout, setTimeout(() => {
      this.dispatchEvent(new CustomEvent("scrollend", { bubbles: true }));
    }, 75));
  }
  if (__privateGet(this, _hasPendingProgrammaticScroll)) {
    return;
  }
  __privateMethod(this, _updateTargetIndex, updateTargetIndex_fn).call(this, __privateMethod(this, _calculateClosestIndexToAlignment, calculateClosestIndexToAlignment_fn).call(this));
};
_onScrollEnd = new WeakSet();
onScrollEnd_fn = function() {
  __privateSet(this, _hasPendingProgrammaticScroll, false);
  if (!__privateGet(this, _isDragging)) {
    this.style.removeProperty("scroll-snap-type");
  }
  __privateMethod(this, _updateTargetIndex, updateTargetIndex_fn).call(this, __privateMethod(this, _calculateClosestIndexToAlignment, calculateClosestIndexToAlignment_fn).call(this));
  this.dispatchEvent(new CustomEvent("carousel:settle", { detail: { index: this.selectedIndex, cell: this.selectedCell } }));
};
_calculateLeftScroll = new WeakSet();
calculateLeftScroll_fn = function(cell) {
  let scrollLeft = Math.round(cell.offsetLeft - this.clientWidth / 2 + cell.clientWidth / 2);
  return Math.min(Math.max(scrollLeft, 0), this.scrollWidth - this.clientWidth);
};
_calculateClosestIndexToAlignment = new WeakSet();
calculateClosestIndexToAlignment_fn = function() {
  let cellAlign = this.cellAlign, offsetAccumulators, targetPoint;
  if (this.cellAlign.length > 0) {
    if (cellAlign === "center") {
      offsetAccumulators = this.cells.map((cell) => Math.round(cell.offsetLeft + cell.clientWidth / 2));
      targetPoint = Math.round(this.scrollLeft + this.clientWidth / 2);
    } else if (cellAlign === "start" && document.dir === "ltr" || cellAlign === "end" && document.dir === "rtl") {
      offsetAccumulators = this.cells.map((cell) => cell.offsetLeft);
      targetPoint = this.scrollLeft;
    } else {
      offsetAccumulators = this.cells.map((cell) => cell.offsetLeft + cell.clientWidth);
      targetPoint = this.scrollLeft + this.clientWidth;
    }
    return offsetAccumulators.indexOf(offsetAccumulators.reduce((prev, curr) => Math.abs(curr - targetPoint) < Math.abs(prev - targetPoint) ? curr : prev));
  }
};
_onMouseDown = new WeakSet();
onMouseDown_fn = function(event) {
  __privateSet(this, _dragPosition, {
    left: this.scrollLeft,
    top: this.scrollTop,
    x: event.clientX,
    y: event.clientY
  });
  __privateSet(this, _isDragging, true);
  this.style.setProperty("scroll-snap-type", "none");
  this.addEventListener("mousemove", __privateGet(this, _onMouseMoveListener));
  this.addEventListener("click", __privateGet(this, _onMouseClickListener), { once: true });
  document.addEventListener("mouseup", __privateGet(this, _onMouseUpListener));
};
_onMouseMove = new WeakSet();
onMouseMove_fn = function(event) {
  event.preventDefault();
  const [dx, dy] = [event.clientX - __privateGet(this, _dragPosition).x, event.clientY - __privateGet(this, _dragPosition).y];
  this.scrollTop = __privateGet(this, _dragPosition).top - dy;
  this.scrollLeft = __privateGet(this, _dragPosition).left - dx;
};
_onMouseClick = new WeakSet();
onMouseClick_fn = function(event) {
  if (event.clientX - __privateGet(this, _dragPosition).x !== 0) {
    event.preventDefault();
  }
};
_onMouseUp = new WeakSet();
onMouseUp_fn = function(event) {
  __privateSet(this, _isDragging, false);
  if (event.clientX - __privateGet(this, _dragPosition).x === 0) {
    this.style.removeProperty("scroll-snap-type");
  } else if (!__privateGet(this, _hasPendingProgrammaticScroll)) {
    this.scrollTo({ left: __privateMethod(this, _calculateLeftScroll, calculateLeftScroll_fn).call(this, this.selectedCell), behavior: "smooth" });
  }
  this.removeEventListener("mousemove", __privateGet(this, _onMouseMoveListener));
  document.removeEventListener("mouseup", __privateGet(this, _onMouseUpListener));
};
_onResize = new WeakSet();
onResize_fn = function() {
  if (this.selectedIndex !== __privateMethod(this, _calculateClosestIndexToAlignment, calculateClosestIndexToAlignment_fn).call(this)) {
    this.select(this.selectedIndex, { instant: true });
  }
  this.classList.toggle("is-scrollable", this.scrollWidth > this.clientWidth);
};
_onMutate = new WeakSet();
onMutate_fn = function() {
  __privateSet(this, _forceChangeEvent, true);
};
_preloadImages2 = new WeakSet();
preloadImages_fn2 = function() {
  if (this.cells.length < 2) {
    return;
  }
  const previousSlide = this.cells[Math.max(this.selectedIndex - 1, 0)], nextSlide = this.cells[Math.min(this.selectedIndex + 1, this.cells.length - 1)];
  [previousSlide, this.selectedCell, nextSlide].filter((item) => item !== null).forEach((item) => {
    if (item) {
      Array.from(item.querySelectorAll('img[loading="lazy"]'))?.forEach((img) => img.setAttribute("loading", "eager"));
      Array.from(item.querySelectorAll('video[preload="none"]'))?.forEach((video) => video.setAttribute("preload", "metadata"));
    }
  });
};
if (!window.customElements.get("scroll-carousel")) {
  window.customElements.define("scroll-carousel", ScrollCarousel);
}

// dev/src/js/common/cart/fetch-cart.js
var fetchCart = new Promise(async (resolve) => {
  resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
});
document.addEventListener("cart:change", (event) => {
  fetchCart = event.detail["cart"];
});

// dev/src/js/common/cart/cart-count.js
var _abortController, _updateFromServer, updateFromServer_fn;
var CartCount = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _updateFromServer);
    __privateAdd(this, _abortController, void 0);
  }
  connectedCallback() {
    __privateSet(this, _abortController, new AbortController());
    document.addEventListener("cart:change", (event) => this.itemCount = event.detail["cart"]["item_count"], { signal: __privateGet(this, _abortController).signal });
    document.addEventListener("cart:refresh", __privateMethod(this, _updateFromServer, updateFromServer_fn).bind(this), { signal: __privateGet(this, _abortController).signal });
    __privateMethod(this, _updateFromServer, updateFromServer_fn).call(this);
  }
  disconnectedCallback() {
    __privateGet(this, _abortController).abort();
  }
  set itemCount(count) {
    this.innerText = count;
  }
};
_abortController = new WeakMap();
_updateFromServer = new WeakSet();
updateFromServer_fn = async function() {
  this.itemCount = (await fetchCart)["item_count"];
};
if (!window.customElements.get("cart-count")) {
  window.customElements.define("cart-count", CartCount);
}

// dev/src/js/common/cart/cart-cross-sell.js
var _isLoaded, _loadRecommendations, loadRecommendations_fn;
var CartCrossSellRecommendation = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _loadRecommendations);
    __privateAdd(this, _isLoaded, false);
  }
  connectedCallback() {
    __privateMethod(this, _loadRecommendations, loadRecommendations_fn).call(this);
  }
};
_isLoaded = new WeakMap();
_loadRecommendations = new WeakSet();
loadRecommendations_fn = async function() {
  if (__privateGet(this, _isLoaded)) {
    return;
  }
  __privateSet(this, _isLoaded, true);
  const section = this.closest(".shopify-section"), intent = this.getAttribute("intent") || "related", url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${extractSectionId(section)}&intent=${intent}`, response = await fetch(url, { priority: intent === "related" ? "low" : "auto" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), productRecommendationsElement = tempDiv.querySelector("cart-cross-sell");
  if (productRecommendationsElement.childElementCount > 0) {
    this.replaceWith(...document.importNode(productRecommendationsElement, true).childNodes);
    this.hidden = false;
  } else {
    this.remove();
  }
};
if (!window.customElements.get("cart-cross-sell")) {
  window.customElements.define("cart-cross-sell", CartCrossSellRecommendation);
}

// dev/src/js/common/cart/cart-tokens.js
async function cartTokens(tokens) {
  let attributes = JSON.stringify(tokens);
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
  const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    keepalive: true,
    body: JSON.stringify({
      attributes: {
        "_bundle": attributes
      },
      sections: sectionsToBundle.join(",")
    })
  });
  const cartContent = await response.json();
  if (response.ok) {
    setTimeout(() => {
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent
        }
      }));
    }, 500);
  }
}

// dev/src/js/common/cart/checkout-button.js
var CheckoutButton = class extends HTMLElement {
  #submitButton;
  #cgvCheckbox;
  #alertError;
  #cvgSessionStorageID;
  #checkCGVCheckboxListener = this.checkCGVCheckbox.bind(this);
  #onCheckboxChanged = this._onCheckboxChanged.bind(this);
  connectedCallback() {
    this.#cvgSessionStorageID = "madura-cgv-checkbox";
    this.#submitButton = this.querySelector('button[type="submit"]');
    this.#submitButton.addEventListener("click", this.#checkCGVCheckboxListener);
    this.#cgvCheckbox = this.querySelector('[name="cart[cgv]"]');
    this.#cgvCheckbox.addEventListener("change", this.#onCheckboxChanged);
    this.#alertError = this.querySelector('[data-type="error"]');
    this.checkIfCGVAlreadyChecked();
  }
  disconnectedCallback() {
    this.#submitButton.removeEventListener("click", this.#checkCGVCheckboxListener);
    this.#submitButton.removeEventListener("click", this.#onCheckboxChanged);
  }
  checkCGVCheckbox(event) {
    if (!this.#cgvCheckbox.checked) {
      event.preventDefault();
      this.#alertError.hidden = false;
    } else {
      this.#submitButton.classList.add("button--loading");
      document.dispatchEvent(new CustomEvent("checkout:begin", {
        bubbles: true,
        detail: window.cartItemsForDataLayer
      }));
    }
  }
  hideAlertError() {
    this.#alertError.hidden = true;
  }
  checkIfCGVAlreadyChecked() {
    if (sessionStorage.getItem(this.#cvgSessionStorageID)) {
      this.#cgvCheckbox.checked = true;
    }
  }
  _onCheckboxChanged() {
    if (this.#cgvCheckbox.checked) {
      sessionStorage.setItem(this.#cvgSessionStorageID, "true");
    } else {
      sessionStorage.removeItem(this.#cvgSessionStorageID);
    }
    this.hideAlertError();
  }
};
if (!window.customElements.get("checkout-button")) {
  window.customElements.define("checkout-button", CheckoutButton);
}

// dev/src/js/common/cart/free-shipping-bar.js
var _onCartChangedListener, _updateMessage, updateMessage_fn, _onCartChanged, onCartChanged_fn;
var FreeShippingBar = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _updateMessage);
    __privateAdd(this, _onCartChanged);
    __privateAdd(this, _onCartChangedListener, __privateMethod(this, _onCartChanged, onCartChanged_fn).bind(this));
  }
  static get observedAttributes() {
    return ["threshold", "total-price"];
  }
  async connectedCallback() {
    this.threshold = Math.round(this.threshold * (Shopify.currency.rate || 1));
    document.addEventListener("cart:change", __privateGet(this, _onCartChangedListener));
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", __privateGet(this, _onCartChangedListener));
  }
  get threshold() {
    return parseFloat(this.getAttribute("threshold"));
  }
  set threshold(value) {
    this.setAttribute("threshold", value);
  }
  get totalPrice() {
    return parseFloat(this.getAttribute("total-price"));
  }
  set totalPrice(value) {
    this.setAttribute("total-price", value);
  }
  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");
    const progressBarElement = this.querySelector("progress-bar");
    switch (attribute) {
      case "threshold":
        progressBarElement.valueMax = newValue;
        break;
      case "total-price":
        progressBarElement.valueNow = newValue;
        break;
    }
    __privateMethod(this, _updateMessage, updateMessage_fn).call(this);
  }
};
_onCartChangedListener = new WeakMap();
_updateMessage = new WeakSet();
updateMessage_fn = function() {
  const messageElement = this.querySelector("[data-message]");
  if (this.totalPrice >= this.threshold) {
    messageElement.innerHTML = this.getAttribute("reached-message");
  } else {
    const replacement = `${formatMoney(this.threshold - this.totalPrice).replace(/\$/g, "$$$$")}`;
    messageElement.innerHTML = this.getAttribute("unreached-message").replace(new RegExp("({{.*}})", "g"), replacement);
  }
};
_onCartChanged = new WeakSet();
onCartChanged_fn = function(event) {
  this.totalPrice = event.detail["cart"]["items"].filter((item) => item["requires_shipping"]).reduce((sum, item) => sum + item["final_line_price"], 0);
};
if (!window.customElements.get("free-shipping-bar")) {
  window.customElements.define("free-shipping-bar", FreeShippingBar);
}

// dev/src/js/common/cart/line-item-quantity.js
import { Delegate } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _delegate, _onQuantityChanged, onQuantityChanged_fn, _onChangeLinkClicked, onChangeLinkClicked_fn, _changeLineItemQuantity, changeLineItemQuantity_fn;
var LineItemQuantity = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onQuantityChanged);
    __privateAdd(this, _onChangeLinkClicked);
    __privateAdd(this, _changeLineItemQuantity);
    __privateAdd(this, _delegate, new Delegate(this));
    __privateGet(this, _delegate).on("change", "[data-line-key]", __privateMethod(this, _onQuantityChanged, onQuantityChanged_fn).bind(this));
    __privateGet(this, _delegate).on("click", '[href*="/cart/change"]', __privateMethod(this, _onChangeLinkClicked, onChangeLinkClicked_fn).bind(this));
  }
};
_delegate = new WeakMap();
_onQuantityChanged = new WeakSet();
onQuantityChanged_fn = function(event, target) {
  __privateMethod(this, _changeLineItemQuantity, changeLineItemQuantity_fn).call(this, target.getAttribute("data-line-key"), parseInt(target.value), target.getAttribute("data-json"));
};
_onChangeLinkClicked = new WeakSet();
onChangeLinkClicked_fn = function(event, target) {
  event.preventDefault();
  const url = new URL(target.href);
  __privateMethod(this, _changeLineItemQuantity, changeLineItemQuantity_fn).call(this, url.searchParams.get("id"), parseInt(url.searchParams.get("quantity")), this.querySelector("input").getAttribute("data-json"));
};
_changeLineItemQuantity = new WeakSet();
changeLineItemQuantity_fn = async function(lineKey, targetQuantity, jsonData) {
  if (window.themeVariables.settings.pageType === "cart") {
    window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
  } else {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const lineItem = this.closest("line-item");
    lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity, jsonData: JSON.parse(jsonData) } }));
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      keepalive: true,
      body: JSON.stringify({
        id: lineKey,
        quantity: targetQuantity,
        sections: sectionsToBundle.join(",")
      })
    })).json();
    if (cartContent.items.some((item) => item.properties && item.properties.hasOwnProperty("_bundle_id"))) {
      const bundleTokens = await (await fetch(`${Shopify.routes.root}cart?view=bundle`)).json();
      await cartTokens(bundleTokens);
    }
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    const lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
    lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
      bubbles: true,
      detail: {
        quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"],
        cart: cartContent
      }
    }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "line-item:change",
        cart: cartContent
      }
    }));
  }
};
if (!window.customElements.get("line-item-quantity")) {
  window.customElements.define("line-item-quantity", LineItemQuantity);
}

// dev/src/js/common/facets/facets-form.js
var _isDirty, _buildUrl, buildUrl_fn, _onFormChanged, onFormChanged_fn, _onFormSubmitted, onFormSubmitted_fn;
var FacetsForm = class extends HTMLFormElement {
  constructor() {
    super();
    __privateAdd(this, _buildUrl);
    __privateAdd(this, _onFormChanged);
    __privateAdd(this, _onFormSubmitted);
    __privateAdd(this, _isDirty, false);
    this.addEventListener("change", __privateMethod(this, _onFormChanged, onFormChanged_fn));
    this.addEventListener("submit", __privateMethod(this, _onFormSubmitted, onFormSubmitted_fn));
    if (this.closest("#facets-drawer")) {
      this.displaySelectedValues();
    }
  }
  displaySelectedValues() {
    Array.from(this.querySelectorAll("[data-selected-values]")).forEach((el) => {
      el.innerHTML = "";
    });
    let formData = new FormData(this);
    let prices = [];
    for (const [key, value] of formData) {
      let colorSwatches = [];
      if (this.querySelector(`[data-field="${key}"]`)) {
        if (key === "filter.p.m.global.groupe_couleur") {
          formData.getAll(key).forEach((el, index) => {
            let currentColor = document.getElementById(`${key}-${el.toLowerCase()}`);
            if (currentColor) {
              let colorTitle = el + (index !== formData.getAll(key).length - 1 ? "," : "");
              colorSwatches.push(`
                <span class="h-stack gap-2">
                  <span class="color-swatch" style="${currentColor.getAttribute("style")}">
                    <span class="color-swatch-background" style="--swatch-size: 1rem;"></span>
                  </span>
                  ${colorTitle}
                </span>
              `);
            }
          });
          if (colorSwatches.length > 2) {
            colorSwatches = colorSwatches.slice(0, 2);
            colorSwatches.push(`+ ${formData.getAll(key).length - 2}`);
          }
          this.querySelector(`[data-field="${key}"] [data-selected-values]`).innerHTML = colorSwatches.join("");
        } else {
          let values = formData.getAll(key);
          values.forEach((value2, index) => {
            values[index] = value2.charAt(0).toUpperCase() + value2.slice(1);
          });
          if (key === "filter.v.availability") {
            values = values.map((value2) => value2 === "1" ? window.themeVariables.translations.product.in_stock : window.themeVariables.translations.product.out_of_stock);
          }
          if (values.length > 2) {
            values = values.slice(0, 2);
            values.push(`+ ${formData.getAll(key).length - 2}`);
          }
          this.querySelector(`[data-field="${key}"] [data-selected-values]`).innerHTML = values.join(", ");
        }
      } else if (key.indexOf("filter.v.price") > -1) {
        if (formData.getAll(key)[0] !== "") {
          prices.push(`${formData.getAll(key)} ${window.themeVariables.settings.currencySymbol}`);
        }
      }
    }
    if (prices.length > 0 && this.querySelector(`[data-field="filter.v.price"]`)) {
      this.querySelector(`[data-field="filter.v.price"] [data-selected-values]`).innerHTML = prices.join(" - ");
    }
    this.displayDynamicContent(formData);
  }
  displayDynamicContent(formData) {
    let eyeletColorDropdown = this.querySelector('[data-field="filter.p.m.global.couleur_oeillets"]');
    for (const [key, value] of formData) {
      if (key === "filter.p.m.global.tete_de_rideau") {
        let values = formData.getAll(key);
        let valueToDisplay = "";
        if (values.length === 1) {
          valueToDisplay = window.themeVariables.strings.faceting.dimensions[`${values[0].toLowerCase()}`];
        }
        if (typeof valueToDisplay === "string" && this.querySelector('[facets-dynamic-content="curtain-head"]')) {
          this.querySelector('[facets-dynamic-content="curtain-head"]').removeAttribute("hidden");
          this.querySelector('[facets-dynamic-content="curtain-head"]').innerHTML = valueToDisplay;
        }
        if (eyeletColorDropdown) {
          if (!(values.length === 1 && values[0] === "Oeillets")) {
            eyeletColorDropdown.classList.add("hidden");
          } else {
            eyeletColorDropdown.classList.remove("hidden");
          }
        }
      }
    }
    if (eyeletColorDropdown && !formData.get("filter.p.m.global.tete_de_rideau")) {
      eyeletColorDropdown.classList.remove("hidden");
    }
    if (this.querySelector('[facets-dynamic-content="curtain-head"]') && !formData.get("filter.p.m.global.tete_de_rideau")) {
      this.querySelector('[facets-dynamic-content="curtain-head"]').setAttribute("hidden", true);
      this.querySelector('[facets-dynamic-content="curtain-head"]').innerHTML = "";
    }
  }
};
_isDirty = new WeakMap();
_buildUrl = new WeakSet();
buildUrl_fn = function() {
  const searchParams = new URLSearchParams(new FormData(this)), url = new URL(this.action);
  url.search = "";
  searchParams.forEach((value, key) => url.searchParams.append(key, value));
  ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((optionToClear) => {
    if (url.searchParams.get(optionToClear) === "") {
      url.searchParams.delete(optionToClear);
    }
  });
  url.searchParams.set("section_id", this.getAttribute("section-id"));
  return url;
};
_onFormChanged = new WeakSet();
onFormChanged_fn = function() {
  __privateSet(this, _isDirty, true);
  if (this.hasAttribute("update-on-change")) {
    this.dispatchEvent(new Event("submit", { cancelable: true }));
  } else {
    cachedFetch(__privateMethod(this, _buildUrl, buildUrl_fn).call(this).toString());
  }
  this.displaySelectedValues();
};
_onFormSubmitted = new WeakSet();
onFormSubmitted_fn = function() {
  if (!__privateGet(this, _isDirty)) {
    return;
  }
  this.dispatchEvent(new CustomEvent("facet:update", {
    bubbles: true,
    detail: {
      url: __privateMethod(this, _buildUrl, buildUrl_fn).call(this)
    }
  }));
  __privateSet(this, _isDirty, false);
};
if (!window.customElements.get("facets-form")) {
  window.customElements.define("facets-form", FacetsForm, { extends: "form" });
}

// dev/src/js/common/facets/facet-link.js
var _onFacetUpdate, onFacetUpdate_fn;
var FacetLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    __privateAdd(this, _onFacetUpdate);
    this.addEventListener("click", __privateMethod(this, _onFacetUpdate, onFacetUpdate_fn).bind(this));
  }
};
_onFacetUpdate = new WeakSet();
onFacetUpdate_fn = function(event) {
  event.preventDefault();
  const sectionId = extractSectionId(event.target), url = new URL(this.href);
  url.searchParams.set("section_id", sectionId);
  this.dispatchEvent(new CustomEvent("facet:update", {
    bubbles: true,
    detail: {
      url
    }
  }));
};
if (!window.customElements.get("facet-link")) {
  window.customElements.define("facet-link", FacetLink, { extends: "a" });
}

// dev/src/js/common/overlay/dialog-element.js
import { animate as animate4, FocusTrap, Delegate as Delegate2 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var lockLayerCount = 0;
var _isLocked, _delegate2, _abortController2, _focusTrap, _originalParentBeforeAppend, _allowOutsideClick, allowOutsideClick_fn, _allowOutsideClickTouch, allowOutsideClickTouch_fn, _allowOutsideClickMouse, allowOutsideClickMouse_fn, _onToggleClicked, onToggleClicked_fn, _updateSlotVisibility, updateSlotVisibility_fn;
var DialogElement = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _allowOutsideClick);
    __privateAdd(this, _allowOutsideClickTouch);
    __privateAdd(this, _allowOutsideClickMouse);
    __privateAdd(this, _onToggleClicked);
    __privateAdd(this, _updateSlotVisibility);
    __privateAdd(this, _isLocked, false);
    __privateAdd(this, _delegate2, new Delegate2(document.body));
    __privateAdd(this, _abortController2, void 0);
    __privateAdd(this, _focusTrap, void 0);
    __privateAdd(this, _originalParentBeforeAppend, void 0);
    if (this.shadowDomTemplate) {
      this.attachShadow({ mode: "open" }).appendChild(document.getElementById(this.shadowDomTemplate).content.cloneNode(true));
      this.shadowRoot.addEventListener("slotchange", (event) => __privateMethod(this, _updateSlotVisibility, updateSlotVisibility_fn).call(this, event.target));
    }
    this.addEventListener("dialog:force-close", (event) => {
      this.hide();
      event.stopPropagation();
    });
    this.addEventListener("dialog:before-show", (event) => {
      this._manageGorgiasChat(event);
    });
    this.addEventListener("dialog:after-hide", (event) => {
      this._manageGorgiasChat(event);
    });
  }
  static get observedAttributes() {
    return ["id", "open"];
  }
  connectedCallback() {
    if (this.id) {
      __privateGet(this, _delegate2).off().on("click", `[aria-controls="${this.id}"]`, __privateMethod(this, _onToggleClicked, onToggleClicked_fn).bind(this));
    }
    __privateSet(this, _abortController2, new AbortController());
    this.setAttribute("role", "dialog");
    if (this.shadowDomTemplate) {
      this.getShadowPartByName("overlay")?.addEventListener("click", this.hide.bind(this), { signal: this.abortController.signal });
      Array.from(this.shadowRoot.querySelectorAll("slot")).forEach((slot) => __privateMethod(this, _updateSlotVisibility, updateSlotVisibility_fn).call(this, slot));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.show(!event.detail.load), { signal: this.abortController.signal });
      this.addEventListener("shopify:block:deselect", this.hide, { signal: this.abortController.signal });
      this._shopifySection = this._shopifySection || this.closest(".shopify-section");
      if (this._shopifySection) {
        if (this.hasAttribute("handle-editor-events")) {
          this._shopifySection.addEventListener("shopify:section:select", (event) => this.show(!event.detail.load), { signal: this.abortController.signal });
          this._shopifySection.addEventListener("shopify:section:deselect", this.hide.bind(this), { signal: this.abortController.signal });
        }
        this._shopifySection.addEventListener("shopify:section:unload", () => this.remove(), { signal: this.abortController.signal });
      }
    }
  }
  disconnectedCallback() {
    __privateGet(this, _delegate2).off();
    this.abortController.abort();
    this.focusTrap?.deactivate({ onDeactivate: () => {
    } });
    if (__privateGet(this, _isLocked)) {
      __privateSet(this, _isLocked, false);
      document.documentElement.classList.toggle("lock", --lockLayerCount > 0);
    }
  }
  show(animate18 = true) {
    if (this.open) {
      return Promise.resolve();
    }
    this.setAttribute("open", animate18 ? "" : "immediate");
    return waitForEvent(this, "dialog:after-show");
  }
  hide() {
    if (!this.open) {
      return Promise.resolve();
    }
    this.removeAttribute("open");
    return waitForEvent(this, "dialog:after-hide");
  }
  get abortController() {
    return __privateGet(this, _abortController2);
  }
  get controls() {
    return Array.from(this.getRootNode().querySelectorAll(`[aria-controls="${this.id}"]`));
  }
  get open() {
    return this.hasAttribute("open");
  }
  get shouldTrapFocus() {
    return true;
  }
  get shouldLock() {
    return false;
  }
  get clickOutsideDeactivates() {
    return true;
  }
  get shouldAppendToBody() {
    return false;
  }
  get initialFocus() {
    return this.hasAttribute("initial-focus") ? this.getAttribute("initial-focus") === "false" ? false : this.querySelector(this.getAttribute("initial-focus")) : this.hasAttribute("tabindex") ? this : this.querySelector('input:not([type="hidden"])') || false;
  }
  get preventScrollWhenTrapped() {
    return true;
  }
  get focusTrap() {
    return __privateSet(this, _focusTrap, __privateGet(this, _focusTrap) || new FocusTrap.createFocusTrap([this, this.shadowRoot], {
      onDeactivate: this.hide.bind(this),
      allowOutsideClick: this.clickOutsideDeactivates ? __privateMethod(this, _allowOutsideClick, allowOutsideClick_fn).bind(this) : false,
      initialFocus: matchesMediaQuery("supports-hover") ? this.initialFocus : false,
      fallbackFocus: this,
      preventScroll: this.preventScrollWhenTrapped
    }));
  }
  get shadowDomTemplate() {
    return this.getAttribute("template");
  }
  getShadowPartByName(name) {
    return this.shadowRoot?.querySelector(`[part="${name}"]`);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "id":
        if (newValue) {
          __privateGet(this, _delegate2).off().on("click", `[aria-controls="${this.id}"]`, __privateMethod(this, _onToggleClicked, onToggleClicked_fn).bind(this));
        }
        break;
      case "open":
        this.controls.forEach((toggle) => toggle.setAttribute("aria-expanded", newValue === null ? "false" : "true"));
        if (oldValue === null && (newValue === "" || newValue === "immediate")) {
          __privateSet(this, _originalParentBeforeAppend, null);
          this.style.setProperty("display", "block");
          this.dispatchEvent(new CustomEvent("dialog:before-show"));
          if (this.shouldAppendToBody && this.parentElement !== document.body) {
            __privateSet(this, _originalParentBeforeAppend, this.parentElement);
            document.body.append(this);
          }
          const animationControls = this.createEnterAnimationControls();
          if (newValue === "immediate") {
            animationControls.finish();
          }
          animationControls.finished.then(() => {
            this.dispatchEvent(new CustomEvent("dialog:after-show"));
          });
          if (this.shouldTrapFocus) {
            this.focusTrap.activate({
              checkCanFocusTrap: () => animationControls.finished
            });
          }
          if (this.shouldLock) {
            lockLayerCount += 1;
            __privateSet(this, _isLocked, true);
            document.documentElement.classList.add("lock");
          }
        } else if (oldValue !== null && newValue === null) {
          this.dispatchEvent(new CustomEvent("dialog:before-hide"));
          const hideTransitionPromise = this.createLeaveAnimationControls().finished;
          hideTransitionPromise.then(() => {
            if (this.parentElement === document.body && __privateGet(this, _originalParentBeforeAppend)) {
              __privateGet(this, _originalParentBeforeAppend).appendChild(this);
              __privateSet(this, _originalParentBeforeAppend, null);
            }
            this.style.setProperty("display", "none");
            this.dispatchEvent(new CustomEvent("dialog:after-hide"));
          });
          this.focusTrap?.deactivate({
            checkCanReturnFocus: () => hideTransitionPromise
          });
          if (this.shouldLock) {
            __privateSet(this, _isLocked, false);
            document.documentElement.classList.toggle("lock", --lockLayerCount > 0);
          }
        }
        this.dispatchEvent(new CustomEvent("toggle", { bubbles: true }));
        break;
    }
  }
  createEnterAnimationControls() {
    return animate4(this, {}, { duration: 0 });
  }
  createLeaveAnimationControls() {
    return animate4(this, {}, { duration: 0 });
  }
  hideForOutsideClickTarget(target) {
    return !this.contains(target);
  }
  allowOutsideClickForTarget(target) {
    return false;
  }
  _manageGorgiasChat(event) {
    if (window.themeVariables.libraries.gorgias.active) {
      if (event.target.nodeName.indexOf("POPOVER") < 0) {
        document.getElementById("gorgias-chat-container").hidden = event.type === "dialog:before-show";
      }
    }
  }
};
_isLocked = new WeakMap();
_delegate2 = new WeakMap();
_abortController2 = new WeakMap();
_focusTrap = new WeakMap();
_originalParentBeforeAppend = new WeakMap();
_allowOutsideClick = new WeakSet();
allowOutsideClick_fn = function(event) {
  if ("TouchEvent" in window && event instanceof TouchEvent) {
    return __privateMethod(this, _allowOutsideClickTouch, allowOutsideClickTouch_fn).call(this, event);
  } else {
    return __privateMethod(this, _allowOutsideClickMouse, allowOutsideClickMouse_fn).call(this, event);
  }
};
_allowOutsideClickTouch = new WeakSet();
allowOutsideClickTouch_fn = function(event) {
  event.target.addEventListener("touchend", (subEvent) => {
    const endTarget = document.elementFromPoint(subEvent.changedTouches.item(0).clientX, subEvent.changedTouches.item(0).clientY);
    if (this.hideForOutsideClickTarget(endTarget)) {
      this.hide();
    }
  }, { once: true, signal: this.abortController.signal });
  return this.allowOutsideClickForTarget(event.target);
};
_allowOutsideClickMouse = new WeakSet();
allowOutsideClickMouse_fn = function(event) {
  if (event.type !== "click") {
    return false;
  }
  if (this.hideForOutsideClickTarget(event.target)) {
    if (matchesMediaQuery("md")) {
      this.hide();
    }
  }
  if (this.allowOutsideClickForTarget(event.target)) {
    return true;
  }
  let target = event.target, closestControl = event.target.closest("[aria-controls]");
  if (closestControl && closestControl.getAttribute("aria-controls") === this.id) {
    target = closestControl;
  }
  return this.id !== target.getAttribute("aria-controls");
};
_onToggleClicked = new WeakSet();
onToggleClicked_fn = function(event) {
  event?.preventDefault();
  this.open ? this.hide() : this.show();
};
_updateSlotVisibility = new WeakSet();
updateSlotVisibility_fn = function(slot) {
  if (!["header", "footer"].includes(slot.name)) {
    return;
  }
  slot.parentElement.hidden = slot.assignedElements({ flatten: true }).length === 0;
};
var DialogCloseButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("dialog:force-close", { bubbles: true, cancelable: true, composed: true })));
    if (this.hasAttribute("show-drawer")) {
      this.addEventListener("dialog:force-close", () => {
        document.getElementById(this.getAttribute("show-drawer")).show();
      });
    }
  }
};
if (!window.customElements.get("dialog-element")) {
  window.customElements.define("dialog-element", DialogElement);
}
if (!window.customElements.get("dialog-close-button")) {
  window.customElements.define("dialog-close-button", DialogCloseButton, { extends: "button" });
}

// dev/src/js/common/overlay/drawer.js
import { animate as animate5, timeline as timeline2 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var Drawer = class extends DialogElement {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
  }
  get shadowDomTemplate() {
    return this.getAttribute("template") || "drawer-default-template";
  }
  get shouldLock() {
    return true;
  }
  get shouldAppendToBody() {
    return true;
  }
  get openFrom() {
    return this.getAttribute("open-from") || "right";
  }
  createEnterAnimationControls() {
    this.getShadowPartByName("content").style.marginInlineStart = this.openFrom === "right" ? "auto" : 0;
    return timeline2([
      [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
      [this.getShadowPartByName("content"), { transform: [`translateX(${this.openFrom === "right" ? "100%" : "-100%"})`, "translateX(0)"] }, { duration: 0.3, at: "<", easing: [0.645, 0.045, 0.355, 1] }]
    ]);
  }
  createLeaveAnimationControls() {
    return timeline2([
      [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
      [this.getShadowPartByName("content"), { transform: ["translateX(0)", `translateX(${this.openFrom === "right" ? "100%" : "-100%"})`] }, { duration: 0.3, at: "<", easing: [0.645, 0.045, 0.355, 1] }]
    ]);
  }
};
if (!window.customElements.get("x-drawer")) {
  window.customElements.define("x-drawer", Drawer);
}

// dev/src/js/common/overlay/modal.js
import { animate as animate6, timeline as timeline3 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var Modal = class extends DialogElement {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
  }
  get shadowDomTemplate() {
    return this.getAttribute("template") || "modal-default-template";
  }
  get shouldLock() {
    return true;
  }
  get shouldAppendToBody() {
    return true;
  }
  createEnterAnimationControls() {
    if (matchesMediaQuery("sm")) {
      return animate6(this, { opacity: [0, 1] }, { duration: 0.2 });
    } else {
      return timeline3([
        [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [this.getShadowPartByName("content"), { transform: ["translateY(100%)", "translateY(0)"] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" }]
      ]);
    }
  }
  createLeaveAnimationControls() {
    if (matchesMediaQuery("sm")) {
      return animate6(this, { opacity: [1, 0] }, { duration: 0.2 });
    } else {
      return timeline3([
        [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [this.getShadowPartByName("content"), { transform: ["translateY(0)", "translateY(100%)"] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" }]
      ]);
    }
  }
};
if (!window.customElements.get("x-modal")) {
  window.customElements.define("x-modal", Modal);
}

// dev/src/js/common/overlay/popover.js
import { animate as animate7, timeline as timeline4 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var Popover = class extends DialogElement {
  connectedCallback() {
    super.connectedCallback();
    this.controls.forEach((control) => control.setAttribute("aria-haspopup", "dialog"));
    if (this.hasAttribute("close-on-listbox-select")) {
      this.addEventListener("listbox:select", this.hide, { signal: this.abortController.signal });
    }
  }
  get shadowDomTemplate() {
    return this.getAttribute("template") || "popover-default-template";
  }
  get shouldLock() {
    return matchesMediaQuery("md-max");
  }
  get shouldAppendToBody() {
    let output = matchesMediaQuery("md-max");
    if (this.shadowDomTemplate === "popover-blank-template" || this.shadowDomTemplate === "popover-select-template") {
      output = false;
    }
    return output;
  }
  get preventScrollWhenTrapped() {
    return true;
  }
  createEnterAnimationControls() {
    if (this.shadowDomTemplate === "popover-blank-template") {
      return animate7(this, { opacity: [0, 1] }, { duration: 0.2 });
    }
    if (matchesMediaQuery("md")) {
      return animate7(this, { opacity: [0, 1] }, { duration: 0.2 });
    } else {
      return timeline4([
        [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [this.getShadowPartByName("content"), { transform: ["translateY(100%)", "translateY(0)"] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" }]
      ]);
    }
  }
  createLeaveAnimationControls() {
    if (this.shadowDomTemplate === "popover-blank-template") {
      return animate7(this, { opacity: [1, 0] }, { duration: 0.2 });
    }
    if (matchesMediaQuery("md")) {
      return animate7(this, { opacity: [1, 0] }, { duration: 0.2 });
    } else {
      return timeline4([
        [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [this.getShadowPartByName("content"), { transform: ["translateY(0)", "translateY(100%)"] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" }]
      ]);
    }
  }
};
if (!window.customElements.get("x-popover")) {
  window.customElements.define("x-popover", Popover);
}

// dev/src/js/common/facets/facets-drawer.js
var _updateFacets, updateFacets_fn;
var FacetsDrawer = class extends Drawer {
  constructor() {
    super();
    __privateAdd(this, _updateFacets);
    this.addEventListener("dialog:after-hide", __privateMethod(this, _updateFacets, updateFacets_fn));
  }
  get shouldAppendToBody() {
    return false;
  }
};
_updateFacets = new WeakSet();
updateFacets_fn = function() {
  this.querySelector('[is="facets-form"]')?.dispatchEvent(new Event("submit", { bubbles: true }));
};
if (!window.customElements.get("facets-drawer")) {
  window.customElements.define("facets-drawer", FacetsDrawer);
}

// dev/src/js/common/facets/facets-sort-popover.js
var _onSortChange, onSortChange_fn;
var FacetsSortPopover = class extends Popover {
  constructor() {
    super();
    __privateAdd(this, _onSortChange);
    this.addEventListener("listbox:change", __privateMethod(this, _onSortChange, onSortChange_fn));
  }
};
_onSortChange = new WeakSet();
onSortChange_fn = function(event) {
  const url = new URL(window.location.href);
  url.searchParams.set("sort_by", event.detail.value);
  url.searchParams.delete("page");
  url.searchParams.set("section_id", this.getAttribute("section-id"));
  this.dispatchEvent(new CustomEvent("facet:update", {
    bubbles: true,
    detail: {
      url
    }
  }));
};
if (!window.customElements.get("facets-sort-popover")) {
  window.customElements.define("facets-sort-popover", FacetsSortPopover);
}

// dev/src/js/common/facets/facets-listeners.js
import { Delegate as Delegate3 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var abortController = null;
var delegate = new Delegate3(document.body);
var openDetailsValues = new Set(Array.from(document.querySelectorAll('[is="facets-form"] details[open] input[name*="filter."]'), (item) => item.name));
delegate.on("toggle", '[is="facets-form"] details', (event, detailsElement) => {
  const inputNames = [...new Set(Array.from(detailsElement.querySelectorAll('input[name*="filter."]'), (item) => item.name))];
  inputNames.forEach((inputName) => {
    detailsElement.open ? openDetailsValues.add(inputName) : openDetailsValues.delete(inputName);
  });
}, true);
document.addEventListener("facet:update", async (event) => {
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  const url = event.detail.url, shopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`);
  const clonedUrl = new URL(url);
  clonedUrl.searchParams.delete("section_id");
  history.replaceState({}, "", clonedUrl.toString());
  try {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const tempContent = new DOMParser().parseFromString(await (await cachedFetch(url.toString(), { signal: abortController.signal })).text(), "text/html");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    const newShopifySection = tempContent.querySelector(".shopify-section");
    newShopifySection.querySelectorAll('[is="facets-form"] details').forEach((detailsElement) => {
      const inputNames = [...new Set(Array.from(detailsElement.querySelectorAll('input[name*="filter."]'), (item) => item.name))];
      inputNames.forEach((inputName) => {
        detailsElement.toggleAttribute("open", openDetailsValues.has(inputName));
      });
    });
    if (event.detail.loadMore) {
      let currentIndex = event.detail.previousButton ? 0 : document.querySelectorAll(".collection__product-list").length - 1;
      let currentProductList = document.querySelectorAll(".collection__product-list")[currentIndex];
      if (event.detail.previousButton) {
        currentProductList.before(...document.importNode(tempContent.querySelector(".shopify-section"), true).childNodes);
      } else {
        currentProductList.after(...document.importNode(tempContent.querySelector(".shopify-section"), true).childNodes);
      }
    } else {
      shopifySection.replaceChildren(...document.importNode(tempContent.querySelector(".shopify-section"), true).childNodes);
      const headerHeight = document.querySelector("header.header").clientHeight;
      const scrollToProductList = () => window.scrollTo({ top: shopifySection.querySelector(".collection").offsetTop - headerHeight, behavior: "smooth" });
      if ("requestIdleCallback" in window) {
        requestIdleCallback(scrollToProductList, { timeout: 500 });
      } else {
        requestAnimationFrame(scrollToProductList);
      }
    }
  } catch (e) {
  }
});

// dev/src/js/common/feedback/progress-bar.js
import { inView as inView4 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _allowUpdatingProgress, _calculateProgressBar, calculateProgressBar_fn;
var ProgressBar = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _calculateProgressBar);
    __privateAdd(this, _allowUpdatingProgress, !this.hasAttribute("animate-on-scroll"));
  }
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  connectedCallback() {
    if (this.hasAttribute("animate-on-scroll")) {
      inView4(this, () => {
        __privateSet(this, _allowUpdatingProgress, true);
        __privateMethod(this, _calculateProgressBar, calculateProgressBar_fn).call(this);
      }, { margin: "-50px 0px" });
    }
  }
  get progress() {
    return Math.min(1, this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"));
  }
  set valueMax(value) {
    this.setAttribute("aria-valuemax", value);
  }
  set valueNow(value) {
    this.setAttribute("aria-valuenow", value);
  }
  attributeChangedCallback() {
    if (__privateGet(this, _allowUpdatingProgress)) {
      __privateMethod(this, _calculateProgressBar, calculateProgressBar_fn).call(this);
    }
  }
};
_allowUpdatingProgress = new WeakMap();
_calculateProgressBar = new WeakSet();
calculateProgressBar_fn = function() {
  this.style.setProperty("--progress", `${this.progress}`);
  this.style.setProperty("--progress-color", this.progress === 1 ? "rgb(var(--color-stock))" : "rgb(var(--color-terracotta))");
};
if (!window.customElements.get("progress-bar")) {
  window.customElements.define("progress-bar", ProgressBar);
}

// dev/src/js/common/form/custom-select.js
var _onSelectedValue, onSelectedValue_fn;
var CustomSelect = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onSelectedValue);
    this.addEventListener("listbox:change", __privateMethod(this, _onSelectedValue, onSelectedValue_fn));
  }
};
_onSelectedValue = new WeakSet();
onSelectedValue_fn = function(event) {
  if (event.target.nodeName === "BUTTON") {
    if (event.target.getAttribute("aria-controls")) {
      const container = this.closest(".fieldset");
      Array.from(container.querySelectorAll("[should-hide]")).forEach((select) => {
        select.hidden = select.id !== event.target.getAttribute("aria-controls") && select !== this;
      });
    }
  }
};
if (!window.customElements.get("custom-select")) {
  window.customElements.define("custom-select", CustomSelect);
}

// dev/src/js/common/form/date-input.js
var DateInput = class extends HTMLElement {
  #inputName;
  #input;
  constructor() {
    super();
    this.#input = this.querySelector("input");
    this.#inputName = this.#input?.getAttribute("name");
    setTimeout(() => {
      let cleave = new Cleave(`[name="${this.#inputName}"]`, {
        date: true,
        dateMin: "1900-01-01",
        dateMax: window.themeVariables.today,
        datePattern: ["d", "m", "Y"]
      });
    }, 1e3);
  }
};
if (!window.customElements.get("date-input")) {
  window.customElements.define("date-input", DateInput);
}

// dev/src/js/common/form/newsletter.js
var _listenersAbortController2, _emailInput, _successMessage, _errorMessage, _formContainer, _onFormSubmitted2, onFormSubmitted_fn2, _showMessage, showMessage_fn, _reinitForm, reinitForm_fn, _sendDataToKlaviyo, sendDataToKlaviyo_fn;
var NewsletterForm = class extends HTMLFormElement {
  constructor() {
    super();
    __privateAdd(this, _onFormSubmitted2);
    __privateAdd(this, _showMessage);
    __privateAdd(this, _reinitForm);
    __privateAdd(this, _sendDataToKlaviyo);
    __privateAdd(this, _listenersAbortController2, void 0);
    __privateAdd(this, _emailInput, void 0);
    __privateAdd(this, _successMessage, void 0);
    __privateAdd(this, _errorMessage, void 0);
    __privateAdd(this, _formContainer, void 0);
    __privateSet(this, _listenersAbortController2, new AbortController());
    __privateSet(this, _emailInput, this.querySelector('[name="email"]'));
    __privateSet(this, _formContainer, this.querySelector('[data-type="form"]'));
    __privateSet(this, _successMessage, this.querySelector('[data-type="success"]'));
    __privateSet(this, _errorMessage, this.querySelector('[data-type="error"]'));
    this.addEventListener("submit", __privateMethod(this, _onFormSubmitted2, onFormSubmitted_fn2));
  }
  disconnectedCallback() {
    __privateGet(this, _listenersAbortController2).abort();
  }
};
_listenersAbortController2 = new WeakMap();
_emailInput = new WeakMap();
_successMessage = new WeakMap();
_errorMessage = new WeakMap();
_formContainer = new WeakMap();
_onFormSubmitted2 = new WeakSet();
onFormSubmitted_fn2 = function(event) {
  event.preventDefault();
  const formData = new FormData(this);
  const emailValue = formData.get("email");
  const emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (emailValue !== "" && emailValue.match(emailFormat)) {
    this.querySelector('[type="submit"]')?.classList.add("button--loading");
    __privateMethod(this, _sendDataToKlaviyo, sendDataToKlaviyo_fn).call(this, formData);
    __privateGet(this, _errorMessage).hidden = true;
  } else {
    __privateGet(this, _emailInput).style = "--border-color:rgb(var(--color-error))";
    __privateGet(this, _errorMessage).hidden = false;
  }
};
_showMessage = new WeakSet();
showMessage_fn = function(success) {
  this.querySelector('[type="submit"]')?.classList.remove("button--loading");
  __privateGet(this, _formContainer).hidden = true;
  __privateGet(this, _errorMessage).hidden = success;
  __privateGet(this, _successMessage).hidden = !success;
  if (success) {
    setTimeout(() => {
      __privateMethod(this, _reinitForm, reinitForm_fn).call(this);
    }, 5e3);
  }
};
_reinitForm = new WeakSet();
reinitForm_fn = function() {
  __privateGet(this, _formContainer).hidden = false;
  __privateGet(this, _emailInput).value = "";
  __privateGet(this, _errorMessage).hidden = true;
  __privateGet(this, _successMessage).hidden = true;
};
_sendDataToKlaviyo = new WeakSet();
sendDataToKlaviyo_fn = function(data) {
  let url = this.getAttribute("data-ajax-submit");
  let source = this.getAttribute("data-source");
  let klaviyoData = new URLSearchParams({
    "g": data.get("g"),
    "$fields": data.get("$fields"),
    "$list_fields": data.get("$list_fields"),
    "email": data.get("email"),
    "source": source
  }).toString();
  fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache"
    },
    body: klaviyoData
  }).then((response) => response.json()).then((response) => {
    __privateMethod(this, _showMessage, showMessage_fn).call(this, response.success);
  }).catch((err) => __privateMethod(this, _showMessage, showMessage_fn).call(this, err.success));
};
if (!window.customElements.get("newsletter-form")) {
  window.customElements.define("newsletter-form", NewsletterForm, { extends: "form" });
}

// dev/src/js/common/form/phone-input.js
var PhoneInput = class extends HTMLElement {
  #input;
  #inputLabel;
  constructor() {
    super();
    this.#input = this.querySelector("input");
    this.#inputLabel = this.querySelector("label");
    this._initPhoneInput();
  }
  async _initPhoneInput() {
    await waitForWindowObject(() => window.hasOwnProperty("intlTelInput")).then(() => {
      this.intlTelInput = window.intlTelInput(this.#input, {
        initialCountry: "FR",
        separateDialCode: true,
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
      });
      this.#input.parentElement.append(this.#inputLabel);
    });
  }
};
if (!window.customElements.get("phone-input")) {
  window.customElements.define("phone-input", PhoneInput);
}

// dev/src/js/common/form/price-range.js
var PriceRange = class extends HTMLElement {
  #abortController;
  connectedCallback() {
    this.#abortController = new AbortController();
    const rangeLowerBound = this.querySelector('input[type="range"]#price-gte'), rangeHigherBound = this.querySelector('input[type="range"]#price-lte'), textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]'), textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
    textInputLowerBound.addEventListener("focus", () => textInputLowerBound.select(), { signal: this.#abortController.signal });
    textInputHigherBound.addEventListener("focus", () => textInputHigherBound.select(), { signal: this.#abortController.signal });
    textInputLowerBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1), event.target.min);
      rangeLowerBound.value = event.target.value;
      let newVal = (parseInt(rangeLowerBound.value) - parseInt(rangeLowerBound.min)) * 100 / (parseInt(rangeLowerBound.max) - parseInt(rangeLowerBound.min));
      rangeLowerBound.closest(".range-group").style.setProperty("--range-min", `calc(${newVal}% + (${16 - newVal * 0.32}px))`);
    }, { signal: this.#abortController.signal });
    textInputHigherBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1), event.target.max);
      rangeHigherBound.value = event.target.value;
      let newVal = (parseInt(rangeHigherBound.value) - parseInt(rangeHigherBound.min)) * 100 / (parseInt(rangeHigherBound.max) - parseInt(rangeHigherBound.min));
      rangeHigherBound.closest(".range-group").style.setProperty("--range-max", `calc(${newVal}% + (${16 - newVal * 0.32}px))`);
    }, { signal: this.#abortController.signal });
    rangeLowerBound.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputLowerBound.value = event.target.value;
      textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this.#abortController.signal });
    rangeHigherBound.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputHigherBound.value = event.target.value;
      textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this.#abortController.signal });
    rangeLowerBound.addEventListener("input", (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1);
      let newVal = (parseInt(rangeLowerBound.value) - parseInt(rangeLowerBound.min)) * 100 / (parseInt(rangeLowerBound.max) - parseInt(rangeLowerBound.min));
      event.target.closest(".range-group").style.setProperty("--range-min", `calc(${newVal}% + (${16 - newVal * 0.32}px))`);
      textInputLowerBound.value = event.target.value;
    }, { signal: this.#abortController.signal });
    rangeHigherBound.addEventListener("input", (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1);
      let newVal = (parseInt(rangeHigherBound.value) - parseInt(rangeHigherBound.min)) * 100 / (parseInt(rangeHigherBound.max) - parseInt(rangeHigherBound.min));
      event.target.closest(".range-group").style.setProperty("--range-max", `calc(${newVal}% + (${16 - newVal * 0.32}px))`);
      textInputHigherBound.value = event.target.value;
    }, { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRange);
}

// dev/src/js/common/form/quantity-selector.js
var _abortController3, _decreaseButton, _increaseButton, _extraInputElement, _inputElement, _quantityButtons, _onDecreaseQuantity, onDecreaseQuantity_fn, _onIncreaseQuantity, onIncreaseQuantity_fn, _onQuantitySelected, onQuantitySelected_fn, _onVariantChangedListener, onVariantChangedListener_fn, _updateUI, updateUI_fn, _updateComplexSelectorUI, updateComplexSelectorUI_fn;
var QuantitySelector = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onDecreaseQuantity);
    __privateAdd(this, _onIncreaseQuantity);
    __privateAdd(this, _onQuantitySelected);
    __privateAdd(this, _onVariantChangedListener);
    __privateAdd(this, _updateUI);
    __privateAdd(this, _updateComplexSelectorUI);
    __privateAdd(this, _abortController3, void 0);
    __privateAdd(this, _decreaseButton, void 0);
    __privateAdd(this, _increaseButton, void 0);
    __privateAdd(this, _extraInputElement, void 0);
    __privateAdd(this, _inputElement, void 0);
    __privateAdd(this, _quantityButtons, void 0);
  }
  connectedCallback() {
    __privateSet(this, _abortController3, new AbortController());
    __privateSet(this, _decreaseButton, this.querySelector("button[decrease]"));
    __privateSet(this, _increaseButton, this.querySelector("button[increase]"));
    __privateSet(this, _quantityButtons, this.querySelectorAll("button[data-quantity]"));
    __privateSet(this, _extraInputElement, this.querySelector("[extra-numbers-input]"));
    __privateSet(this, _inputElement, __privateGet(this, _extraInputElement) ? __privateGet(this, _extraInputElement).querySelector("input") : this.querySelector("input"));
    this.masterSelector = document.forms[__privateGet(this, _inputElement).getAttribute("form")]?.id;
    __privateGet(this, _decreaseButton)?.addEventListener("click", __privateMethod(this, _onDecreaseQuantity, onDecreaseQuantity_fn).bind(this), { signal: __privateGet(this, _abortController3).signal });
    __privateGet(this, _increaseButton)?.addEventListener("click", __privateMethod(this, _onIncreaseQuantity, onIncreaseQuantity_fn).bind(this), { signal: __privateGet(this, _abortController3).signal });
    if (__privateGet(this, _quantityButtons).length > 0) {
      Array.from(__privateGet(this, _quantityButtons)).forEach((button) => {
        button.addEventListener("click", __privateMethod(this, _onQuantitySelected, onQuantitySelected_fn).bind(this));
      });
    }
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateMethod(this, _onVariantChangedListener, onVariantChangedListener_fn).bind(this), { signal: __privateGet(this, _abortController3).signal });
    this.masterSelector.form.addEventListener("quantity:change", (event) => {
      __privateGet(this, _decreaseButton).disabled = event.detail.quantity <= 1;
    });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController3).abort();
  }
};
_abortController3 = new WeakMap();
_decreaseButton = new WeakMap();
_increaseButton = new WeakMap();
_extraInputElement = new WeakMap();
_inputElement = new WeakMap();
_quantityButtons = new WeakMap();
_onDecreaseQuantity = new WeakSet();
onDecreaseQuantity_fn = function() {
  __privateGet(this, _inputElement).stepDown();
  __privateMethod(this, _updateUI, updateUI_fn).call(this);
};
_onIncreaseQuantity = new WeakSet();
onIncreaseQuantity_fn = function() {
  __privateGet(this, _inputElement).stepUp();
  __privateMethod(this, _updateUI, updateUI_fn).call(this);
};
_onQuantitySelected = new WeakSet();
onQuantitySelected_fn = function(event) {
  __privateGet(this, _inputElement).value = parseInt(event.target.getAttribute("data-quantity"));
  __privateMethod(this, _updateUI, updateUI_fn).call(this);
};
_onVariantChangedListener = new WeakSet();
onVariantChangedListener_fn = function(event) {
  const inventoryQuantity = parseInt(event.detail.inventoryQuantity);
  inventoryQuantity > 4 ? __privateGet(this, _increaseButton).removeAttribute("disabled") : __privateGet(this, _increaseButton).setAttribute("disabled", "disabled");
  if (__privateGet(this, _quantityButtons).length > 0) {
    Array.from(__privateGet(this, _quantityButtons))?.forEach((button) => {
      if (inventoryQuantity >= parseInt(button.getAttribute("data-quantity"))) {
        button.removeAttribute("disabled");
      } else {
        button.setAttribute("disabled", "disabled");
      }
    });
  }
  __privateGet(this, _inputElement).updateVariantRule(event.detail);
};
_updateUI = new WeakSet();
updateUI_fn = function() {
  this.masterSelector.form.dispatchEvent(new CustomEvent("quantity:change", {
    bubbles: true,
    detail: {
      quantity: __privateGet(this, _inputElement).quantity
    }
  }));
  if (__privateGet(this, _quantityButtons).length > 0) {
    __privateMethod(this, _updateComplexSelectorUI, updateComplexSelectorUI_fn).call(this);
  }
};
_updateComplexSelectorUI = new WeakSet();
updateComplexSelectorUI_fn = function() {
  __privateGet(this, _extraInputElement).hidden = __privateGet(this, _inputElement).quantity <= 3;
  __privateGet(this, _decreaseButton).hidden = __privateGet(this, _inputElement).quantity <= 3;
  Array.from(__privateGet(this, _quantityButtons)).forEach((button, index) => {
    button.hidden = __privateGet(this, _inputElement).quantity > 3;
    button.classList.toggle("is-selected", index + 1 === __privateGet(this, _inputElement).quantity);
  });
};
var _abortController4, _decreaseButton2, _increaseButton2, _inputElement2, _onDecreaseQuantity2, onDecreaseQuantity_fn2, _onIncreaseQuantity2, onIncreaseQuantity_fn2, _onVariantChangedListener2, onVariantChangedListener_fn2, _updateUI2, updateUI_fn2;
var CartQuantitySelector = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onDecreaseQuantity2);
    __privateAdd(this, _onIncreaseQuantity2);
    __privateAdd(this, _onVariantChangedListener2);
    __privateAdd(this, _updateUI2);
    __privateAdd(this, _abortController4, void 0);
    __privateAdd(this, _decreaseButton2, void 0);
    __privateAdd(this, _increaseButton2, void 0);
    __privateAdd(this, _inputElement2, void 0);
  }
  connectedCallback() {
    __privateSet(this, _abortController4, new AbortController());
    __privateSet(this, _decreaseButton2, this.querySelector("button:first-of-type"));
    __privateSet(this, _increaseButton2, this.querySelector("button:last-of-type"));
    __privateSet(this, _inputElement2, this.querySelector("input"));
    __privateGet(this, _decreaseButton2)?.addEventListener("click", __privateMethod(this, _onDecreaseQuantity2, onDecreaseQuantity_fn2).bind(this), { signal: __privateGet(this, _abortController4).signal });
    __privateGet(this, _increaseButton2)?.addEventListener("click", __privateMethod(this, _onIncreaseQuantity2, onIncreaseQuantity_fn2).bind(this), { signal: __privateGet(this, _abortController4).signal });
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateMethod(this, _onVariantChangedListener2, onVariantChangedListener_fn2).bind(this), { signal: __privateGet(this, _abortController4).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController4).abort();
  }
};
_abortController4 = new WeakMap();
_decreaseButton2 = new WeakMap();
_increaseButton2 = new WeakMap();
_inputElement2 = new WeakMap();
_onDecreaseQuantity2 = new WeakSet();
onDecreaseQuantity_fn2 = function() {
  __privateGet(this, _inputElement2).stepDown();
  __privateMethod(this, _updateUI2, updateUI_fn2).call(this);
};
_onIncreaseQuantity2 = new WeakSet();
onIncreaseQuantity_fn2 = function() {
  __privateGet(this, _inputElement2).stepUp();
  __privateMethod(this, _updateUI2, updateUI_fn2).call(this);
};
_onVariantChangedListener2 = new WeakSet();
onVariantChangedListener_fn2 = function(event) {
  __privateGet(this, _inputElement2).updateVariantRule(event.detail.variant);
};
_updateUI2 = new WeakSet();
updateUI_fn2 = function() {
  __privateGet(this, _decreaseButton2).disabled = __privateGet(this, _inputElement2).quantity <= 1;
};
var _onValueInput, onValueInput_fn;
var QuantityInput = class extends HTMLInputElement {
  constructor() {
    super();
    __privateAdd(this, _onValueInput);
    this.masterSelector = document.forms[this.getAttribute("form")]?.id;
    this.addEventListener("input", __privateMethod(this, _onValueInput, onValueInput_fn));
    this.addEventListener("focus", this.select);
  }
  get quantity() {
    return parseInt(this.value);
  }
  updateVariantRule(variant) {
    this.setAttribute("max", parseInt(variant.inventoryQuantity));
  }
};
_onValueInput = new WeakSet();
onValueInput_fn = function() {
  if (this.value === "") {
    this.value = this.min || 1;
  }
  this.masterSelector?.form.dispatchEvent(new CustomEvent("quantity:change", {
    bubbles: true,
    detail: {
      quantity: this.value
    }
  }));
};
var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
var _onQuantityChangedListener, onQuantityChangedListener_fn;
var QuantityPrice = class extends HTMLInputElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onQuantityChangedListener);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("quantity:change", __privateMethod(this, _onQuantityChangedListener, onQuantityChangedListener_fn).bind(this));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("quantity:change", __privateMethod(this, _onQuantityChangedListener, onQuantityChangedListener_fn).bind(this));
  }
};
_onQuantityChangedListener = new WeakSet();
onQuantityChangedListener_fn = function(event) {
  const variantPrice = this.getAttribute("data-price");
  if (event.detail.quantity && variantPrice) {
    this.value = formatMoney(variantPrice * event.detail.quantity, currencyFormat);
  }
};
if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}
if (!window.customElements.get("cart-quantity-selector")) {
  window.customElements.define("cart-quantity-selector", CartQuantitySelector);
}
if (!window.customElements.get("quantity-input")) {
  window.customElements.define("quantity-input", QuantityInput, { extends: "input" });
}
if (!window.customElements.get("quantity-price")) {
  window.customElements.define("quantity-price", QuantityPrice, { extends: "input" });
}

// dev/src/js/common/form/show-password.js
var ShowPassword = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      this.querySelectorAll("svg").forEach((el) => {
        if (el.getAttribute("aria-hidden") === "true") {
          el.setAttribute("aria-hidden", "false");
          this.previousElementSibling.type = "text";
        } else {
          el.setAttribute("aria-hidden", "true");
          this.previousElementSibling.type = "password";
        }
      });
    });
  }
};
if (!window.customElements.get("show-password")) {
  window.customElements.define("show-password", ShowPassword);
}

// dev/src/js/common/list/listbox.js
var _accessibilityInitialized, _hiddenInput, _setupAccessibility, setupAccessibility_fn, _onOptionClicked, onOptionClicked_fn, _onInputChanged, onInputChanged_fn, _onKeyDown, onKeyDown_fn;
var Listbox = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _setupAccessibility);
    __privateAdd(this, _onOptionClicked);
    __privateAdd(this, _onInputChanged);
    __privateAdd(this, _onKeyDown);
    __privateAdd(this, _accessibilityInitialized, false);
    __privateAdd(this, _hiddenInput, void 0);
    this.addEventListener("keydown", __privateMethod(this, _onKeyDown, onKeyDown_fn));
  }
  static get observedAttributes() {
    return ["aria-activedescendant"];
  }
  connectedCallback() {
    __privateSet(this, _hiddenInput, this.querySelector('input[type="hidden"]'));
    __privateGet(this, _hiddenInput)?.addEventListener("change", __privateMethod(this, _onInputChanged, onInputChanged_fn).bind(this));
    if (!__privateGet(this, _accessibilityInitialized)) {
      requestAnimationFrame(__privateMethod(this, _setupAccessibility, setupAccessibility_fn).bind(this));
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "aria-activedescendant" && oldValue !== null && newValue !== oldValue) {
      Array.from(this.querySelectorAll('[role="option"]')).forEach((option) => {
        if (option.id === newValue) {
          option.setAttribute("aria-selected", "true");
          if (__privateGet(this, _hiddenInput) && __privateGet(this, _hiddenInput).value !== option.value) {
            __privateGet(this, _hiddenInput).value = option.value;
            __privateGet(this, _hiddenInput).dispatchEvent(new Event("change", { bubbles: true }));
          }
          if (this.hasAttribute("aria-owns")) {
            this.getAttribute("aria-owns").split(" ").forEach((boundId) => {
              document.getElementById(boundId).textContent = option.getAttribute("title") || option.innerText || option.value;
              document.getElementById(boundId).setAttribute("aria-selected", "true");
            });
          }
          option.dispatchEvent(new CustomEvent("listbox:change", {
            bubbles: true,
            detail: {
              value: option.value
            }
          }));
        } else {
          option.setAttribute("aria-selected", "false");
        }
      });
    }
  }
};
_accessibilityInitialized = new WeakMap();
_hiddenInput = new WeakMap();
_setupAccessibility = new WeakSet();
setupAccessibility_fn = function() {
  this.setAttribute("role", "listbox");
  Array.from(this.querySelectorAll('[role="option"]')).forEach((option) => {
    option.addEventListener("click", __privateMethod(this, _onOptionClicked, onOptionClicked_fn).bind(this));
    option.id = "option-" + (crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4));
    if (option.getAttribute("aria-selected") === "true") {
      this.setAttribute("aria-activedescendant", option.id);
    }
  });
  __privateSet(this, _accessibilityInitialized, true);
};
_onOptionClicked = new WeakSet();
onOptionClicked_fn = function(event) {
  if (event.currentTarget.getAttribute("type") === "submit") {
    return;
  }
  this.setAttribute("aria-activedescendant", event.currentTarget.id);
  event.currentTarget.dispatchEvent(new CustomEvent("listbox:select", {
    bubbles: true,
    detail: {
      value: event.currentTarget.value
    }
  }));
};
_onInputChanged = new WeakSet();
onInputChanged_fn = function(event) {
  this.setAttribute("aria-activedescendant", this.querySelector(`[role="option"][value="${CSS.escape(event.target.value)}"]`).id);
};
_onKeyDown = new WeakSet();
onKeyDown_fn = function(event) {
  if (event.key === "ArrowUp") {
    event.target.previousElementSibling?.focus();
    event.preventDefault();
  } else if (event.key === "ArrowDown") {
    event.target.nextElementSibling?.focus();
    event.preventDefault();
  }
};
if (!window.customElements.get("x-listbox")) {
  window.customElements.define("x-listbox", Listbox);
}

// dev/src/js/common/product/product-card.js
import { Delegate as Delegate4 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var ProductCard = class extends HTMLElement {
  #delegate = new Delegate4(this);
  constructor() {
    super();
    this.addEventListener("click", this.clickedProduct.bind(this));
    this.addEventListener("set:colors", this.setProductColors.bind(this));
  }
  connectedCallback() {
  }
  disconnectedCallback() {
    this.#delegate.off();
  }
  get category() {
    return this.getAttribute("title");
  }
  get type() {
    return this.getAttribute("type");
  }
  get isInCollection() {
    return this.getAttribute("main-collection");
  }
  get handle() {
    return this.getAttribute("data-handle");
  }
  clickedProduct(event) {
    if (this.isInCollection === "true") {
      sessionStorage.setItem("lastClickedProductCard", this.handle);
      const currentPage = this.getAttribute("data-current-page");
      const url = new URL(window.location.href);
      url.searchParams.set("page", currentPage);
      window.history.pushState({}, "", url);
    }
    const data = {
      id: this.getAttribute("data-id"),
      data: JSON.parse(this.getAttribute("data-json"))
    };
    document.documentElement.dispatchEvent(new CustomEvent("product:clicked", {
      bubbles: true,
      detail: {
        data,
        listInfos: {
          listId: this.closest("product-list").getAttribute("list-id"),
          listName: this.closest("product-list").getAttribute("list-name")
        }
      }
    }));
  }
  setProductColors(event) {
    this.querySelector(".color-list").innerHTML = event.detail.colorListHTML;
    this.selectCurrentProductColor();
  }
  selectCurrentProductColor() {
    if (this.querySelectorAll(".color-swatch").length > 0) {
      Array.from(this.querySelectorAll(".color-swatch")).forEach((item) => {
        if (item.getAttribute("data-handle") === this.getAttribute("data-handle")) {
          if (item.querySelector(".color-swatch-border")) {
            item.querySelector(".color-swatch-border").style.display = "block";
          }
        }
      });
    }
  }
};
var _delegate3, _wishlistRemoveButton, _wishlistLid, _fetchWishlistLid, fetchWishlistLid_fn, _removeFromWishlist, removeFromWishlist_fn, _removeProductFromDOM, removeProductFromDOM_fn;
var ProductCardLight = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _fetchWishlistLid);
    __privateAdd(this, _removeFromWishlist);
    __privateAdd(this, _removeProductFromDOM);
    __privateAdd(this, _delegate3, new Delegate4(this));
    __privateAdd(this, _wishlistRemoveButton, void 0);
    __privateAdd(this, _wishlistLid, null);
    this.addEventListener("click", this.clickedProduct.bind(this));
    __privateSet(this, _wishlistRemoveButton, this.querySelector(".product-card__wishlist-remove-button"));
    __privateGet(this, _wishlistRemoveButton)?.addEventListener("click", __privateMethod(this, _removeFromWishlist, removeFromWishlist_fn).bind(this));
    __privateMethod(this, _fetchWishlistLid, fetchWishlistLid_fn).call(this);
  }
  disconnectedCallback() {
    __privateGet(this, _delegate3).off();
  }
  clickedProduct(event) {
    const data = {
      id: this.getAttribute("data-id"),
      data: JSON.parse(this.getAttribute("data-json"))
    };
    document.documentElement.dispatchEvent(new CustomEvent("product:clicked", {
      bubbles: true,
      detail: {
        data,
        listInfos: {
          listId: this.closest("product-list").getAttribute("list-id"),
          listName: this.closest("product-list").getAttribute("list-name")
        }
      }
    }));
  }
};
_delegate3 = new WeakMap();
_wishlistRemoveButton = new WeakMap();
_wishlistLid = new WeakMap();
_fetchWishlistLid = new WeakSet();
fetchWishlistLid_fn = function() {
  if (window._swat && window._swat.wishlist) {
    const onSuccess = (data) => {
      const wishlist = data.data.find((list) => list.lty === "wl");
      if (wishlist) {
        __privateSet(this, _wishlistLid, wishlist.lid);
      } else {
        console.warn("No wishlist found for this user");
      }
    };
    const onError = (error) => {
    };
    window._swat.wishlist.fetchUserLists(onSuccess, onError);
  }
};
_removeFromWishlist = new WeakSet();
removeFromWishlist_fn = function() {
  if (!__privateGet(this, _wishlistLid)) {
    console.error("Wishlist lid not available");
    return;
  }
  let lid = __privateGet(this, _wishlistLid);
  let product = {
    epi: this.getAttribute("data-variant-id"),
    empi: this.getAttribute("data-id"),
    du: this.getAttribute("data-url")
  };
  let onSuccess = (deletedProduct) => {
    __privateMethod(this, _removeProductFromDOM, removeProductFromDOM_fn).call(this);
  };
  let onError = (error) => {
  };
  window._swat.deleteFromList(lid, product, onSuccess, onError);
};
_removeProductFromDOM = new WeakSet();
removeProductFromDOM_fn = function() {
  this.parentElement.removeChild(this);
  document.dispatchEvent(new CustomEvent("gtm:custom-event", {
    bubbles: true,
    detail: {
      event: "uaevent",
      action: "Produits supprim\xE9s",
      category: "Wishlist"
    }
  }));
};
if (!window.customElements.get("product-card")) {
  window.customElements.define("product-card", ProductCard);
}
if (!window.customElements.get("product-card-light")) {
  window.customElements.define("product-card-light", ProductCardLight);
}

// dev/src/js/common/product/product-bundle.js
var currencyFormat2 = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
var ProductBundle = class extends HTMLElement {
  constructor() {
    super();
    this.submitButton = this.querySelector('form#product-bundle-form-id button[type="submit"]');
    this.updateBundlePrice();
  }
  get productChildItems() {
    return this.querySelectorAll("product-bundle-child-item");
  }
  get discountPercent() {
    return this.getAttribute("discount");
  }
  get salePrice() {
    return this.querySelectorAll("sale-price:not(product-bundle-child-item-cross-sell sale-price)");
  }
  get compareAtPrice() {
    return this.querySelectorAll("compare-at-price:not(product-bundle-child-item-cross-sell compare-at-price)");
  }
  updateBundlePrice() {
    let newPrice = 0, disabledSubmit = false;
    Array.from(this.productChildItems).forEach((childItem) => {
      let currentChildItem = childItem.querySelector('[data-element="item-size-selector"]:not([hidden])');
      if (currentChildItem) {
        let currentQuantity = parseInt(currentChildItem.querySelector('[name="_productQuantity"]')?.value);
        newPrice += parseInt(currentChildItem.querySelector('[name="_productPrice"]')?.value) * currentQuantity;
        if (currentChildItem.querySelector('[name="_productAvailability"]')?.value === "false") {
          disabledSubmit = true;
        }
      }
    });
    if (newPrice > 0) {
      if (this.discountPercent) {
        Array.from(this.salePrice).forEach((salePrice) => {
          salePrice.textContent = formatMoney(newPrice * (1 - this.discountPercent / 100), currencyFormat2);
        });
        Array.from(this.compareAtPrice).forEach((compareAtPrice) => {
          compareAtPrice.textContent = formatMoney(newPrice, currencyFormat2);
        });
      } else {
        Array.from(this.salePrice).forEach((salePrice) => {
          salePrice.textContent = formatMoney(newPrice, currencyFormat2);
        });
      }
    }
    if (disabledSubmit) {
      this.submitButton.setAttribute("disabled", "disabled");
      this.submitButton.classList.add("button--disabled");
    } else {
      this.submitButton.removeAttribute("disabled");
      this.submitButton.classList.remove("button--disabled");
    }
  }
};
var ProductBundleChildItem = class extends HTMLElement {
  constructor() {
    super();
    this.colorSwatches = this.querySelectorAll(".color-swatch");
    this.sizeElements = this.querySelectorAll('[data-element="item-size-selector"]');
    this.bindedSizeElements = this.querySelectorAll("[data-binded]");
    this.forms = this.querySelectorAll("form");
    this.addEventListeners();
  }
  addEventListeners() {
    Array.from(this.colorSwatches).forEach((swatch) => {
      swatch.addEventListener("click", (event) => {
        event?.preventDefault();
        this.onColorSelected(swatch);
      });
    });
    Array.from(this.forms).forEach((form) => {
      form.addEventListener("variant:change", (event) => {
        const variantId = event?.detail?.variant?.id;
        const index = event?.target?.dataset?.index;
        this.updateVariantId(variantId, index);
        this.updateVariantPrice(event?.target, event?.detail?.variant?.price);
        this.updateVariantAvailability(event?.target, event?.detail?.variant?.available);
        this.updateBackInStockInfo(event?.target, event?.detail?.variant);
        this.productBundle.updateBundlePrice();
      });
    });
    Array.from(this.bindedSizeElements).forEach((sizeElement) => {
      sizeElement.addEventListener("click", (event) => {
        let productBindedHandle = event?.currentTarget?.getAttribute("data-binded");
        let productBindedImage = event?.currentTarget?.getAttribute("data-image");
        this.updateSizeVariants(productBindedHandle);
        this.updateImage(productBindedImage, productBindedHandle);
      });
    });
  }
  get imageElement() {
    return this.querySelector("[data-item-image]");
  }
  get productBundle() {
    return this.closest("product-bundle");
  }
  get isCrossSellProduct() {
    return this.hasAttribute("cross-sell-item");
  }
  onColorSelected(element) {
    Array.from(this.colorSwatches).forEach((swatch) => {
      swatch.classList.remove("active");
    });
    if (element) {
      element?.classList.add("active");
      this.updateImage(element.dataset.productImage, element.dataset.productHandle);
      this.updateSizeVariants(element.dataset.productHandle);
      this.updateBundleIdAttribute(element.dataset.productId, element.dataset.productIndex);
      if (!this.isCrossSellProduct) {
        this.productBundle.updateBundlePrice();
      } else {
        this.updateCrossSellPrice();
      }
    }
  }
  updateSizeVariants(productHandle) {
    Array.from(this.sizeElements).forEach((size) => {
      size.setAttribute("hidden", "");
      if (size.dataset.productHandle === productHandle) {
        size.removeAttribute("hidden");
        const variantId = size.querySelector('[name="id"]').value;
        const index = size.querySelector("[data-index]")?.dataset?.index;
        if (!this.isCrossSellProduct) {
          this.updateVariantId(variantId, index);
        } else {
          this.updateCrossSellVariant(variantId);
        }
      }
    });
  }
  updateImage(imgSrc, handle) {
    if (imgSrc) {
      this.imageElement.setAttribute("src", imgSrc);
    }
    if (handle) {
      this.imageElement.closest("a").setAttribute("href", `${Shopify.routes.root}products/${handle}`);
    }
  }
  updateVariantId(variantId, index) {
    const mainForm = document.querySelector("#product-bundle-form-id");
    if (mainForm && index && variantId) {
      mainForm.querySelector(`[name="items[${index - 1}]id"]`).value = variantId;
    }
  }
  updateVariantPrice(form, price) {
    form.querySelector('[name="_productPrice"]').value = price;
  }
  updateVariantAvailability(form, available) {
    form.querySelector('[name="_productAvailability"]').value = available;
    if (!available) {
      form.querySelector('[data-element="back-in-stock-button"]')?.removeAttribute("hidden");
    } else {
      form.querySelector('[data-element="back-in-stock-button"]')?.setAttribute("hidden", "");
    }
  }
  updateBackInStockInfo(form, variant) {
    const backInStockVariantPrice = form.querySelector('[data-bis-modal="variant-price"]');
    const backInStockVariantTitle = form.querySelector('[data-bis-modal="variant-title"]');
    const backInStockVariantId = form.querySelector('[name="variant"]');
    if (backInStockVariantPrice) {
      backInStockVariantPrice.textContent = formatMoney(variant.price, currencyFormat2);
    }
    if (backInStockVariantTitle) {
      backInStockVariantTitle.textContent = variant.title.split("-")[0].trim();
    }
    if (backInStockVariantId) {
      backInStockVariantId.value = variant.id;
    }
  }
  updateBundleIdAttribute(productId, index) {
    let productIdInput = document.querySelector(`[name="_product_id_${index - 1}"]`);
    if (productIdInput)
      productIdInput.value = productId;
    let productIds = document.querySelectorAll("[name^='_product_id']");
    let newBundleId = 0;
    Array.from(productIds).forEach((productId2) => {
      newBundleId += parseInt(productId2.value);
    });
    let bundles = document.querySelectorAll("[name*='[_bundle_id]']");
    Array.from(bundles).forEach((bundle) => {
      bundle.value = bundle.value.split("|")[0] + "|" + newBundleId;
    });
  }
};
var ProductBundleChildItemCrossSell = class extends ProductBundleChildItem {
  constructor() {
    super();
    this.updateCrossSellPrice();
  }
  get mainForm() {
    return this.querySelector("#product-bundle-cross-sell-form-id");
  }
  get quantityInput() {
    return this.mainForm?.querySelector('[name="quantity"]');
  }
  get submitButton() {
    return this.querySelectorAll('[type="submit"]');
  }
  get salePrice() {
    return this.querySelectorAll("sale-price");
  }
  get compareAtPrice() {
    return this.querySelectorAll("compare-at-price");
  }
  get quantityButtons() {
    return this.querySelectorAll("quantity-selector button");
  }
  get productBundle() {
    return this.closest("product-bundle");
  }
  addEventListeners() {
    super.addEventListeners();
    Array.from(this.quantityButtons).forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.updateCrossSellPrice();
      });
    });
  }
  updateCrossSellVariant(variantId) {
    const mainForm = this.querySelector("#product-bundle-cross-sell-form-id");
    if (mainForm && variantId) {
      mainForm.querySelector(`[name="id"]`).value = variantId;
    }
  }
  updateCrossSellPrice() {
    let newPrice = 0, disabledSubmit = false;
    let currentChildItem = this.querySelector('[data-element="item-size-selector"]:not([hidden])');
    if (currentChildItem) {
      this.quantityInput.value = currentChildItem.querySelector('input[name="quantity"]')?.value;
      newPrice += parseInt(currentChildItem.querySelector('[name="_productPrice"]')?.value) * parseInt(this.quantityInput.value);
      if (currentChildItem.querySelector('[name="_productAvailability"]')?.value === "false") {
        disabledSubmit = true;
      }
    }
    if (newPrice > 0) {
      Array.from(this.salePrice).forEach((item) => {
        item.textContent = formatMoney(newPrice, currencyFormat2);
      });
    }
    if (disabledSubmit) {
      Array.from(this.submitButton).forEach((button) => {
        button.setAttribute("disabled", "disabled");
      });
    } else {
      Array.from(this.submitButton).forEach((button) => {
        button.removeAttribute("disabled");
      });
    }
  }
};
if (!window.customElements.get("product-bundle")) {
  window.customElements.define("product-bundle", ProductBundle);
}
if (!window.customElements.get("product-bundle-child-item")) {
  window.customElements.define("product-bundle-child-item", ProductBundleChildItem);
}
if (!window.customElements.get("product-bundle-child-item-cross-sell")) {
  window.customElements.define("product-bundle-child-item-cross-sell", ProductBundleChildItemCrossSell);
}

// dev/src/js/common/product/product-card-binded-sizes-form.js
var currencyFormat3 = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
var ProductCardBindedSizesForm = class extends HTMLElement {
  #quantitySelector;
  #selectOptions;
  #quantityWrapper;
  #hasMainProductBinding;
  #productCardBindedForm;
  #priceInButton;
  constructor() {
    super();
    this.#hasMainProductBinding = this.getAttribute("form");
    if (!!this.#hasMainProductBinding) {
      this.mainProductMasterSelector = document.forms[this.getAttribute("form")];
      this.mainProductMasterSelector?.addEventListener("quantity:change", this._onMainProductQuantityChanged.bind(this));
      this.mainProductMasterSelector?.addEventListener("variant:change", this._onMainProductVariantChanged.bind(this));
    }
    this.#productCardBindedForm = this.querySelector("form");
    this.#productCardBindedForm?.addEventListener("quantity:change", this._onProductCardBindedQuantityChanged.bind(this));
    this.#productCardBindedForm?.addEventListener("variant:change", this._onProductCardBindedVariantChanged.bind(this));
    this.#quantityWrapper = this.querySelector("quantity-selector");
    this.#quantitySelector = this.querySelector('[name="quantity"]');
    this.#selectOptions = this.querySelectorAll('[name="option1"]');
    this.#priceInButton = this.querySelector('[type="submit"] [price]');
  }
  _onMainProductQuantityChanged(event) {
    if (this.#quantitySelector) {
      this.#quantitySelector.value = event.detail.quantity;
      let disabledButton = this.#quantitySelector.closest("quantity-selector")?.querySelector("[decrease]");
      if (disabledButton) {
        disabledButton.disabled = parseInt(this.#quantitySelector.value) === 1;
      }
      this.#productCardBindedForm.dispatchEvent(new CustomEvent("quantity:change", {
        bubbles: true,
        detail: {
          quantity: event.detail.quantity,
          changeBinded: true
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("compose:changed", { bubbles: true }));
    }
    if (this.#priceInButton) {
      let totalPrice = parseInt(this.#priceInButton.getAttribute("price")) * event.detail.quantity;
      this.#priceInButton.innerHTML = formatMoney(totalPrice, currencyFormat3);
    }
  }
  _onMainProductVariantChanged(event) {
    let selectedValue = event.detail.variant.title?.split("-")[1].trim();
    if (this.#selectOptions.length > 0) {
      Array.from(this.#selectOptions).forEach((option) => {
        let optionValue = option.value.split("-")[1].trim();
        if (optionValue === selectedValue) {
          option.nextElementSibling.click();
        }
      });
    }
  }
  _onProductCardBindedVariantChanged(event) {
    const selectedAdviceMessage = event.detail.crossSellAdvice;
    if (selectedAdviceMessage) {
      const adviceMessage = document.querySelectorAll(".cross-sell__rod-ring-advice");
      adviceMessage.forEach((message) => {
        message.innerHTML = selectedAdviceMessage;
      });
    }
    this.classList.toggle("form-unavailable", !event.detail.variant.available);
  }
  _onProductCardBindedQuantityChanged(event) {
    if (this.#priceInButton) {
      let totalPrice = parseInt(this.#priceInButton.getAttribute("price")) * event.detail.quantity;
      this.#priceInButton.innerHTML = formatMoney(totalPrice, currencyFormat3);
    }
  }
};
if (!window.customElements.get("product-card-binded-sizes-form")) {
  window.customElements.define("product-card-binded-sizes-form", ProductCardBindedSizesForm);
}

// dev/src/js/common/product/product-form.js
var _onSubmit, onSubmit_fn;
var ProductForm = class extends HTMLFormElement {
  constructor() {
    super();
    __privateAdd(this, _onSubmit);
    if (window.themeVariables.settings.cartType !== "page" && window.themeVariables.settings.pageType !== "cart") {
      this.addEventListener("submit", __privateMethod(this, _onSubmit, onSubmit_fn));
    }
  }
  connectedCallback() {
    if (typeof this.id.value !== "undefined") {
      this.id.disabled = false;
    }
  }
};
_onSubmit = new WeakSet();
onSubmit_fn = async function(event) {
  event.preventDefault();
  if (!this.checkValidity()) {
    this.reportValidity();
    return;
  }
  const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
  submitButtons.forEach((submitButton) => {
    submitButton.setAttribute("disabled", "disabled");
    submitButton.setAttribute("aria-busy", "true");
    submitButton.classList.add("button--loading");
  });
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
  const formData = new FormData(this);
  formData.set("sections", sectionsToBundle.join(","));
  if (typeof this.id.value !== "undefined") {
    formData.set("sections_url", `${Shopify.routes.root}variants/${this.id.value}`);
  }
  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    body: formData,
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  });
  submitButtons.forEach((submitButton) => {
    submitButton.removeAttribute("disabled");
    submitButton.removeAttribute("aria-busy");
    submitButton.classList.remove("button--loading");
  });
  const responseJson = await response.json();
  if (response.ok) {
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent["sections"] = responseJson["sections"];
    if (cartContent.items.some((item) => item.properties && item.properties.hasOwnProperty("_bundle_id"))) {
      const bundleTokens = await (await fetch(`${Shopify.routes.root}cart?view=bundle`)).json();
      await cartTokens(bundleTokens);
    }
    this.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: {
        items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
        cart: cartContent,
        quantity: parseInt(formData.get("quantity")),
        showAlert: this.getAttribute("alert"),
        additionalInfos: JSON.parse(this.getAttribute("data-json")) || null,
        isInWishlist: !!document.querySelector("[data-wishlist-add][hidden]")
      }
    }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        cart: cartContent,
        openDrawer: this.getAttribute("drawer")
      }
    }));
  } else {
    this.dispatchEvent(new CustomEvent("cart:error", {
      bubbles: true,
      detail: {
        error: responseJson["description"]
      }
    }));
    const bannerElement = document.querySelector(".product-error-message .alert");
    if (bannerElement) {
      bannerElement.removeAttribute("hidden");
      bannerElement.style.opacity = 1;
      bannerElement.style.visibility = "visible";
      setTimeout(() => {
        bannerElement.style.opacity = 0;
        bannerElement.style.visibility = "hidden";
      }, 2500);
    }
  }
};
if (!window.customElements.get("product-form")) {
  window.customElements.define("product-form", ProductForm, { extends: "form" });
}

// dev/src/js/common/product/product-form-listeners.js
import { animate as animate8, timeline as timeline5 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var currencyFormat4 = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
var _onVariantChangedListener3, _onCartErrorListener, _onProductAddedListener, _animationProgress, _onVariantChanged, onVariantChanged_fn, _onCartError, onCartError_fn, _onCartSuccess, onCartSuccess_fn;
var BuyButtons = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged);
    __privateAdd(this, _onCartError);
    __privateAdd(this, _onCartSuccess);
    __privateAdd(this, _onVariantChangedListener3, __privateMethod(this, _onVariantChanged, onVariantChanged_fn).bind(this));
    __privateAdd(this, _onCartErrorListener, __privateMethod(this, _onCartError, onCartError_fn).bind(this));
    __privateAdd(this, _onProductAddedListener, __privateMethod(this, _onCartSuccess, onCartSuccess_fn).bind(this));
    __privateAdd(this, _animationProgress, void 0);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:add", __privateGet(this, _onProductAddedListener));
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener3));
    document.forms[this.getAttribute("form")]?.addEventListener("cart:error", __privateGet(this, _onCartErrorListener));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:add", __privateGet(this, _onProductAddedListener));
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener3));
    document.forms[this.getAttribute("form")]?.removeEventListener("cart:error", __privateGet(this, _onCartErrorListener));
  }
  get target() {
    return this.hasAttribute("data-target") ? this.getAttribute("data-target") : ".shopify-section";
  }
};
_onVariantChangedListener3 = new WeakMap();
_onCartErrorListener = new WeakMap();
_onProductAddedListener = new WeakMap();
_animationProgress = new WeakMap();
_onVariantChanged = new WeakSet();
onVariantChanged_fn = function(event) {
  const addToCartButton = this.querySelector('button[type="submit"]'), unavailableButton = this.querySelector("button[disabled]"), paymentButton = this.querySelector(".shopify-payment-button");
  addToCartButton.hidden = !event.detail.variant || !event.detail.variant["available"];
  unavailableButton.hidden = !event.detail.variant || event.detail.variant["available"];
  this.setAttribute("variant-title", event.detail.label);
};
_onCartError = new WeakSet();
onCartError_fn = function(event) {
  let errorMessage = window.themeVariables.strings.cartErrorMessage;
  const bannerElement = document.createRange().createContextualFragment(`
    <div class="product-error-message quick-buy-error-message">
      <div class="alert alert--error error h-stack-grid align-center gap-3" data-type="error" style="opacity: 1; visibility: visible;">
        <svg aria-hidden="true" fill="none" focusable="false" width="20" class="icon icon-close-error" viewBox="0 0 20 24">
          <rect width="20" height="20" y="1" fill="#CF2338" rx="10"></rect>
          <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m7.429 8.429 5.142 5.142M12.571 8.429 7.43 13.57"></path>
        </svg>
        <p class="text-s" data-content="">${errorMessage}</p>
      </div>
    </div>
    `).firstElementChild;
  this.prepend(bannerElement);
  setTimeout(() => {
    bannerElement.remove();
  }, 2500);
};
_onCartSuccess = new WeakSet();
onCartSuccess_fn = function(event) {
  if (event.detail.showAlert === "true") {
    let bannerElement = document.createRange().createContextualFragment(`
      <div class="alert alert--success alert--auto-closing shadow-s v-stack gap-0.5" role="alert">
         <span class="alert__progress-bar"></span>
         <span class="alert__close-button">${window.themeVariables.strings.closeIcon}</span>
         <span class="success smallcaps-s demibold">${window.themeVariables.strings.addedToCartLabel}</span>
         <span class="alert__product-title text-xs medium">${event.detail.quantity} x ${event.detail.items[0].title?.split("-")[0].trim()}</span>
         <p class="alert__product-info grey text-xs h-stack gap-2">
          <span>${this.getAttribute("variant-title") ? this.getAttribute("variant-title") : event.detail.items[0].variant_title?.split("-")[0].trim()}</span>
          <span>\u2022</span>
          <span>${event.detail.quantity} x ${formatMoney(event.detail.items[0].price, currencyFormat4)}</span>
        </p>
      </div>
    `).firstElementChild;
    if (!this.closest(this.target).querySelector(".alert--success")) {
      this.closest(this.target)?.prepend(bannerElement);
      __privateSet(this, _animationProgress, timeline5([
        [this.closest(this.target).querySelector(".alert--success"), { translateY: ["-150%", "0%"] }, { duration: 0.5, easing: "ease" }],
        [this.closest(this.target).querySelector(".alert > .alert__progress-bar"), { width: ["0%", "100%"] }, { duration: 1, easing: "linear" }]
      ]));
      bannerElement.querySelector(".alert__close-button")?.addEventListener("click", (event2) => {
        bannerElement.remove();
        document.dispatchEvent(new CustomEvent("alert:closed"));
        __privateGet(this, _animationProgress).cancel();
      });
    } else {
      this.closest(this.target).querySelector(".alert").querySelector(".alert__product-title").innerHTML = event.detail.quantity + " x " + event.detail.items[0].title?.split("-")[0].trim();
      this.closest(this.target).querySelector(".alert").querySelector(".alert__product-info").innerHTML = `<span>${this.getAttribute("variant-title") ? this.getAttribute("variant-title") : event.detail.items[0].variant_title?.split("-")[0].trim()}</span>
            <span>\u2022</span>
            <span>${event.detail.quantity} x ${formatMoney(event.detail.items[0].price, currencyFormat4)}</span>`;
      __privateSet(this, _animationProgress, animate8(this.closest(this.target).querySelector(".alert > .alert__progress-bar"), { width: ["0%", "100%"] }, { duration: 1, easing: "linear" }));
    }
    __privateGet(this, _animationProgress).finished.then((event2) => {
      if (event2) {
        animate8(this.closest(this.target).querySelector(".alert--success"), { translateY: ["0%", "-150%"] }, {
          duration: 0.5,
          easing: "ease"
        }).finished.then(() => {
          event2[0].effect.target.closest(".alert")?.remove();
          document.dispatchEvent(new CustomEvent("alert:closed"));
        });
      }
    });
  }
};
if (!window.customElements.get("buy-buttons")) {
  window.customElements.define("buy-buttons", BuyButtons);
}
var _onVariantChangedListener4, _sizesAttribute, _classAttribute, _widths, widths_get, _onVariantChanged2, onVariantChanged_fn2;
var VariantMedia = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _widths);
    __privateAdd(this, _onVariantChanged2);
    __privateAdd(this, _onVariantChangedListener4, __privateMethod(this, _onVariantChanged2, onVariantChanged_fn2).bind(this));
    __privateAdd(this, _sizesAttribute, void 0);
    __privateAdd(this, _classAttribute, void 0);
  }
  connectedCallback() {
    __privateSet(this, _sizesAttribute, this.querySelector("img").sizes);
    __privateSet(this, _classAttribute, this.querySelector("img").className);
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener4));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener4));
  }
};
_onVariantChangedListener4 = new WeakMap();
_sizesAttribute = new WeakMap();
_classAttribute = new WeakMap();
_widths = new WeakSet();
widths_get = function() {
  return this.getAttribute("widths").split(",").map((width) => parseInt(width));
};
_onVariantChanged2 = new WeakSet();
onVariantChanged_fn2 = function(event) {
  if (!event.detail.variant || !event.detail.variant["featured_media"]) {
    return;
  }
  this.replaceChildren(createMediaImg(event.detail.variant["featured_media"], __privateGet(this, _widths, widths_get), { "class": __privateGet(this, _classAttribute), "sizes": __privateGet(this, _sizesAttribute) }));
};
if (!window.customElements.get("variant-media")) {
  window.customElements.define("variant-media", VariantMedia);
}
var _onVariantChangedListener5, _onVariantChanged3, onVariantChanged_fn3;
var PaymentTerms = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged3);
    __privateAdd(this, _onVariantChangedListener5, __privateMethod(this, _onVariantChanged3, onVariantChanged_fn3).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener5));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener5));
  }
};
_onVariantChangedListener5 = new WeakMap();
_onVariantChanged3 = new WeakSet();
onVariantChanged_fn3 = function(event) {
  if (event.detail.variant) {
    const element = this.querySelector('[name="id"]');
    element.value = event.detail.variant["id"];
    element.dispatchEvent(new Event("change", { bubbles: true }));
  }
};
if (!window.customElements.get("payment-terms")) {
  window.customElements.define("payment-terms", PaymentTerms);
}
var _onVariantChangedListener6, _onVariantChanged4, onVariantChanged_fn4;
var PickupAvailability = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged4);
    __privateAdd(this, _onVariantChangedListener6, __privateMethod(this, _onVariantChanged4, onVariantChanged_fn4).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener6));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener6));
  }
};
_onVariantChangedListener6 = new WeakMap();
_onVariantChanged4 = new WeakSet();
onVariantChanged_fn4 = async function(event) {
  if (!event.detail.variant) {
    this.innerHTML = "";
  } else {
    const element = document.createElement("div");
    element.innerHTML = await (await fetch(`${Shopify.routes.root}variants/${event.detail.variant["id"]}?section_id=pickup-availability`)).text();
    this.replaceChildren(...element.querySelector("pickup-availability").childNodes);
  }
};
if (!window.customElements.get("pickup-availability")) {
  window.customElements.define("pickup-availability", PickupAvailability);
}
var _onVariantChangedListener7, _onVariantChanged5, onVariantChanged_fn5;
var SalePrice = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged5);
    __privateAdd(this, _onVariantChangedListener7, __privateMethod(this, _onVariantChanged5, onVariantChanged_fn5).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener7));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener7));
  }
};
_onVariantChangedListener7 = new WeakMap();
_onVariantChanged5 = new WeakSet();
onVariantChanged_fn5 = function(event) {
  const variant = event.detail.variant;
  this.setAttribute("price", variant["price"]);
  this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["price"], currencyFormat4)));
  this.classList.toggle("text-on-sale", variant["compare_at_price"] > variant["price"]);
};
var _onVariantChangedListener8, _onVariantChanged6, onVariantChanged_fn6;
var CompareAtPrice = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged6);
    __privateAdd(this, _onVariantChangedListener8, __privateMethod(this, _onVariantChanged6, onVariantChanged_fn6).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener8));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener8));
  }
};
_onVariantChangedListener8 = new WeakMap();
_onVariantChanged6 = new WeakSet();
onVariantChanged_fn6 = function(event) {
  const variant = event.detail.variant;
  this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["compare_at_price"], currencyFormat4)));
  this.hidden = !(variant["compare_at_price"] > variant["price"]);
};
var _onVariantChangedListener9, _onVariantChanged7, onVariantChanged_fn7;
var UnitPrice = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged7);
    __privateAdd(this, _onVariantChangedListener9, __privateMethod(this, _onVariantChanged7, onVariantChanged_fn7).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener9));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener9));
  }
};
_onVariantChangedListener9 = new WeakMap();
_onVariantChanged7 = new WeakSet();
onVariantChanged_fn7 = function(event) {
  const variant = event.detail.variant;
  if (!variant["unit_price"]) {
    return this.hidden = true;
  }
  const referenceValue = variant["unit_price_measurement"]["reference_value"] !== 1 ? variant["unit_price_measurement"]["reference_value"] : "";
  const node = document.createRange().createContextualFragment(
    `${formatMoney(variant["unit_price"])}/${referenceValue}${variant["unit_price_measurement"]["reference_unit"]}`
  );
  this.lastChild.replaceWith(node);
  this.hidden = false;
};
var _onVariantChangedListener10, _onVariantChanged8, onVariantChanged_fn8;
var B2BSalePrice = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged8);
    __privateAdd(this, _onVariantChangedListener10, __privateMethod(this, _onVariantChanged8, onVariantChanged_fn8).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener10));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener10));
  }
  get discountMultiplier() {
    return parseFloat(this.getAttribute("discount-multiplier"));
  }
};
_onVariantChangedListener10 = new WeakMap();
_onVariantChanged8 = new WeakSet();
onVariantChanged_fn8 = function(event) {
  const variant = event.detail.variant;
  const includingTaxesPriceElem = this.querySelector("[including-taxes-price]");
  const excludingTaxesPriceElem = this.querySelector("[excluding-taxes-price]");
  const includingTaxesPrice = Math.round(variant.compare_at_price !== null ? variant.price : variant.price * this.discountMultiplier);
  const excludingTaxesPrice = Math.round(includingTaxesPrice / 1.2);
  this.setAttribute("price", includingTaxesPrice.toString());
  includingTaxesPriceElem.innerHTML = formatMoney(includingTaxesPrice, currencyFormat4);
  excludingTaxesPriceElem.innerHTML = formatMoney(excludingTaxesPrice, currencyFormat4);
};
if (!window.customElements.get("sale-price")) {
  window.customElements.define("sale-price", SalePrice);
}
if (!window.customElements.get("compare-at-price")) {
  window.customElements.define("compare-at-price", CompareAtPrice);
}
if (!window.customElements.get("unit-price")) {
  window.customElements.define("unit-price", UnitPrice);
}
if (!window.customElements.get("b2b-sale-price")) {
  window.customElements.define("b2b-sale-price", B2BSalePrice);
}
var _onVariantChangedListener11, _onVariantChanged9, onVariantChanged_fn9;
var SoldOutBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged9);
    __privateAdd(this, _onVariantChangedListener11, __privateMethod(this, _onVariantChanged9, onVariantChanged_fn9).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener11));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener11));
  }
};
_onVariantChangedListener11 = new WeakMap();
_onVariantChanged9 = new WeakSet();
onVariantChanged_fn9 = function(event) {
  this.hidden = event.detail.variant["available"];
};
var _onVariantChangedListener12, _onVariantChanged10, onVariantChanged_fn10;
var OnSaleBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged10);
    __privateAdd(this, _onVariantChangedListener12, __privateMethod(this, _onVariantChanged10, onVariantChanged_fn10).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener12));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener12));
  }
};
_onVariantChangedListener12 = new WeakMap();
_onVariantChanged10 = new WeakSet();
onVariantChanged_fn10 = function(event) {
  const variant = event.detail.variant;
  if (variant["compare_at_price"] > variant["price"]) {
    this.hidden = false;
    if (this.hasAttribute("discount-mode")) {
      const savings = this.getAttribute("discount-mode") === "percentage" ? `${Math.round((variant["compare_at_price"] - variant["price"]) * 100 / variant["compare_at_price"])}%` : formatMoney(variant["compare_at_price"] - variant["price"]);
      this.innerHTML = `${window.themeVariables.strings.discountBadge.replace("@@", savings)}`;
    }
  } else {
    this.hidden = true;
  }
};
var _onBadgeChange, onBadgeChange_fn;
var BadgeList = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onBadgeChange);
    const mutationObserver = new MutationObserver(__privateMethod(this, _onBadgeChange, onBadgeChange_fn).bind(this));
    Array.from(this.children).forEach((badge) => {
      mutationObserver.observe(badge, { attributes: true, attributeFilter: ["hidden"] });
    });
  }
};
_onBadgeChange = new WeakSet();
onBadgeChange_fn = function() {
  this.hidden = Array.from(this.children).every((badge) => badge.hasAttribute("hidden"));
};
if (!window.customElements.get("sold-out-badge")) {
  window.customElements.define("sold-out-badge", SoldOutBadge);
}
if (!window.customElements.get("on-sale-badge")) {
  window.customElements.define("on-sale-badge", OnSaleBadge);
}
if (!window.customElements.get("badge-list")) {
  window.customElements.define("badge-list", BadgeList);
}
var _onVariantChangedListener13, _inventoryElements, _progressBarElement, _onVariantChanged11, onVariantChanged_fn11;
var VariantInventory = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged11);
    __privateAdd(this, _onVariantChangedListener13, __privateMethod(this, _onVariantChanged11, onVariantChanged_fn11).bind(this));
    __privateAdd(this, _inventoryElements, void 0);
    __privateAdd(this, _progressBarElement, void 0);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener13));
    __privateSet(this, _inventoryElements, Array.from(this.querySelectorAll("[data-variant-id]")));
    __privateSet(this, _progressBarElement, this.querySelector("progress-bar"));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener13));
  }
};
_onVariantChangedListener13 = new WeakMap();
_inventoryElements = new WeakMap();
_progressBarElement = new WeakMap();
_onVariantChanged11 = new WeakSet();
onVariantChanged_fn11 = function(event) {
  this.hidden = !event.detail.variant;
  if (event.detail.variant) {
    __privateGet(this, _inventoryElements).forEach((item) => {
      const isItemHidden = item.toggleAttribute("hidden", event.detail.variant["id"] !== parseInt(item.getAttribute("data-variant-id")));
      if (!isItemHidden && __privateGet(this, _progressBarElement)) {
        __privateGet(this, _progressBarElement).valueNow = item.getAttribute("data-quantity");
        this.className = `inventory text-${item.getAttribute("data-status")}`;
      }
    });
  }
};
if (!window.customElements.get("variant-inventory")) {
  window.customElements.define("variant-inventory", VariantInventory);
}
var _onVariantChangedListener14, _onVariantChanged12, onVariantChanged_fn12;
var VariantSku = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged12);
    __privateAdd(this, _onVariantChangedListener14, __privateMethod(this, _onVariantChanged12, onVariantChanged_fn12).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener14));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener14));
  }
};
_onVariantChangedListener14 = new WeakMap();
_onVariantChanged12 = new WeakSet();
onVariantChanged_fn12 = function(event) {
  if (!event.detail.variant) {
    this.hidden = true;
  } else {
    this.innerText = `${window.themeVariables.strings.sku} ${event.detail.variant["sku"]}`;
    this.hidden = !event.detail.variant["sku"];
  }
};
if (!window.customElements.get("variant-sku")) {
  window.customElements.define("variant-sku", VariantSku);
}
var _onVariantChangedListener15, _onVariantChanged13, onVariantChanged_fn13;
var VariantAdvice = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged13);
    __privateAdd(this, _onVariantChangedListener15, __privateMethod(this, _onVariantChanged13, onVariantChanged_fn13).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener15));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener15));
  }
};
_onVariantChangedListener15 = new WeakMap();
_onVariantChanged13 = new WeakSet();
onVariantChanged_fn13 = function(event) {
  this.innerText = event.detail.advice ? event.detail.advice : "";
  this.hidden = event.detail.advice === void 0 || event.detail.advice === null || event.detail.advice === "";
};
if (!window.customElements.get("variant-advice")) {
  window.customElements.define("variant-advice", VariantAdvice);
}
var _onQuantityChangeListener, _onQuantityChange, onQuantityChange_fn;
var ProductRealQuantity = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onQuantityChange);
    __privateAdd(this, _onQuantityChangeListener, __privateMethod(this, _onQuantityChange, onQuantityChange_fn).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("quantity:change", __privateGet(this, _onQuantityChangeListener));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("quantity:change", __privateGet(this, _onQuantityChangeListener));
  }
};
_onQuantityChangeListener = new WeakMap();
_onQuantityChange = new WeakSet();
onQuantityChange_fn = function(event) {
  let quantity = parseInt(event.detail.quantity) * parseInt(this.getAttribute("sell-by"));
  let wording = quantity > 1 ? this.getAttribute("plural") : this.getAttribute("singular");
  this.innerHTML = " (" + quantity + " " + wording + ")";
};
if (!window.customElements.get("product-real-quantity")) {
  window.customElements.define("product-real-quantity", ProductRealQuantity);
}
var _onQuantityChangeListener2, _onVariantChangedListener16, _onVariantChange, onVariantChange_fn, _onQuantityChange2, onQuantityChange_fn2;
var QuantitySalePrice = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChange);
    __privateAdd(this, _onQuantityChange2);
    __privateAdd(this, _onQuantityChangeListener2, __privateMethod(this, _onQuantityChange2, onQuantityChange_fn2).bind(this));
    __privateAdd(this, _onVariantChangedListener16, __privateMethod(this, _onVariantChange, onVariantChange_fn).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener16));
    document.forms[this.getAttribute("form")]?.addEventListener("quantity:change", __privateGet(this, _onQuantityChangeListener2));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener16));
    document.forms[this.getAttribute("form")]?.removeEventListener("quantity:change", __privateGet(this, _onQuantityChangeListener2));
  }
};
_onQuantityChangeListener2 = new WeakMap();
_onVariantChangedListener16 = new WeakMap();
_onVariantChange = new WeakSet();
onVariantChange_fn = function(event) {
  const variant = event.detail.variant;
  this.setAttribute("price", variant["price"]);
  let quantity = new FormData(document.forms[this.getAttribute("form")])?.get("quantity");
  this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["price"] * parseInt(quantity), currencyFormat4)));
};
_onQuantityChange2 = new WeakSet();
onQuantityChange_fn2 = function(event) {
  const quantity = parseInt(event.detail.quantity) || 1;
  const variantPrice = parseInt(this.getAttribute("price"));
  this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variantPrice * quantity, currencyFormat4)));
};
if (!window.customElements.get("quantity-sale-price")) {
  window.customElements.define("quantity-sale-price", QuantitySalePrice);
}
var _onVariantChangedListener17, _onVariantChanged14, onVariantChanged_fn14;
var B2Btooltip = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged14);
    __privateAdd(this, _onVariantChangedListener17, __privateMethod(this, _onVariantChanged14, onVariantChanged_fn14).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener17));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener17));
  }
};
_onVariantChangedListener17 = new WeakMap();
_onVariantChanged14 = new WeakSet();
onVariantChanged_fn14 = function(event) {
  const variant = event.detail.variant;
  this.querySelectorAll(".product-info__b2b-content")[0].hidden = variant.compare_at_price !== null;
  this.querySelectorAll(".product-info__b2b-content")[1].hidden = variant.compare_at_price === null;
};
if (!window.customElements.get("b2b-tooltip")) {
  window.customElements.define("b2b-tooltip", B2Btooltip);
}

// dev/src/js/common/product/product-gallery.js
import { PhotoSwipeLightbox } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _abortController5, _photoSwipeInstance, _onGestureChangedListener, _settledMedia, _registerLightboxUi, registerLightboxUi_fn, _onVariantChange2, onVariantChange_fn2, _onMediaChange, onMediaChange_fn, _onMediaSettle, onMediaSettle_fn, _onCarouselClick, onCarouselClick_fn, _getFilteredMediaIndexes, getFilteredMediaIndexes_fn, _onGestureStart, onGestureStart_fn, _onGestureChanged, onGestureChanged_fn;
var ProductGallery = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _registerLightboxUi);
    __privateAdd(this, _onVariantChange2);
    __privateAdd(this, _onMediaChange);
    __privateAdd(this, _onMediaSettle);
    __privateAdd(this, _onCarouselClick);
    __privateAdd(this, _getFilteredMediaIndexes);
    __privateAdd(this, _onGestureStart);
    __privateAdd(this, _onGestureChanged);
    __privateAdd(this, _abortController5, void 0);
    __privateAdd(this, _photoSwipeInstance, void 0);
    __privateAdd(this, _onGestureChangedListener, __privateMethod(this, _onGestureChanged, onGestureChanged_fn).bind(this));
    __privateAdd(this, _settledMedia, void 0);
    this.addEventListener("lightbox:open", (event) => this.openLightBox(event?.detail?.index));
  }
  connectedCallback() {
    __privateSet(this, _abortController5, new AbortController());
    if (!this.carousel) {
      return;
    }
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateMethod(this, _onVariantChange2, onVariantChange_fn2).bind(this), { signal: __privateGet(this, _abortController5).signal });
    this.carousel.addEventListener("carousel:change", __privateMethod(this, _onMediaChange, onMediaChange_fn).bind(this), { signal: __privateGet(this, _abortController5).signal });
    this.carousel.addEventListener("carousel:settle", __privateMethod(this, _onMediaSettle, onMediaSettle_fn).bind(this), { signal: __privateGet(this, _abortController5).signal });
    this.carousel.addEventListener("click", __privateMethod(this, _onCarouselClick, onCarouselClick_fn).bind(this), { signal: __privateGet(this, _abortController5).signal });
    if (this.hasAttribute("allow-zoom")) {
      this.carousel.addEventListener("gesturestart", __privateMethod(this, _onGestureStart, onGestureStart_fn).bind(this), { capture: false, signal: __privateGet(this, _abortController5).signal });
    }
    __privateMethod(this, _onMediaChange, onMediaChange_fn).call(this);
  }
  disconnectedCallback() {
    __privateGet(this, _abortController5).abort();
  }
  get viewInSpaceButton() {
    return this.querySelector("[data-shopify-xr]");
  }
  get carousel() {
    return this.querySelector(".product-gallery__carousel");
  }
  get lightBox() {
    if (__privateGet(this, _photoSwipeInstance)) {
      return __privateGet(this, _photoSwipeInstance);
    }
    __privateSet(this, _photoSwipeInstance, new PhotoSwipeLightbox({
      pswpModule: () => Promise.resolve().then(() => (init_photoswipe_esm(), photoswipe_esm_exports)),
      bgOpacity: 1,
      maxZoomLevel: parseInt(this.getAttribute("allow-zoom")) || 3,
      closeTitle: window.themeVariables.strings.closeGallery,
      zoomTitle: window.themeVariables.strings.zoomGallery,
      errorMsg: window.themeVariables.strings.errorGallery,
      arrowPrev: false,
      arrowNext: false,
      counter: false,
      close: false,
      zoom: false
    }));
    __privateGet(this, _photoSwipeInstance).on("uiRegister", __privateMethod(this, _registerLightboxUi, registerLightboxUi_fn).bind(this));
    __privateGet(this, _photoSwipeInstance).addFilter("thumbEl", (thumbEl, data) => data.thumbnailElement);
    __privateGet(this, _photoSwipeInstance).init();
    return __privateGet(this, _photoSwipeInstance);
  }
  openLightBox(index) {
    const images = this.carousel.cells.flatMap((cell) => Array.from(cell.querySelectorAll(":scope > img")));
    const dataSource = images.map((image) => {
      return {
        thumbnailElement: image,
        src: image.src,
        srcset: image.srcset,
        msrc: image.currentSrc || image.src,
        width: parseInt(image.getAttribute("width")),
        height: parseInt(image.getAttribute("height")),
        alt: image.alt,
        thumbCropped: true
      };
    });
    this.lightBox.loadAndOpen(index ?? this.carousel.selectedIndex, dataSource);
  }
};
_abortController5 = new WeakMap();
_photoSwipeInstance = new WeakMap();
_onGestureChangedListener = new WeakMap();
_settledMedia = new WeakMap();
_registerLightboxUi = new WeakSet();
registerLightboxUi_fn = function() {
  __privateGet(this, _photoSwipeInstance).pswp.ui.registerElement({
    name: "close-button",
    className: "circle-button circle-button--close circle-button--xl hover:animate-icon-block",
    ariaLabel: window.themeVariables.strings.closeGallery,
    order: 2,
    isButton: true,
    html: `
        <svg aria-hidden="true" focusable="false" width="12" fill="none" class="icon" viewBox="0 0 12 12">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m1.09 1.09 9.819 9.82M10.909 1.09 1.09 10.91"/>
        </svg>
      `,
    onClick: () => {
      __privateGet(this, _photoSwipeInstance).pswp.close();
    }
  });
  if (__privateGet(this, _photoSwipeInstance).pswp.options.dataSource.length > 1) {
    __privateGet(this, _photoSwipeInstance).pswp.ui.registerElement({
      name: "previous-button",
      className: "circle-button circle-button--arrow previous hover:animate-icon-inline",
      ariaLabel: window.themeVariables.strings.previous,
      order: 1,
      isButton: true,
      html: `
          <svg aria-hidden="true" focusable="false" fill="none" width="8" class="icon" viewBox="0 0 8 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.849 13.06S4.424 8.485 2 6.969C4.424 5.815 6.85.94 6.85.94"/>
          </svg>
      `,
      onClick: () => {
        __privateGet(this, _photoSwipeInstance).pswp.prev();
      }
    });
    __privateGet(this, _photoSwipeInstance).pswp.ui.registerElement({
      name: "next-button",
      className: "circle-button circle-button--arrow next hover:animate-icon-inline",
      ariaLabel: window.themeVariables.strings.next,
      order: 3,
      isButton: true,
      html: `
          <svg aria-hidden="true" focusable="false" fill="none" width="8" class="icon" viewBox="0 0 8 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1.151 13.06S3.576 8.485 6 6.969C3.576 5.815 1.15.94 1.15.94"/>
          </svg>
      `,
      onClick: () => {
        __privateGet(this, _photoSwipeInstance).pswp.next();
      }
    });
  }
};
_onVariantChange2 = new WeakSet();
onVariantChange_fn2 = function(event) {
  if (event.detail.variantImage) {
    let filteredMedia = event.detail.product["media"].filter((media) => !(media.alt.indexOf("listing") > -1 || media.alt.indexOf("mkp") > -1));
    const selectedMedia = filteredMedia.find((media) => media["src"].indexOf(event.detail.variantImage) > -1);
    if (selectedMedia) {
      this.carousel.select(filteredMedia.indexOf(selectedMedia), { instant: true });
    }
  }
};
_onMediaChange = new WeakSet();
onMediaChange_fn = function() {
  if (!__privateGet(this, _settledMedia)) {
    return;
  }
  switch (__privateGet(this, _settledMedia).getAttribute("data-media-type")) {
    case "external_video":
    case "video":
    case "model":
      __privateGet(this, _settledMedia).firstElementChild.pause();
  }
};
_onMediaSettle = new WeakSet();
onMediaSettle_fn = function(event) {
  const media = event ? event.detail.cell : this.carousel.selectedCell, zoomButton2 = this.querySelector(".product-gallery__zoom-button");
  switch (media.getAttribute("data-media-type")) {
    case "image":
      this.viewInSpaceButton?.setAttribute("data-shopify-model3d-id", this.viewInSpaceButton?.getAttribute("data-shopify-model3d-default-id"));
      zoomButton2?.classList.remove("product-gallery__zoom-button--hidden");
      break;
    case "external_video":
    case "video":
      this.viewInSpaceButton?.setAttribute("data-shopify-model3d-id", this.viewInSpaceButton?.getAttribute("data-shopify-model3d-default-id"));
      zoomButton2?.classList.add("product-gallery__zoom-button--hidden");
      if (this.hasAttribute("autoplay-media")) {
        media.firstElementChild.play();
      }
      break;
    case "model":
      if (matchesMediaQuery("md")) {
        media.firstElementChild.play();
      }
      this.viewInSpaceButton?.setAttribute("data-shopify-model3d-id", event.detail.cell.getAttribute("data-media-id"));
      zoomButton2?.classList.add("product-gallery__zoom-button--hidden");
      break;
  }
  __privateSet(this, _settledMedia, media);
};
_onCarouselClick = new WeakSet();
onCarouselClick_fn = function(event) {
  if (!this.hasAttribute("allow-zoom") || event.target.tagName !== "IMG") {
    return;
  }
  const media = event.target.closest(".product-gallery__media");
  if (media.getAttribute("data-media-type") === "video") {
    return;
  }
  const openIndex = this.carousel.cells.filter((cell) => cell.getAttribute("data-media-type") === "image").indexOf(media);
  this.dispatchEvent(new CustomEvent("lightbox:open", { bubbles: true, detail: { index: openIndex } }));
};
_getFilteredMediaIndexes = new WeakSet();
getFilteredMediaIndexes_fn = function(product, variant) {
  const filteredMediaIds = [];
  product["media"].forEach((media) => {
    let matchMedia2 = variant["featured_media"] && media["position"] === variant["featured_media"]["position"];
    if (media["alt"]?.includes("#") && media["alt"] !== product["title"]) {
      if (!matchMedia2) {
        const altParts = media["alt"].split("#"), mediaGroupParts = altParts.pop().split("_");
        product["options"].forEach((option) => {
          if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
            if (variant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
              filteredMediaIds.push(media["position"] - 1);
            }
          }
        });
      }
    }
  });
  return filteredMediaIds;
};
_onGestureStart = new WeakSet();
onGestureStart_fn = function(event) {
  event.preventDefault();
  this.carousel.addEventListener("gesturechange", __privateGet(this, _onGestureChangedListener), { capture: false, signal: __privateGet(this, _abortController5).signal });
};
_onGestureChanged = new WeakSet();
onGestureChanged_fn = function(event) {
  event.preventDefault();
  if (event.scale > 1.5) {
    this.dispatchEvent(new CustomEvent("lightbox:open", { bubbles: true, detail: { index: this.carousel.selectedIndex } }));
    this.removeEventListener("gesturechange", __privateGet(this, _onGestureChangedListener));
  }
};
var _intersectionObserver, _hasProgrammaticScroll, _scrollDirection, _lastScrollPosition, _onMediaObserve, onMediaObserve_fn;
var ProductGalleryNavigation = class extends CarouselNavigation {
  constructor() {
    super();
    __privateAdd(this, _onMediaObserve);
    __privateAdd(this, _intersectionObserver, new IntersectionObserver(__privateMethod(this, _onMediaObserve, onMediaObserve_fn).bind(this), { threshold: [0, 0.5, 1] }));
    __privateAdd(this, _hasProgrammaticScroll, false);
    __privateAdd(this, _scrollDirection, "bottom");
    __privateAdd(this, _lastScrollPosition, void 0);
    window.addEventListener("scroll", () => {
      if (window.scrollY > __privateGet(this, _lastScrollPosition)) {
        __privateSet(this, _scrollDirection, "bottom");
      } else {
        __privateSet(this, _scrollDirection, "top");
      }
      __privateSet(this, _lastScrollPosition, window.scrollY);
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.carousel.allCells.forEach((cell) => __privateGet(this, _intersectionObserver).observe(cell));
  }
  onButtonClicked(newIndex) {
    if (this.carousel.isScrollable) {
      super.onButtonClicked(newIndex);
    } else {
      this.carousel.cells[newIndex]?.scrollIntoView({ block: "start", behavior: "smooth" });
      this.onNavigationChange(newIndex);
      __privateSet(this, _hasProgrammaticScroll, true);
      if (!("onscrollend" in window)) {
        setTimeout(() => {
          __privateSet(this, _hasProgrammaticScroll, false);
        }, 1e3);
      } else {
        window.addEventListener("scrollend", () => {
          __privateSet(this, _hasProgrammaticScroll, false);
        }, { once: true });
      }
    }
  }
};
_intersectionObserver = new WeakMap();
_hasProgrammaticScroll = new WeakMap();
_scrollDirection = new WeakMap();
_lastScrollPosition = new WeakMap();
_onMediaObserve = new WeakSet();
onMediaObserve_fn = function(entries) {
  if (this.carousel.isScrollable) {
    return;
  }
  const firstEntry = entries.find((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5);
  if (!firstEntry || __privateGet(this, _hasProgrammaticScroll)) {
    return;
  }
  const selectedItem = this.items.find((item) => item.getAttribute("aria-current") === "true"), candidateItem = this.items.find((item) => item.getAttribute("data-media-id") === firstEntry.target.getAttribute("data-media-id"));
  if (__privateGet(this, _scrollDirection) === "bottom" && parseInt(candidateItem.getAttribute("data-media-position")) > parseInt(selectedItem.getAttribute("data-media-position"))) {
    selectedItem.setAttribute("aria-current", "false");
    candidateItem.setAttribute("aria-current", "true");
  } else if (__privateGet(this, _scrollDirection) === "top" && parseInt(candidateItem.getAttribute("data-media-position")) < parseInt(selectedItem.getAttribute("data-media-position"))) {
    selectedItem.setAttribute("aria-current", "false");
    candidateItem.setAttribute("aria-current", "true");
  }
};
var OpenLightBoxButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("lightbox:open", { bubbles: true })));
  }
};
if (!window.customElements.get("product-gallery")) {
  window.customElements.define("product-gallery", ProductGallery);
}
if (!window.customElements.get("product-gallery-navigation")) {
  window.customElements.define("product-gallery-navigation", ProductGalleryNavigation);
}
if (!window.customElements.get("open-lightbox-button")) {
  window.customElements.define("open-lightbox-button", OpenLightBoxButton, { extends: "button" });
}

// dev/src/js/common/product/product-list.js
import { inView as inView5, animate as animate9, stagger } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var ProductList = class extends HTMLElement {
  constructor() {
    super();
    this.productIds = [];
    this.productsArray = [];
  }
  connectedCallback() {
    if (matchesMediaQuery("motion-safe") && this.querySelectorAll('[reveal-on-scroll="true"]').length > 0) {
      inView5(this, this.reveal.bind(this));
    }
    if (this.hasAttribute("fetch-delayed")) {
      document.addEventListener("DOMContentLoaded", this.fetchProductColors.bind(this));
    } else {
      this.fetchProductColors();
    }
    const hasDataPage = this.getAttribute("data-page") && parseInt(this.getAttribute("data-page")) > 1;
    const hasListImpression = this.hasAttribute("list-impression");
    if (hasDataPage || hasListImpression) {
      Array.from(this.querySelectorAll("product-card")).forEach((item) => {
        this.productIds.push(item.getAttribute("data-id"));
        this.productsArray.push(JSON.parse(item.getAttribute("data-json")));
      });
      if (this.productsArray.length > 0) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                this.dispatchEvent(new CustomEvent("productList:impression", {
                  bubbles: true,
                  detail: {
                    data: this.productIds,
                    currentPage: this.getAttribute("data-page"),
                    jsonData: this.productsArray,
                    listInfos: {
                      listId: this.getAttribute("list-id"),
                      listName: this.getAttribute("list-name")
                    }
                  }
                }));
              }, 500);
              this.observer.unobserve(this);
            }
          });
        }, { threshold: 0.01 });
        this.observer.observe(this);
      }
    }
    if (this.getAttribute("scroll-to-last-product-card") === "true") {
      if (this.lastClickedProductCard) {
        document.body.style.overflow = "hidden";
        setTimeout(() => {
          this.scrollToLastClickedProduct();
        }, 300);
      }
    }
  }
  get productListItem() {
    return this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children;
  }
  get lastClickedProductCard() {
    return sessionStorage.getItem("lastClickedProductCard");
  }
  reveal({ event, noAnim } = {}) {
    let animationControls = animate9(this.querySelectorAll('[reveal-on-scroll="true"]:not([loaded="true"])'), {
      opacity: [0, 1],
      transform: ["translateY(20px)", "translateY(0)"]
    }, {
      duration: 0.2,
      easing: "ease-in",
      delay: stagger(0.025, { start: 0.2, easing: "ease-out" })
    });
    animationControls.finished.then((elem) => {
      if (elem) {
        Array.from(elem)?.forEach((el) => el?.effect?.target?.setAttribute("loaded", "true"));
      }
    });
    if (noAnim) {
      animationControls.finish();
    }
  }
  async fetchProductColors() {
    let productVendorList = [];
    let productCategoryList = [];
    Array.from(this.productListItem).forEach((product) => {
      let vendor = product.getAttribute("vendor") ? Shopify.handleize(product.getAttribute("vendor")) : null;
      let title = product.getAttribute("title") ? Shopify.handleize(product.getAttribute("title")) : null;
      let searchItem = `vendor:${vendor}`;
      if (vendor && productVendorList.indexOf(searchItem) < 0) {
        productVendorList.push(searchItem);
      }
      if (title && productCategoryList.indexOf(title) < 0) {
        productCategoryList.push(title);
      }
    });
    if (productVendorList.length === 0 && productCategoryList.length === 0)
      return;
    const response = await fetch(`${Shopify.routes.root}search?resources[type]=product&section_id=product-card-colors&q=${productVendorList.join(" OR ")} OR category:${productCategoryList.join("@")}`);
    const responseText = await response.text();
    if (response.ok) {
      let div = document.createElement("div");
      div.innerHTML = responseText;
      let object = JSON.parse(div.querySelector(".shopify-section").innerHTML);
      Array.from(this.productListItem).forEach((product) => {
        product.dispatchEvent(new CustomEvent("set:colors", {
          bubbles: true,
          detail: {
            colorListHTML: object.hasOwnProperty(product.category) ? object[product.category]["colors"] : null
          }
        }));
      });
    }
  }
  scrollToLastClickedProduct() {
    const productCard = this.querySelector(`[data-handle="${this.lastClickedProductCard}"]`);
    if (productCard) {
      productCard.scrollIntoView({ block: "center", behavior: "auto" });
    } else {
      const url = new URL(window.location.href);
      const currentPage = url.searchParams.get("page");
      const productCard2 = this.querySelector(`[current-page="${currentPage}"]`)?.closest(".product-card");
      if (productCard2) {
        productCard2.scrollIntoView({ block: "center", behavior: "auto" });
      }
    }
    document.body.style.overflow = "auto";
    sessionStorage.removeItem("lastClickedProductCard");
  }
};
if (!window.customElements.get("product-list")) {
  window.customElements.define("product-list", ProductList);
}

// dev/src/js/common/product/product-load-more.js
var _maxPageCount, _currentPage, _minPageCount, _onLoadMore, onLoadMore_fn, _onProductsLoaded, onProductsLoaded_fn;
var ProductLoadMore = class extends HTMLAnchorElement {
  constructor() {
    super();
    __privateAdd(this, _onLoadMore);
    __privateAdd(this, _onProductsLoaded);
    __privateAdd(this, _maxPageCount, void 0);
    __privateAdd(this, _currentPage, void 0);
    __privateAdd(this, _minPageCount, void 0);
    __privateSet(this, _maxPageCount, this.getAttribute("data-max"));
    __privateSet(this, _minPageCount, this.getAttribute("data-min"));
    this.addEventListener("click", __privateMethod(this, _onLoadMore, onLoadMore_fn).bind(this));
    document.documentElement.addEventListener("theme:loading:end", __privateMethod(this, _onProductsLoaded, onProductsLoaded_fn).bind(this));
  }
  set hrefPage(newUrl) {
    this.setAttribute("href", newUrl);
  }
};
_maxPageCount = new WeakMap();
_currentPage = new WeakMap();
_minPageCount = new WeakMap();
_onLoadMore = new WeakSet();
onLoadMore_fn = function(event) {
  event.preventDefault();
  const sectionId = extractSectionId(event.target), url = new URL(this.href);
  url.searchParams.delete("phcursor");
  url.searchParams.set("section_id", "collection-load-more-products");
  __privateSet(this, _currentPage, url.searchParams.get("page"));
  this.dispatchEvent(new CustomEvent("facet:update", {
    bubbles: true,
    detail: {
      url,
      loadMore: true,
      previousButton: !__privateGet(this, _maxPageCount)
    }
  }));
  let newUrl = new URL(this.href);
  newUrl.searchParams.set("page", (parseInt(url.searchParams.get("page")) + (__privateGet(this, _maxPageCount) ? 1 : -1)).toString());
  this.hrefPage = newUrl.pathname + newUrl.search;
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
};
_onProductsLoaded = new WeakSet();
onProductsLoaded_fn = function() {
  if (__privateGet(this, _currentPage) === __privateGet(this, _maxPageCount)) {
    this.remove();
  }
  if (__privateGet(this, _currentPage) === __privateGet(this, _minPageCount)) {
    this.remove();
  }
};
if (!window.customElements.get("product-load-more")) {
  window.customElements.define("product-load-more", ProductLoadMore, { extends: "a" });
}

// dev/src/js/common/product/product-loader.js
var loadedProducts = {};
var ProductLoader = class {
  static load(productHandle) {
    if (!productHandle) {
      return;
    }
    if (loadedProducts[productHandle]) {
      return loadedProducts[productHandle];
    }
    loadedProducts[productHandle] = new Promise(async (resolve) => {
      const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`);
      const responseAsJson = await response.json();
      resolve(responseAsJson);
    });
    return loadedProducts[productHandle];
  }
};

// dev/src/js/common/product/product-options-popover.js
var ProductOptionsPopover = class extends Popover {
  constructor() {
    super();
  }
};
if (!window.customElements.get("product-options-popover")) {
  window.customElements.define("product-options-popover", ProductOptionsPopover);
}

// dev/src/js/common/product/quick-buy-drawer.js
var QuickBuyDrawer = class extends Drawer {
  #isLoaded = false;
  async show() {
    if (!this.#isLoaded) {
      [this, ...this.controls].forEach((control) => control.setAttribute("aria-busy", "true"));
      const responseContent = await (await fetch(`${window.Shopify.routes.root}products/${this.getAttribute("handle")}`)).text();
      [this, ...this.controls].forEach((control) => control.setAttribute("aria-busy", "false"));
      const tempDoc = new DOMParser().parseFromString(responseContent, "text/html");
      const quickBuyContent = tempDoc.getElementById("quick-buy-content").content;
      Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
      this.replaceChildren(document.importNode(quickBuyContent, true));
      Shopify?.PaymentButton.init();
      this.#isLoaded = true;
    }
    super.show();
  }
};
if (!window.customElements.get("quick-buy-drawer")) {
  window.customElements.define("quick-buy-drawer", QuickBuyDrawer);
}

// dev/src/js/common/product/quick-buy-modal.js
var QuickBuyModal = class extends Modal {
  #isLoaded = false;
  constructor() {
    super();
    if (window.themeVariables.settings.cartType === "drawer") {
      document.addEventListener("variant:add", this.hide.bind(this));
    }
  }
  get dynamicTitle() {
    return this.hasAttribute("dynamic-title") ? this.getAttribute("dynamic-title") : "";
  }
  async show() {
    if (!this.#isLoaded) {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
      const responseContent = await (await fetch(`${window.Shopify.routes.root}products/${this.getAttribute("handle")}`)).text();
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      const tempDoc = new DOMParser().parseFromString(responseContent, "text/html");
      const quickBuyContent = tempDoc.getElementById("quick-buy-content").content;
      if (this.dynamicTitle !== "") {
        if (quickBuyContent.querySelector('[slot="header"]')) {
          quickBuyContent.querySelector('[slot="header"]').innerText = this.dynamicTitle;
        }
      }
      Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
      this.replaceChildren(document.importNode(quickBuyContent, true));
      Shopify?.PaymentButton?.init();
      this.#isLoaded = true;
    }
    super.show();
  }
};
if (!window.customElements.get("quick-buy-modal")) {
  window.customElements.define("quick-buy-modal", QuickBuyModal);
}

// dev/src/js/common/product/variant-picker.js
var _abortController6, _variantAdvice, _crossSellAdvice, _variantStock, _variantLabel, _variantDelivery, _variantInventoryQuantity, _onOptionChanged, onOptionChanged_fn, _onMasterSelectorChanged, onMasterSelectorChanged_fn, _getVariantById, getVariantById_fn, _getVariantFromOptions, getVariantFromOptions_fn, _isVariantSelectable, isVariantSelectable_fn, _getFirstMatchingAvailableOrSelectableVariant, getFirstMatchingAvailableOrSelectableVariant_fn, _getSelectedOptionValues, getSelectedOptionValues_fn, _updateDisableSelectors, updateDisableSelectors_fn;
var VariantPicker = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onOptionChanged);
    __privateAdd(this, _onMasterSelectorChanged);
    __privateAdd(this, _getVariantById);
    __privateAdd(this, _getVariantFromOptions);
    __privateAdd(this, _isVariantSelectable);
    __privateAdd(this, _getFirstMatchingAvailableOrSelectableVariant);
    __privateAdd(this, _getSelectedOptionValues);
    __privateAdd(this, _updateDisableSelectors);
    __privateAdd(this, _abortController6, void 0);
    __privateAdd(this, _variantAdvice, void 0);
    __privateAdd(this, _crossSellAdvice, void 0);
    __privateAdd(this, _variantStock, void 0);
    __privateAdd(this, _variantLabel, void 0);
    __privateAdd(this, _variantDelivery, void 0);
    __privateAdd(this, _variantInventoryQuantity, void 0);
  }
  async connectedCallback() {
    __privateSet(this, _abortController6, new AbortController());
    this.masterSelector = document.forms[this.getAttribute("form")].id;
    this.optionSelectors = Array.from(this.querySelectorAll("[data-option-selector]"));
    if (!this.masterSelector) {
      console.warn(`The variant selector for product with handle ${this.productHandle} is not linked to any product form.`);
      return;
    }
    this.product = await ProductLoader.load(this.productHandle);
    this.optionSelectors.forEach((optionSelector) => {
      optionSelector.addEventListener("change", __privateMethod(this, _onOptionChanged, onOptionChanged_fn).bind(this), { signal: __privateGet(this, _abortController6).signal });
    });
    this.masterSelector.addEventListener("change", __privateMethod(this, _onMasterSelectorChanged, onMasterSelectorChanged_fn).bind(this), { signal: __privateGet(this, _abortController6).signal });
    __privateMethod(this, _updateDisableSelectors, updateDisableSelectors_fn).call(this);
    if (this.selectedVariant)
      this.selectVariant(this.selectedVariant["id"]);
  }
  disconnectedCallback() {
    __privateGet(this, _abortController6).abort();
  }
  get selectedVariant() {
    return __privateMethod(this, _getVariantById, getVariantById_fn).call(this, parseInt(this.masterSelector.value));
  }
  get productHandle() {
    return this.getAttribute("handle");
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.hasAttribute("update-url");
  }
  selectVariant(id) {
    if (!__privateMethod(this, _isVariantSelectable, isVariantSelectable_fn).call(this, __privateMethod(this, _getVariantById, getVariantById_fn).call(this, id))) {
      id = __privateMethod(this, _getFirstMatchingAvailableOrSelectableVariant, getFirstMatchingAvailableOrSelectableVariant_fn).call(this)["id"];
    }
    const previousVariant = this.selectedVariant;
    if (previousVariant && previousVariant.id === id) {
      return;
    }
    this.masterSelector.value = id;
    this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
    if (this.updateUrl && history.replaceState) {
      const newUrl = new URL(window.location.href);
      if (id) {
        newUrl.searchParams.set("variant", id);
      } else {
        newUrl.searchParams.delete("variant");
      }
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
    }
    __privateMethod(this, _updateDisableSelectors, updateDisableSelectors_fn).call(this);
    this.masterSelector.form.dispatchEvent(new CustomEvent("variant:change", {
      bubbles: true,
      detail: {
        product: this.product,
        variant: this.selectedVariant,
        advice: __privateGet(this, _variantAdvice),
        crossSellAdvice: __privateGet(this, _crossSellAdvice),
        stock: __privateGet(this, _variantStock),
        label: __privateGet(this, _variantLabel),
        delivery: __privateGet(this, _variantDelivery),
        inventoryQuantity: __privateGet(this, _variantInventoryQuantity),
        previousVariant,
        variantImage: this.variantImage
      }
    }));
    __privateSet(this, _variantAdvice, "");
    __privateSet(this, _crossSellAdvice, "");
    __privateSet(this, _variantStock, "");
    __privateSet(this, _variantDelivery, "");
    __privateSet(this, _variantLabel, "");
    __privateSet(this, _variantInventoryQuantity, "");
    this.variantImage = "";
    if (this.hasAttribute("check-diameter")) {
      this.variantDiameter = this.selectedVariant.title.split(" - ").pop().split("L")[0];
      this.accordingDiameter = this.getAttribute("diameter");
      if (!this.accordingDiameter.includes(this.variantDiameter)) {
        this.querySelector(".product-card__size-warning")?.removeAttribute("hidden");
      } else {
        this.querySelector(".product-card__size-warning")?.setAttribute("hidden", "");
      }
    }
  }
};
_abortController6 = new WeakMap();
_variantAdvice = new WeakMap();
_crossSellAdvice = new WeakMap();
_variantStock = new WeakMap();
_variantLabel = new WeakMap();
_variantDelivery = new WeakMap();
_variantInventoryQuantity = new WeakMap();
_onOptionChanged = new WeakSet();
onOptionChanged_fn = function(event) {
  if (!event.target.name.startsWith("option")) {
    return;
  }
  this.selectVariant(__privateMethod(this, _getVariantFromOptions, getVariantFromOptions_fn).call(this)?.id);
};
_onMasterSelectorChanged = new WeakSet();
onMasterSelectorChanged_fn = function() {
  const options = this.selectedVariant?.options || [];
  options.forEach((value, index) => {
    let input = this.optionSelectors[index].querySelector(`input[type="radio"][name="option1"][value="${CSS.escape(value)}"], input[type="hidden"][name="option${index + 1}"], select[name="option${index + 1}"]`), triggerChangeEvent = false;
    if (input && input.hasAttribute("data-advice")) {
      __privateSet(this, _variantAdvice, input.getAttribute("data-advice"));
    }
    if (input && input.hasAttribute("data-cross-sell-advice")) {
      __privateSet(this, _crossSellAdvice, input.getAttribute("data-cross-sell-advice"));
    }
    if (input && input.hasAttribute("data-stock")) {
      __privateSet(this, _variantStock, input.getAttribute("data-stock"));
    }
    if (input && input.hasAttribute("data-delivery")) {
      __privateSet(this, _variantDelivery, input.getAttribute("data-delivery"));
    }
    if (input && input.hasAttribute("data-label")) {
      __privateSet(this, _variantLabel, input.getAttribute("data-label"));
    }
    if (input && input.hasAttribute("data-quantity")) {
      __privateSet(this, _variantInventoryQuantity, input.getAttribute("data-quantity"));
    }
    if (input && input.hasAttribute("data-image")) {
      this.variantImage = input.getAttribute("data-image");
    }
    if (input.tagName === "SELECT" || input.tagName === "INPUT" && input.type === "hidden") {
      triggerChangeEvent = input.value !== value;
      input.value = value;
    } else if (input.tagName === "INPUT" && input.type === "radio") {
      triggerChangeEvent = !input.checked && input.value === value;
      input.checked = input.value === value;
    }
    if (triggerChangeEvent) {
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
};
_getVariantById = new WeakSet();
getVariantById_fn = function(id) {
  return this.product["variants"].find((variant) => variant["id"] === id);
};
_getVariantFromOptions = new WeakSet();
getVariantFromOptions_fn = function() {
  const options = __privateMethod(this, _getSelectedOptionValues, getSelectedOptionValues_fn).call(this);
  return this.product["variants"].find((variant) => {
    return variant["options"].every((value, index) => value === options[index]);
  });
};
_isVariantSelectable = new WeakSet();
isVariantSelectable_fn = function(variant) {
  if (!variant) {
    return false;
  } else {
    return variant["available"] || !this.hideSoldOutVariants && !variant["available"];
  }
};
_getFirstMatchingAvailableOrSelectableVariant = new WeakSet();
getFirstMatchingAvailableOrSelectableVariant_fn = function() {
  let options = __privateMethod(this, _getSelectedOptionValues, getSelectedOptionValues_fn).call(this), matchedVariant = null, slicedCount = 0;
  do {
    options.pop();
    slicedCount += 1;
    matchedVariant = this.product["variants"].find((variant) => {
      if (this.hideSoldOutVariants) {
        return variant["available"] && variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
      } else {
        return variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
      }
    });
  } while (!matchedVariant && options.length > 0);
  return matchedVariant;
};
_getSelectedOptionValues = new WeakSet();
getSelectedOptionValues_fn = function() {
  return this.optionSelectors.map((optionSelector) => {
    return optionSelector.querySelector('input[name^="option"][type="hidden"], input[name^="option"]:checked, select[name^="option"]').value;
  });
};
_updateDisableSelectors = new WeakSet();
updateDisableSelectors_fn = function() {
  const selectedVariant = this.selectedVariant;
  if (!selectedVariant) {
    return;
  }
  const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
    const optionValue = Array.from(selector.querySelectorAll("[data-option-value]"))[valueIndex];
    if (optionValue) {
      optionValue.toggleAttribute("hidden", !hasAtLeastOneCombination);
      if (this.hideSoldOutVariants) {
        optionValue.toggleAttribute("hidden", !available);
      } else {
        optionValue.classList.toggle("is-disabled", !available);
      }
    }
  };
  if (this.optionSelectors && this.optionSelectors[0]) {
    this.product["options"][0]["values"].forEach((value, valueIndex) => {
      const hasAtLeastOneCombination = this.product["variants"].some((variant) => variant["option1"] === value && variant), hasAvailableVariant = this.product["variants"].some((variant) => variant["option1"] === value && variant["available"]);
      applyClassToSelector(this.optionSelectors[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
      if (this.optionSelectors[1]) {
        this.product["options"][1]["values"].forEach((value2, valueIndex2) => {
          const hasAtLeastOneCombination2 = this.product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant), hasAvailableVariant2 = this.product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
          applyClassToSelector(this.optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
          if (this.optionSelectors[2]) {
            this.product["options"][2]["values"].forEach((value3, valueIndex3) => {
              const hasAtLeastOneCombination3 = this.product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant), hasAvailableVariant3 = this.product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
              applyClassToSelector(this.optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
            });
          }
        });
      }
    });
  }
};
var _onVariantChangedListener18, _onVariantChanged15, onVariantChanged_fn15;
var VariantOptionValue = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onVariantChanged15);
    __privateAdd(this, _onVariantChangedListener18, __privateMethod(this, _onVariantChanged15, onVariantChanged_fn15).bind(this));
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener18));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener18));
  }
};
_onVariantChangedListener18 = new WeakMap();
_onVariantChanged15 = new WeakSet();
onVariantChanged_fn15 = function(event) {
  this.classList.toggle("unavailable-variant", !event.detail.variant.available);
  this.innerHTML = event.detail.label;
};
if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}
if (!window.customElements.get("variant-option-value")) {
  window.customElements.define("variant-option-value", VariantOptionValue);
}

// dev/src/js/common/product/product-reviews.js
var ProductReviews = class extends HTMLElement {
  #listenersAbortController;
  #allStars;
  connectedCallback() {
    this.#listenersAbortController = new AbortController();
    this.#allStars = Array.from(document.querySelectorAll("[reviews-stars]"));
    this.productId = window.themeVariables.product.id;
    this.avisVerifies = {
      baseURL: "https://cl.avis-verifies.com/fr/cache/d/3/7/d37a327e-150c-ae54-69e1-ac5c92cb0027/AWS",
      productReviewsURL: `/PRODUCT_API/REVIEWS/index_${this.productId}.json`
    };
    this._initReviewsRequest();
  }
  disconnectedCallback() {
    this.#listenersAbortController.abort();
  }
  _initReviewsRequest() {
    fetch(this.avisVerifies.baseURL + this.avisVerifies.productReviewsURL).then((response) => response.json()).then((data) => {
      let tempRange = 0;
      Array.from(data.rated, (el, index) => {
        tempRange += el * (index + 1);
      });
      this.productReviewsRange = tempRange / data.total_reviews;
      this.productReviewsCount = data.total_reviews;
    }).catch((error) => {
      console.log("Avis verifies error : " + error.message);
      this.remove();
    });
  }
  set productReviewsRange(count) {
    this.#allStars.forEach((el) => {
      Array.from(el.querySelectorAll("svg")).forEach((star, index) => {
        if (count >= index + 1 - 0.5) {
          star.style.opacity = 1;
        }
      });
    });
    document.querySelector("[reviews-note]").innerHTML = count.toFixed(1);
  }
  set productReviewsCount(count) {
    if (document.querySelectorAll("[reviews-count]").length > 0) {
      Array.from(document.querySelectorAll("[reviews-count]")).forEach((el) => {
        this.querySelector(".review-count").innerHTML = count;
      });
    }
  }
};
var ProductReviewsDrawer = class extends Drawer {
  constructor() {
    super();
    this.productId = window.themeVariables.product.id;
    this.avisVerifies = {
      baseURL: "https://cl.avis-verifies.com/fr/cache/d/3/7/d37a327e-150c-ae54-69e1-ac5c92cb0027/AWS",
      productReviewsURL: `/PRODUCT_API/REVIEWS/date_desc_${this.productId}.json`
    };
    this._initReviewsRequest();
  }
  _initReviewsRequest() {
    fetch(this.avisVerifies.baseURL + this.avisVerifies.productReviewsURL).then((response) => response.json()).then((data) => {
      this.productReviews = data;
    }).catch((error) => {
      console.log("Avis verifies error : " + error.message);
      this.remove();
    });
  }
  set productReviews(data) {
    let productReviews = "";
    for (let i = 0; i < data.length; i++) {
      let date = new Date(data[i].review_date);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = new Intl.DateTimeFormat(window.themeVariables.settings.currentDateFormat, options).format(date);
      productReviews += `
        <div class="v-stack gap-2.5 sm:gap-3 reviews-drawer__review">
          <div class="h-stack gap-1 terracotta">
            <svg aria-hidden="true" fill="none" focusable="false" width="8" class="icon icon-star-rating" data-index="1" viewBox="0 0 8 8" style="opacity: ${data[i].rate > 0 ? 1 : 0.3};">
              <path fill="currentColor" d="M3.723.18A.31.31 0 0 1 4 0c.118 0 .226.07.278.18l.996 2.115a.311.311 0 0 0 .233.177l2.228.34a.314.314 0 0 1 .25.22.335.335 0 0 1-.079.332L6.295 5.01a.334.334 0 0 0-.09.287l.381 2.324a.332.332 0 0 1-.123.317.3.3 0 0 1-.327.025L4.144 6.866a.297.297 0 0 0-.288 0L1.863 7.963a.299.299 0 0 1-.326-.025.332.332 0 0 1-.123-.317l.38-2.324a.334.334 0 0 0-.089-.287L.094 3.364a.335.335 0 0 1-.079-.332.314.314 0 0 1 .25-.22l2.228-.34a.311.311 0 0 0 .233-.177L3.723.18Z"></path>
            </svg>
            <svg aria-hidden="true" fill="none" focusable="false" width="8" class="icon icon-star-rating" data-index="1" viewBox="0 0 8 8" style="opacity: ${data[i].rate > 1 ? 1 : 0.3};">
              <path fill="currentColor" d="M3.723.18A.31.31 0 0 1 4 0c.118 0 .226.07.278.18l.996 2.115a.311.311 0 0 0 .233.177l2.228.34a.314.314 0 0 1 .25.22.335.335 0 0 1-.079.332L6.295 5.01a.334.334 0 0 0-.09.287l.381 2.324a.332.332 0 0 1-.123.317.3.3 0 0 1-.327.025L4.144 6.866a.297.297 0 0 0-.288 0L1.863 7.963a.299.299 0 0 1-.326-.025.332.332 0 0 1-.123-.317l.38-2.324a.334.334 0 0 0-.089-.287L.094 3.364a.335.335 0 0 1-.079-.332.314.314 0 0 1 .25-.22l2.228-.34a.311.311 0 0 0 .233-.177L3.723.18Z"></path>
            </svg>
            <svg aria-hidden="true" fill="none" focusable="false" width="8" class="icon icon-star-rating" data-index="1" viewBox="0 0 8 8" style="opacity: ${data[i].rate > 2 ? 1 : 0.3};">
              <path fill="currentColor" d="M3.723.18A.31.31 0 0 1 4 0c.118 0 .226.07.278.18l.996 2.115a.311.311 0 0 0 .233.177l2.228.34a.314.314 0 0 1 .25.22.335.335 0 0 1-.079.332L6.295 5.01a.334.334 0 0 0-.09.287l.381 2.324a.332.332 0 0 1-.123.317.3.3 0 0 1-.327.025L4.144 6.866a.297.297 0 0 0-.288 0L1.863 7.963a.299.299 0 0 1-.326-.025.332.332 0 0 1-.123-.317l.38-2.324a.334.334 0 0 0-.089-.287L.094 3.364a.335.335 0 0 1-.079-.332.314.314 0 0 1 .25-.22l2.228-.34a.311.311 0 0 0 .233-.177L3.723.18Z"></path>
            </svg>
            <svg aria-hidden="true" fill="none" focusable="false" width="8" class="icon icon-star-rating" data-index="1" viewBox="0 0 8 8" style="opacity: ${data[i].rate > 3 ? 1 : 0.3};">
              <path fill="currentColor" d="M3.723.18A.31.31 0 0 1 4 0c.118 0 .226.07.278.18l.996 2.115a.311.311 0 0 0 .233.177l2.228.34a.314.314 0 0 1 .25.22.335.335 0 0 1-.079.332L6.295 5.01a.334.334 0 0 0-.09.287l.381 2.324a.332.332 0 0 1-.123.317.3.3 0 0 1-.327.025L4.144 6.866a.297.297 0 0 0-.288 0L1.863 7.963a.299.299 0 0 1-.326-.025.332.332 0 0 1-.123-.317l.38-2.324a.334.334 0 0 0-.089-.287L.094 3.364a.335.335 0 0 1-.079-.332.314.314 0 0 1 .25-.22l2.228-.34a.311.311 0 0 0 .233-.177L3.723.18Z"></path>
            </svg>
            <svg aria-hidden="true" fill="none" focusable="false" width="8" class="icon icon-star-rating" data-index="1" viewBox="0 0 8 8" style="opacity: ${data[i].rate > 4 ? 1 : 0.3};">
              <path fill="currentColor" d="M3.723.18A.31.31 0 0 1 4 0c.118 0 .226.07.278.18l.996 2.115a.311.311 0 0 0 .233.177l2.228.34a.314.314 0 0 1 .25.22.335.335 0 0 1-.079.332L6.295 5.01a.334.334 0 0 0-.09.287l.381 2.324a.332.332 0 0 1-.123.317.3.3 0 0 1-.327.025L4.144 6.866a.297.297 0 0 0-.288 0L1.863 7.963a.299.299 0 0 1-.326-.025.332.332 0 0 1-.123-.317l.38-2.324a.334.334 0 0 0-.089-.287L.094 3.364a.335.335 0 0 1-.079-.332.314.314 0 0 1 .25-.22l2.228-.34a.311.311 0 0 0 .233-.177L3.723.18Z"></path>
            </svg>
          </div>
          <span>${data[i].review}</span>
          <div class="h-stack gap-2 text-xxs grey">
            <span class="medium">${data[i].firstname !== "anonymous" ? data[i].lastname.toUpperCase() + ". " + data[i].firstname : window.themeVariables.strings.anonymous}</span>
            <span>\u2022</span>
            <span>${window.themeVariables.strings.on_before_date} ${date}</span>
          </div>
        </div>
      `;
      if (data[i].moderation) {
        let answerDateString = data[i].moderation[0].comment_date;
        let answerDate = new Date(answerDateString.split("T")[0]);
        answerDate = new Intl.DateTimeFormat(window.themeVariables.settings.currentDateFormat, options).format(answerDate);
        productReviews += `
          <div class="h-stack gap-4 reviews-drawer__answer">
            <div class="review-answer__arrow-icon">
              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 0V6.75C1 7.85457 1.89543 8.75 3 8.75H11M11 8.75L7.875 5.625M11 8.75L7.875 11.875" stroke="#373632" stroke-opacity="0.7"/>
              </svg>
            </div>

            <div class="v-stack reviews-drawer__answer-wrapper">
              <p class="text-xs">${data[i].moderation[0].comment}</p>
              <div class="h-stack gap-2 text-xxs reviews-drawer__answer-author">
                <div class="reviews-drawer__answer-madura-logo">
                  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.41946 0.329399L8.39972 0.368318L8.38882 0.38194V0.38967L5.02013 6.86238L1.44202 0.329399H0.5V8.24635H0.878954V1.24255L4.70149 8.28878L4.74271 8.27727L8.38882 1.20806V8.24635H9.5V0.329399H8.41946Z" fill="#373632"/>
                  </svg>
                </div>              
                <span class="medium">L'\xE9quipe Madura</span>
                <span class="medium">\u2022</span>
                <span>${window.themeVariables.strings.on_before_date} ${answerDate}</span>
              </div>
            </div>
          </div>
        `;
      } else {
        productReviews += `
          <div class="reviews-drawer__review-separator"></div>
        `;
      }
    }
    this.querySelector("[reviews-content]").innerHTML = productReviews;
  }
};
if (!window.customElements.get("product-reviews")) {
  window.customElements.define("product-reviews", ProductReviews);
}
if (!window.customElements.get("reviews-drawer")) {
  window.customElements.define("reviews-drawer", ProductReviewsDrawer);
}

// dev/src/js/common/product/product-size-guide.js
var _tabButtons, _tabContent, _tabSelected, tabSelected_fn;
var SizeGuideDrawer = class extends Drawer {
  constructor() {
    super();
    __privateAdd(this, _tabSelected);
    __privateAdd(this, _tabButtons, void 0);
    __privateAdd(this, _tabContent, void 0);
    __privateSet(this, _tabButtons, this.querySelectorAll("[data-tab]"));
    __privateSet(this, _tabContent, this.querySelectorAll("[data-tab-content]"));
    Array.from(__privateGet(this, _tabButtons))?.forEach((button) => {
      button.addEventListener("click", __privateMethod(this, _tabSelected, tabSelected_fn).bind(this));
    });
  }
  get shouldAppendToBody() {
    return false;
  }
  displayTab(id) {
    Array.from(__privateGet(this, _tabButtons)).forEach((button) => {
      button.setAttribute("aria-selected", button.getAttribute("data-tab") === id);
      Array.from(button.querySelectorAll("svg")).forEach((el) => {
        if (el.hasAttribute("hidden")) {
          el.removeAttribute("hidden");
        } else {
          el.setAttribute("hidden", "");
        }
      });
    });
    Array.from(__privateGet(this, _tabContent)).forEach((tab) => {
      tab.hidden = tab.getAttribute("data-tab-content") !== id;
    });
  }
};
_tabButtons = new WeakMap();
_tabContent = new WeakMap();
_tabSelected = new WeakSet();
tabSelected_fn = function(event) {
  this.displayTab(event.target.getAttribute("data-tab"));
};
if (!window.customElements.get("size-guide-drawer")) {
  window.customElements.define("size-guide-drawer", SizeGuideDrawer);
}

// dev/src/js/common/product/product-back-in-stock.js
var ProductBackInStock = class extends HTMLElement {
  constructor() {
    super();
    this.listenersAbortController = new AbortController();
    this.form = this.querySelector("form");
    this.formId = this.querySelector('input[type="hidden"][name="_formId"]');
    this.emailInput = this.querySelector('[name="email"]');
    this.submitButton = this.querySelector('[type="submit"]');
    this.variantIdInput = this.querySelector('[name="variant"]');
    this.klaviyoAPIKey = this.querySelector('[name="a"]');
    this.infoStep = this.querySelector('[data-step="info"]');
    this.successStep = this.querySelector('[data-step="success"]');
    this.form.addEventListener("submit", this.onFormSubmitted.bind(this));
    this.masterSelector = document.forms[this.form.id];
    document.forms[this.formId.getAttribute("form")]?.addEventListener("variant:change", this.onVariantChangedListener.bind(this), { signal: this.listenersAbortController.signal });
  }
  connectedCallback() {
    this.emailInput.addEventListener("input", () => {
      if (this.emailInput.value.includes("@")) {
        this.submitButton.removeAttribute("disabled");
      } else {
        this.submitButton.setAttribute("disabled", "true");
      }
    });
  }
  async onFormSubmitted(event) {
    event.preventDefault();
    let that = this;
    let emailValue = this.emailInput.value;
    if (emailValue !== "") {
      this.submitButton.setAttribute("disabled", "disabled");
      this.submitButton.setAttribute("aria-busy", "true");
      this.submitButton.classList.add("button--loading");
      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": emailValue
                }
              }
            },
            "channels": ["EMAIL"]
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": `$shopify:::$default:::${this.variantIdInput.value}`
              }
            }
          }
        }
      };
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.klaviyoAPIKey.value}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-06-15"
        },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        that.form?.setAttribute("data-success", "true");
        that.successStep.hidden = false;
        that.infoStep.hidden = true;
      } else {
        this.submitButton.removeAttribute("disabled");
        this.submitButton.setAttribute("aria-busy", "false");
        this.submitButton.classList.remove("button--loading");
        console.log("There was an Error while subscribing the email for the alert.");
      }
    } else {
      this.emailInput.style = "--border-color:rgb(var(--color-error))";
    }
  }
  onVariantChangedListener(event) {
    this.form.hidden = event.detail.variant.available;
    this.variantIdInput.value = event.detail.variant.id;
    Array.from(document.querySelectorAll('[data-hide="back-in-stock"]'))?.forEach((item) => {
      item.hidden = !event.detail.variant.available;
    });
  }
  disconnectedCallback() {
    this.listenersAbortController.abort();
  }
};
var BackInStockModal = class extends Modal {
  constructor() {
    super();
  }
};
var WhatsAppStockAlert = class extends HTMLElement {
  constructor() {
    super();
    this.whatsAppButton = this.querySelector("button");
    this.phoneInput = this.querySelector("input");
    const parentElement = this.closest("product-back-in-stock");
    this.form = parentElement?.querySelector("form");
    this.infoStep = parentElement?.querySelector('[data-step="info"]');
    this.successStep = parentElement?.querySelector('[data-step="success"]');
    this.variantIdInput = parentElement?.querySelector('[name="variant"]');
  }
  connectedCallback() {
    this.whatsAppButton.addEventListener("click", this.onWhatsAppButtonClicked.bind(this));
    this.phoneInput.addEventListener("input", () => {
      if (this.phoneInput.value.trim().length > 8) {
        this.whatsAppButton.removeAttribute("disabled");
      } else {
        this.whatsAppButton.setAttribute("disabled", "true");
      }
    });
  }
  onWhatsAppButtonClicked(event) {
    event.preventDefault();
    let that = this;
    const phoneNumber = this.phoneInput.value.trim();
    const customerId = "1163";
    this.whatsAppButton.setAttribute("disabled", "disabled");
    this.whatsAppButton.setAttribute("aria-busy", "true");
    this.whatsAppButton.classList.add("button--loading");
    if (phoneNumber.length > 8 && this.variantIdInput.value) {
      fetch("https://app.getsimio.com/backinstock/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          phoneNumber,
          customerId,
          variantId: this.variantIdInput.value
        })
      }).then((response) => {
        if (response.ok) {
          that.form?.setAttribute("data-success", "true");
          that.successStep.hidden = false;
          that.infoStep.hidden = true;
          return response.text();
        }
        throw new Error("Erreur lors de la requ\xEAte.");
      }).catch((error) => {
        console.error(error);
        this.whatsAppButton.removeAttribute("disabled");
        this.whatsAppButton.setAttribute("aria-busy", "false");
        this.whatsAppButton.classList.remove("button--loading");
        console.log("There was an Error while subscribing the phone number for the alert.");
      });
    }
  }
};
if (!window.customElements.get("product-back-in-stock")) {
  window.customElements.define("product-back-in-stock", ProductBackInStock);
}
if (!window.customElements.get("back-in-stock-modal")) {
  window.customElements.define("back-in-stock-modal", BackInStockModal);
}
if (!window.customElements.get("whatsapp-stock-alert")) {
  window.customElements.define("whatsapp-stock-alert", WhatsAppStockAlert);
}

// dev/src/js/common/product/product-stock.js
var _formId, _stockValue, _onVariantChangedListener19, onVariantChangedListener_fn3;
var ProductStock = class extends HTMLFormElement {
  constructor() {
    super();
    __privateAdd(this, _onVariantChangedListener19);
    __privateAdd(this, _formId, void 0);
    __privateAdd(this, _stockValue, void 0);
    __privateSet(this, _formId, this.querySelector('input[type="hidden"]'));
    __privateSet(this, _stockValue, this.querySelector("[data-stock]"));
    document.forms[__privateGet(this, _formId).getAttribute("form")]?.addEventListener("variant:change", __privateMethod(this, _onVariantChangedListener19, onVariantChangedListener_fn3).bind(this));
  }
};
_formId = new WeakMap();
_stockValue = new WeakMap();
_onVariantChangedListener19 = new WeakSet();
onVariantChangedListener_fn3 = function(event) {
  __privateGet(this, _stockValue).setAttribute("data-stock", event.detail.stock);
  __privateGet(this, _stockValue).innerHTML = window.themeVariables.strings.productStock[event.detail.stock];
};
var _formId2, _deliveryValue, _onVariantChangedListener20, onVariantChangedListener_fn4;
var ProductDelivery = class extends HTMLFormElement {
  constructor() {
    super();
    __privateAdd(this, _onVariantChangedListener20);
    __privateAdd(this, _formId2, void 0);
    __privateAdd(this, _deliveryValue, void 0);
    __privateSet(this, _formId2, this.querySelector('input[type="hidden"]'));
    __privateSet(this, _deliveryValue, this.querySelector("[data-delivery]"));
    document.forms[__privateGet(this, _formId2).getAttribute("form")]?.addEventListener("variant:change", __privateMethod(this, _onVariantChangedListener20, onVariantChangedListener_fn4).bind(this));
  }
};
_formId2 = new WeakMap();
_deliveryValue = new WeakMap();
_onVariantChangedListener20 = new WeakSet();
onVariantChangedListener_fn4 = function(event) {
  __privateGet(this, _deliveryValue).innerHTML = event.detail.delivery;
};
if (!window.customElements.get("product-stock")) {
  window.customElements.define("product-stock", ProductStock, { extends: "form" });
}
if (!window.customElements.get("product-delivery")) {
  window.customElements.define("product-delivery", ProductDelivery, { extends: "form" });
}

// dev/src/js/common/product/product-tabs.js
var _detailsSize, _formId3, _detailsData, _productFunction, _detailsShipping, _textLabels, _detailsCareIcons, _detailsDownload, _onVariantChangedListener21, onVariantChangedListener_fn5, _setSizeElement, setSizeElement_fn;
var ProductTabs = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onVariantChangedListener21);
    __privateAdd(this, _setSizeElement);
    __privateAdd(this, _detailsSize, void 0);
    __privateAdd(this, _formId3, void 0);
    __privateAdd(this, _detailsData, void 0);
    __privateAdd(this, _productFunction, void 0);
    __privateAdd(this, _detailsShipping, void 0);
    __privateAdd(this, _textLabels, void 0);
    __privateAdd(this, _detailsCareIcons, void 0);
    __privateAdd(this, _detailsDownload, void 0);
    __privateSet(this, _detailsSize, this.querySelectorAll("[product-size]"));
    if (__privateGet(this, _detailsSize).length > 0) {
      __privateSet(this, _formId3, this.querySelector('input[type="hidden"]'));
      if (__privateGet(this, _formId3)) {
        document.forms[__privateGet(this, _formId3).value].addEventListener("variant:change", __privateMethod(this, _onVariantChangedListener21, onVariantChangedListener_fn5).bind(this));
      }
    }
    __privateSet(this, _detailsData, JSON.parse(document.querySelector("[data-tabs-icons]").innerText));
    if (__privateGet(this, _detailsData)) {
      __privateMethod(this, _setSizeElement, setSizeElement_fn).call(this, __privateGet(this, _detailsData)["variant_metafields"][__privateGet(this, _detailsData)["first_variant_id"]]);
    }
    __privateSet(this, _productFunction, this.querySelectorAll("[product-functions]"));
    if (__privateGet(this, _productFunction).length > 0) {
      Array.from(__privateGet(this, _productFunction)).forEach((el) => {
        el.classList.add("scroll-area");
        let selectedIndex = parseFloat(el.getAttribute("product-functions"));
        let elements = el.querySelectorAll("li");
        let elementsSize = matchesMediaQuery("md") ? 92 : 80;
        el.style = `--product-function-left-position: calc(${elements.length * (elementsSize + 2) / (elements.length * 2) * selectedIndex / 16}rem - 0.4375rem)`;
        Array.from(el.querySelectorAll("li")).forEach((li, index) => {
          if (index + 1 - selectedIndex * 0.5 >= 0 && index + 1 - selectedIndex * 0.5 <= 1) {
            li.classList.add("active");
          }
        });
      });
    }
    __privateSet(this, _textLabels, this.querySelectorAll("[data-label]"));
    if (__privateGet(this, _textLabels).length > 0) {
      Array.from(__privateGet(this, _textLabels)).forEach((label) => {
        let labelBrand = label.getAttribute("data-label");
        if (__privateGet(this, _detailsData)["labels"][labelBrand]) {
          let labelTooltip = `<span class="tooltip-content tooltip--white tooltip--middle text-xs shadow-s">${__privateGet(this, _detailsData)["labels"][labelBrand]}</span>`;
          label.innerHTML = label.innerHTML + labelTooltip;
        }
      });
    }
    __privateSet(this, _detailsShipping, this.querySelectorAll('[data-tab="shipping"]'));
    __privateSet(this, _detailsCareIcons, this.querySelectorAll("[data-icon-care]"));
    if (__privateGet(this, _detailsCareIcons).length > 0 && __privateGet(this, _detailsData)["icons-care"]) {
      Array.from(__privateGet(this, _detailsCareIcons)).forEach((el) => {
        el.innerHTML = __privateGet(this, _detailsData)["icons-care"];
      });
    }
    __privateSet(this, _detailsDownload, this.querySelectorAll("[download-link]"));
    if (__privateGet(this, _detailsDownload).length > 0) {
      Array.from(__privateGet(this, _detailsDownload)).forEach((el) => {
        el.classList = "h-stack gap-2 terracotta";
        el.innerHTML = __privateGet(this, _detailsData)["download-icon"] + el.innerHTML;
      });
    }
  }
};
_detailsSize = new WeakMap();
_formId3 = new WeakMap();
_detailsData = new WeakMap();
_productFunction = new WeakMap();
_detailsShipping = new WeakMap();
_textLabels = new WeakMap();
_detailsCareIcons = new WeakMap();
_detailsDownload = new WeakMap();
_onVariantChangedListener21 = new WeakSet();
onVariantChangedListener_fn5 = function(event) {
  __privateMethod(this, _setSizeElement, setSizeElement_fn).call(this, __privateGet(this, _detailsData)["variant_metafields"][event.detail.variant.id]);
  if (__privateGet(this, _detailsShipping).length > 0) {
    Array.from(__privateGet(this, _detailsShipping)).forEach((tab) => {
      tab.innerHTML = __privateGet(this, _detailsData)["shipping"][__privateGet(this, _detailsData)["variant_metafields"][event.detail.variant.id]["shipping_size"]];
    });
  }
};
_setSizeElement = new WeakSet();
setSizeElement_fn = function(source) {
  let elements = [];
  if (source["width"])
    elements.push({ title: window.themeVariables.strings.productTabs.width, value: source["width"], icon: "product-tab-width-icon" });
  if (source["height"])
    elements.push({ title: window.themeVariables.strings.productTabs.height, value: source["height"], icon: "product-tab-height-icon" });
  if (source["depth"])
    elements.push({ title: window.themeVariables.strings.productTabs.depth, value: source["depth"], icon: "product-tab-depth-icon" });
  if (source["diameter"])
    elements.push({ title: window.themeVariables.strings.productTabs.diameter, value: source["diameter"], icon: "product-tab-diameter-icon" });
  if (source["length"])
    elements.push({ title: window.themeVariables.strings.productTabs.length, value: source["length"], icon: "product-tab-length-icon" });
  let htmlElements = "";
  if (elements.length > 0) {
    for (let i = 0; i < elements.length; i++) {
      htmlElements += `
          <div class="product__tabs-icon h-stack gap-4">
            <div>${__privateGet(this, _detailsData)[elements[i].icon]}</div>
            <div class="v-stack">
              <span class="smallcaps-xs medium">${elements[i].title}</span>
              <span class="text-m grey product__tabs-icon-value">${elements[i].value}</span>
            </div>
          </div>
        `;
    }
  }
  Array.from(__privateGet(this, _detailsSize)).forEach((el) => {
    if (htmlElements !== "") {
      el.innerHTML = `<div class="product__tabs-icons-list h-stack gap-3">${htmlElements}</div>`;
    } else {
      el.remove();
    }
  });
};
if (!window.customElements.get("product-tabs")) {
  window.customElements.define("product-tabs", ProductTabs);
}

// dev/src/js/common/product/product-ksp.js
import { animate as animate10 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var ProductKsp = class extends EffectCarousel {
  createOnChangeAnimationControls(fromSlide, toSlide) {
    return {
      leaveControls: () => animate10(fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"] }),
      enterControls: () => animate10(toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" })
    };
  }
};
if (!window.customElements.get("product-ksp-carousel")) {
  window.customElements.define("product-ksp-carousel", ProductKsp);
}

// dev/src/js/common/product/product-wishlist.js
var _fetchWishlistProducts, fetchWishlistProducts_fn, _removeFromWishlist2, removeFromWishlist_fn2, _addToWishlist, addToWishlist_fn;
var ProductWishlist = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _fetchWishlistProducts);
    __privateAdd(this, _removeFromWishlist2);
    __privateAdd(this, _addToWishlist);
    this.wishlistAddButton = this.querySelector("[data-wishlist-add]");
    this.wishlistRemoveButton = this.querySelector("[data-wishlist-remove]");
    this.wishlistAddButton.addEventListener("click", __privateMethod(this, _addToWishlist, addToWishlist_fn).bind(this));
    this.wishlistRemoveButton.addEventListener("click", __privateMethod(this, _removeFromWishlist2, removeFromWishlist_fn2).bind(this));
    document.addEventListener("DOMContentLoaded", __privateMethod(this, _fetchWishlistProducts, fetchWishlistProducts_fn).bind(this));
  }
};
_fetchWishlistProducts = new WeakSet();
fetchWishlistProducts_fn = async function() {
  await waitForWindowObject(() => window.hasOwnProperty("_swat")).then(() => {
    window._swat.fetchWrtEventTypeET((e) => {
      const activeProductId = SwymPageData.empi, activeVariantId = SwymPageData.epi;
      const isInWishlist = e.find(function(p) {
        return p.empi === activeProductId && p.epi === activeVariantId;
      });
      if (isInWishlist) {
        this.wishlistAddButton.hidden = true;
        this.wishlistRemoveButton.hidden = false;
      }
    }, 4);
  });
};
_removeFromWishlist2 = new WeakSet();
removeFromWishlist_fn2 = function() {
  if (SwymPageData) {
    window._swat.removeFromWishList(
      {
        "epi": SwymPageData.epi
      },
      (r) => {
        this.wishlistAddButton.hidden = false;
        this.wishlistRemoveButton.hidden = true;
      }
    );
  }
};
_addToWishlist = new WeakSet();
addToWishlist_fn = function() {
  if (SwymPageData) {
    SwymPageData.et = 4;
    _swat.addToWishList(SwymPageData, (e) => {
      this.wishlistAddButton.hidden = true;
      this.wishlistRemoveButton.hidden = false;
    });
  }
  this.dispatchEvent(new CustomEvent("wishlist:add", {
    bubbles: true,
    detail: {
      items: [SwymPageData],
      additionalInfos: JSON.parse(this.getAttribute("data-json")) || null
    }
  }));
};
if (!window.customElements.get("product-wishlist")) {
  window.customElements.define("product-wishlist", ProductWishlist);
}

// dev/src/js/common/media/base-media.js
import { inView as inView6 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var BaseMedia = class extends HTMLElement {
  static get observedAttributes() {
    return ["playing"];
  }
  connectedCallback() {
    this._abortController = new AbortController();
    if (this.hasAttribute("autoplay")) {
      inView6(this, this.play.bind(this), { margin: "0px 0px 0px 0px" });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get playing() {
    return this.hasAttribute("playing");
  }
  get player() {
    return this._playerProxy = this._playerProxy || new Proxy(this._playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this._playerHandler(target, prop);
        };
      }
    });
  }
  play() {
    if (!this.playing) {
      this.player.play();
    }
  }
  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "playing") {
      if (oldValue === null && newValue === "") {
        this.dispatchEvent(new CustomEvent("media:play", { bubbles: true }));
        if (this.hasAttribute("group")) {
          Array.from(document.querySelectorAll(`[group="${this.getAttribute("group")}"]`)).filter((item) => item !== this).forEach((itemToPause) => {
            itemToPause.pause();
          });
        }
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent("media:pause", { bubbles: true }));
      }
    }
  }
};

// dev/src/js/common/media/model.js
var ModelMedia = class extends BaseMedia {
  connectedCallback() {
    super.connectedCallback();
    this.player;
  }
  _playerTarget() {
    return new Promise((resolve) => {
      this.setAttribute("loaded", "");
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this._setupShopifyXr.bind(this)
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: () => {
            const modelViewer = this.querySelector("model-viewer");
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_play", () => this.setAttribute("playing", ""));
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_pause", () => this.removeAttribute("playing"));
            resolve(new window.Shopify.ModelViewerUI(modelViewer, { focusOnPlay: true }));
          }
        }
      ]);
    });
  }
  _playerHandler(target, prop) {
    target[prop]();
  }
  async _setupShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));
    } else {
      const models = (await ProductLoader.load(this.getAttribute("handle")))["media"].filter((media) => media["media_type"] === "model");
      window.ShopifyXR.addModels(models);
      window.ShopifyXR.setupXRElements();
    }
  }
};
if (!window.customElements.get("model-media")) {
  window.customElements.define("model-media", ModelMedia);
}

// dev/src/js/common/media/video.js
import { inView as inView7 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var onYouTubePromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
var VideoMedia = class extends BaseMedia {
  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute("autoplay")) {
      this.addEventListener("click", this.play, { once: true, signal: this._abortController.signal });
    }
    if (this.hasAttribute("show-play-button") && !this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(document.getElementById("video-media-default-template").content.cloneNode(true));
    }
    if (this.getAttribute("type") === "video") {
      inView7(this, () => {
        this.querySelector("video")?.setAttribute("preload", "metadata");
      }, { margin: "800px" });
    }
  }
  _playerTarget() {
    if (this.hasAttribute("host")) {
      this.setAttribute("loaded", "");
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector("template");
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        const muteVideo = this.hasAttribute("autoplay") || matchesMediaQuery("md-max");
        const script = document.createElement("script");
        script.type = "text/javascript";
        if (this.getAttribute("host") === "youtube") {
          if (!window.YT || !window.YT.Player) {
            script.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubePromise;
          const player = new YT.Player(this.querySelector("iframe"), {
            events: {
              "onReady": () => {
                if (muteVideo) {
                  player.mute();
                }
                resolve(player);
              },
              "onStateChange": (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute("playing", "");
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute("playing");
                }
              }
            }
          });
        }
        if (this.getAttribute("host") === "vimeo") {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = "https://player.vimeo.com/api/player.js";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const player = new Vimeo.Player(this.querySelector("iframe"));
          if (muteVideo) {
            player.setMuted(true);
          }
          player.on("play", () => {
            this.setAttribute("playing", "");
          });
          player.on("pause", () => this.removeAttribute("playing"));
          player.on("ended", () => this.removeAttribute("playing"));
          resolve(player);
        }
      });
    } else {
      const videoElement = this.querySelector("video");
      this.setAttribute("loaded", "");
      videoElement.addEventListener("play", () => {
        this.setAttribute("playing", "");
      });
      videoElement.addEventListener("pause", () => {
        if (!videoElement.seeking && videoElement.paused) {
          this.removeAttribute("playing");
        }
      });
      return videoElement;
    }
  }
  _playerHandler(target, prop) {
    if (this.getAttribute("host") === "youtube") {
      prop === "play" ? target.playVideo() : target.pauseVideo();
    } else {
      target[prop]();
    }
  }
};
if (!window.customElements.get("video-media")) {
  window.customElements.define("video-media", VideoMedia);
}

// dev/src/js/common/navigation/accordion-disclosure.js
import { timeline as timeline6 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";

// dev/src/js/common/navigation/animated-details.js
var AnimatedDetails = class extends HTMLDetailsElement {
  static get observedAttributes() {
    return ["open"];
  }
  #onSummaryClickedListener = this._onSummaryClicked.bind(this);
  constructor() {
    super();
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.show(!event.detail.load));
      this.addEventListener("shopify:block:deselect", this.hide);
    }
  }
  connectedCallback() {
    this.summaryElement.addEventListener("click", this.#onSummaryClickedListener);
  }
  disconnectedCallback() {
    this.summaryElement.removeEventListener("click", this.#onSummaryClickedListener.bind(this));
  }
  get summaryElement() {
    return this.firstElementChild;
  }
  get contentElement() {
    return this.lastElementChild;
  }
  show(animate18 = true) {
    if (this.open) {
      return;
    }
    this.isConnected ? this._openTransition(animate18) : this.setAttribute("open", "");
    this.classList.add("is-expanded");
  }
  hide() {
    if (!this.open) {
      return;
    }
    this.classList.remove("is-expanded");
    this.isConnected ? this._closeTransition() : this.removeAttribute("open");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.classList.toggle("is-expanded", newValue === "");
    switch (name) {
      case "open":
        this.setAttribute("aria-expanded", newValue !== null ? "true" : "false");
        break;
    }
  }
  _onSummaryClicked(event) {
    event.preventDefault();
    this.open ? this.hide() : this.show();
  }
  _openTransition(animate18 = true) {
  }
  _closeTransition(animate18 = true) {
  }
};

// dev/src/js/common/navigation/accordion-disclosure.js
var AccordionDisclosure = class extends AnimatedDetails {
  constructor() {
    super();
    if (this.getAttribute("data-open")) {
      if (matchesMediaQuery(this.getAttribute("data-open"))) {
        this.show();
      }
    }
  }
  async _openTransition(animate18 = true) {
    this.style.overflow = "hidden";
    this.setAttribute("open", "");
    const animationControls = timeline6([
      [this, { height: [`${this.summaryElement.clientHeight}px`, `${this.scrollHeight}px`] }, { duration: 0.25, easing: "ease" }],
      [this.contentElement, { opacity: [0, 1], transform: ["translateY(0)", "translateY(" + this.translateY + "px)"] }, { duration: 0.15, at: "-0.1" }]
    ]);
    animate18 ? animationControls.play() : animationControls.finish();
    await animationControls.finished;
    this.style.height = "auto";
    this.style.overflow = "visible";
  }
  get translateY() {
    return this.hasAttribute("translate-y") ? this.getAttribute("translate-y") : -4;
  }
  async _closeTransition(animate18 = true) {
    this.style.overflow = "hidden";
    const animationControls = timeline6([
      [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
      [this, { height: [`${this.clientHeight}px`, `${this.summaryElement.clientHeight}px`] }, { duration: 0.25, at: "<", easing: "ease" }]
    ]);
    animate18 ? animationControls.play() : animationControls.finish();
    await animationControls.finished;
    this.removeAttribute("open");
    this.style.height = "auto";
    this.style.overflow = "visible";
  }
};
if (!window.customElements.get("accordion-disclosure")) {
  window.customElements.define("accordion-disclosure", AccordionDisclosure, { extends: "details" });
}

// dev/src/js/common/navigation/accordion-list-animated.js
var _accordionItems, _toggleTab, toggleTab_fn;
var AccordionListAnimated = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _toggleTab);
    __privateAdd(this, _accordionItems, []);
  }
  connectedCallback() {
    __privateSet(this, _accordionItems, Array.from(this.children));
    this.cycleSpeed = this.getAttribute("cycle-speed") * 1e3;
    if (this.cycleSpeed > 0) {
      this.interval = this.setInterval();
    }
    __privateMethod(this, _toggleTab, toggleTab_fn).call(this);
  }
  set selectedIndex(value) {
    this.setAttribute("selected-index", value);
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index"));
  }
  setInterval() {
    return setInterval(() => {
      let nextAccordionIndex = this.selectedIndex + 1;
      if (nextAccordionIndex === __privateGet(this, _accordionItems).length) {
        nextAccordionIndex = 0;
      }
      __privateGet(this, _accordionItems)[this.selectedIndex].hide();
      __privateGet(this, _accordionItems)[this.selectedIndex].setAttribute("aria-current", "false");
      __privateGet(this, _accordionItems)[nextAccordionIndex].show();
      __privateGet(this, _accordionItems)[nextAccordionIndex].setAttribute("aria-current", "true");
      this.selectedIndex = nextAccordionIndex;
    }, this.cycleSpeed);
  }
};
_accordionItems = new WeakMap();
_toggleTab = new WeakSet();
toggleTab_fn = function() {
  Array.from(__privateGet(this, _accordionItems)).forEach((item, index) => {
    if (item.open) {
      this.selectedIndex = index;
      item.setAttribute("aria-current", "true");
    }
    item.addEventListener("click", () => {
      Array.from(__privateGet(this, _accordionItems)).forEach((accordion, v) => {
        if (v === index) {
          accordion.show();
          this.selectedIndex = v;
          accordion.setAttribute("aria-current", "true");
          if (this.cycleSpeed > 0) {
            clearInterval(this.interval);
            this.interval = this.setInterval();
          }
        } else {
          accordion.hide();
          accordion.setAttribute("aria-current", "false");
        }
      });
    });
  });
};
if (!window.customElements.get("accordion-list-animated")) {
  window.customElements.define("accordion-list-animated", AccordionListAnimated);
}

// dev/src/js/common/navigation/custom-details.js
var _onSummaryClickedListener, _onSummaryClicked, onSummaryClicked_fn;
var CustomDetails = class extends HTMLDetailsElement {
  constructor() {
    super();
    __privateAdd(this, _onSummaryClicked);
    __privateAdd(this, _onSummaryClickedListener, __privateMethod(this, _onSummaryClicked, onSummaryClicked_fn).bind(this));
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.toggle(true, !event.detail.load));
      this.addEventListener("shopify:block:deselect", (event) => this.toggle(false, !event.detail.load));
    }
  }
  static get observedAttributes() {
    return ["open", "aria-expanded"];
  }
  connectedCallback() {
    this.setAttribute("aria-expanded", this.open ? "true" : "false");
    this.summaryElement.addEventListener("click", __privateGet(this, _onSummaryClickedListener));
  }
  disconnectedCallback() {
    this.summaryElement.removeEventListener("click", __privateGet(this, _onSummaryClickedListener));
  }
  get summaryElement() {
    return this.firstElementChild;
  }
  get contentElement() {
    return this.lastElementChild;
  }
  toggle(force = void 0, animate18 = true) {
    const newValue = typeof force === "boolean" ? force : !(this.getAttribute("aria-expanded") === "true");
    if (newValue) {
      this.setAttribute("open", animate18 ? "" : "immediate");
    }
    this.setAttribute("aria-expanded", newValue ? "true" : "false");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "open":
        this.setAttribute("aria-expanded", newValue !== null ? "true" : "false");
        break;
      case "aria-expanded":
        if (oldValue === newValue || !this.isConnected) {
          return;
        }
        if (newValue === "false" && this.open) {
          this.createHideAnimationControls()?.finished.then((event) => {
            if (event !== void 0) {
              this.removeAttribute("open");
            }
          });
        } else if (newValue === "true") {
          const controls = this.createShowAnimationControls();
          if (this.getAttribute("open") === "immediate") {
            controls.finish();
          }
        }
    }
  }
  createShowAnimationControls() {
  }
  createHideAnimationControls() {
  }
};
_onSummaryClickedListener = new WeakMap();
_onSummaryClicked = new WeakSet();
onSummaryClicked_fn = function(event) {
  if (this.open && this.summaryElement.hasAttribute("data-follow-link")) {
    return window.location.href = this.summaryElement.getAttribute("data-follow-link");
  }
  event.preventDefault();
  this.toggle();
};

// dev/src/js/common/navigation/menu-disclosure.js
var _hoverTimer, _detectClickOutsideListener, _detectEscKeyboardListener, _detectFocusOutListener, _detectHoverOutsideListener, _detectHoverListener, _detectClickOutside, detectClickOutside_fn, _detectHover, detectHover_fn, _detectHoverOutside, detectHoverOutside_fn, _detectEscKeyboard, detectEscKeyboard_fn, _detectFocusOut, detectFocusOut_fn;
var _MenuDisclosure = class extends CustomDetails {
  constructor() {
    super();
    __privateAdd(this, _detectClickOutside);
    __privateAdd(this, _detectHover);
    __privateAdd(this, _detectHoverOutside);
    __privateAdd(this, _detectEscKeyboard);
    __privateAdd(this, _detectFocusOut);
    __privateAdd(this, _hoverTimer, void 0);
    __privateAdd(this, _detectClickOutsideListener, __privateMethod(this, _detectClickOutside, detectClickOutside_fn).bind(this));
    __privateAdd(this, _detectEscKeyboardListener, __privateMethod(this, _detectEscKeyboard, detectEscKeyboard_fn).bind(this));
    __privateAdd(this, _detectFocusOutListener, __privateMethod(this, _detectFocusOut, detectFocusOut_fn).bind(this));
    __privateAdd(this, _detectHoverOutsideListener, __privateMethod(this, _detectHoverOutside, detectHoverOutside_fn).bind(this));
    __privateAdd(this, _detectHoverListener, __privateMethod(this, _detectHover, detectHover_fn).bind(this));
    this.addEventListener("mouseover", __privateGet(this, _detectHoverListener));
    this.addEventListener("mouseout", __privateGet(this, _detectHoverListener));
  }
  get trigger() {
    return !window.matchMedia("screen and (pointer: fine)").matches ? "click" : this.getAttribute("trigger");
  }
  get mouseOverDelayTolerance() {
    return 50;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "aria-expanded") {
      if (oldValue === newValue) {
        return;
      }
      if (newValue === "false") {
        document.removeEventListener("click", __privateGet(this, _detectClickOutsideListener));
        document.removeEventListener("keydown", __privateGet(this, _detectEscKeyboardListener));
        document.removeEventListener("focusout", __privateGet(this, _detectFocusOutListener));
        document.removeEventListener("mouseover", __privateGet(this, _detectHoverOutsideListener));
      } else {
        document.addEventListener("click", __privateGet(this, _detectClickOutsideListener));
        document.addEventListener("keydown", __privateGet(this, _detectEscKeyboardListener));
        document.addEventListener("focusout", __privateGet(this, _detectFocusOutListener));
        document.addEventListener("mouseover", __privateGet(this, _detectHoverOutsideListener));
      }
    }
  }
};
var MenuDisclosure = _MenuDisclosure;
_hoverTimer = new WeakMap();
_detectClickOutsideListener = new WeakMap();
_detectEscKeyboardListener = new WeakMap();
_detectFocusOutListener = new WeakMap();
_detectHoverOutsideListener = new WeakMap();
_detectHoverListener = new WeakMap();
_detectClickOutside = new WeakSet();
detectClickOutside_fn = function(event) {
  if (this.trigger !== "click") {
    return;
  }
  if (!this.contains(event.target) && !(event.target.closest("details") instanceof _MenuDisclosure)) {
    this.toggle(false);
  }
};
_detectHover = new WeakSet();
detectHover_fn = function(event) {
  if (this.trigger !== "hover") {
    return;
  }
  if (event.type === "mouseover") {
    clearTimeout(__privateGet(this, _hoverTimer));
    this.toggle(true);
  } else if (event.type === "mouseout") {
    __privateSet(this, _hoverTimer, setTimeout(() => this.toggle(false), this.mouseOverDelayTolerance));
  }
};
_detectHoverOutside = new WeakSet();
detectHoverOutside_fn = function(event) {
  if (this.trigger !== "hover") {
    return;
  }
  const closestDetails = event.target.closest("details");
  if (closestDetails instanceof _MenuDisclosure && closestDetails !== this && !closestDetails.contains(this) && !this.contains(closestDetails)) {
    clearTimeout(__privateGet(this, _hoverTimer));
    this.toggle(false);
  }
};
_detectEscKeyboard = new WeakSet();
detectEscKeyboard_fn = function(event) {
  if (event.code === "Escape") {
    const targetMenu = event.target.closest("details[open]");
    if (targetMenu && targetMenu instanceof _MenuDisclosure) {
      targetMenu.toggle(false);
      event.stopPropagation();
    }
  }
};
_detectFocusOut = new WeakSet();
detectFocusOut_fn = function(event) {
  if (event.relatedTarget && !this.contains(event.relatedTarget)) {
    this.toggle(false);
  }
};

// dev/src/js/common/navigation/menu-inspiration.js
var MenuInspiration = class extends HTMLElement {
  #textButtons;
  #abortController;
  #relatedImages;
  constructor() {
    super();
    this.#abortController = new AbortController();
    this.#textButtons = this.querySelectorAll("[data-index]");
    this.#relatedImages = this.querySelectorAll("[data-image]");
    Array.from(this.#textButtons).forEach((button) => {
      button.addEventListener("mouseover", this.onHover.bind(this));
    });
  }
  onHover(event) {
    this.show(event.target.getAttribute("data-index"));
  }
  show(id) {
    Array.from(this.#relatedImages).forEach((image) => {
      image.style.opacity = image.getAttribute("data-image") !== id ? 0 : 1;
    });
  }
};
if (!window.customElements.get("menu-inspiration")) {
  window.customElements.define("menu-inspiration", MenuInspiration);
}

// dev/src/js/common/navigation/read-more.js
import { timeline as timeline7 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var ReadMore = class extends HTMLElement {
  static get observedAttributes() {
    return ["open"];
  }
  #onSummaryClickedListener = this._onSummaryClicked.bind(this);
  #switcherButtons = this.querySelectorAll("[data-switcher]");
  constructor() {
    super();
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.show(!event.detail.load));
      this.addEventListener("shopify:block:deselect", this.hide);
    }
  }
  connectedCallback() {
    this.summaryElement.addEventListener("click", this.#onSummaryClickedListener);
  }
  disconnectedCallback() {
    this.summaryElement.removeEventListener("click", this.#onSummaryClickedListener.bind(this));
  }
  get summaryElement() {
    return this.lastElementChild;
  }
  get contentElement() {
    return this.firstElementChild;
  }
  show(animate18 = true) {
    if (this.hasAttribute("open")) {
      return;
    }
    this.isConnected ? this._openTransition(animate18) : this.setAttribute("open", "");
    this.classList.add("is-expanded");
  }
  hide() {
    if (!this.hasAttribute("open")) {
      return;
    }
    this.classList.remove("is-expanded");
    this.isConnected ? this._closeTransition() : this.removeAttribute("open");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.classList.toggle("is-expanded", newValue === "");
    this.setAttribute("aria-expanded", newValue !== null ? "true" : "false");
  }
  _onSummaryClicked(event) {
    event.preventDefault();
    this.hasAttribute("open") ? this.hide() : this.show();
    Array.from(this.#switcherButtons).forEach((el) => {
      el.hidden = !el.hidden;
    });
  }
  async _openTransition(animate18 = true) {
    this.style.overflow = "hidden";
    this.setAttribute("open", "");
    const animationControls = timeline7([
      [this.contentElement, { height: [`${this.contentElement.clientHeight}px`, `${this.contentElement.scrollHeight + 10}px`] }, { duration: 0.25, easing: "ease" }]
    ]);
    animate18 ? animationControls.play() : animationControls.finish();
    await animationControls.finished;
    this.style.height = "auto";
    this.style.overflow = "visible";
  }
  async _closeTransition(animate18 = true) {
    this.style.overflow = "hidden";
    this.removeAttribute("open");
    const animationControls = timeline7([
      [this.contentElement, { height: [`${this.contentElement.scrollHeight}px`, `${getComputedStyle(this.contentElement).getPropertyValue("--seo-read-more-content-height")}`] }, { duration: 0.25, at: "<", easing: "ease" }]
    ]);
    animate18 ? animationControls.play() : animationControls.finish();
    await animationControls.finished;
    this.style.height = "auto";
    this.style.overflow = "visible";
  }
};
if (!window.customElements.get("read-more")) {
  window.customElements.define("read-more", ReadMore);
}

// dev/src/js/common/navigation/scrolling-tabs.js
var ScrollingTabs = class extends HTMLElement {
  #tabs;
  connectedCallback() {
    this.#tabs = this.querySelectorAll("[data-tab]");
    this.#tabs?.forEach((el) => {
      el.addEventListener("click", this.scrollToView.bind(this));
    });
  }
  disconnectedCallback() {
    this.#tabs?.forEach((el) => {
      el.removeEventListener("click", this.scrollToView.bind(this));
    });
  }
  scrollToView(event) {
    let element = event.target;
    let elementRightPosition = element?.getBoundingClientRect().x + element?.getBoundingClientRect().width;
    let elementLeftPosition = element?.getBoundingClientRect().x;
    let scrollTo = false;
    if (elementRightPosition > window.innerWidth) {
      scrollTo = element.offsetLeft - this.clientWidth / 2 + element.clientWidth / 2;
    }
    if (elementLeftPosition < 0) {
      scrollTo = 0;
    }
    if (typeof scrollTo === "number") {
      this.closest(".scroll-area")?.scrollTo({
        left: scrollTo,
        behavior: "smooth"
      });
    }
  }
};
if (!window.customElements.get("scrolling-tabs")) {
  window.customElements.define("scrolling-tabs", ScrollingTabs);
}

// dev/src/js/common/navigation/tabs.js
import { Delegate as Delegate5, animate as animate11 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _componentID, _buttons, _panels, _images, _delegate4, _setupComponent, setupComponent_fn, _onButtonClicked, onButtonClicked_fn, _onSlotChange, onSlotChange_fn, _handleKeyboard, handleKeyboard_fn;
var Tabs = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _setupComponent);
    __privateAdd(this, _onButtonClicked);
    __privateAdd(this, _onSlotChange);
    __privateAdd(this, _handleKeyboard);
    __privateAdd(this, _componentID, crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4));
    __privateAdd(this, _buttons, []);
    __privateAdd(this, _panels, []);
    __privateAdd(this, _images, []);
    __privateAdd(this, _delegate4, void 0);
  }
  static get observedAttributes() {
    return ["selected-index"];
  }
  connectedCallback() {
    __privateSet(this, _delegate4, new Delegate5(this));
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = __privateGet(this, _buttons).indexOf(event.target));
    }
    __privateGet(this, _delegate4).on("click", 'button[role="tab"]', __privateMethod(this, _onButtonClicked, onButtonClicked_fn).bind(this));
    this.shadowRoot.addEventListener("slotchange", __privateMethod(this, _onSlotChange, onSlotChange_fn).bind(this));
    this.addEventListener("keydown", __privateMethod(this, _handleKeyboard, handleKeyboard_fn));
    __privateMethod(this, _setupComponent, setupComponent_fn).call(this);
    this.selectedIndex = this.selectedIndex;
  }
  disconnectedCallback() {
    __privateGet(this, _delegate4).destroy();
  }
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.15;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), __privateGet(this, _buttons).length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
  }
  attributeChangedCallback(name, oldValue, newValue) {
    __privateGet(this, _buttons).forEach((button, index) => button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this.transition(__privateGet(this, _panels)[parseInt(oldValue)], __privateGet(this, _panels)[parseInt(newValue)]);
      if (__privateGet(this, _images).length > 0) {
        this.transition(__privateGet(this, _images)[parseInt(oldValue)], __privateGet(this, _images)[parseInt(newValue)]);
      }
    }
  }
  async transition(fromPanel, toPanel) {
    this.dispatchEvent(new CustomEvent("slot:changed", {
      detail: {
        panelToHide: fromPanel,
        panelToShow: toPanel
      }
    }));
    await animate11(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    if (fromPanel)
      fromPanel.hidden = true;
    if (toPanel)
      toPanel.hidden = false;
    await animate11(toPanel, { opacity: [0, 1] }, { duration: this.animationDuration }).finished;
  }
};
_componentID = new WeakMap();
_buttons = new WeakMap();
_panels = new WeakMap();
_images = new WeakMap();
_delegate4 = new WeakMap();
_setupComponent = new WeakSet();
setupComponent_fn = function() {
  __privateSet(this, _buttons, Array.from(this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(), (item) => item.matches("button") && item || item.querySelector("button")));
  __privateSet(this, _panels, Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes()));
  if (this.shadowRoot.querySelector('slot[name="image"]')) {
    __privateSet(this, _images, Array.from(this.shadowRoot.querySelector('slot[name="image"]').assignedNodes()));
  }
  __privateGet(this, _buttons).forEach((button, index) => {
    button.setAttribute("role", "tab");
    button.setAttribute("aria-controls", `tab-panel-${__privateGet(this, _componentID)}-${index}`);
    button.id = `tab-${__privateGet(this, _componentID)}-${index}`;
  });
  __privateGet(this, _panels).forEach((panel, index) => {
    panel.setAttribute("role", "tabpanel");
    panel.setAttribute("aria-labelledby", `tab-${__privateGet(this, _componentID)}-${index}`);
    panel.id = `tab-panel-${__privateGet(this, _componentID)}-${index}`;
    panel.hidden = index !== this.selectedIndex;
  });
  __privateGet(this, _images)?.forEach((panel, index) => {
    panel.setAttribute("role", "tabimage");
    panel.setAttribute("aria-labelledby", `tab-${__privateGet(this, _componentID)}-${index}`);
    panel.id = `tab-image-${__privateGet(this, _componentID)}-${index}`;
    panel.hidden = index !== this.selectedIndex;
  });
  this.style.setProperty("--item-count", __privateGet(this, _buttons).length.toString());
};
_onButtonClicked = new WeakSet();
onButtonClicked_fn = function(event, button) {
  this.selectedIndex = __privateGet(this, _buttons).indexOf(button);
};
_onSlotChange = new WeakSet();
onSlotChange_fn = function() {
  __privateMethod(this, _setupComponent, setupComponent_fn).call(this);
};
_handleKeyboard = new WeakSet();
handleKeyboard_fn = function(event) {
  const index = __privateGet(this, _buttons).indexOf(document.activeElement);
  if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
    return;
  }
  if (event.key === "ArrowLeft") {
    this.selectedIndex = (this.selectedIndex - 1 + __privateGet(this, _buttons).length) % __privateGet(this, _buttons).length;
  } else {
    this.selectedIndex = (this.selectedIndex + 1 + __privateGet(this, _buttons).length) % __privateGet(this, _buttons).length;
  }
  __privateGet(this, _buttons)[this.selectedIndex].focus();
};
if (!window.customElements.get("x-tabs")) {
  window.customElements.define("x-tabs", Tabs);
}

// dev/src/js/common/search/search-results.js
var import_algoliasearch = __toESM(require_algoliasearch_umd());
import { createApp, reactive } from "https://cdn.jsdelivr.net/npm/petite-vue@0.4.1/+esm";
import { animate as animate12 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var currencyFormat5 = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
var _listenersAbortController3, _fetchAbortController, _searchForm, _queryInput, _hitsToShowDrawer, _hitsToShowResultPage, _onInputChanged2, onInputChanged_fn2, _doAlgoliaSearch, doAlgoliaSearch_fn, _onSearchCleared, onSearchCleared_fn, _onFormSubmitted3, onFormSubmitted_fn3, _transitionToSlot, transitionToSlot_fn, _fetchProductData, fetchProductData_fn;
var SearchResults = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onInputChanged2);
    __privateAdd(this, _doAlgoliaSearch);
    __privateAdd(this, _onSearchCleared);
    __privateAdd(this, _onFormSubmitted3);
    __privateAdd(this, _transitionToSlot);
    __privateAdd(this, _fetchProductData);
    __privateAdd(this, _listenersAbortController3, void 0);
    __privateAdd(this, _fetchAbortController, void 0);
    __privateAdd(this, _searchForm, void 0);
    __privateAdd(this, _queryInput, void 0);
    __privateAdd(this, _hitsToShowDrawer, 10);
    __privateAdd(this, _hitsToShowResultPage, 24);
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(`<slot name="idle"></slot>`));
  }
  connectedCallback() {
    __privateSet(this, _listenersAbortController3, new AbortController());
    __privateSet(this, _searchForm, document.querySelector(`[aria-owns="${this.id}"]`));
    __privateSet(this, _queryInput, __privateGet(this, _searchForm).elements["q"]);
    this.algoliaClient = (0, import_algoliasearch.default)(window.themeVariables.libraries.algolia.app_id, window.themeVariables.libraries.algolia.api_key);
    this.algoliaProductIndex = window.themeVariables.libraries.algolia.productIndex;
    this.algoliaCollectionIndex = window.themeVariables.libraries.algolia.collectionIndex;
    this.algoliaSuggestionsIndex = "shopify_products_query_suggestions";
    __privateGet(this, _searchForm).addEventListener("reset", __privateMethod(this, _onSearchCleared, onSearchCleared_fn).bind(this), { signal: __privateGet(this, _listenersAbortController3).signal });
    __privateGet(this, _queryInput).addEventListener("input", debounce(__privateMethod(this, _onInputChanged2, onInputChanged_fn2).bind(this), this.autoCompleteDelay, { signal: __privateGet(this, _listenersAbortController3).signal }));
    __privateGet(this, _searchForm).addEventListener("submit", __privateMethod(this, _onFormSubmitted3, onFormSubmitted_fn3).bind(this), { signal: __privateGet(this, _listenersAbortController3).signal });
    this.initVueComponent();
    if (window.themeVariables.settings.pageType === "search") {
      __privateMethod(this, _onInputChanged2, onInputChanged_fn2).call(this);
    }
  }
  disconnectedCallback() {
    __privateGet(this, _listenersAbortController3).abort();
  }
  initVueComponent() {
    let that = this;
    const searchResults = reactive({
      scope: "",
      pageHasChanged: false,
      drawer: {
        query: "",
        queryID: "",
        nbHits: 0,
        products: [],
        collections: [],
        suggestions: [],
        currentPage: 0,
        nbPages: 0
      },
      search: {
        query: "",
        queryID: "",
        nbHits: 0,
        products: [],
        collections: [],
        suggestions: [],
        currentPage: 0,
        nbPages: 0
      },
      processSuggestions(results) {
        let tempResults = results.hits;
        tempResults.forEach(function(item) {
          if (item._highlightResult?.query?.fullyHighlighted) {
            tempResults.splice(tempResults.indexOf(item), 1);
          }
        });
        return tempResults;
      },
      pushData(data) {
        this[data.scope] = {
          query: data.products.query,
          queryID: data.queryID,
          nbHits: data.products.nbHits,
          products: data.products.hits,
          collections: data.collections.hits,
          suggestions: this.processSuggestions(data.suggestions),
          currentPage: data.products.page + 1,
          nbPages: data.products.nbPages
        };
      },
      setSearchQuery(query2) {
        this.drawer.query = query2;
        __privateGet(that, _queryInput).value = query2;
        __privateGet(that, _queryInput).dispatchEvent(new Event("input"));
      },
      moneyFormat(price) {
        return formatMoney(price * 100, currencyFormat5);
      },
      htMoneyFormat(price) {
        return formatMoney(price * (1 - window.themeVariables.pro.discount / 100) / (1 + 0.2) * 100, currencyFormat5) + " HT";
      },
      ttcMoneyFormat(price) {
        return formatMoney(price * (1 - window.themeVariables.pro.discount / 100) * 100, currencyFormat5) + " TTC";
      },
      sizeFormat(variant) {
        return variant.split(" - ")[0].split("x").join(" x ").trim();
      },
      getProductTitle(product) {
        const title = product.title, pattern = product.meta.global.pattern;
        const final_title = title.split(pattern.toUpperCase());
        if (!this.algoliaProductIndex === "shopify_products_france_en") {
          return `${final_title[0]} ${pattern} ${final_title[1]}`;
        } else {
          return title;
        }
      },
      getCategory(product) {
        const pattern = product.meta.global.pattern, lining = product.meta.global.doublure, sous_famille = product.meta.global.sous_famille, support = product.meta.global.type_de_support, curtain_head = product.meta.global.tete_de_rideau;
        return Shopify.handleize(`${product.product_type}-${curtain_head ? curtain_head + "-" : ""}${lining ? lining + "-" : ""}${support ? support + "-" : ""}${sous_famille ? sous_famille + "-" : ""}-${pattern}`);
      },
      goToPage(page) {
        var _a;
        if (typeof page === "number" && page > 0) {
          __privateMethod(_a = that, _doAlgoliaSearch, doAlgoliaSearch_fn).call(_a, page, __privateGet(that, _hitsToShowResultPage));
        }
      },
      getPageCount(currentPage, nbPages) {
        return Pagination.getPagination(currentPage, nbPages, 1);
      },
      setJsonData(product, index) {
        return JSON.stringify({
          name: product.title,
          id: product.sku,
          item_variant: product.variant_title,
          price: product.price,
          currency: window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.currency : "null",
          brand: product.vendor,
          product_collection: product.product_type,
          product_collection_parent: null,
          collection_master: null,
          position: index
        });
      },
      handleClick: function(event, target, queryID) {
        const item = {
          objectID: target.objectID,
          queryID,
          position: parseInt(event.currentTarget.getAttribute("position"))
        };
        Shopify.analytics.publish("algolia_product_clicked", item);
      }
    });
    this.addEventListener("search:results", async function(data) {
      let results = await __privateMethod(this, _fetchProductData, fetchProductData_fn).call(this, data.detail);
      searchResults.pushData(results);
      if (window.themeVariables.settings.pageType === "search") {
        document.documentElement.scrollIntoView({ block: "start", behavior: "smooth" });
      }
      setTimeout(() => {
        this.sendSearchDataToDataLayer();
      }, 0);
      if (data.detail.products.page === 0) {
        document.title = document.title.replace(/[0-9]+/g, data.detail.products.nbHits);
      }
      if (searchResults.pageHasChanged) {
        setTimeout(() => {
          this.querySelector("product-list").fetchProductColors();
        }, 0);
      }
      searchResults.pageHasChanged = true;
      return __privateMethod(this, _transitionToSlot, transitionToSlot_fn).call(this, "results");
    });
    createApp({
      searchResults
    }).mount(`#${this.getAttribute("data-results-container")}`);
  }
  sendSearchDataToDataLayer() {
    let products = [];
    Array.from(this.querySelectorAll(".product-card")).forEach((productCard) => {
      let productData = JSON.parse(productCard.getAttribute("data-json") || "{}");
      products.push(productData);
    });
    document.dispatchEvent(new CustomEvent("productList:impression", {
      bubbles: true,
      detail: {
        jsonData: products,
        listInfos: {
          listId: "search_results",
          listName: "search_results"
        }
      }
    }));
  }
  get autoCompleteDelay() {
    return 280;
  }
};
_listenersAbortController3 = new WeakMap();
_fetchAbortController = new WeakMap();
_searchForm = new WeakMap();
_queryInput = new WeakMap();
_hitsToShowDrawer = new WeakMap();
_hitsToShowResultPage = new WeakMap();
_onInputChanged2 = new WeakSet();
onInputChanged_fn2 = async function() {
  if (__privateGet(this, _queryInput).value === "") {
    return __privateMethod(this, _onSearchCleared, onSearchCleared_fn).call(this);
  }
  await __privateMethod(this, _transitionToSlot, transitionToSlot_fn).call(this, "loading");
  __privateGet(this, _fetchAbortController)?.abort();
  __privateSet(this, _fetchAbortController, new AbortController());
  try {
    if (window.themeVariables.libraries.algolia.active) {
      return __privateMethod(this, _doAlgoliaSearch, doAlgoliaSearch_fn).call(this, 1, window.themeVariables.settings.pageType === "search" ? __privateGet(this, _hitsToShowResultPage) : __privateGet(this, _hitsToShowDrawer));
    }
  } catch (e) {
    if (e.name !== "AbortError") {
      throw e;
    }
  }
};
_doAlgoliaSearch = new WeakSet();
doAlgoliaSearch_fn = function(page = 1, hitsPerPage = __privateGet(this, _hitsToShowDrawer)) {
  const queries = [
    {
      indexName: this.algoliaProductIndex,
      query: __privateGet(this, _queryInput).value,
      clickAnalytics: true,
      page: page - 1,
      params: {
        hitsPerPage
      }
    },
    {
      indexName: this.algoliaCollectionIndex,
      query: __privateGet(this, _queryInput).value,
      params: {
        hitsPerPage: 4
      }
    },
    {
      indexName: this.algoliaSuggestionsIndex,
      query: __privateGet(this, _queryInput).value,
      params: {
        hitsPerPage: 4
      }
    }
  ];
  this.algoliaClient.multipleQueries(queries).then(({ results }) => {
    this.dispatchEvent(new CustomEvent("search:results", {
      bubbles: true,
      detail: {
        scope: this.getAttribute("data-template"),
        products: results[0],
        collections: results[1],
        suggestions: results[2],
        queryID: results[0].queryID
      }
    }));
  });
};
_onSearchCleared = new WeakSet();
onSearchCleared_fn = function() {
  __privateGet(this, _fetchAbortController)?.abort();
  __privateGet(this, _queryInput).focus();
  return __privateMethod(this, _transitionToSlot, transitionToSlot_fn).call(this, "idle");
};
_onFormSubmitted3 = new WeakSet();
onFormSubmitted_fn3 = function(event) {
  if (__privateGet(this, _queryInput).value === "") {
    event.preventDefault();
  }
};
_transitionToSlot = new WeakSet();
transitionToSlot_fn = async function(toSlotName) {
  if (this.shadowRoot.firstElementChild.name === toSlotName) {
    return;
  }
  await animate12(this.shadowRoot.firstElementChild.assignedNodes(), { opacity: [1, 0] }, { duration: 0.1 }).finished;
  this.shadowRoot.firstElementChild.setAttribute("name", toSlotName);
  return animate12(this.shadowRoot.firstElementChild.assignedNodes(), { opacity: [0, 1], transform: ["translateY(5px)", "translateY(0)"] }, { duration: 0.1 }).finished;
};
_fetchProductData = new WeakSet();
fetchProductData_fn = async function(data) {
  let tempData = data;
  let tempProducts = data.products.hits;
  this.currentHandles = [];
  tempProducts.forEach((item) => {
    this.currentHandles.push(`handle:${item.handle}`);
  });
  const response = await fetch(`/search?view=product-infos&q=${this.currentHandles.join(" OR ")}`, {
    method: "GET"
  });
  const resultText = await response.text();
  const resultObject = JSON.parse(resultText);
  tempProducts.forEach((item) => {
    if (resultObject[item.id]) {
      let resultObj = resultObject[item.id];
      if (resultObj) {
        item["custom_price"] = resultObj.custom_price;
        item["custom_compare_at_price"] = resultObj.custom_compare_at_price;
        item["badges"] = resultObj.badges;
      }
    }
  });
  return tempData;
};
if (!window.customElements.get("search-results")) {
  window.customElements.define("search-results", SearchResults);
}

// dev/src/js/sections/announcement-bar.js
import { animate as animate13 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var AnnouncementBarCarousel = class extends EffectCarousel {
  createOnChangeAnimationControls(fromSlide, toSlide) {
    return {
      leaveControls: () => animate13(fromSlide, { opacity: [1, 0], transform: ["translateY(0)", "translateY(-10px)"] }, { duration: 0.25, easing: [0.55, 0.055, 0.675, 0.19] }),
      enterControls: () => animate13(toSlide, { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0px)"] }, { duration: 0.4, easing: [0.215, 0.61, 0.355, 1] })
    };
  }
};
if (!window.customElements.get("announcement-bar-carousel")) {
  window.customElements.define("announcement-bar-carousel", AnnouncementBarCarousel);
}

// dev/src/js/sections/banner-cta.js
var BannerCtaSticky = class extends HTMLElement {
  constructor() {
    super();
    this.onScrollBound = this.onScroll.bind(this);
    this.sectionReassuranceTop = 0;
    this.lastScrollPosition = 0;
    this.sectionId = this.getAttribute("data-section-id");
    this.targetSection = document.getElementById(this.sectionId);
  }
  connectedCallback() {
    const sectionReassurance = document.querySelector(".section-reassurance");
    if (sectionReassurance) {
      this.sectionReassuranceTop = sectionReassurance.getBoundingClientRect().top + window.scrollY;
    }
    window.addEventListener("scroll", this.onScrollBound);
    if (matchesMediaQuery("lg")) {
      if (this.targetSection) {
        const main = document.querySelector("main");
        const headerStickyHeight = main.style.getPropertyValue("--header-sticky-height").trim();
        this.targetSection.style.top = headerStickyHeight;
      }
    } else {
      if (this.targetSection) {
        this.targetSection.style.top = document.querySelector(".header").offsetHeight + "px";
      }
    }
  }
  onScroll() {
    const scrollPosition = window.scrollY;
    const offset = 200;
    if (scrollPosition >= this.sectionReassuranceTop + offset) {
      if (scrollPosition > this.lastScrollPosition) {
        this.targetSection.classList.add("sticky-hide");
      } else {
        this.targetSection.classList.remove("sticky-hide");
      }
    }
    this.lastScrollPosition = scrollPosition;
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollBound);
  }
};
customElements.define("banner-cta", BannerCtaSticky);

// dev/src/js/sections/cart.js
var CartTemplate = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const url = `${Shopify.routes.root}cart?view=products-infos`;
    fetch(url).then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    }).then((data) => {
      this.dispatchEvent(new CustomEvent("cart:load", {
        bubbles: true,
        detail: data
      }));
    }).catch((error) => {
      console.error(error);
    });
  }
};
window.customElements.define("cart-template", CartTemplate);

// dev/src/js/sections/cart-bundle-edit-modal.js
var CartBundleEditModal = class extends Modal {
  constructor() {
    super();
    this.button?.addEventListener("click", this.onButtonClick.bind(this));
  }
  get button() {
    return this.querySelector("button");
  }
  get buttonURL() {
    return this.button?.getAttribute("data-bundle-url");
  }
  get productList() {
    return this.button?.getAttribute("product-list").split("|");
  }
  async onButtonClick(event) {
    event.preventDefault();
    this.button?.classList.add("button--loading");
    let updates = {};
    this.productList.forEach((productId) => {
      updates[productId] = 0;
    });
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      keepalive: true,
      body: JSON.stringify({ updates })
    });
    if (response.ok) {
      window.location.href = this.buttonURL;
    }
  }
  hide() {
    this.button?.classList.remove("button--loading");
    super.hide();
  }
};
if (!window.customElements.get("cart-bundle-edit-modal")) {
  window.customElements.define("cart-bundle-edit-modal", CartBundleEditModal);
}

// dev/src/js/sections/cart-drawer.js
var _sectionId, _onBundleSection, onBundleSection_fn, _onCartOpened, onCartOpened_fn, _onCartChange, onCartChange_fn, _onPageShow, onPageShow_fn, _refreshCart, refreshCart_fn, _replaceContent, replaceContent_fn;
var CartDrawer = class extends Drawer {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onBundleSection);
    __privateAdd(this, _onCartOpened);
    __privateAdd(this, _onCartChange);
    __privateAdd(this, _onPageShow);
    __privateAdd(this, _refreshCart);
    __privateAdd(this, _replaceContent);
    __privateAdd(this, _sectionId, void 0);
  }
  connectedCallback() {
    super.connectedCallback();
    __privateGet(this, _sectionId) ?? __privateSet(this, _sectionId, extractSectionId(this));
    document.addEventListener("cart:prepare-bundled-sections", __privateMethod(this, _onBundleSection, onBundleSection_fn).bind(this), { signal: this.abortController.signal });
    document.addEventListener("cart:change", __privateMethod(this, _onCartChange, onCartChange_fn).bind(this), { signal: this.abortController.signal });
    this.addEventListener("dialog:after-show", __privateMethod(this, _onCartOpened, onCartOpened_fn).bind(this), { signal: this.abortController.signal });
    window.addEventListener("pageshow", __privateMethod(this, _onPageShow, onPageShow_fn).bind(this), { signal: this.abortController.signal });
  }
};
_sectionId = new WeakMap();
_onBundleSection = new WeakSet();
onBundleSection_fn = function(event) {
  event.detail.sections.push(__privateGet(this, _sectionId));
};
_onCartOpened = new WeakSet();
onCartOpened_fn = function(event) {
  const url = `${Shopify.routes.root}cart?view=products-infos`;
  fetch(url).then((response) => {
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  }).then((data) => {
    this.dispatchEvent(new CustomEvent("cart-drawer:open", {
      bubbles: true,
      detail: data
    }));
  }).catch((error) => {
    console.error(error);
  });
};
_onCartChange = new WeakSet();
onCartChange_fn = function(event) {
  __privateMethod(this, _replaceContent, replaceContent_fn).call(this, event.detail.cart["sections"][__privateGet(this, _sectionId)]);
  if (event.detail.openDrawer === "false") {
    return;
  }
  if (event.detail.baseEvent === "variant:add") {
    this.show();
  }
};
_onPageShow = new WeakSet();
onPageShow_fn = async function(event) {
  if (!event.persisted) {
    return;
  }
  __privateMethod(this, _refreshCart, refreshCart_fn).call(this);
};
_refreshCart = new WeakSet();
refreshCart_fn = async function() {
  __privateMethod(this, _replaceContent, replaceContent_fn).call(this, await (await fetch(`${Shopify.routes.root}?section_id=${__privateGet(this, _sectionId)}`)).text());
};
_replaceContent = new WeakSet();
replaceContent_fn = async function(html) {
  const domElement = new DOMParser().parseFromString(html, "text/html"), newCartDrawer = document.createRange().createContextualFragment(domElement.getElementById(`shopify-section-${__privateGet(this, _sectionId)}`).querySelector("cart-drawer").innerHTML), itemCount = (await fetchCart)["item_count"];
  if (itemCount === 0) {
    this.replaceChildren(...newCartDrawer.children);
  } else {
    this.replaceChildren(...newCartDrawer.children);
  }
  this.classList.toggle("cart-drawer--empty", itemCount === 0);
};
if (!window.customElements.get("cart-drawer")) {
  window.customElements.define("cart-drawer", CartDrawer);
}

// dev/src/js/sections/compose-drawer.js
import { timeline as timeline8 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var currencyFormat6 = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
var ComposeDrawer = class extends Drawer {
  #composeContent;
  #submitForm;
  #selectedProducts;
  #form;
  constructor() {
    super();
    this.#composeContent = this.querySelector("#product-compose-content");
    this._initComposeProducts();
    document.addEventListener("compose:changed", this._updateComposeForm.bind(this));
  }
  async _initComposeProducts() {
    const response = await fetch(`${Shopify.routes.root}products/${this.getAttribute("product")}?section_id=product-compose-async-product-list`);
    const responseText = await response.text();
    if (response.ok) {
      this.#composeContent.innerHTML = responseText;
      this.#form = this.querySelector("#product-compose-form");
      this.#submitForm = this.#form?.querySelector("#submit-compose");
      this.#form?.addEventListener("submit", this._submitComposeForm.bind(this));
      this.#selectedProducts = this.querySelectorAll("compose-product-colors");
      Array.from(this.#selectedProducts)?.forEach((form) => {
        Array.from(form.querySelectorAll("product-card-binded"))?.forEach((item) => {
          document.forms[item.getAttribute("form")]?.addEventListener("quantity:change", this._updateComposeForm.bind(this));
          document.forms[item.getAttribute("form")]?.addEventListener("variant:change", this._updateComposeForm.bind(this));
        });
      });
      this._updateComposeForm();
    }
  }
  _updateComposeForm(event) {
    let totalPrice = 0;
    let variantGroup = "";
    let variantIndex = 0;
    setTimeout(() => {
      Array.from(this.#selectedProducts)?.forEach((form) => {
        Array.from(form.querySelectorAll("product-card-binded:not([hidden])"))?.forEach((item) => {
          if (!item.querySelector('button[type="submit"]').hasAttribute("hidden")) {
            let variantId = item.querySelector('[name="id"]').value;
            let price = parseInt(item.querySelector("sale-price")?.getAttribute("price"));
            let quantity = parseInt(item.querySelector('[name="quantity"]').value);
            totalPrice += price * quantity;
            variantGroup += `
              <input type="hidden" name="items[${variantIndex}][id]" value="${variantId}">
              <input type="hidden" name="items[${variantIndex}][quantity]" value="${quantity}">
            `;
            variantIndex++;
          }
        });
      });
      if (this.#form) {
        this.#form.querySelector("[data-variants]").innerHTML = variantGroup;
      }
      if (this.#submitForm) {
        this.#submitForm.querySelector("[data-price]").innerHTML = formatMoney(totalPrice, currencyFormat6);
        this.#submitForm.disabled = totalPrice === 0;
      }
    }, 0);
  }
  _submitComposeForm() {
    setTimeout(() => {
      this.hide();
    }, 300);
  }
  createEnterAnimationControls() {
    this.getShadowPartByName("content").style.marginInlineStart = this.openFrom === "right" ? "auto" : 0;
    let outputTimeline;
    if (matchesMediaQuery("lg")) {
      outputTimeline = timeline8([
        [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [this.getShadowPartByName("content"), { transform: [`translateY(100%)`, "translateY(0)"] }, { duration: 0.3, at: "<", easing: [0.645, 0.045, 0.355, 1] }]
      ]);
    } else {
      outputTimeline = timeline8([
        [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [this.getShadowPartByName("content"), { transform: [`translateX(${this.openFrom === "right" ? "100%" : "-100%"})`, "translateX(0)"] }, { duration: 0.3, at: "<", easing: [0.645, 0.045, 0.355, 1] }]
      ]);
    }
    return outputTimeline;
  }
  createLeaveAnimationControls() {
    let outputTimeline;
    if (matchesMediaQuery("lg")) {
      outputTimeline = timeline8([
        [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [this.getShadowPartByName("content"), { transform: ["translateY(0)", `translateY(100%)`] }, { duration: 0.3, at: "<", easing: [0.645, 0.045, 0.355, 1] }]
      ]);
    } else {
      outputTimeline = timeline8([
        [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [this.getShadowPartByName("content"), { transform: ["translateX(0)", `translateX(${this.openFrom === "right" ? "100%" : "-100%"})`] }, { duration: 0.3, at: "<", easing: [0.645, 0.045, 0.355, 1] }]
      ]);
    }
    return outputTimeline;
  }
};
var ComposeProductColors = class extends HTMLElement {
  #productList;
  constructor() {
    super();
    this.#productList = this.querySelectorAll("product-card-binded");
    Array.from(this.#productList)?.forEach((product) => {
      Array.from(product.querySelectorAll(".color-swatch"))?.forEach((swatch) => {
        swatch.addEventListener("click", this._onColorSelected.bind(this));
      });
      Array.from(product.querySelectorAll("[data-binded]"))?.forEach((size) => {
        size.addEventListener("click", this._onSizeSelected.bind(this));
      });
    });
    if (this.querySelector("[data-compose-count]")) {
      let index = Array.from(this.parentElement.childNodes).indexOf(this);
      let totalCount = this.parentElement.querySelectorAll("compose-product-colors").length;
      this.querySelector("[data-compose-count]").innerText = `${index + 1} / ${totalCount}`;
    }
  }
  _onColorSelected(event) {
    event.preventDefault();
    let colorSelected = event.currentTarget?.getAttribute("data-handle");
    this._showProductByHandle(colorSelected);
  }
  _onSizeSelected(event) {
    event.preventDefault();
    let sizeSelected = event.currentTarget?.getAttribute("data-binded");
    this._showProductByHandle(sizeSelected);
  }
  _showProductByHandle(handle) {
    Array.from(this.#productList)?.forEach((product) => {
      product.hidden = product.getAttribute("data-handle") !== handle;
    });
    document.documentElement.dispatchEvent(new CustomEvent("compose:changed", { bubbles: true }));
  }
};
if (!window.customElements.get("compose-drawer")) {
  window.customElements.define("compose-drawer", ComposeDrawer);
}
if (!window.customElements.get("compose-product-colors")) {
  window.customElements.define("compose-product-colors", ComposeProductColors);
}

// dev/src/js/sections/collection-bundle-push.js
var CollectionBundlePush = class extends HTMLElement {
  constructor() {
    super();
    this.setHeight();
    window.addEventListener("resize", throttle(this.setHeight.bind(this)));
  }
  setHeight() {
    if (matchesMediaQuery("md")) {
      this.style.height = this.nextElementSibling.getBoundingClientRect().height + "px";
    } else {
      this.style.height = "auto";
    }
  }
};
if (!customElements.get("collection-bundle-push")) {
  customElements.define("collection-bundle-push", CollectionBundlePush);
}

// dev/src/js/sections/cross-sell-doublure.js
var CrossSellDoublure = class extends HTMLElement {
  #tabButtons;
  #tabContent;
  #tabProducts;
  #onSelectTab = this._onSelectedTab.bind(this);
  connectedCallback() {
    this.#tabButtons = this.querySelectorAll("[data-tab]");
    this.#tabContent = this.querySelectorAll("[data-content]");
    this.#tabProducts = this.querySelectorAll("[data-product]");
    Array.from(this.#tabButtons)?.forEach((tab) => {
      tab.addEventListener("click", this.#onSelectTab);
    });
  }
  disconnectedCallback() {
    Array.from(this.#tabButtons)?.forEach((tab) => {
      tab.removeEventListener("click", this.#onSelectTab);
    });
  }
  _onSelectedTab(event) {
    this._displayTab(event.target.getAttribute("data-tab"));
  }
  _displayTab(id) {
    Array.from(this.#tabButtons).forEach((button) => {
      button.setAttribute("aria-selected", button.getAttribute("data-tab") === id);
    });
    Array.from(this.#tabContent).forEach((tab) => {
      tab.hidden = tab.getAttribute("data-content") !== id;
    });
    Array.from(this.#tabProducts).forEach((tab) => {
      tab.hidden = tab.getAttribute("data-product") !== id;
    });
  }
};
var CartDrawerCrossSellDoublure = class extends Modal {
  #isLoaded = false;
  constructor() {
    super();
    if (window.themeVariables.settings.cartType === "drawer") {
      document.addEventListener("variant:add", this.hide.bind(this));
    }
  }
  async show() {
    if (!this.#isLoaded) {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
      const responseContent = await (await fetch(`${window.Shopify.routes.root}products/${this.getAttribute("handle")}`)).text();
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      const tempDoc = new DOMParser().parseFromString(responseContent, "text/html");
      const crossSellDoublureContent = tempDoc.getElementById("cart-drawer-cross-sell-lining").content;
      Array.from(crossSellDoublureContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
      this.replaceChildren(document.importNode(crossSellDoublureContent, true));
      this.#isLoaded = true;
    }
    super.show();
  }
};
if (!window.customElements.get("cross-sell-lining")) {
  window.customElements.define("cross-sell-lining", CrossSellDoublure);
}
if (!window.customElements.get("cart-drawer-cross-sell-lining")) {
  window.customElements.define("cart-drawer-cross-sell-lining", CartDrawerCrossSellDoublure);
}

// dev/src/js/sections/cross-sell-rod.js
import { createApp as createApp2, reactive as reactive2 } from "https://cdn.jsdelivr.net/npm/petite-vue@0.4.1/+esm";
var CrossSellRod = class extends HTMLElement {
  #originalWeight;
  #quantity = 1;
  #curtainLength;
  #globalLength;
  #accessoriesLotRecommended;
  connectedCallback() {
    this.initVueComponent();
    this.masterSelector = document.forms[this.getAttribute("form")].id;
    this.#originalWeight = this.weight;
    this.calcAccessoriesLotRecommended(this.length);
    this.masterSelector.form?.addEventListener("variant:change", (event) => {
      this.weight = event.detail.variant.weight * this.#quantity;
      this.#originalWeight = this.weight;
      this.#curtainLength = parseInt(event.detail.variant.option1.split("x")[0]);
      this.calcAccessoriesLotRecommended(this.length);
    });
    this.masterSelector.form?.addEventListener("quantity:change", (event) => {
      this.#quantity = event.detail.quantity;
      this.weight = this.#originalWeight * this.#quantity;
      this.calcAccessoriesLotRecommended(this.length);
    });
  }
  get weight() {
    return parseInt(this.getAttribute("weight"));
  }
  set weight(value) {
    this.setAttribute("weight", value);
  }
  get length() {
    return this.#curtainLength ? this.#curtainLength : parseInt(this.getAttribute("length"));
  }
  calcAccessoriesLotRecommended(length) {
    this.#globalLength = length * this.#quantity;
    this.#accessoriesLotRecommended = Math.ceil(this.#globalLength / 15 / 10);
    return this.#accessoriesLotRecommended;
  }
  initVueComponent() {
    const self2 = this, crossSellRod = reactive2({
      crossSellRodData: JSON.parse(document.getElementById(self2.getAttribute("data-json")).innerText),
      windowSize: "",
      inputError: false,
      curtainLength: 0,
      accessoriesLotRecommended: 0,
      exceedSize: 30,
      rodSizes: [150, 180, 200, 250],
      wallMount: 0,
      rodTypeAdded: "",
      rodQuantityAdded: 0,
      rodDiameter: "",
      windowSizeSubmitted: "",
      rodRecommended: {
        sizes: [],
        diameters: [],
        quantity: 1
      },
      rodConnectionRecommendedQuantity: 0,
      rodCentralSupport: 0,
      rod: {
        recommended: 0,
        added: 0
      },
      rodConnection: {
        recommended: 0,
        added: 0
      },
      rodSupport: {
        recommended: 0,
        added: 0
      },
      rodEnd: {
        recommended: 0,
        added: 0
      },
      rodAccessories: {
        recommended: 0,
        added: 0
      },
      submitWindowSize(event) {
        if (event)
          event.preventDefault();
        if (this.windowSizeSubmitted !== "") {
          this.initObject();
          this.closeAllCollapse();
        }
        if (crossSellRod.windowSize === "" || parseInt(crossSellRod.windowSize) < 20) {
          this.inputError = true;
          setTimeout(() => {
            this.inputError = false;
          }, 3e3);
          return;
        }
        let target = event.target;
        this.accessoriesLotRecommended = self2.#accessoriesLotRecommended;
        this.curtainLength = self2.#globalLength;
        target.classList.add("button--loading");
        setTimeout(() => {
          this.calcRodSizeRecommended();
          this.getRodRecommended();
          this.getRodConnection();
          this.toggleCollapse("window-size");
          target.classList.remove("button--loading");
        }, 500);
      },
      getRodRecommended() {
        for (let i = 0; i < this.rodRecommended.sizes.length; i++) {
          if (this.crossSellRodData["rodList"].hasOwnProperty(this.rodRecommended.sizes[i])) {
            let productCard = this.getProductCard(this.crossSellRodData["rodList"][this.rodRecommended.sizes[i]].handle);
            let recommendedOption = productCard.querySelector('label[for="' + this.crossSellRodData["rodList"][this.rodRecommended.sizes[i]].inputId + '"]');
            let inputQuantity = productCard.querySelector('input[name="quantity"]');
            let productCardForm = productCard.querySelector("form");
            if (recommendedOption) {
              recommendedOption.click();
            }
            if (inputQuantity) {
              inputQuantity.value = this.rodRecommended.quantity;
            }
            if (productCardForm) {
              productCardForm.addEventListener("quantity:change", this.rodProductCardFormOnQuantityChange);
              productCardForm.removeEventListener("quantity:change", this.rodProductCardFormOnQuantityChange, true);
              productCardForm.dispatchEvent(new CustomEvent("quantity:change", {
                bubbles: true,
                detail: {
                  quantity: this.rodRecommended.quantity
                }
              }));
              productCardForm.addEventListener("variant:change", this.rodProductCardFormOnVariantChange);
              productCardForm.removeEventListener("variant:change", this.rodProductCardFormOnVariantChange, true);
              productCardForm.addEventListener("variant:add", this.rodProductCardFormOnVariantAdd);
              productCardForm.removeEventListener("variant:add", this.rodProductCardFormOnVariantAdd, true);
            }
          }
        }
      },
      rodProductCardFormOnQuantityChange(event) {
        crossSellRod.rod.recommended = event.detail.quantity;
      },
      rodProductCardFormOnVariantChange(event) {
        let previousDiameter = event.detail.previousVariant.public_title.split("-")[1].split("L")[0].trim();
        let newDiameter = event.detail.variant.public_title.split("-")[1].split("L")[0].trim();
        if (previousDiameter !== newDiameter) {
          let index = crossSellRod.rodRecommended.diameters.indexOf(previousDiameter);
          if (index !== -1) {
            crossSellRod.rodRecommended.diameters[index] = newDiameter;
            crossSellRod.getRodConnection();
          }
        }
      },
      rodProductCardFormOnVariantAdd(event) {
        const rodType = event.target.closest(".cross-sell-rod__product")?.getAttribute("data-rod-type");
        crossSellRod.rodDiameter = event.detail.items[0].variant_title.split("-")[1].split("L")[0].trim();
        crossSellRod.rodQuantityAdded = event.detail.quantity;
        crossSellRod.rod.added = event.detail.quantity;
        crossSellRod.rodTypeAdded = rodType;
        crossSellRod.getRodSupport(crossSellRod.rodDiameter);
        crossSellRod.getRocAccessoriesLotRecommended(crossSellRod.accessoriesLotRecommended, crossSellRod.rodDiameter);
        crossSellRod.toggleProducts(rodType);
        if (crossSellRod.rodConnection.added >= crossSellRod.rodConnection.recommended && crossSellRod.rod.added >= crossSellRod.rod.recommended) {
          document.addEventListener("alert:closed", crossSellRod.toggleCollapse);
        }
      },
      getRodConnection() {
        if (this.crossSellRodData.hasOwnProperty("rodConnection")) {
          let connectionObject = this.crossSellRodData["rodConnection"];
          for (let connection in connectionObject) {
            let productCard = this.getProductCard(connectionObject[connection].handle);
            if (productCard) {
              productCard.hidden = true;
            }
          }
          for (let i = 0; i < this.rodRecommended.diameters.length; i++) {
            if (connectionObject.hasOwnProperty(this.rodRecommended.diameters[i])) {
              let productCard = this.getProductCard(connectionObject[this.rodRecommended.diameters[i]].handle);
              let inputQuantity = productCard.querySelector('input[name="quantity"]');
              let productCardForm = productCard.querySelector("form");
              if (productCard) {
                productCard.hidden = !(this.rodRecommended.quantity > 1);
              }
              if (inputQuantity) {
                inputQuantity.value = this.rodRecommended.quantity - 1;
                this.rodConnectionRecommendedQuantity = this.rodRecommended.quantity - 1;
              }
              if (productCardForm) {
                productCardForm.addEventListener("quantity:change", this.rodConnectionProductCardFormOnQuantityChange);
                productCardForm.removeEventListener("quantity:change", this.rodConnectionProductCardFormOnQuantityChange, true);
                productCardForm.dispatchEvent(new CustomEvent("quantity:change", {
                  bubbles: true,
                  detail: {
                    quantity: this.rodRecommended.quantity - 1
                  }
                }));
                productCardForm.addEventListener("variant:add", this.rodConnectionProductCardFormOnVariantAdd);
                productCardForm.removeEventListener("variant:add", this.rodConnectionProductCardFormOnVariantAdd, true);
              }
            }
          }
        }
      },
      rodConnectionProductCardFormOnQuantityChange(event) {
        crossSellRod.rodConnection.recommended = event.detail.quantity;
      },
      rodConnectionProductCardFormOnVariantAdd(event) {
        crossSellRod.rodConnection.added += event.detail.quantity;
        if (crossSellRod.rodConnection.added >= crossSellRod.rodConnection.recommended && crossSellRod.rod.added >= crossSellRod.rod.recommended) {
          document.addEventListener("alert:closed", crossSellRod.toggleCollapse);
        }
      },
      getRodSupport(diameter) {
        for (let support in this.crossSellRodData["rodSupport"]) {
          if (support.indexOf(diameter) > -1) {
            let productCard = this.getProductCard(this.crossSellRodData["rodSupport"][support].handle);
            let productCardForm = productCard.querySelector("form");
            let recommendedOption = productCard.querySelector('label[for="' + this.crossSellRodData["rodSupport"][support].inputId + '"]');
            let inputQuantity = productCard.querySelector('input[name="quantity"]');
            if (recommendedOption) {
              recommendedOption.click();
            }
            let quantity = this.crossSellRodData["rodSupport"][support].adaptQuantity ? this.rodQuantityAdded + 1 : 2;
            this.rodSupport.recommended = this.rodQuantityAdded + 1;
            this.rodCentralSupport = this.rodSupport.recommended - 2;
            if (productCardForm) {
              productCardForm.dispatchEvent(new CustomEvent("quantity:change", {
                bubbles: true,
                detail: {
                  quantity
                }
              }));
              productCardForm.addEventListener("variant:add", this.rodSupportProductCardFormOnVariantAdd);
              productCardForm.removeEventListener("variant:add", this.rodSupportProductCardFormOnVariantAdd, true);
            }
            inputQuantity.value = quantity;
          }
        }
      },
      rodSupportProductCardFormOnVariantAdd(event) {
        if (event.detail.items[0].vendor.indexOf("Naissance") > -1 || event.detail.items[0].vendor.indexOf("coud\xE9") > -1) {
          crossSellRod.wallMount += event.detail.quantity;
        }
        crossSellRod.rodDiameter = event.detail.items[0].variant_title.split("-")[1].split("L")[0].trim();
        crossSellRod.rodSupport.added += event.detail.quantity;
        if (crossSellRod.rodSupport.added >= crossSellRod.rodSupport.recommended) {
          document.addEventListener("alert:closed", crossSellRod.toggleCollapse);
          crossSellRod.getRodEnd(crossSellRod.rodDiameter);
        }
      },
      getRodEnd(diameter) {
        for (let end in this.crossSellRodData["rodEnd"]) {
          if (end.indexOf(diameter) > -1) {
            let productCard = this.getProductCard(this.crossSellRodData["rodEnd"][end].handle);
            let productCardForm = productCard.querySelector("form");
            let recommendedOption = productCard.querySelector('label[for="' + this.crossSellRodData["rodEnd"][end].inputId + '"]');
            let inputQuantity = productCard.querySelector('input[name="quantity"]');
            if (recommendedOption) {
              recommendedOption.click();
            }
            this.rodEnd.recommended = 2 - this.wallMount;
            productCard.querySelector("form")?.dispatchEvent(new CustomEvent("quantity:change", {
              bubbles: true,
              detail: {
                quantity: 2 - this.wallMount
              }
            }));
            productCardForm.addEventListener("variant:add", this.rodEndProductCardFormOnVariantAdd);
            productCardForm.removeEventListener("variant:add", this.rodEndProductCardFormOnVariantAdd, true);
            inputQuantity.value = 2 - this.wallMount;
          }
        }
      },
      rodEndProductCardFormOnVariantAdd(event) {
        crossSellRod.rodEnd.added += event.detail.quantity;
        if (crossSellRod.rodEnd.added >= crossSellRod.rodEnd.recommended) {
          document.addEventListener("alert:closed", crossSellRod.toggleCollapse);
        }
      },
      getRocAccessoriesLotRecommended(quantity, diameter) {
        let objectKey = diameter.replace("D23", "ND");
        if (!self2.hasAttribute("additional-diameter")) {
          objectKey = diameter.replace("D29", "D35").replace("D19", "D35");
        }
        this.rodAccessories.recommended = quantity;
        for (let accessory in this.crossSellRodData["rodAccessories"]) {
          if (accessory.indexOf(objectKey) > -1) {
            let productCard = this.getProductCard(this.crossSellRodData["rodAccessories"][accessory].handle);
            let productCardForm = productCard.querySelector("form");
            let recommendedOption = productCard.querySelector('label[for="' + this.crossSellRodData["rodAccessories"][accessory].inputId + '"]');
            let inputQuantity = productCard.querySelector('input[name="quantity"]');
            if (recommendedOption) {
              recommendedOption.click();
            }
            productCard.querySelector("form")?.dispatchEvent(new CustomEvent("quantity:change", {
              bubbles: true,
              detail: {
                quantity: this.rodAccessories.recommended
              }
            }));
            productCardForm.addEventListener("variant:add", this.rodAccessoriesProductCardFormOnVariantAdd);
            productCardForm.removeEventListener("variant:add", this.rodAccessoriesProductCardFormOnVariantAdd, true);
            inputQuantity.value = quantity;
          }
        }
      },
      rodAccessoriesProductCardFormOnVariantAdd(event) {
        crossSellRod.rodAccessories.added += event.detail.quantity;
        if (crossSellRod.rodAccessories.added >= crossSellRod.rodAccessories.recommended) {
          document.addEventListener("alert:closed", crossSellRod.toggleCollapse);
        }
      },
      calcRodSizeRecommended() {
        this.rodRecommended.sizes = [];
        this.rodRecommended.quantity = 1;
        this.windowSizeSubmitted = this.windowSize;
        this.rodRecommended.diameters = this.getRecommendedDiameter();
        while (this.rodRecommended.sizes.length === 0) {
          for (let i = 0; i < this.rodSizes.length; i++) {
            if (parseInt(this.windowSize) + this.exceedSize <= this.rodSizes[i] * this.rodRecommended.quantity) {
              for (let j = 0; j < this.rodRecommended.diameters.length; j++) {
                this.rodRecommended.sizes.push(this.rodRecommended.diameters[j] + "L" + (i + 1));
              }
              break;
            }
          }
          if (this.rodRecommended.sizes.length === 0) {
            this.rodRecommended.quantity++;
          }
        }
      },
      initObject() {
        this.rodQuantityAdded = 0;
        this.rodRecommended.sizes = [];
        this.rodRecommended.diameters = [];
        this.rodRecommended.quantity = 1;
        this.rodConnectionRecommendedQuantity = 0;
        this.rodCentralSupport = 0;
        this.rod.recommended = 0;
        this.rod.added = 0;
        this.rodConnection.recommended = 0;
        this.rodConnection.added = 0;
        this.rodSupport.recommended = 0;
        this.rodSupport.added = 0;
        this.rodEnd.recommended = 0;
        this.rodEnd.added = 0;
        this.rodAccessories.recommended = 0;
        this.rodAccessories.added = 0;
      },
      getRecommendedDiameter() {
        this.rodRecommended.diameters = [];
        this.rodDiameter = self2.weight > 500 ? "D29" : "D19";
        if (self2.weight > 500) {
          this.rodRecommended.diameters.push("D29");
        } else {
          this.rodRecommended.diameters.push("D19");
        }
        if (self2.hasAttribute("additional-diameter")) {
          this.rodRecommended.diameters.push("D23");
        }
        return this.rodRecommended.diameters;
      },
      getProductCard(handle) {
        return self2.querySelector('product-card-binded[data-handle="' + handle + '"]')?.closest(".cross-sell-rod__product");
      },
      toggleCollapse() {
        document.removeEventListener("alert:closed", crossSellRod.toggleCollapse);
        let collapseList = Array.from(self2.querySelectorAll(".cross-sell-rod__accordion"));
        let currentCollapse = self2.querySelector(".cross-sell-rod__accordion[open]");
        let isCurrentElement = false;
        for (let i = 0; i < collapseList.length; i++) {
          let collapse = collapseList[i];
          if (collapse === currentCollapse) {
            collapse.hide();
            collapse.classList.add("completed");
            isCurrentElement = true;
            setTimeout(() => {
              let drawer = self2.closest(".cross-sell-rod-drawer").shadowRoot;
              drawer.querySelector('[part="body"]').scrollTo({
                top: collapse.offsetTop + collapse.querySelector(".accordion__toggle").offsetHeight,
                left: 0,
                behavior: "smooth"
              });
            }, 0);
          }
          if (isCurrentElement && collapse !== currentCollapse && !collapse.hidden) {
            collapse.show();
            self2.closest(".cross-sell-rod-drawer").shadowRoot.querySelector('[part="body"]').scrollTo({
              top: collapse.getBoundingClientRect().top,
              left: 0,
              behavior: "smooth"
            });
            break;
          }
        }
        if (currentCollapse === collapseList[collapseList.length - 1]) {
          self2.closest(".cross-sell-rod-drawer").hide();
          setTimeout(function() {
            document.querySelector("#cart-drawer").show();
          }, 250);
        }
      },
      closeAllCollapse() {
        let collapseList = Array.from(self2.querySelectorAll(".cross-sell-rod__accordion:not(:first-child)"));
        for (let i = 0; i < collapseList.length; i++) {
          collapseList[i].classList.remove("completed");
          collapseList[i].hide();
        }
      },
      toggleProducts(rodType) {
        let collapseList = self2.querySelectorAll(".cross-sell-rod__accordion[adapt-content]");
        if (collapseList.length > 0) {
          Array.from(collapseList).forEach((collapse) => {
            let productItemList = collapse.querySelectorAll(".cross-sell-rod__product");
            if (productItemList.length > 0) {
              Array.from(productItemList).forEach((product) => {
                product.hidden = !(product.getAttribute("data-rod-type") === rodType);
              });
            }
            collapse.hidden = collapse.querySelectorAll(".cross-sell-rod__product[hidden]").length === productItemList.length;
          });
        }
      }
    });
    createApp2({
      crossSellRod
    }).mount(this.id);
  }
};
var CurtainSelected = class extends HTMLElement {
  connectedCallback() {
    this.masterSelector = document.forms[this.getAttribute("form")];
    this.masterSelector?.addEventListener("quantity:change", this.setQuantity.bind(this));
    this.masterSelector?.addEventListener("variant:change", this.setSize.bind(this));
  }
  setSize(event) {
    this.querySelector("[data-size]").innerText = event.detail.variant.title.split("-")[0].replace("x", " x ");
  }
  setQuantity(event) {
    let quantity = event.detail.quantity.toString();
    let wording = event.detail.quantity > 1 ? " pans" : " pan";
    this.querySelector("[data-quantity]").innerText = quantity + wording;
  }
};
var CartDrawerCrossSellRod = class extends Modal {
  constructor() {
    super();
  }
  get handle() {
    return this.getAttribute("handle");
  }
  get variantId() {
    return this.getAttribute("variant-id");
  }
  async show() {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const responseContent = await (await fetch(`${window.Shopify.routes.root}products/${this.handle}?variant=${this.variantId}`)).text();
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    const tempDoc = new DOMParser().parseFromString(responseContent, "text/html");
    const crossSellRodContent = tempDoc.getElementById("cart-drawer-cross-sell-rod").content;
    Array.from(crossSellRodContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
    this.replaceChildren(document.importNode(crossSellRodContent, true));
    super.show();
  }
};
if (!window.customElements.get("cart-drawer-cross-sell-rod")) {
  window.customElements.define("cart-drawer-cross-sell-rod", CartDrawerCrossSellRod);
}
if (!window.customElements.get("cross-sell-rod")) {
  window.customElements.define("cross-sell-rod", CrossSellRod);
}
if (!window.customElements.get("curtain-selected")) {
  window.customElements.define("curtain-selected", CurtainSelected);
}

// dev/src/js/sections/customers.js
import { animate as animate14 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _loginForm, loginForm_get, _recoverForm, recoverForm_get, _switchForm, switchForm_fn;
var AccountLogin = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _loginForm);
    __privateAdd(this, _recoverForm);
    __privateAdd(this, _switchForm);
    window.addEventListener("hashchange", __privateMethod(this, _switchForm, switchForm_fn).bind(this));
    if (window.location.hash === "#recover") {
      __privateGet(this, _loginForm, loginForm_get).hidden = true;
      __privateGet(this, _recoverForm, recoverForm_get).hidden = false;
    }
  }
};
_loginForm = new WeakSet();
loginForm_get = function() {
  return this.querySelector("#login");
};
_recoverForm = new WeakSet();
recoverForm_get = function() {
  return this.querySelector("#recover");
};
_switchForm = new WeakSet();
switchForm_fn = async function() {
  const fromForm = window.location.hash === "#recover" ? __privateGet(this, _loginForm, loginForm_get) : __privateGet(this, _recoverForm, recoverForm_get), toForm = window.location.hash === "#recover" ? __privateGet(this, _recoverForm, recoverForm_get) : __privateGet(this, _loginForm, loginForm_get);
  await animate14(fromForm, { transform: ["translateY(0)", "translateY(10px)"], opacity: [1, 0] }, { duration: 0.3, easing: "ease" }).finished;
  fromForm.hidden = true;
  toForm.hidden = false;
  await animate14(toForm, { transform: ["translateY(10px)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.3, easing: "ease" });
};
var _submitForm, _submitAccountForm, submitAccountForm_fn;
var AccountForm = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _submitAccountForm);
    __privateAdd(this, _submitForm, __privateMethod(this, _submitAccountForm, submitAccountForm_fn).bind(this));
    this.querySelector("form").addEventListener("submit", __privateGet(this, _submitForm));
  }
};
_submitForm = new WeakMap();
_submitAccountForm = new WeakSet();
submitAccountForm_fn = function() {
  this.querySelector('button[type="submit"]:not(.link)').classList.add("button--loading");
};
var AccountRegister = class extends HTMLElement {
  #form;
  #CFformID;
  #errorFormMessage;
  constructor() {
    super();
    this.#form = this.querySelector("#create-customer-form");
    this.#CFformID = this.getAttribute("data-form-id");
    this.#errorFormMessage = this.#form.querySelector(".alert--error");
    CF.customerReady(() => {
      this.#form.addEventListener("submit", this._submitForm.bind(this));
    });
  }
  _submitForm(event) {
    event.preventDefault();
    let data = new FormData(this.#form);
    let formData = {};
    for (const [key, value] of data) {
      let current_key = key.substring(key.indexOf("[") + 1, key.lastIndexOf("]"));
      if (current_key.indexOf("email_marketing_consent") > -1) {
        formData["email_marketing_consent"] = {
          "marketing_state": "SUBSCRIBED",
          "consent_updated_at": new Date(),
          "marketing_opt_in_level": "SINGLE_OPT_IN"
        };
      } else {
        formData[current_key] = current_key.indexOf("optin_") > -1 ? true : value;
      }
    }
    CF.customer.set(formData);
    let customerSaveOptions = {
      redirect: false,
      login: true,
      redirectUrl: "/account",
      formId: this.#CFformID
    };
    CF.customer.save(customerSaveOptions).then((errorObj) => {
      if (errorObj) {
        console.error("CF.customer.save", errorObj);
        this.querySelector('button[type="submit"]:not(.link)').classList.remove("button--loading");
        if (errorObj.phone) {
          this.#errorFormMessage.querySelector("[data-content]").innerText = window.themeVariables.strings.customer.register.phone_error;
        }
        if (errorObj.email) {
          this.#errorFormMessage.querySelector("[data-content]").innerText = window.themeVariables.strings.customer.register.email_error;
        }
        if (errorObj) {
          this.#errorFormMessage.removeAttribute("hidden");
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      document.dispatchEvent(new CustomEvent("gtm:custom-event", {
        bubbles: true,
        detail: {
          event: "uaevent",
          action: "Validation",
          category: "Form",
          label: "Account creation"
        }
      }));
    }).catch(function(error) {
      alert("Failed to save customer! :(");
      console.error(error);
    });
    return false;
  }
};
var AccountCustomerInfo = class extends HTMLElement {
  #form;
  #CFformID;
  #successFormMessage;
  constructor() {
    super();
    this.#form = this.querySelector("#update-customer-form");
    this.#successFormMessage = this.#form.querySelector(".alert--success");
    this.#CFformID = this.getAttribute("data-form-id");
    CF.customerReady(() => {
      this._getCustomerInfos();
      this.#form.addEventListener("submit", this._submitForm.bind(this));
    });
  }
  _getCustomerInfos() {
    let data = CF.customer.get("gender", "birthday", "optin_email", "optin_sms", "optin_phone", "email_marketing_consent");
    if (data.gender)
      this.#form.querySelector('[name="customer[gender]"][value="' + data.gender + '"]').checked = true;
    if (data.birthday)
      this.#form.querySelector('[name="customer[birthday]"]').value = new Date(data.birthday).toLocaleDateString();
    if (data.optin_sms)
      this.#form.querySelector('[name="customer[optin_sms]"]').checked = true;
    if (data.optin_phone)
      this.#form.querySelector('[name="customer[optin_phone]"]').checked = true;
    if (data.email_marketing_consent.marketing_state === "SUBSCRIBED")
      this.#form.querySelector('[name="customer[email_marketing_consent][marketing_state]"]').checked = true;
  }
  _submitForm(event) {
    event.preventDefault();
    let formData = {};
    Array.from(this.#form.querySelectorAll("input")).forEach((el) => {
      let current_name = el.getAttribute("name");
      let current_key = current_name.substring(current_name.indexOf("[") + 1, current_name.lastIndexOf("]"));
      if (current_key === "gender" && el.checked)
        formData[current_key] = el.value;
      else if (current_key.indexOf("optin_") > -1)
        formData[current_key] = el.checked;
      else if (current_key.indexOf("email_marketing_consent") > -1)
        formData["email_marketing_consent"] = {
          "marketing_state": el.checked ? "SUBSCRIBED" : "UNSUBSCRIBED",
          "consent_updated_at": new Date(),
          "marketing_opt_in_level": "SINGLE_OPT_IN"
        };
      else if (current_key !== "gender")
        formData[current_key] = el.value;
    });
    CF.customer.set(formData);
    let customerSaveOptions = {
      redirect: false,
      formId: this.#CFformID
    };
    CF.customer.save(customerSaveOptions).then((errorObj) => {
      this.#form.querySelector('button[type="submit"]:not(.link)').classList.remove("button--loading");
      this.#successFormMessage.hidden = false;
      setTimeout(() => {
        this.#successFormMessage.hidden = true;
      }, 5e3);
      if (errorObj) {
        console.error("CF.customer.save", errorObj);
      } else {
        console.log("customer has been saved !");
      }
    }).catch(function(error) {
      alert("Failed to save customer! :(");
      console.error(error);
    });
    return false;
  }
};
if (!window.customElements.get("account-login")) {
  window.customElements.define("account-login", AccountLogin);
}
if (!window.customElements.get("account-register")) {
  window.customElements.define("account-register", AccountRegister);
}
if (!window.customElements.get("account-form")) {
  window.customElements.define("account-form", AccountForm);
}
if (!window.customElements.get("account-customer-info")) {
  window.customElements.define("account-customer-info", AccountCustomerInfo);
}

// dev/src/js/sections/faq.js
var _observer, _onObserve, onObserve_fn;
var FaqToc = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onObserve);
    __privateAdd(this, _observer, new IntersectionObserver(__privateMethod(this, _onObserve, onObserve_fn).bind(this), { rootMargin: "0px 0px -70% 0px" }));
  }
  connectedCallback() {
    this.anchoredElements.forEach((anchoredElement) => __privateGet(this, _observer).observe(anchoredElement));
  }
  disconnectedCallback() {
    __privateGet(this, _observer).disconnect();
  }
  get anchorLinks() {
    return Array.from(this.querySelectorAll('a[href^="#"]'));
  }
  get anchoredElements() {
    return this.anchorLinks.map((anchor) => document.querySelector(anchor.getAttribute("href")));
  }
};
_observer = new WeakMap();
_onObserve = new WeakSet();
onObserve_fn = function(entries) {
  for (const entry of entries) {
    const anchorLink = this.anchorLinks.find((anchor) => anchor.getAttribute("href") === `#${entry.target.id}`);
    if (!entry.isIntersecting && anchorLink.classList.contains("is-active")) {
      continue;
    }
    if (entry.isIntersecting) {
      this.anchorLinks.forEach((link) => {
        link.classList.toggle("is-active", link === anchorLink);
        if (link === anchorLink && this.scrollWidth !== this.clientWidth) {
          this.scrollTo({
            left: link.offsetLeft - this.clientWidth / 2 + link.clientWidth / 2,
            behavior: "smooth"
          });
        }
      });
    }
  }
};
if (!window.customElements.get("faq-toc")) {
  window.customElements.define("faq-toc", FaqToc);
}

// dev/src/js/sections/featured-collection.js
var FeaturedCollection = class extends HTMLElement {
  connectedCallback() {
    this.allTabs.forEach((tab) => {
      tab.addEventListener("click", this.handleTabClick.bind(this));
    });
  }
  get allTabs() {
    return this.querySelectorAll(".featured-collection__tabs");
  }
  handleTabClick(event) {
    this.scrollToTab(event.target);
  }
  scrollToTab(tab) {
    const wrapper = this.querySelector(".content-tabs").shadowRoot.querySelector('slot[role="tablist"]');
    const tabRect = tab.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();
    const offset = tabRect.left - wrapperRect.left + wrapper.scrollLeft;
    const centeredPosition = offset - (wrapperRect.width - tabRect.width) / 2;
    wrapper.scrollTo({
      left: centeredPosition,
      behavior: "smooth"
    });
  }
};
if (!window.customElements.get("featured-collection")) {
  window.customElements.define("featured-collection", FeaturedCollection);
}

// dev/src/js/sections/header.js
import { animate as animate15, timeline as timeline9, stagger as stagger2, Delegate as Delegate6 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _onScrollListener2, _offset2, _onScroll3, onScroll_fn3, _recalculateOffset, recalculateOffset_fn;
var Header = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onScroll3);
    __privateAdd(this, _recalculateOffset);
    __privateAdd(this, _onScrollListener2, throttle(__privateMethod(this, _onScroll3, onScroll_fn3).bind(this)));
    __privateAdd(this, _offset2, matchesMediaQuery("lg") ? 108 : 10);
  }
  connectedCallback() {
    if (window.CSS.supports("selector(:has(.foo))")) {
      window.addEventListener("scroll", __privateGet(this, _onScrollListener2));
      new ResizeObserver(__privateMethod(this, _recalculateOffset, recalculateOffset_fn).bind(this)).observe(this);
    } else if (matchesMediaQuery("lg")) {
      window.addEventListener("scroll", __privateGet(this, _onScrollListener2));
    }
    __privateMethod(this, _onScroll3, onScroll_fn3).call(this);
  }
};
_onScrollListener2 = new WeakMap();
_offset2 = new WeakMap();
_onScroll3 = new WeakSet();
onScroll_fn3 = function() {
  const isScrolled = window.scrollY > __privateGet(this, _offset2);
  this.classList.toggle("active", isScrolled);
};
_recalculateOffset = new WeakSet();
recalculateOffset_fn = function() {
  const previousSibling = this.closest(".shopify-section").previousElementSibling;
  if (previousSibling.classList.contains("shopify-section--announcement-bar")) {
    const computedStyles = getComputedStyle(document.documentElement), isAnnouncementBarSticky = parseInt(computedStyles.getPropertyValue("--announcement-bar-is-sticky") || 0);
    if (isAnnouncementBarSticky === 1) {
      __privateSet(this, _offset2, matchesMediaQuery("lg") ? 108 : 10);
    } else {
      __privateSet(this, _offset2, previousSibling.clientHeight);
    }
  } else {
    __privateSet(this, _offset2, matchesMediaQuery("lg") ? 108 : 10);
  }
};
var _collapsiblePanel, _buttonElements, _headerElement2, _offset3, _openCollapsiblePanel, openCollapsiblePanel_fn, _onSidebarBeforeShow, onSidebarBeforeShow_fn, _onSidebarAfterShow, onSidebarAfterShow_fn, _onSidebarBeforeHide, onSidebarBeforeHide_fn, _onSidebarAfterHide, onSidebarAfterHide_fn;
var HeaderSidebar = class extends Drawer {
  constructor() {
    super();
    __privateAdd(this, _openCollapsiblePanel);
    __privateAdd(this, _onSidebarBeforeShow);
    __privateAdd(this, _onSidebarAfterShow);
    __privateAdd(this, _onSidebarBeforeHide);
    __privateAdd(this, _onSidebarAfterHide);
    __privateAdd(this, _collapsiblePanel, void 0);
    __privateAdd(this, _buttonElements, void 0);
    __privateAdd(this, _headerElement2, void 0);
    __privateAdd(this, _offset3, 10);
    this.addEventListener("dialog:before-show", __privateMethod(this, _onSidebarBeforeShow, onSidebarBeforeShow_fn));
    this.addEventListener("dialog:after-show", __privateMethod(this, _onSidebarAfterShow, onSidebarAfterShow_fn));
    this.addEventListener("dialog:before-hide", __privateMethod(this, _onSidebarBeforeHide, onSidebarBeforeHide_fn));
    this.addEventListener("dialog:after-hide", __privateMethod(this, _onSidebarAfterHide, onSidebarAfterHide_fn));
  }
  connectedCallback() {
    super.connectedCallback();
    __privateSet(this, _headerElement2, document.querySelector("header.header"));
    __privateSet(this, _collapsiblePanel, this.querySelector('[slot="collapsible-panel"]'));
    __privateSet(this, _buttonElements, Array.from(this.querySelectorAll(".header-sidebar__main-panel .header-sidebar__linklist [aria-controls]")));
    __privateGet(this, _buttonElements).forEach((button) => button.addEventListener("click", __privateMethod(this, _openCollapsiblePanel, openCollapsiblePanel_fn).bind(this), { signal: this.abortController.signal }));
  }
  revealItems(withDelay = false) {
    return timeline9([
      [this.querySelector(".header-sidebar__main-panel"), { opacity: 1, transform: "translateX(0)" }, { duration: 0, delay: withDelay ? 0.5 : 0 }],
      [this.querySelectorAll(".header-sidebar__main-panel .header-sidebar__linklist li"), { opacity: [0, 1], transform: ["translateY(8px)", "translateY(0)"] }, { duration: 0.15, at: "-0.15", delay: stagger2(0.05) }],
      [this.querySelector(".header-sidebar__footer"), { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 }]
    ]);
  }
};
_collapsiblePanel = new WeakMap();
_buttonElements = new WeakMap();
_headerElement2 = new WeakMap();
_offset3 = new WeakMap();
_openCollapsiblePanel = new WeakSet();
openCollapsiblePanel_fn = function(event) {
  __privateGet(this, _buttonElements).forEach((button) => button.setAttribute("aria-expanded", button === event.target ? "true" : "false"));
  __privateGet(this, _collapsiblePanel)?.setAttribute("aria-activedescendant", event.target.getAttribute("aria-controls"));
  if (matchesMediaQuery("lg-max")) {
    animate15(this.querySelector(".header-sidebar__main-panel"), { opacity: [1, 0], transform: ["translateX(0)", "translateX(-10px)"] }, { duration: 0.25 });
  }
};
_onSidebarBeforeShow = new WeakSet();
onSidebarBeforeShow_fn = function() {
  __privateGet(this, _headerElement2).setAttribute("open", "");
  __privateGet(this, _headerElement2).classList.add("active");
  if (document.querySelector(".shopify-section--announcement-bar")) {
    document.documentElement.style.setProperty("--announcement-bar-is-sticky", window.scrollY > __privateGet(this, _offset3) ? "0" : "1");
  }
  animate15(this.querySelector(".header-sidebar__main-panel"), { opacity: 0, transform: "translateX(0)" }, { duration: 0 });
};
_onSidebarAfterShow = new WeakSet();
onSidebarAfterShow_fn = function() {
  this.revealItems();
};
_onSidebarBeforeHide = new WeakSet();
onSidebarBeforeHide_fn = function() {
  __privateGet(this, _headerElement2).removeAttribute("open");
  __privateGet(this, _headerElement2).classList.remove("active");
  if (matchesMediaQuery("md")) {
    __privateGet(this, _collapsiblePanel)?.removeAttribute("aria-activedescendant");
    __privateGet(this, _buttonElements).forEach((button) => button.setAttribute("aria-expanded", "false"));
  }
};
_onSidebarAfterHide = new WeakSet();
onSidebarAfterHide_fn = function() {
  if (matchesMediaQuery("lg-max")) {
    __privateGet(this, _collapsiblePanel)?.removeAttribute("aria-activedescendant");
    __privateGet(this, _buttonElements).forEach((button) => button.setAttribute("aria-expanded", "false"));
  }
  Array.from(this.querySelectorAll("details")).forEach((detail) => detail.open = false);
};
var _sidebarDelegate, _closePanel, closePanel_fn, _switchPanel, switchPanel_fn;
var HeaderSidebarCollapsiblePanel = class extends DialogElement {
  constructor() {
    super();
    __privateAdd(this, _closePanel);
    __privateAdd(this, _switchPanel);
    __privateAdd(this, _sidebarDelegate, new Delegate6(this));
    __privateGet(this, _sidebarDelegate).on("click", '[data-action="close-panel"]', __privateMethod(this, _closePanel, closePanel_fn).bind(this));
  }
  static get observedAttributes() {
    return [...super.observedAttributes, "aria-activedescendant"];
  }
  hideForOutsideClickTarget(target) {
    return false;
  }
  allowOutsideClickForTarget(target) {
    return target.closest(".header-sidebar") !== void 0;
  }
  createEnterAnimationControls() {
    if (matchesMediaQuery("lg-max")) {
      return timeline9([
        [this, { opacity: [0, 1], transform: "translateX(0)" }, { duration: 0.3 }]
      ]);
    } else {
      return timeline9([
        [this, { opacity: [0, 1], transform: ["translateX(0)", "translateX(100%)"] }, { duration: 0.3 }]
      ]);
    }
  }
  createLeaveAnimationControls() {
    if (matchesMediaQuery("lg-max")) {
      return timeline9([
        [this, { opacity: [1, 0], transform: ["translateX(0)", "translateX(10px)"] }, { duration: 0.3 }]
      ]);
    } else {
      return timeline9([
        [this, { opacity: [1, 0], transform: ["translateX(100%)", "translateX(0)"] }, { duration: 0.3 }]
      ]);
    }
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "aria-activedescendant") {
      if (oldValue === newValue) {
        return;
      }
      if (newValue !== null) {
        __privateMethod(this, _switchPanel, switchPanel_fn).call(this, this.querySelector(`#${oldValue}`), this.querySelector(`#${newValue}`));
      } else {
        await this.hide();
        Array.from(this.querySelectorAll(".header-sidebar__sub-panel")).forEach((subPanel) => subPanel.hidden = true);
      }
    }
  }
};
_sidebarDelegate = new WeakMap();
_closePanel = new WeakSet();
closePanel_fn = function() {
  this.removeAttribute("aria-activedescendant");
  this.closest("header-sidebar").revealItems(true);
};
_switchPanel = new WeakSet();
switchPanel_fn = async function(fromPanel, toPanel) {
  if (!this.open) {
    await this.show();
  }
  if (fromPanel) {
    await animate15(fromPanel, { opacity: [1, 0] }, { duration: 0.15 }).finished;
    fromPanel.hidden = true;
    Array.from(fromPanel.querySelectorAll("details")).forEach((detail) => detail.open = false);
  }
  toPanel.hidden = false;
  const listSelector = matchesMediaQuery("lg-max") ? ".header-sidebar__back-button, .header-sidebar__linklist li" : ".header-sidebar__linklist li";
  timeline9([
    [toPanel, { opacity: 1 }, { duration: 0 }],
    [toPanel.querySelectorAll(listSelector), { opacity: [0, 1], transform: ["translateY(8px)", "translateY(0)"] }, { duration: 0.15, at: "-0.15", delay: stagger2(0.05) }],
    [toPanel.querySelector(".header-sidebar__promo"), { opacity: [0, 1] }, { duration: 0.45 }]
  ]);
};
var DropdownMenuDisclosure = class extends MenuDisclosure {
  createShowAnimationControls() {
    return timeline9([
      [this.contentElement, { opacity: [0, 1] }, { duration: 0.25 }],
      [this.contentElement.querySelectorAll(":scope > li"), { opacity: [0, 1], transform: ["translateY(8px)", "translateY(0)"] }, { duration: 0.15, at: "-0.15", delay: stagger2(0.05) }]
    ]);
  }
  createHideAnimationControls() {
    return timeline9([
      [this.contentElement, { opacity: [1, 0] }, { duration: 0.15, delay: 0.1625 }]
    ]);
  }
};
var _onClick, onClick_fn;
var MobileSearchButton = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onClick);
    this.searchButton = this.querySelector(".header-searchbar__input");
    this.addEventListener("click", __privateMethod(this, _onClick, onClick_fn).bind(this));
  }
};
_onClick = new WeakSet();
onClick_fn = function() {
  setTimeout(() => {
    const inputElement = document.querySelector(".search-drawer__header input");
    if (inputElement) {
      inputElement.focus();
    }
  }, 100);
};
if (!window.customElements.get("header-nav")) {
  window.customElements.define("header-nav", Header, { extends: "header" });
}
if (!window.customElements.get("header-sidebar")) {
  window.customElements.define("header-sidebar", HeaderSidebar);
}
if (!window.customElements.get("header-sidebar-collapsible-panel")) {
  window.customElements.define("header-sidebar-collapsible-panel", HeaderSidebarCollapsiblePanel);
}
if (!window.customElements.get("dropdown-menu-disclosure")) {
  window.customElements.define("dropdown-menu-disclosure", DropdownMenuDisclosure, { extends: "details" });
}
if (!window.customElements.get("mobile-search-button")) {
  window.customElements.define("mobile-search-button", MobileSearchButton);
}

// dev/src/js/sections/image-with-tabs.js
var ImageWithTabs = class extends Tabs {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("slot:changed", this.toggleImage.bind(this));
  }
  get controlledImageList() {
    return document.getElementById(this.getAttribute("controlled-image-list"))?.children;
  }
  toggleImage(event) {
    if (this.controlledImageList) {
      const imageToShow = document.getElementById(event.detail.panelToShow.getAttribute("data-image"));
      const imageToHide = document.getElementById(event.detail.panelToHide.getAttribute("data-image"));
      if (imageToShow && imageToHide) {
        this.transition(imageToHide, imageToShow);
      }
    }
  }
};
if (!window.customElements.get("image-with-tabs")) {
  window.customElements.define("image-with-tabs", ImageWithTabs);
}

// dev/src/js/sections/instagram-feed.js
import { inView as inView8, animate as animate16, stagger as stagger3 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var InstagramFeed = class extends ScrollCarousel {
  connectedCallback() {
    this.instagramList = this.querySelector(".feed-instagram__list");
    inView8(this, this.reveal.bind(this), { margin: "0px 0px 0px 0px" });
  }
  async fetchMedia() {
    const response = await fetch(`https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=${Shopify.shop}&resource=default`);
    const responseJson = await response.json();
    if (response.ok) {
      for (let i = 0; i < responseJson.length; i++) {
        let media = responseJson[i];
        if (media.media_type !== "VIDEO") {
          let imgElement = document.createElement("img");
          imgElement.src = media.media_url;
          imgElement.setAttribute("reveal-on-scroll", "true");
          this.instagramList.append(imgElement);
        }
      }
    }
  }
  reveal() {
    this.fetchMedia().then((r) => {
      this.style.opacity = "1";
      animate16(
        this.instagramList.children,
        { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] },
        { duration: 0.25, delay: stagger3(0.025, { easing: "ease-out" }), easing: "ease" }
      );
    });
  }
};
if (!window.customElements.get("instagram-feed")) {
  window.customElements.define("instagram-feed", InstagramFeed);
}

// dev/src/js/sections/madura-at-home.js
var MaduraAtHome = class extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }
  connectedCallback() {
    this.setupObserver();
  }
  get imageContainer() {
    return this.querySelector(".madura-at-home__wrapper");
  }
  get backgroundImages() {
    return this.querySelectorAll(".madura-at-home__images img");
  }
  get textContent() {
    return this.querySelector(".madura-at-home__content");
  }
  setupObserver() {
    const options = {
      root: null,
      threshold: 0.7
    };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let textTransition = 500;
          if (matchMedia("md").matches) {
            textTransition = 800;
          }
          setTimeout(() => {
            this.setAttribute("data-in-view", "true");
          }, 500);
          setTimeout(() => {
            this.textContent.style.setProperty("--text-color", "rgb(var(--color-white))");
          }, textTransition);
        }
      });
    }, options);
    this.observer.observe(this);
  }
};
if (!window.customElements.get("madura-at-home")) {
  window.customElements.define("madura-at-home", MaduraAtHome);
}

// dev/src/js/sections/order.js
var OrderDetails = class extends HTMLElement {
  connectedCallback() {
    this.checkInvoicesAndDisplayMessages();
  }
  async checkInvoicesAndDisplayMessages() {
    if (this.getAttribute("fullURL") != "") {
      try {
        let response = await fetch(this.getAttribute("fullURL"), {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });
        if (response.status === 403) {
          this.invoiceMessageManager(false);
        } else {
          this.invoiceMessageManager(true);
        }
      } catch (error) {
        console.error("error", error);
        this.invoiceMessageManager(false);
      }
    }
  }
  invoiceMessageManager(show) {
    let errorMessage = this.querySelector('[data-invoice-error="true"]');
    let invoiceMessage = this.querySelector('[data-invoice-error="false"]');
    if (show) {
      if (errorMessage) {
        errorMessage.style.display = "none";
      }
      if (invoiceMessage) {
        invoiceMessage.style.display = "flex";
      }
    } else {
      if (errorMessage) {
        errorMessage.style.display = "inline-block";
      }
      if (invoiceMessage) {
        invoiceMessage.style.display = "none";
      }
    }
  }
};
if (!window.customElements.get("order-details")) {
  window.customElements.define("order-details", OrderDetails);
}

// dev/src/js/sections/phone-availability.js
var _scheduleWeekDays, _scheduleWeekendDays, _onlineElement, _offlineElement, _scheduleWeekDaysHourStart, _scheduleWeekDaysHourEnd, _scheduleWeekendDaysHourStart, _scheduleWeekendDaysHourEnd, _getCurrentHour, getCurrentHour_fn;
var PhoneAvailability = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _getCurrentHour);
    __privateAdd(this, _scheduleWeekDays, void 0);
    __privateAdd(this, _scheduleWeekendDays, void 0);
    __privateAdd(this, _onlineElement, void 0);
    __privateAdd(this, _offlineElement, void 0);
    __privateAdd(this, _scheduleWeekDaysHourStart, void 0);
    __privateAdd(this, _scheduleWeekDaysHourEnd, void 0);
    __privateAdd(this, _scheduleWeekendDaysHourStart, void 0);
    __privateAdd(this, _scheduleWeekendDaysHourEnd, void 0);
  }
  connectedCallback() {
    __privateSet(this, _scheduleWeekDays, this.getAttribute("data-schedule-week").split("-"));
    __privateSet(this, _scheduleWeekDaysHourStart, parseInt(__privateGet(this, _scheduleWeekDays)[0].split(":")[0]));
    __privateSet(this, _scheduleWeekDaysHourEnd, parseInt(__privateGet(this, _scheduleWeekDays)[1].split(":")[0]));
    __privateSet(this, _scheduleWeekendDays, this.getAttribute("data-schedule-weekend").split("-"));
    __privateSet(this, _scheduleWeekendDaysHourStart, parseInt(__privateGet(this, _scheduleWeekendDays)[0].split(":")[0]));
    __privateSet(this, _scheduleWeekendDaysHourEnd, parseInt(__privateGet(this, _scheduleWeekendDays)[1].split(":")[0]));
    __privateSet(this, _onlineElement, this.querySelector('[data-phone-availability="true"]'));
    __privateSet(this, _offlineElement, this.querySelector('[data-phone-availability="false"]'));
    __privateMethod(this, _getCurrentHour, getCurrentHour_fn).call(this);
  }
};
_scheduleWeekDays = new WeakMap();
_scheduleWeekendDays = new WeakMap();
_onlineElement = new WeakMap();
_offlineElement = new WeakMap();
_scheduleWeekDaysHourStart = new WeakMap();
_scheduleWeekDaysHourEnd = new WeakMap();
_scheduleWeekendDaysHourStart = new WeakMap();
_scheduleWeekendDaysHourEnd = new WeakMap();
_getCurrentHour = new WeakSet();
getCurrentHour_fn = function() {
  let parisDatetime = new Date().toLocaleString("en-US", { timeZone: "Europe/Paris" });
  let currentDate = new Date(parisDatetime);
  if (currentDate.getDay() < 5) {
    __privateGet(this, _onlineElement).hidden = !(currentDate.getHours() >= __privateGet(this, _scheduleWeekendDaysHourStart) && currentDate.getHours() < __privateGet(this, _scheduleWeekendDaysHourEnd));
    __privateGet(this, _offlineElement).hidden = !(currentDate.getHours() < __privateGet(this, _scheduleWeekendDaysHourStart) && currentDate.getHours() > __privateGet(this, _scheduleWeekendDaysHourEnd));
  } else {
    __privateGet(this, _onlineElement).hidden = !(currentDate.getHours() >= __privateGet(this, _scheduleWeekDaysHourStart) && currentDate.getHours() < __privateGet(this, _scheduleWeekDaysHourEnd));
    __privateGet(this, _offlineElement).hidden = !(currentDate.getHours() < __privateGet(this, _scheduleWeekDaysHourStart) && currentDate.getHours() > __privateGet(this, _scheduleWeekDaysHourEnd));
  }
};
if (!window.customElements.get("phone-availability")) {
  window.customElements.define("phone-availability", PhoneAvailability);
}

// dev/src/js/sections/product.js
var _intersectionObserver2, _formElement, _formContainer2, _footerElement, _availableButtons, _unavailableButtons, _backToTopIcon, _bodyElement, _stickyQuantity, _latestFooterCondition, _latestFormCondition, _onFormVisibilityChange, onFormVisibilityChange_fn, _onVariantChangedListener22, onVariantChangedListener_fn6, _onQuantityChangedListener2, onQuantityChangedListener_fn2;
var ProductStickyBar = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onFormVisibilityChange);
    __privateAdd(this, _onVariantChangedListener22);
    __privateAdd(this, _onQuantityChangedListener2);
    __privateAdd(this, _intersectionObserver2, new IntersectionObserver(__privateMethod(this, _onFormVisibilityChange, onFormVisibilityChange_fn).bind(this)));
    __privateAdd(this, _formElement, void 0);
    __privateAdd(this, _formContainer2, void 0);
    __privateAdd(this, _footerElement, void 0);
    __privateAdd(this, _availableButtons, void 0);
    __privateAdd(this, _unavailableButtons, void 0);
    __privateAdd(this, _backToTopIcon, void 0);
    __privateAdd(this, _bodyElement, void 0);
    __privateAdd(this, _stickyQuantity, void 0);
    __privateAdd(this, _latestFooterCondition, false);
    __privateAdd(this, _latestFormCondition, false);
  }
  connectedCallback() {
    __privateSet(this, _formElement, document.forms[this.getAttribute("form")]);
    __privateSet(this, _formContainer2, document.querySelector(".form-container"));
    __privateSet(this, _footerElement, document.querySelector(".shopify-section--main-footer"));
    __privateSet(this, _availableButtons, document.querySelector(".sticky-available-buttons"));
    __privateSet(this, _unavailableButtons, document.querySelector(".sticky-unavailable-buttons"));
    __privateSet(this, _stickyQuantity, document.querySelector(".product-sticky-bar .quantity-selector__input"));
    __privateSet(this, _backToTopIcon, document.querySelector(".button--back-to-top"));
    __privateSet(this, _bodyElement, document.querySelector("body"));
    if (__privateGet(this, _formContainer2)) {
      __privateGet(this, _intersectionObserver2).observe(__privateGet(this, _formContainer2));
      __privateGet(this, _intersectionObserver2).observe(__privateGet(this, _footerElement));
    }
    __privateGet(this, _formElement).addEventListener("variant:change", __privateMethod(this, _onVariantChangedListener22, onVariantChangedListener_fn6).bind(this));
    __privateGet(this, _formElement).addEventListener("quantity:change", __privateMethod(this, _onQuantityChangedListener2, onQuantityChangedListener_fn2).bind(this));
  }
};
_intersectionObserver2 = new WeakMap();
_formElement = new WeakMap();
_formContainer2 = new WeakMap();
_footerElement = new WeakMap();
_availableButtons = new WeakMap();
_unavailableButtons = new WeakMap();
_backToTopIcon = new WeakMap();
_bodyElement = new WeakMap();
_stickyQuantity = new WeakMap();
_latestFooterCondition = new WeakMap();
_latestFormCondition = new WeakMap();
_onFormVisibilityChange = new WeakSet();
onFormVisibilityChange_fn = function(entries) {
  const [formEntry, footerEntry] = [entries.find((entry) => entry.target === __privateGet(this, _formContainer2)), entries.find((entry) => entry.target === __privateGet(this, _footerElement))];
  if (formEntry) {
    __privateSet(this, _latestFormCondition, !formEntry.isIntersecting && formEntry.boundingClientRect.bottom < 0);
  }
  if (footerEntry) {
    __privateSet(this, _latestFooterCondition, !footerEntry.isIntersecting);
  }
  this.classList.toggle("is-visible", __privateGet(this, _latestFooterCondition) && __privateGet(this, _latestFormCondition));
  __privateGet(this, _bodyElement).classList.toggle("template-product-sticky", __privateGet(this, _latestFooterCondition) && __privateGet(this, _latestFormCondition));
  __privateGet(this, _backToTopIcon).classList.toggle("button--back-to-top-sticky", __privateGet(this, _latestFooterCondition) && __privateGet(this, _latestFormCondition));
};
_onVariantChangedListener22 = new WeakSet();
onVariantChangedListener_fn6 = function(event) {
  event.detail.variant.available ? (__privateGet(this, _availableButtons).setAttribute("aria-hidden", "false"), __privateGet(this, _unavailableButtons).setAttribute("aria-hidden", "true")) : (__privateGet(this, _availableButtons).setAttribute("aria-hidden", "true"), __privateGet(this, _unavailableButtons).setAttribute("aria-hidden", "false"));
};
_onQuantityChangedListener2 = new WeakSet();
onQuantityChangedListener_fn2 = function(event) {
  __privateGet(this, _stickyQuantity).value = event.detail.quantity;
};
if (!window.customElements.get("product-sticky-bar")) {
  window.customElements.define("product-sticky-bar", ProductStickyBar);
}

// dev/src/js/sections/product-recommendations.js
var _isLoaded2, _onMediaQueryChange, _init, init_fn, _getTargetElement, getTargetElement_fn, _moveSectionTo, moveSectionTo_fn, _loadRecommendations2, loadRecommendations_fn2;
var ProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _init);
    __privateAdd(this, _getTargetElement);
    __privateAdd(this, _moveSectionTo);
    __privateAdd(this, _loadRecommendations2);
    __privateAdd(this, _isLoaded2, false);
    __privateAdd(this, _onMediaQueryChange, __privateMethod(this, _init, init_fn).bind(this, false));
    __privateMethod(this, _init, init_fn).call(this, true);
    mediaQueryListener("int", __privateGet(this, _onMediaQueryChange));
    mediaQueryListener("md", __privateGet(this, _onMediaQueryChange));
    mediaQueryListener("md-max", __privateGet(this, _onMediaQueryChange));
  }
  disconnectedCallback() {
    mediaQueryRemoveListener("int", __privateGet(this, _onMediaQueryChange));
    mediaQueryRemoveListener("md", __privateGet(this, _onMediaQueryChange));
    mediaQueryRemoveListener("md-max", __privateGet(this, _onMediaQueryChange));
  }
};
_isLoaded2 = new WeakMap();
_onMediaQueryChange = new WeakMap();
_init = new WeakSet();
init_fn = function(launchRecommendation = false) {
  const targetElement = __privateMethod(this, _getTargetElement, getTargetElement_fn).call(this);
  const queryTargetElement = document.querySelector(targetElement);
  if (!this.closest(targetElement)) {
    if (launchRecommendation) {
      __privateMethod(this, _loadRecommendations2, loadRecommendations_fn2).call(this);
    }
    const shouldPrepend = queryTargetElement?.classList.contains("product__description-content");
    __privateMethod(this, _moveSectionTo, moveSectionTo_fn).call(this, queryTargetElement, shouldPrepend);
  }
};
_getTargetElement = new WeakSet();
getTargetElement_fn = function() {
  if (matchesMediaQuery("md-max") || matchesMediaQuery("int")) {
    return ".product__infos-container";
  }
  if (matchesMediaQuery("md") && !matchesMediaQuery("int")) {
    return ".product__description-content";
  }
  return null;
};
_moveSectionTo = new WeakSet();
moveSectionTo_fn = function(element, prepend = false) {
  if (!element)
    return;
  const section = this.closest(".shopify-section");
  if (section) {
    if (prepend) {
      element.prepend(section);
    } else {
      element.appendChild(section);
    }
  }
};
_loadRecommendations2 = new WeakSet();
loadRecommendations_fn2 = async function() {
  if (__privateGet(this, _isLoaded2)) {
    return;
  }
  __privateSet(this, _isLoaded2, true);
  const section = this.closest(".shopify-section"), intent = this.getAttribute("intent") || "related", url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${extractSectionId(section)}&intent=${intent}`, response = await fetch(url, { priority: intent === "related" ? "low" : "auto" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), productRecommendationsElement = tempDiv.querySelector("product-recommendations");
  if (productRecommendationsElement.childElementCount > 0) {
    this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
    this.hidden = false;
  } else {
    this.remove();
  }
};
if (!window.customElements.get("product-recommendations")) {
  window.customElements.define("product-recommendations", ProductRecommendations);
}

// dev/src/js/sections/pro-form.js
var ProCreateAccountForm = class extends HTMLFormElement {
  #siretInput;
  #errorFormMessage;
  #formWrapper;
  #CFformID;
  submitButton;
  constructor() {
    super();
    this.#CFformID = this.getAttribute("data-form-id");
    CF.customerReady(() => {
      this.addEventListener("submit", this._submitForm.bind(this));
    });
    this.submitButton = this.querySelector('button[type="submit"]');
  }
  connectedCallback() {
    this.#siretInput = this.querySelector('input[name="siret"]');
    this.#errorFormMessage = this.querySelectorAll(".alert--error");
    this.#formWrapper = this.querySelector(".pro-form__wrapper");
  }
  _validateSiret() {
    const siretRegex = /^[0-9]{14}$/;
    return siretRegex.test(this.#siretInput.value);
  }
  _hideAllErrors() {
    this.#errorFormMessage.forEach((error) => error.setAttribute("hidden", ""));
  }
  _showErrorFor(fieldName) {
    const errorElement = this.querySelector(`.error-${fieldName}`);
    if (errorElement) {
      errorElement.removeAttribute("hidden");
    }
  }
  _handleFormSubmission(isSuccess, errorType = "") {
    this.submitButton.classList.remove("button--loading");
    this._hideAllErrors();
    if (isSuccess) {
      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        "event": "lead_b2b_created",
        "email": this.querySelector('input[name="email"]').value,
        "type_of_lead": sessionStorage.getItem("trafficSource")
      });
      const successMessageContainer = this.querySelector(".pro-form__success");
      if (successMessageContainer) {
        successMessageContainer.classList.remove("hidden");
        document.querySelector(".section-pro-form").scrollIntoView({ behavior: "smooth", block: "start" });
      }
      this.#formWrapper.classList.add("hidden");
    } else {
      this.#formWrapper.classList.remove("hidden");
      if (errorType) {
        this._showErrorFor(errorType);
      }
    }
  }
  _submitBackEndFormData(formData) {
    const url = this.getAttribute("full-url");
    fetch(url, {
      method: "POST",
      contentType: "application/json",
      dataType: "json",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then((response) => {
      if (!response.ok) {
        throw new Error("Network error");
      }
      return response.json();
    }).then((data) => {
      if (data.success) {
        this._handleFormSubmission(true);
      } else {
        this._handleFormSubmission(false, "form");
      }
    }).catch((error) => {
      console.error("Fetch error:", error);
      this._handleFormSubmission(false, "form");
    });
  }
  _handleSubmit(token) {
    let formData = new FormData(this);
    formData.append("recaptcha_token", token);
    let customerData = {};
    for (const [key, value] of formData) {
      customerData[key] = value;
    }
    CF.customer.set(customerData);
    let customerSaveOptions = {
      redirect: false,
      login: false,
      formId: this.#CFformID
    };
    CF.customer.save(customerSaveOptions).then((errorObj) => {
      if (errorObj) {
        this._handleFormSubmission(false, errorObj.email ? "email" : "cfError");
      } else {
        this._submitBackEndFormData(formData);
      }
    }).catch(() => {
      this._handleFormSubmission(false, "cfFailure");
    });
  }
  _submitForm(event) {
    event.preventDefault();
    this.submitButton.classList.add("button--loading");
    this._hideAllErrors();
    if (!this._validateSiret()) {
      this._handleFormSubmission(false, "siret");
      return;
    }
    grecaptcha.ready(() => {
      grecaptcha.execute("6LfYOWQpAAAAAK7_fO4JVqAWakLDLpufaJNl3DV1", { action: "submit" }).then((token) => {
        this._handleSubmit(token);
      });
    });
  }
};
if (!window.customElements.get("pro-create-account-form")) {
  customElements.define("pro-create-account-form", ProCreateAccountForm, { extends: "form" });
}
var DrawerProContactForm = class extends HTMLFormElement {
  #formWrapper;
  #formDescription;
  #errorFormMessage;
  constructor() {
    super();
    this.addEventListener("submit", this._submitForm.bind(this));
    this.submitButton = this.querySelector('button[type="submit"]');
  }
  connectedCallback() {
    this.#formDescription = document.querySelector(".drawer__pro-description");
    this.#formWrapper = this.querySelector(".pro-form__wrapper");
    this.#errorFormMessage = this.querySelectorAll(".alert--error");
  }
  _hideAllErrors() {
    this.#errorFormMessage.forEach((error) => error.setAttribute("hidden", ""));
  }
  _showErrorFor(fieldName) {
    const errorElement = this.querySelector(`.error-${fieldName}`);
    if (errorElement) {
      errorElement.removeAttribute("hidden");
    }
  }
  _handleFormSubmission(isSuccess, errorType = "") {
    this.submitButton.classList.remove("button--loading");
    this._hideAllErrors();
    if (isSuccess) {
      const successMessageContainer = this.querySelector(".pro-form__success");
      if (successMessageContainer) {
        successMessageContainer.classList.remove("hidden");
      }
      this.#formDescription.classList.add("hidden");
      this.#formWrapper.classList.add("hidden");
    } else {
      this.#formWrapper.classList.remove("hidden");
      if (errorType) {
        this._showErrorFor(errorType);
      }
    }
  }
  _submitBackEndFormData(formData) {
    const url = this.getAttribute("full-url");
    fetch(url, {
      method: "POST",
      contentType: "application/json",
      dataType: "json",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then((response) => {
      if (!response.ok) {
        throw new Error("Network error");
      }
      return response.json();
    }).then((data) => {
      if (data.success) {
        this._handleFormSubmission(true);
      } else {
        this._handleFormSubmission(false, "form");
      }
    }).catch((error) => {
      console.error("Fetch error:", error);
      this._handleFormSubmission(false, "form");
    });
  }
  _handleSubmit(token) {
    let data = new FormData(this);
    let formData = {};
    for (const [key, value] of data) {
      if (key.indexOf("email_marketing_consent") > -1) {
        formData["email_marketing_consent"] = {
          "marketing_state": "SUBSCRIBED",
          "consent_updated_at": new Date(),
          "marketing_opt_in_level": "SINGLE_OPT_IN"
        };
      } else {
        formData[key] = key.indexOf("optin_") > -1 ? true : value;
      }
    }
    let backEndFormData = new FormData(this);
    if (!formData["email_marketing_consent"]) {
      backEndFormData.append("email_marketing_consent", "no");
    } else {
      backEndFormData.append("email_marketing_consent", "yes");
    }
    backEndFormData.append("recaptcha_token", token);
    this._submitBackEndFormData(backEndFormData);
  }
  _submitForm(event) {
    event.preventDefault();
    this.submitButton.classList.add("button--loading");
    this._hideAllErrors();
    grecaptcha.ready(() => {
      grecaptcha.execute("6LfYOWQpAAAAAK7_fO4JVqAWakLDLpufaJNl3DV1", { action: "submit" }).then((token) => {
        this._handleSubmit(token);
      });
    });
  }
};
if (!window.customElements.get("drawer-pro-contact-form")) {
  customElements.define("drawer-pro-contact-form", DrawerProContactForm, { extends: "form" });
}

// dev/src/js/sections/recently-viewed-products.js
var _isLoaded3, _observer2, _searchQueryString, searchQueryString_get, _loadProducts, loadProducts_fn, _sendRecentlyViewedToDataLayer, sendRecentlyViewedToDataLayer_fn;
var RecentlyViewedProducts = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _searchQueryString);
    __privateAdd(this, _loadProducts);
    __privateAdd(this, _sendRecentlyViewedToDataLayer);
    __privateAdd(this, _isLoaded3, false);
    __privateAdd(this, _observer2, void 0);
    __privateSet(this, _observer2, new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          __privateMethod(this, _loadProducts, loadProducts_fn).call(this).then(() => {
            __privateMethod(this, _sendRecentlyViewedToDataLayer, sendRecentlyViewedToDataLayer_fn).call(this);
          });
          __privateGet(this, _observer2).unobserve(this);
        }
      });
    }, { threshold: 0.8 }));
  }
  connectedCallback() {
    __privateGet(this, _observer2).observe(this);
  }
  disconnectedCallback() {
    if (__privateGet(this, _observer2)) {
      __privateGet(this, _observer2).disconnect();
    }
  }
};
_isLoaded3 = new WeakMap();
_observer2 = new WeakMap();
_searchQueryString = new WeakSet();
searchQueryString_get = function() {
  const items = new Set(JSON.parse(localStorage.getItem("madura:recently-viewed-products") || "[]"));
  if (this.hasAttribute("exclude-id")) {
    items.delete(parseInt(this.getAttribute("exclude-id")));
  }
  return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
};
_loadProducts = new WeakSet();
loadProducts_fn = async function() {
  if (__privateGet(this, _isLoaded3)) {
    return;
  }
  __privateSet(this, _isLoaded3, true);
  const section = this.closest(".shopify-section"), url = `${Shopify.routes.root}search?type=product&q=${__privateGet(this, _searchQueryString, searchQueryString_get)}&section_id=${extractSectionId(section)}`, response = await fetch(url, { priority: "low" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
  if (recentlyViewedProductsElement.childElementCount > 0) {
    this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
  } else {
    section.remove();
  }
};
_sendRecentlyViewedToDataLayer = new WeakSet();
sendRecentlyViewedToDataLayer_fn = function() {
  let products = [];
  Array.from(this.querySelectorAll(".product-card")).forEach((productCard) => {
    let productData = JSON.parse(productCard.getAttribute("data-json") || "{}");
    products.push({
      "name": productData.name || null,
      "id": productData.id || null,
      "item_variant": productData.item_variant || null,
      "price": productData.price || null,
      "currency": productData.currency || null,
      "brand": productData.brand || "Madura",
      "product_collection": productData.product_collection || null,
      "product_collection_parent": productData.product_collection_parent || null,
      "collection_master": productData.collection_master || null,
      "position": productData.position || null
    });
  });
  if (products.length > 0) {
    document.documentElement.dispatchEvent(new CustomEvent("productList:impression", {
      bubbles: true,
      detail: {
        jsonData: products,
        listInfos: {
          listId: this.querySelector("product-list")?.getAttribute("list-id"),
          listName: this.querySelector("product-list")?.getAttribute("list-name")
        }
      }
    }));
  }
};
if (!window.customElements.get("recently-viewed-products")) {
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}

// dev/src/js/sections/search-drawer.js
var SearchDrawer = class extends Drawer {
  get shouldAppendToBody() {
    return false;
  }
};
if (!window.customElements.get("search-drawer")) {
  window.customElements.define("search-drawer", SearchDrawer);
}

// dev/src/js/sections/shop-the-look.js
var _handleAutoplayProgress, handleAutoplayProgress_fn;
var ShopTheLookCarousel = class extends EffectCarousel {
  constructor() {
    super(...arguments);
    __privateAdd(this, _handleAutoplayProgress);
  }
  connectedCallback() {
    if (this.hasAttribute("autoplay")) {
      this.player.addEventListener("player:start", __privateMethod(this, _handleAutoplayProgress, handleAutoplayProgress_fn).bind(this));
      this.player.addEventListener("player:stop", __privateMethod(this, _handleAutoplayProgress, handleAutoplayProgress_fn).bind(this));
      this.player.addEventListener("player:visibility-pause", __privateMethod(this, _handleAutoplayProgress, handleAutoplayProgress_fn).bind(this));
      this.player.addEventListener("player:visibility-resume", __privateMethod(this, _handleAutoplayProgress, handleAutoplayProgress_fn).bind(this));
      let product = this.querySelectorAll(".shop-the-look__product");
      Array.from(product).forEach((item) => {
        item.querySelector(".shop-the-look-popover").addEventListener("dialog:after-show", () => {
          this.player.dispatchEvent(new CustomEvent("player:stop"));
          this.player.pause();
        });
        item.querySelector(".shop-the-look-modal").addEventListener("dialog:after-show", () => {
          this.player.dispatchEvent(new CustomEvent("player:stop"));
          this.player.pause();
        });
        item.querySelector(".shop-the-look-popover").addEventListener("dialog:before-hide", () => {
          this.player.dispatchEvent(new CustomEvent("player:start"));
          this.player.resume();
        });
        item.querySelector(".shop-the-look-modal").addEventListener("dialog:before-hide", () => {
          this.player.dispatchEvent(new CustomEvent("player:start"));
          this.player.resume();
        });
      });
    }
  }
};
_handleAutoplayProgress = new WeakSet();
handleAutoplayProgress_fn = function(event) {
  switch (event.type) {
    case "player:start":
      let autoplayDuration = this.getAttribute("autoplay");
      this.style.setProperty("--shop-the-look-progress-duration", `${autoplayDuration}s`);
      this.style.setProperty("--shop-the-look-progress-play-state", "running");
      break;
    case "player:stop":
      this.style.setProperty("--shop-the-look-progress-play-state", "paused");
      break;
    case "player:visibility-pause":
      this.style.setProperty("--shop-the-look-progress-play-state", "paused");
      break;
    case "player:visibility-resume":
      this.style.setProperty("--shop-the-look-progress-play-state", "running");
      break;
  }
};
if (!window.customElements.get("shop-the-look-carousel")) {
  window.customElements.define("shop-the-look-carousel", ShopTheLookCarousel);
}

// dev/src/js/sections/slideshow.js
import { timeline as timeline10, animate as animate17, Delegate as Delegate7 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
var _delegate5, _onVideoEndedListener, _autoplayPauseOnVideo, autoplayPauseOnVideo_get, _muteVideo, muteVideo_fn, _unmuteVideo, unmuteVideo_fn, _onVolumeChange, onVolumeChange_fn, _onSlideSettle, onSlideSettle_fn, _onVideoEnded, onVideoEnded_fn, _onNextButtonClicked, onNextButtonClicked_fn, _handleAutoplayProgress2, handleAutoplayProgress_fn2;
var SlideshowCarousel = class extends EffectCarousel {
  constructor() {
    super();
    __privateAdd(this, _autoplayPauseOnVideo);
    __privateAdd(this, _muteVideo);
    __privateAdd(this, _unmuteVideo);
    __privateAdd(this, _onVolumeChange);
    __privateAdd(this, _onSlideSettle);
    __privateAdd(this, _onVideoEnded);
    __privateAdd(this, _onNextButtonClicked);
    __privateAdd(this, _handleAutoplayProgress2);
    __privateAdd(this, _delegate5, new Delegate7(this));
    __privateAdd(this, _onVideoEndedListener, __privateMethod(this, _onVideoEnded, onVideoEnded_fn).bind(this));
    __privateGet(this, _delegate5).on("click", '[data-action="navigate-next"]', __privateMethod(this, _onNextButtonClicked, onNextButtonClicked_fn).bind(this));
    __privateGet(this, _delegate5).on("click", '[data-action="unmute"]', __privateMethod(this, _unmuteVideo, unmuteVideo_fn).bind(this));
    __privateGet(this, _delegate5).on("click", '[data-action="mute"]', __privateMethod(this, _muteVideo, muteVideo_fn).bind(this));
    this.addEventListener("volumechange", __privateMethod(this, _onVolumeChange, onVolumeChange_fn), { capture: true });
    this.addEventListener("carousel:settle", __privateMethod(this, _onSlideSettle, onSlideSettle_fn));
    if (this.hasAttribute("autoplay")) {
      this.player.addEventListener("player:start", __privateMethod(this, _handleAutoplayProgress2, handleAutoplayProgress_fn2).bind(this));
      this.player.addEventListener("player:stop", __privateMethod(this, _handleAutoplayProgress2, handleAutoplayProgress_fn2).bind(this));
      this.player.addEventListener("player:visibility-pause", __privateMethod(this, _handleAutoplayProgress2, handleAutoplayProgress_fn2).bind(this));
      this.player.addEventListener("player:visibility-resume", __privateMethod(this, _handleAutoplayProgress2, handleAutoplayProgress_fn2).bind(this));
    }
  }
  disconnectedCallback() {
    __privateGet(this, _delegate5).destroy();
  }
  async createOnBecameVisibleAnimationControls(toSlide) {
    if (toSlide.getAttribute("media-type") === "image") {
      await imageLoaded(toSlide.querySelectorAll("img"));
    } else {
      await videoLoaded(toSlide.querySelectorAll("video"));
    }
    return animate17(toSlide, { opacity: [0, 1] }, { duration: 0.3, easing: "ease" });
  }
  createOnChangeAnimationControls(fromSlide, toSlide, { direction } = {}) {
    const fromVideo = Array.from(fromSlide.querySelectorAll("video")), toVideo = Array.from(toSlide.querySelectorAll("video")).filter((video) => video.offsetParent);
    fromSlide.removeEventListener("ended", __privateGet(this, _onVideoEndedListener), { capture: true });
    fromVideo.forEach((video) => {
      video.muted = true;
      video.pause();
    });
    toVideo.forEach((video) => {
      video.muted = true;
      video.currentTime = 0;
      video.play();
    });
    if (direction === "next") {
      return timeline10([
        [fromSlide, { transform: ["translateX(0)", "translateX(-100%)"] }, { duration: 0.8, easing: [0.25, 0.46, 0.45, 0.94] }],
        [toSlide, { transform: ["translateX(100%)", "translateX(0)"] }, { duration: 0.8, at: "<", easing: [0.25, 0.46, 0.45, 0.94] }]
      ]);
    } else {
      return timeline10([
        [fromSlide, { transform: ["translateX(0)", "translateX(100%)"] }, { duration: 0.8, easing: [0.25, 0.46, 0.45, 0.94] }],
        [toSlide, { transform: ["translateX(-100%)", "translateX(0)"] }, { duration: 0.8, at: "<", easing: [0.25, 0.46, 0.45, 0.94] }]
      ]);
    }
  }
};
_delegate5 = new WeakMap();
_onVideoEndedListener = new WeakMap();
_autoplayPauseOnVideo = new WeakSet();
autoplayPauseOnVideo_get = function() {
  return this.hasAttribute("autoplay-pause-on-video");
};
_muteVideo = new WeakSet();
muteVideo_fn = function(event) {
  event.preventDefault();
  Array.from(this.selectedCell.querySelectorAll("video")).filter((video) => video.offsetParent).forEach((video) => video.muted = true);
};
_unmuteVideo = new WeakSet();
unmuteVideo_fn = function(event) {
  event.preventDefault();
  Array.from(this.selectedCell.querySelectorAll("video")).filter((video) => video.offsetParent).forEach((video) => video.muted = false);
};
_onVolumeChange = new WeakSet();
onVolumeChange_fn = function(event) {
  const volumeControl = event.target.closest(".slideshow__slide").querySelector(".slideshow__volume-control");
  if (volumeControl) {
    volumeControl.querySelector('[data-action="unmute"]').hidden = !event.target.muted;
    volumeControl.querySelector('[data-action="mute"]').hidden = event.target.muted;
  }
};
_onSlideSettle = new WeakSet();
onSlideSettle_fn = function(event) {
  const videoList = Array.from(event.detail.cell.querySelectorAll("video"));
  if (__privateGet(this, _autoplayPauseOnVideo, autoplayPauseOnVideo_get) && this.cells.length > 1 && videoList.length > 0) {
    this.player?.pause();
    videoList.forEach((video) => video.loop = false);
    event.detail.cell.addEventListener("ended", __privateGet(this, _onVideoEndedListener), { capture: true, once: true });
  }
};
_onVideoEnded = new WeakSet();
onVideoEnded_fn = function() {
  this.next();
};
_onNextButtonClicked = new WeakSet();
onNextButtonClicked_fn = function() {
  this.closest(".shopify-section").nextElementSibling?.scrollIntoView({ block: "start", behavior: "smooth" });
};
_handleAutoplayProgress2 = new WeakSet();
handleAutoplayProgress_fn2 = function(event) {
  switch (event.type) {
    case "player:start":
      let autoplayDuration = this.getAttribute("autoplay");
      if (__privateGet(this, _autoplayPauseOnVideo, autoplayPauseOnVideo_get) && this.selectedCell.getAttribute("media-type") === "video") {
        const video = Array.from(this.selectedCell.querySelectorAll("video")).filter((video2) => video2.offsetParent).pop();
        if (video) {
          autoplayDuration = video.duration;
        }
      }
      this.style.setProperty("--slideshow-progress-duration", `${autoplayDuration}s`);
      this.style.setProperty("--slideshow-progress-play-state", "running");
      break;
    case "player:stop":
      this.style.setProperty("--slideshow-progress-duration", `0s`);
      this.style.setProperty("--slideshow-progress-play-state", "paused");
      break;
    case "player:visibility-pause":
      this.style.setProperty("--slideshow-progress-play-state", "paused");
      break;
    case "player:visibility-resume":
      this.style.setProperty("--slideshow-progress-play-state", "running");
      break;
  }
};
if (!window.customElements.get("slideshow-carousel")) {
  window.customElements.define("slideshow-carousel", SlideshowCarousel);
}

// dev/src/js/sections/store-locator.js
var StoreLocator = class extends HTMLElement {
  connectedCallback() {
    mapboxgl.accessToken = "pk.eyJ1IjoibWFldmFwYXN0ZXVyIiwiYSI6ImNrb282eDRuNTA4ajAydG51cnBrdWhwaDcifQ.IrhI8RAeoBGuDYDdQVPPKg";
    this.map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/mapbox/light-v10",
      center: [2.61878695312962, 47.8249046208979],
      zoom: 4.1
    });
    this.map.scrollZoom.disable();
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.on("load", () => {
      this.map.loadImage(this.getAttribute("data-pin"), (error, image) => {
        if (error)
          throw error;
        this.map.addSource("stores", {
          type: "geojson",
          data: this.data,
          cluster: true,
          clusterMaxZoom: 14,
          clusterRadius: 50
        });
        this.map.addImage("image-marker", image, {
          pixelRatio: 2
        });
        this.addClusterCircles();
        this.addClusterCounts();
        this.addPinImageLayer();
        this.initClickOnClusters();
        this.initClickOnStoreMarkers();
      });
      this.initGeocoder();
      this.initGeolocation();
    });
  }
  get data() {
    return JSON.parse(document.getElementById(this.getAttribute("data-json")).innerText);
  }
  addClusterCircles() {
    this.map.addLayer({
      id: "clusters",
      type: "circle",
      source: "stores",
      filter: ["has", "point_count"],
      paint: {
        "circle-color": "#975F56",
        "circle-radius": 20
      }
    });
  }
  addClusterCounts() {
    this.map.addLayer({
      id: "cluster-count",
      type: "symbol",
      source: "stores",
      filter: ["has", "point_count"],
      layout: {
        "text-field": "{point_count_abbreviated}",
        "text-font": ["Arial Unicode MS Bold"],
        "text-size": 14
      },
      paint: {
        "text-color": "#ffffff"
      }
    });
  }
  addPinImageLayer() {
    this.map.addLayer({
      id: "unclustered-point",
      type: "symbol",
      source: "stores",
      filter: ["!", ["has", "point_count"]],
      layout: {
        "icon-image": "image-marker"
      }
    });
  }
  initClickOnClusters() {
    this.map.on("click", "clusters", (e) => {
      const features = this.map.queryRenderedFeatures(e.point, { layers: ["clusters"] });
      const clusterId = features[0].properties.cluster_id;
      this.map.getSource("stores").getClusterExpansionZoom(clusterId, (err, zoom) => {
        if (err)
          return;
        this.centerMap(features[0].geometry.coordinates, zoom);
      });
    });
  }
  initClickOnStoreMarkers() {
    this.map.on("click", "unclustered-point", (e) => {
      const store = e.features[0].properties;
      this.centerMap([store.long, store.lat], 15);
      this.displayMapboxPopupForStore(e.features[0].properties);
    });
  }
  centerMap(positions, zoom) {
    this.map.flyTo({
      center: positions,
      zoom,
      speed: 1,
      curve: 2
    });
  }
  initGeocoder() {
    const geocoder = new MapboxGeocoder({
      accessToken: "pk.eyJ1IjoibWFldmFwYXN0ZXVyIiwiYSI6ImNrb282eDRuNTA4ajAydG51cnBrdWhwaDcifQ.IrhI8RAeoBGuDYDdQVPPKg",
      mapboxgl,
      trackProximity: true,
      countries: "FR,BE,TN",
      types: "place,locality,neighborhood,region,postcode,country,address",
      marker: {
        color: "#373532"
      },
      flyTo: {
        speed: 2.7
      }
    });
    document.querySelector("#geocoder").appendChild(geocoder.onAdd(this.map));
    const searchInput = document.querySelector("#geocoder .mapboxgl-ctrl-geocoder--input");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.q && params.q != "") {
      searchInput.value = params.q;
      geocoder.query(searchInput.value);
      const suggestionsElement = document.querySelector(".mapboxgl-ctrl-geocoder .suggestions");
      setTimeout(() => {
        suggestionsElement.style.display = "none";
      }, 200);
    }
    geocoder.on("clear", () => {
      this.clearResults();
    });
    const searchInputButtonSubmit = document.querySelector("#geocoder button[type=submit]");
    searchInputButtonSubmit.addEventListener("click", () => {
      geocoder.query(searchInput.value);
      const suggestionsElement = document.querySelector(".mapboxgl-ctrl-geocoder .suggestions");
      setTimeout(() => {
        suggestionsElement.style.display = "none";
      }, 200);
    });
    searchInput.addEventListener("keydown", (e) => {
      if (e.key == "Enter" || e.key == 13) {
        const listOfSuggestions = document.querySelectorAll(".mapboxgl-ctrl-geocoder .suggestions li");
        if (listOfSuggestions || listOfSuggestions.length == 0) {
          geocoder.query(searchInput.value);
        }
        const suggestionsElement = document.querySelector(".mapboxgl-ctrl-geocoder .suggestions");
        setTimeout(() => {
          suggestionsElement.style.display = "none";
        }, 200);
      }
    });
    geocoder.on("result", (event) => {
      const searchResult = event.result.geometry;
      const placeType = event.result.place_type[0];
      if (placeType == "neighborhood" || placeType == "address" || placeType == "poi") {
        this.centerMap(searchResult.coordinates, 13);
      }
    });
    this.map.on("zoomend", () => {
      const bounds = this.map.getBounds();
      const boundingBox = [bounds._sw.lng, bounds._sw.lat, bounds._ne.lng, bounds._ne.lat];
      const storeIn = [];
      for (const store of this.data.features) {
        checkIfStoreIsInBBox(store, boundingBox, storeIn);
      }
      this.initSearchMap(storeIn);
      this.querySelector("store-result").dispatchEvent(new CustomEvent("result-show", {
        bubbles: true,
        detail: {
          resultCount: storeIn.length
        }
      }));
    });
    const checkIfStoreIsInBBox = (store, bbox, storeIn) => {
      const point = {
        x: store.geometry.coordinates[0],
        y: store.geometry.coordinates[1]
      };
      if (bbox[0] <= point.x && point.x <= bbox[2] && bbox[1] <= point.y && point.y <= bbox[3]) {
        storeIn.push(store.properties.handle);
      }
    };
  }
  initGeolocation() {
    let geolocate = new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: false
    });
    this.map.addControl(geolocate);
    geolocate.on("geolocate", (e) => {
      this.centerMap([e.coords.longitude, e.coords.latitude], 12);
    });
    if (this.querySelector(".js-geolocation")) {
      this.querySelector(".js-geolocation").addEventListener("click", (e) => {
        e.preventDefault();
        if (!this.mapGeolocationButton)
          this.mapGeolocationButton = document.querySelector(".mapboxgl-ctrl-geolocate");
        if (this.mapGeolocationButton) {
          this.mapGeolocationButton.click();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      });
    }
  }
  displayMapboxPopupForStore(store) {
    const popupHTML = '<p class="h6 terracotta">' + store.title + "</p><p>" + store.description + "<p><p>" + store.phoneNumber + "</p>";
    new mapboxgl.Popup().setLngLat([store.long, store.lat]).setHTML(popupHTML).addTo(this.map);
  }
  initSearchMap(storeInNames) {
    const elems = this.querySelectorAll("[data-city]");
    const storeIn = [];
    if (storeInNames.length > 0) {
      for (const storeInName of storeInNames) {
        const result = this.data.features.find((store) => store.properties.handle === storeInName);
        storeIn.push(result);
      }
      elems.forEach((el) => {
        if (storeIn.find((item) => item.properties.handle === el.getAttribute("data-city"))) {
          el.classList.remove("hidden");
        } else {
          el.classList.add("hidden");
        }
      });
    } else if (storeInNames.length == 0) {
      elems.forEach((el) => {
        if (storeIn.find((r) => r.id === el.dataset.id)) {
          el.classList.remove("hidden");
        } else {
          el.classList.add("hidden");
        }
      });
    }
  }
};
var StoreItem = class extends HTMLElement {
  connectedCallback() {
    this.updateStatus();
  }
  updateStatus() {
    const hour = new Date().getHours();
    if (this.openingHour !== null && this.closingHour !== null) {
      if (hour >= this.openingHour && hour < this.closingHour) {
        this.querySelector("[data-status]").setAttribute("data-status", "open");
        this.querySelector("[data-open]").removeAttribute("hidden");
        this.querySelector("[data-close]").setAttribute("hidden", "");
      } else {
        this.querySelector("[data-status]").setAttribute("data-status", "close");
        this.querySelector("[data-open]").setAttribute("hidden", "");
        this.querySelector("[data-close]").removeAttribute("hidden");
      }
    }
  }
  get openingHour() {
    return this.hasAttribute("opening-hour") ? parseInt(this.getAttribute("opening-hour")) : null;
  }
  get closingHour() {
    return this.hasAttribute("closing-hour") ? parseInt(this.getAttribute("closing-hour")) : null;
  }
};
var StoreResult = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener("result-show", (event) => {
      this.displayResultCount(event.detail.resultCount);
    });
  }
  displayResultCount(resultCount) {
    this.style.display = "block";
    if (resultCount > 1) {
      this.innerHTML = '<p class="text-center text-subdued">' + resultCount + " " + this.plural + "</p>";
    } else {
      this.innerHTML = '<p class="text-center text-subdued">' + resultCount + " " + this.singular + "</p>";
    }
  }
  get singular() {
    return this.getAttribute("singular-word");
  }
  get plural() {
    return this.getAttribute("plural-word");
  }
};
if (!window.customElements.get("store-locator")) {
  window.customElements.define("store-locator", StoreLocator);
}
if (!window.customElements.get("store-item")) {
  window.customElements.define("store-item", StoreItem);
}
if (!window.customElements.get("store-result")) {
  window.customElements.define("store-result", StoreResult);
}

// dev/src/js/sections/wishlist.js
var _wishlistCount, _wishlistProductList, _fetchWishlistProducts2, fetchWishlistProducts_fn2, _initWishlistPage, initWishlistPage_fn, _sendWishlistToDataLayer, sendWishlistToDataLayer_fn;
var AccountWishlist = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _fetchWishlistProducts2);
    __privateAdd(this, _initWishlistPage);
    __privateAdd(this, _sendWishlistToDataLayer);
    __privateAdd(this, _wishlistCount, void 0);
    __privateAdd(this, _wishlistProductList, void 0);
    __privateSet(this, _wishlistCount, this.querySelector("#wishlist-product-count"));
    __privateSet(this, _wishlistProductList, this.querySelector("#wishlist-product-list"));
    document.addEventListener("DOMContentLoaded", __privateMethod(this, _fetchWishlistProducts2, fetchWishlistProducts_fn2).bind(this));
  }
};
_wishlistCount = new WeakMap();
_wishlistProductList = new WeakMap();
_fetchWishlistProducts2 = new WeakSet();
fetchWishlistProducts_fn2 = async function() {
  await waitForWindowObject(() => window.hasOwnProperty("_swat")).then(() => {
    window._swat.fetchWrtEventTypeET(
      (e) => {
        __privateMethod(this, _initWishlistPage, initWishlistPage_fn).call(this, e);
      },
      window._swat.EventTypes.addToWishList
    );
  });
};
_initWishlistPage = new WeakSet();
initWishlistPage_fn = async function(e) {
  const productStringValue = e.length > 1 ? window.themeVariables.strings.products : window.themeVariables.strings.product;
  __privateGet(this, _wishlistCount).innerHTML = `${e.length} ${productStringValue}`;
  let productIds = [];
  e.forEach((item) => {
    if (item.empi) {
      productIds.push(`id:${item.empi}`);
    }
  });
  const response = await fetch(`${Shopify.routes.root}search?resources[type]=product&section_id=product-card-wishlist&q=${productIds.join(" OR ")}`);
  const responseText = await response.text();
  if (response.ok) {
    let div = document.createElement("div");
    div.innerHTML = responseText;
    __privateGet(this, _wishlistProductList).innerHTML = div.querySelector(".shopify-section").innerHTML;
    __privateMethod(this, _sendWishlistToDataLayer, sendWishlistToDataLayer_fn).call(this);
  }
};
_sendWishlistToDataLayer = new WeakSet();
sendWishlistToDataLayer_fn = function() {
  let products = [];
  Array.from(this.querySelectorAll(".product-card")).forEach((productCard) => {
    let productData = JSON.parse(productCard.getAttribute("data-json") || "{}");
    products.push({
      "item_name": productData.name || "",
      "item_id": productData.id || "",
      "item_variant": productData.item_variant || "",
      "price": productData.price || "",
      "currency": productData.currency || "",
      "item_brand": productData.brand || "Madura",
      "item_category": productData.product_collection || "",
      "item_category2": productData.product_collection_parent || "",
      "item_category3": productData.collection_master || "",
      "index": productData.position || ""
    });
  });
  this.dispatchEvent(new CustomEvent("wishlist:view_page", {
    bubbles: true,
    detail: {
      "items": products
    }
  }));
};
if (!window.customElements.get("wishlist-product-list")) {
  window.customElements.define("wishlist-product-list", AccountWishlist);
}

// dev/src/js/theme.js
import { Delegate as Delegate8 } from "//www.madura.com/cdn/shop/t/181/assets/vendor.min.js?v=131457669274275901961742557217";
(() => {
  const delegateDocument = new Delegate8(document.documentElement);
  delegateDocument.on("click", 'a[href*="#"]', (event, target) => {
    if (event.defaultPrevented || target.matches("[allow-hash-change]") || target.pathname !== window.location.pathname || target.search !== window.location.search) {
      return;
    }
    const url = new URL(target.href);
    if (url.hash === "") {
      return;
    }
    const anchorElement = document.querySelector(url.hash);
    if (anchorElement) {
      event.preventDefault();
      const headerHeight = document.querySelector("header.header").clientHeight;
      const stickyBarHeight = document.querySelector(".page__nav")?.clientHeight || 0;
      window.scrollTo({
        top: anchorElement.offsetTop - (headerHeight + stickyBarHeight),
        behavior: "smooth"
      });
      document.documentElement.dispatchEvent(new CustomEvent("hashchange:simulate", { bubbles: true, detail: { hash: url.hash } }));
    }
  });
  if (navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
    document.head.querySelector('meta[name="viewport"]').content = "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0";
  }
})();
export {
  AccordionDisclosure,
  AccordionListAnimated,
  AccountForm,
  AccountLogin,
  AccountWishlist,
  AnimatedDetails,
  AnnouncementBarCarousel,
  B2BSalePrice,
  B2Btooltip,
  BackToTop,
  BadgeList,
  BannerCtaSticky,
  BuyButtons,
  CarouselContainer,
  CarouselNavigation,
  CarouselNextButton,
  CarouselPrevButton,
  CartBundleEditModal,
  CartCount,
  CartCrossSellRecommendation,
  CartDrawer,
  CartDrawerCrossSellRod,
  CartTemplate,
  CheckoutButton,
  CollectionBundlePush,
  CompareAtPrice,
  ComposeDrawer,
  ConfirmButton,
  CountrySelector,
  CrossSellDoublure,
  CrossSellRod,
  CurtainSelected,
  CustomDetails,
  CustomScrollCarousel,
  CustomSelect,
  DateInput,
  DialogElement,
  Drawer,
  DrawerProContactForm,
  EffectCarousel,
  FacetLink,
  FacetsDrawer,
  FacetsForm,
  FacetsSortPopover,
  FaqToc,
  FeaturedCollection,
  FreeShippingBar,
  GestureArea,
  Header,
  HeightObserver,
  ImageWithTabs,
  InstagramFeed,
  KspCarousel,
  LineItemQuantity,
  Listbox,
  LoadingBar,
  MaduraAtHome,
  MarqueeText,
  MenuDisclosure,
  MenuInspiration,
  MobileSearchButton,
  Modal,
  ModelMedia,
  NewsletterForm,
  OnSaleBadge,
  OrderDetails,
  Pagination,
  PaymentTerms,
  PhoneAvailability,
  PhoneInput,
  PickupAvailability,
  Player,
  Popover,
  PriceRange,
  ProCreateAccountForm,
  ProductBackInStock,
  ProductBundle,
  ProductCard,
  ProductCardBindedSizesForm,
  ProductForm,
  ProductGallery,
  ProductKsp,
  ProductList,
  ProductLoadMore,
  ProductLoader,
  ProductOptionsPopover,
  ProductRecommendations,
  ProductReviews,
  ProductStickyBar,
  ProductStock,
  ProductTabs,
  ProductWishlist,
  ProgressBar,
  QrCode,
  QuantityInput,
  QuantitySelector,
  QuickBuyDrawer,
  QuickBuyModal,
  ReadMore,
  RecentlyViewedProducts,
  SafeSticky,
  SalePrice,
  ScrollCarousel,
  ScrollShadow,
  ScrollingTabs,
  SearchDrawer,
  SearchResults,
  ShopTheLookCarousel,
  ShowPassword,
  SizeGuideDrawer,
  SlideshowCarousel,
  SoldOutBadge,
  StoreItem,
  StoreLocator,
  StoreResult,
  Tabs,
  UnitPrice,
  VariantInventory,
  VariantMedia,
  VariantPicker,
  VariantSku,
  VideoMedia,
  cachedFetch,
  cartTokens,
  createMediaImg,
  debounce,
  extractSectionId,
  fetchCart,
  formatMoney,
  generateSrcset,
  imageLoaded,
  matchesMediaQuery,
  mediaQueryListener,
  mediaQueryRemoveListener,
  throttle,
  videoLoaded,
  waitForEvent
};
/*!
  * PhotoSwipe 5.4.4 - https://photoswipe.com
  * (c) 2024 Dmytro Semenov
  */
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
/*! algoliasearch.umd.js | 4.24.0 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */
